
/* ==== /js/068-twh-invsync-v92.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  function D_(){ return window.D||(window.D={}); }
  function $(id){ return document.getElementById(id); }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function num(v){ var n=parseFloat(v); return isNaN(n)?0:n; }
  function tdy(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
  function genId(){ try{ return (typeof nid==='function')?nid():(Date.now()+Math.floor(Math.random()*1000)); }catch(e){ return Date.now(); } }
  function uidv(){ try{ return (typeof uid==='function')?uid():Math.random().toString(36).substr(2,6).toUpperCase(); }catch(e){ return Math.random().toString(36).substr(2,6).toUpperCase(); } }
  function money(n){ try{ return (typeof F==='function')?F(n):('₦'+Number(n||0).toLocaleString()); }catch(e){ return '₦'+(n||0); } }
  function toasty(m,t){ try{ if(typeof toast==='function') toast(m,t); }catch(e){} }
  function save(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} }

  /* ════════ unified inventory engine ════════ */
  var TWHinv = window.TWHinv = window.TWHinv || {};

  /* import every pharmacy item into Inventory as a linked record (idempotent) */
  TWHinv.importAll = function(){
    var D=D_(); D.inventory=D.inventory||[]; D.pharmacy=D.pharmacy||[];
    var added=0;
    D.pharmacy.forEach(function(ph){
      var exists=D.inventory.some(function(i){ return i.linkedPharmacyId===ph.id; });
      if(exists) return;
      D.inventory.push({ id:genId(), code:'INV-RX'+(ph.code||ph.id), name:ph.name, category:ph.category||'Pharmacy',
        qty:num(ph.stock), minTh:num(ph.minStock), price:num(ph.unitPrice)||num(ph.sellingPrice),
        supplier:ph.supplier||'', linkedPharmacyId:ph.id, source:'pharmacy' });
      added++;
    });
    if(added){ save(); }
    return added;
  };
  /* mirror pharmacy balances onto their linked inventory rows (single source of truth = pharmacy) */
  TWHinv.sync = function(){
    var D=D_();
    (D.inventory||[]).forEach(function(i){
      if(i.linkedPharmacyId){
        var ph=(D.pharmacy||[]).find(function(p){return p.id===i.linkedPharmacyId;});
        if(ph){ i.qty=num(ph.stock); i.minTh=num(ph.minStock); i.price=num(ph.unitPrice)||num(ph.sellingPrice); i.name=ph.name; i.category=ph.category||i.category; }
      }
    });
  };
  /* the merged item master used by Procurement (pharmacy items + non-linked inventory items) */
  TWHinv.unifiedItems = function(){
    var D=D_(); var out=[];
    (D.pharmacy||[]).forEach(function(p){ out.push({ kind:'pharmacy', id:p.id, name:p.name, category:p.category||'Pharmacy', stock:num(p.stock), cost:num(p.unitPrice)||num(p.sellingPrice), min:num(p.minStock) }); });
    (D.inventory||[]).forEach(function(i){ if(!i.linkedPharmacyId) out.push({ kind:'inventory', id:i.id, name:i.name, category:i.category||'', stock:num(i.qty), cost:num(i.price), min:num(i.minTh) }); });
    out.sort(function(a,b){ return String(a.name||'').localeCompare(String(b.name||'')); });
    return out;
  };
  /* adjust the underlying stock for an item (kind+id) and keep mirrors in sync */
  TWHinv.adjust = function(kind, id, delta, reason){
    var D=D_(); delta=num(delta);
    if(kind==='pharmacy'){ var ph=(D.pharmacy||[]).find(function(p){return p.id===id;}); if(ph){ ph.stock=Math.max(0,num(ph.stock)+delta); } }
    else { var inv=(D.inventory||[]).find(function(i){return i.id===id;}); if(inv){ inv.qty=Math.max(0,num(inv.qty)+delta); } }
    TWHinv.sync();
    try{ if(Array.isArray(D.stockMovements)) D.stockMovements.push({ id:genId(), date:tdy(), kind:kind, refId:id, delta:delta, reason:reason||'adjustment' }); }catch(e){}
  };

  /* show all pharmacy items inside Inventory (import + mirror before each render) */
  function wrapRenderInventory(){
    if(typeof window.renderInventory!=='function' || window.renderInventory.__invV92) return;
    var _r=window.renderInventory;
    window.renderInventory=function(){ try{ TWHinv.importAll(); TWHinv.sync(); }catch(e){} return _r.apply(this, arguments); };
    window.renderInventory.__invV92=true;
  }

  /* ════════ Procurement — real PO line items + working receive/GRN ════════ */
  function itemOptions(sel){
    return '<option value="">— select item —</option>'+TWHinv.unifiedItems().map(function(it){
      return '<option value="'+it.kind+':'+it.id+'" data-cost="'+it.cost+'" data-name="'+esc(it.name)+'"'+(sel===(it.kind+':'+it.id)?' selected':'')+'>'+esc(it.name)+' — '+esc(it.category)+' (bal '+it.stock+')</option>';
    }).join('');
  }
  function poRow(){
    return '<tr class="po-line">'
      +'<td style="min-width:220px"><select class="po-item" style="width:100%" onchange="__poPickItem(this)">'+itemOptions('')+'</select></td>'
      +'<td><input class="po-qty" type="number" value="1" min="1" style="width:70px" oninput="__poRecalc()"></td>'
      +'<td><input class="po-cost" type="number" value="0" style="width:100px" oninput="__poRecalc()"></td>'
      +'<td class="po-linetot" style="text-align:right">'+money(0)+'</td>'
      +'<td style="text-align:center"><button type="button" class="btn btn-xs" style="background:#fee2e2;color:#dc2626;padding:2px 8px" onclick="__poRemoveLine(this)">×</button></td>'
    +'</tr>';
  }
  window.__poPickItem=function(sel){ var tr=sel.closest('tr'); if(!tr)return; var o=sel.options[sel.selectedIndex]; var c=o&&o.getAttribute?num(o.getAttribute('data-cost')):0; var ci=tr.querySelector('.po-cost'); if(ci && (!num(ci.value)||ci.value==='0')) ci.value=c; window.__poRecalc(); };
  window.__poAddLine=function(){ var tb=$('po_lines'); if(tb) tb.insertAdjacentHTML('beforeend', poRow()); };
  window.__poRemoveLine=function(btn){ var tb=$('po_lines'); if(!tb)return; var rows=tb.querySelectorAll('tr.po-line'); var tr=btn.closest('tr'); if(rows.length<=1){ if(tr) tr.querySelectorAll('input,select').forEach(function(x){x.value=(x.classList.contains('po-qty')?'1':'');}); } else if(tr){ tr.remove(); } window.__poRecalc(); };
  window.__poRecalc=function(){ var total=0; document.querySelectorAll('#po_lines tr.po-line').forEach(function(tr){ var q=num((tr.querySelector('.po-qty')||{}).value), c=num((tr.querySelector('.po-cost')||{}).value); var lt=q*c; total+=lt; var cell=tr.querySelector('.po-linetot'); if(cell) cell.innerHTML=money(lt); }); var t=$('po_total'); if(t) t.innerHTML='<b>'+money(total)+'</b>'; };

  window.newPurchaseOrder=function(){
    var D=D_();
    var supOpts=(D.suppliers||[]).map(function(s){return '<option value="'+esc(s.name)+'">'+esc(s.name)+'</option>';}).join('');
    var body='<div class="form-grid">'
      +'<div class="form-group"><label>Supplier <span class="req">*</span></label><input id="po_supplier" list="po_sup_dl" placeholder="Supplier name"><datalist id="po_sup_dl">'+supOpts+'</datalist></div>'
      +'<div class="form-group"><label>Order Date</label><input id="po_date" type="date" value="'+tdy()+'"></div>'
      +'<div class="form-group"><label>Expected Delivery</label><input id="po_eta" type="date"></div>'
      +'<div class="form-group"><label>Status</label><select id="po_status"><option>Ordered</option><option>Draft</option><option>Submitted</option><option>Approved</option></select></div>'
      +'<div class="form-group full"><label>Items <span class="req">*</span></label>'
        +'<div class="tbl-wrap" style="border:1px solid var(--bdr);border-radius:8px;overflow:auto"><table class="tbl" style="margin:0;font-size:12px"><thead><tr><th>Item</th><th>Qty</th><th>Unit Cost</th><th style="text-align:right">Total</th><th></th></tr></thead><tbody id="po_lines"></tbody>'
        +'<tfoot><tr style="background:#f0fdfa;font-weight:700"><td colspan="3" style="text-align:right">PO Total</td><td id="po_total" style="text-align:right"><b>'+money(0)+'</b></td><td></td></tr></tfoot></table></div>'
        +'<button type="button" class="btn btn-xs" style="margin-top:6px;background:#ede9fe;color:#6d28d9" onclick="__poAddLine()"><i class="fa-solid fa-plus"></i> Add item</button></div>'
      +'<div class="form-group full"><label>Notes</label><textarea id="po_notes" rows="2"></textarea></div></div>';
    showModal('<i class="fa-solid fa-cart-plus" style="color:#0d9488;margin-right:8px"></i>New Purchase Order', body,
      '<button class="btn btn-pri" onclick="savePurchaseOrderV92()"><i class="fa-solid fa-save"></i> Create PO</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
    window.__poAddLine();
  };
  window.savePurchaseOrderV92=function(){
    var D=D_(); var supplier=($('po_supplier')||{}).value||'';
    if(!supplier.trim()){ toasty('Supplier is required','err'); return; }
    var lines=[]; document.querySelectorAll('#po_lines tr.po-line').forEach(function(tr){
      var v=(tr.querySelector('.po-item')||{}).value||''; if(!v) return;
      var parts=v.split(':'); var q=num((tr.querySelector('.po-qty')||{}).value)||1; var c=num((tr.querySelector('.po-cost')||{}).value);
      var o=tr.querySelector('.po-item'); var nm=o&&o.options[o.selectedIndex]?o.options[o.selectedIndex].getAttribute('data-name'):'';
      lines.push({ kind:parts[0], id:parseInt(parts[1]), name:nm, qty:q, unitCost:c });
    });
    if(!lines.length){ toasty('Add at least one item','err'); return; }
    var total=lines.reduce(function(s,l){return s+l.qty*l.unitCost;},0);
    D.purchaseOrders=D.purchaseOrders||[];
    D.purchaseOrders.push({ id:genId(), code:'PO-'+uidv(), supplier:supplier, orderDate:($('po_date')||{}).value||tdy(),
      expectedDelivery:($('po_eta')||{}).value||'', total:total, status:($('po_status')||{}).value||'Ordered',
      lineItems:lines, items:lines.map(function(l){return l.qty+'× '+l.name;}).join(', '), notes:($('po_notes')||{}).value||'' });
    try{ if(typeof auditAction==='function') auditAction('FINANCE','Procurement','CREATE','PO created — '+lines.length+' line(s), '+money(total),'Low'); }catch(e){}
    save(); toasty('Purchase Order created — '+money(total)); try{ closeModal(); }catch(e){} try{ if(typeof render==='function') render(); }catch(e){}
  };

  /* receiving a PO now moves stock into Inventory/Pharmacy (then the original GL/status runs) */
  function wrapConfirmReceive(){
    if(typeof window.confirmReceive!=='function' || window.confirmReceive.__invV92) return;
    var _c=window.confirmReceive;
    window.confirmReceive=function(poId){
      try{
        var D=D_(); var po=(D.purchaseOrders||[]).find(function(p){return p.id===poId;});
        if(po && Array.isArray(po.lineItems) && !po.__stockReceived){
          po.lineItems.forEach(function(l){ TWHinv.adjust(l.kind, l.id, +num(l.qty), 'PO '+po.code+' received'); });
          po.__stockReceived=true;
          toasty('Stock received into Inventory/Pharmacy — '+po.lineItems.length+' item(s)');
        }
      }catch(e){ try{console.warn('[v92 receive]',e);}catch(_){} }
      return _c.apply(this, arguments);
    };
    window.confirmReceive.__invV92=true;
  }

  /* GRN modal: pick a PO and actually post its stock */
  window.showGRN=function(){
    var D=D_();
    var open=(D.purchaseOrders||[]).filter(function(p){return p.status!=='Delivered'&&p.status!=='Cancelled';});
    var opts=open.map(function(po){return '<option value="'+po.id+'">'+esc(po.code)+' — '+esc(po.supplier)+' ('+money(po.total)+')</option>';}).join('');
    showModal('<i class="fa-solid fa-clipboard-check" style="color:var(--pri);margin-right:8px"></i>Goods Received Note (GRN)',
      '<div class="form-grid"><div class="form-group full"><label>PO Reference <span class="req">*</span></label><select id="grn_po">'+(opts||'<option value="">No open POs</option>')+'</select></div>'
      +'<div class="form-group"><label>Received Date</label><input id="grn_date" type="date" value="'+tdy()+'"></div>'
      +'<div class="form-group"><label>Received By</label><input id="grn_by" value="'+esc((D.currentUser&&D.currentUser.fullName)||'Store Keeper')+'"></div>'
      +'<div class="form-group full"><label>Notes</label><textarea id="grn_notes" rows="2"></textarea></div></div>'
      +'<div class="alert alert-blue" style="margin-top:8px"><i class="fa-solid fa-info-circle"></i> Recording the GRN receives the PO: stock is added to Inventory/Pharmacy and posted to Payables.</div>',
      '<button class="btn btn-pri" onclick="__grnRecord()"><i class="fa-solid fa-save"></i> Record GRN</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.__grnRecord=function(){
    var v=($('grn_po')||{}).value; if(!v){ toasty('Select a PO','err'); return; }
    try{ closeModal(); }catch(e){}
    if(typeof window.confirmReceive==='function') window.confirmReceive(parseInt(v));
  };

  /* route "New PO" button to the line-item PO builder */
  function wrapAddNewRecord(){
    if(typeof window.addNewRecord!=='function' || window.addNewRecord.__poV92) return;
    var _a=window.addNewRecord;
    window.addNewRecord=function(dataKey){ if(dataKey==='purchaseOrders'){ return window.newPurchaseOrder(); } return _a.apply(this, arguments); };
    window.addNewRecord.__poV92=true;
  }

  /* ════════ reinforce Order Lab Test "Patient" across both lab modals ════════ */
  function wrapLabModalV50(){
    if(typeof window.buildLabOrderModal!=='function' || window.buildLabOrderModal.__patV92) return;
    var _b=window.buildLabOrderModal;
    window.buildLabOrderModal=function(rec){ var r=_b.apply(this, arguments); try{ if(typeof window.__labFillAllPatients==='function') window.__labFillAllPatients(rec&&rec.patientId!=null?rec.patientId:''); }catch(e){} return r; };
    window.buildLabOrderModal.__patV92=true;
  }

  function boot(){ wrapRenderInventory(); wrapConfirmReceive(); wrapAddNewRecord(); wrapLabModalV50(); try{ TWHinv.importAll(); }catch(e){} }
  boot(); setTimeout(boot,600); setTimeout(boot,1800); setTimeout(boot,4200);
  if(document.readyState==='loading'){ window.addEventListener('DOMContentLoaded', function(){ setTimeout(boot,300); }); }

  try{ console.log('%c✅ v92 Batch3: inventory↔pharmacy↔procurement sync + import-all active','color:#7c3aed;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/069-v93-order-lab-test-patient-field-bulletproof-ful.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  function D_(){ return window.D||(window.D={}); }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function byName(a,b){ return String(a.fullName||a.name||'').localeCompare(String(b.fullName||b.name||'')); }

  /* ensure the full roster is present (merge DOC2's records if a reset thinned D.patients) */
  function ensureRoster(){
    var D=D_(); D.patients=D.patients||[];
    try{
      if(typeof DOC2!=='undefined' && DOC2 && Array.isArray(DOC2.patients) && DOC2.patients.length){
        var have={}; D.patients.forEach(function(p){ have[p.id]=true; });
        var changed=false;
        DOC2.patients.forEach(function(p){ if(!have[p.id]){ D.patients.push(p); changed=true; } });
        if(changed){ try{ if(window._hmsSave) window._hmsSave(); }catch(e){} }
      }
    }catch(e){}
  }

  /* (re)build the Patient select from the live roster */
  window.__labFillAllPatients=function(keep){
    var sel=document.getElementById('add_patientId'); if(!sel) return false;
    var D=D_(); var pts=(D.patients||[]).slice().sort(byName);
    var cur=(keep!=null && keep!=='')?String(keep):sel.value;
    sel.innerHTML='<option value="">Select patient… ('+pts.length+')</option>'+pts.map(function(p){
      var nm=p.fullName||p.name||((p.firstName||'')+' '+(p.lastName||'')).trim()||('Patient '+p.id);
      var mrn=p.mrn||p.code||('ID-'+p.id);
      return '<option value="'+p.id+'">'+esc(nm)+' ['+esc(mrn)+']</option>';
    }).join('');
    if(cur) sel.value=cur;
    return true;
  };

  /* bulletproof: refill whenever the user touches the field, regardless of how the modal was built */
  function onInteract(e){
    var t=e.target;
    if(t && t.id==='add_patientId'){ try{ ensureRoster(); window.__labFillAllPatients(t.value); }catch(err){} }
  }
  document.addEventListener('mousedown', onInteract, true);
  document.addEventListener('focusin', onInteract, true);
  document.addEventListener('touchstart', onInteract, true);

  function boot(){ ensureRoster(); try{ window.__labFillAllPatients(''); }catch(e){} }
  boot(); setTimeout(boot,800); setTimeout(boot,2500); setTimeout(boot,5000);
  if(document.readyState==='loading'){ window.addEventListener('DOMContentLoaded', function(){ setTimeout(boot,300); }); }

  try{ console.log('%c✅ v93 Order Lab Test patient roster — bulletproof fill active','color:#7c3aed;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/070-v94-master-data-guarantee-d-patients-36-d-pharma.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  function D_(){ return window.D||(window.D={}); }
  function num(v){ var n=parseFloat(v); return isNaN(n)?0:n; }

  function doc(){ return window.__TWH_DOC2 || (typeof window.DOC2!=='undefined'?window.DOC2:null); }

  function restore(){
    var D=D_(); var src=doc(); if(!src) return false;
    var changed=false;
    /* ── master patients: merge every DOC2 patient by id (preserve user-created) ── */
    if(Array.isArray(src.patients) && src.patients.length){
      D.patients = D.patients || [];
      var have={}; D.patients.forEach(function(p){ have[p.id]=true; });
      src.patients.forEach(function(p){ if(!have[p.id]){ D.patients.push(p); changed=true; } });
    }
    /* ── master pharmacy formulary: merge by code, assign ids ── */
    if(Array.isArray(src.pharmacy) && src.pharmacy.length){
      D.pharmacy = D.pharmacy || [];
      var byCode={}; D.pharmacy.forEach(function(d){ byCode[d.code]=true; });
      var maxId=D.pharmacy.reduce(function(m,d){ return Math.max(m, num(d.id)); }, 0);
      src.pharmacy.forEach(function(d){ if(!byCode[d.code]){ D.pharmacy.push(Object.assign({id:++maxId}, d)); changed=true; } });
    }
    if(changed){ try{ if(window._hmsSave) window._hmsSave(); }catch(e){} }
    /* ── Inventory mirrors Pharmacy (single shared balance) ── */
    try{ if(window.TWHinv){ window.TWHinv.importAll(); window.TWHinv.sync(); } }catch(e){}
    /* ── refresh the lab Patient dropdown from master D.patients ── */
    try{ if(window.__labFillAllPatients) window.__labFillAllPatients(''); }catch(e){}
    return changed;
  }
  window.__twhRestoreMasters = restore;

  /* refill the lab patient field on interaction, after restoring masters */
  document.addEventListener('mousedown', function(e){
    if(e.target && e.target.id==='add_patientId'){ try{ restore(); if(window.__labFillAllPatients) window.__labFillAllPatients(e.target.value); }catch(err){} }
  }, true);

  /* DOC2 is exposed ~900ms after load, so restore on a slightly later cadence + retries */
  [1000,1600,3000,5200,8000].forEach(function(t){ setTimeout(restore, t); });
  if(document.readyState==='loading'){ window.addEventListener('DOMContentLoaded', function(){ setTimeout(restore,1200); }); }

  try{ console.log('%c✅ v94 Master data guarantee — patients & pharmacy restored, inventory mirrored','color:#7c3aed;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/071-twh-production-census-v100.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  var CENSUS_VER = 100;
  var TX_TABLES = ["appointments","medicalRecords","prescriptions","labTests","emergencyCases","transactions","creditNotes","dailyCashUp","bills","insuranceClaims","auditLog","orSchedules","radiologyOrders","purchaseOrders","bloodDonations","bloodRequests","attendance","leaveRequests","claims","importLogs","referrals","dischargeSummaries","appointmentReminders","notifications","userSessions","teleConsultations","queueTokens","infectionControl","dietaryOrders","immunizations","documents","consentRecords","soapNotes","handoverNotes","bloodDonors","crossmatches","transfusionReactions","incidents","waitlist","anesthesiaRecords","deposits","marRecords","carePlans","problemLists","nursingNotes","sepsisScreening","specimenTracking","radiationDose","medReconciliation","paymentPlans","denialTracking","glEntries","customFees","hahAdmissions"];
  var CENSUS = [
{id:1,mrn:"2603TH0001",fullName:"Jemila YUNUSA",gender:"Female",age:45,bloodGroup:"O+",deptId:2,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:2,mrn:"2603TH0002",fullName:"Lucy Ata EWA",gender:"Female",age:32,bloodGroup:"A+",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:3,mrn:"2604TH0003",fullName:"Nkeiruka Dorathy CHIMEZIE",gender:"Female",age:67,bloodGroup:"B+",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:4,mrn:"2604TH0004",fullName:"Simeon OMEBEN",gender:"Male",age:39,bloodGroup:"AB+",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:5,mrn:"2604TH0005",fullName:"David Okechukwu MBA",gender:"Male",age:54,bloodGroup:"O-",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:6,mrn:"2604TH0006",fullName:"Victor Uchenna IKEME",gender:"Male",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:7,mrn:"2604TH0007",fullName:"Toyin Mary BAKO",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:8,mrn:"2604TH0008",fullName:"Kayode Kolade JOHNSON",gender:"Male",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:9,mrn:"2604TH0009",fullName:"Alice GREGORY",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:10,mrn:"2605TH0010",fullName:"Gabrial Ogaba ONMONYA",gender:"Male",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:11,mrn:"2605TH0011",fullName:"Nenman CHINDAPBA",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:12,mrn:"2605TH0012",fullName:"Diana Owan OWAN",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:13,mrn:"2605TH0013",fullName:"Kate NASAMU",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:14,mrn:"2605TH0014",fullName:"Christopher Father GREGORY",gender:"Male",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:15,mrn:"2605TH0015",fullName:"Bogob Jehu THOMAS",gender:"Male",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:16,mrn:"2605TH0016",fullName:"Goodness EFFA",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:17,mrn:"2605TH0017",fullName:"Maryam ALIYU-JIBRIL",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:18,mrn:"2605TH0018",fullName:"Stella IKPEOHA",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:19,mrn:"2605TH0019",fullName:"Melvin ADEPEKO",gender:"Male",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:20,mrn:"2605TH0020",fullName:"Juliet Amarachi CHILAKA",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:21,mrn:"2605TH0021",fullName:"Samuel ALI",gender:"Male",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:22,mrn:"2605TH0022",fullName:"Abatcha CHINDA",gender:"Male",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:23,mrn:"2605TH0023",fullName:"Susan EMMANUEL",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:24,mrn:"2605TH0024",fullName:"Edward EDE",gender:"Male",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:25,mrn:"2605TH0025",fullName:"Mercy NKPECHA PRECIOS",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:26,mrn:"2606TH0026",fullName:"Ama Nwankwo KALU",gender:"Male",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:27,mrn:"2606TH0027",fullName:"Babatunde LOYIWMI",gender:"Male",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:28,mrn:"2606TH0028",fullName:"Jennifer EKPO",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:29,mrn:"2606TH0029",fullName:"Amazingrace Chinyere JOHNSON",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:30,mrn:"2606TH0030",fullName:"Favour Elozino OGHALE",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:31,mrn:"2606TH0031",fullName:"Seraphina Assumpta ITOE",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:32,mrn:"2606TH0032",fullName:"Abdulsalam IDLBI",gender:"Male",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:33,mrn:"2606TH0033",fullName:"Ebunoluwa ADEBYI OMOLADE",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:34,mrn:"2606TH0034",fullName:"Favour ENE ATTAH",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:35,mrn:"2606TH0035",fullName:"Francisca IMONIUNU",gender:"Female",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""},
{id:36,mrn:"2606TH0036",fullName:"Chokwuemeka BONIFACE",gender:"Male",age:null,bloodGroup:"",deptId:null,doctorId:null,status:"Active",room:null,phone:"",email:"",insurance:"Self-Pay",insuranceNo:"",address:"",allergies:"None",conditions:"",genotype:"",nin:"",dob:"",nationality:"Nigerian",partyType:"Patient",referralSource:"",registrationDate:"",admissionDate:null,bedId:null,ecName:"",ecRelation:"",ecPhone:""}
];

  function D_(){ return window.D || (window.D = {}); }

  // A record is USER-CREATED (must NEVER be swept/tombstoned) when it carries
  // any provenance marker. Every create/edit path in the app + the standalone
  // pages stamp at least one of these. Demo/seed rows carried NONE of them.
  //   • _rev        — millisecond revision stamp (create/edit)
  //   • createdDate / createdAt / created / dateCreated — creation timestamp
  //   • code        — human business code (APT-…, LAB-…, RAD-…, MR-…)
  //   • mrn         — patient medical-record number
  // This is the same "no _rev ⇒ seed" safety already used for patients below,
  // generalised so the self-heal sweep can only ever remove genuine demo rows
  // and can NEVER delete a record a user actually created (which is what made
  // saved appointments / medical records / lab / radiology "disappear").
  function isUserRecord(r){
    if(!r || typeof r!=="object") return false;
    if(r._rev!=null) return true;
    if(r.createdDate!=null || r.createdAt!=null || r.created!=null || r.dateCreated!=null) return true;
    if(typeof r.code==="string" && r.code) return true;
    if(typeof r.mrn==="string" && r.mrn) return true;
    return false;
  }

  // Tombstone + drop ONLY genuine sample/demo rows from a transaction table.
  // User-created rows (see isUserRecord) are always retained. Returns true if
  // it changed anything. Used both by the one-time reconcile and by the
  // repeating self-heal sweep (some enhancement packs re-seed demo rows on their
  // own timers AFTER the initial reconcile — this keeps demo rows cleared for
  // good WITHOUT ever touching real data).
  function clearSampleTables(D){
    D.__deletedIds = (D.__deletedIds && typeof D.__deletedIds==="object") ? D.__deletedIds : {};
    var changed = false;
    TX_TABLES.forEach(function(t){
      var arr = D[t];
      if(!Array.isArray(arr) || !arr.length) return;
      var tomb = D.__deletedIds[t] || (D.__deletedIds[t] = []);
      var kept = [];
      arr.forEach(function(r){
        if(isUserRecord(r)){ kept.push(r); return; } // PROTECT real data
        // genuine demo/seed row → tombstone + drop
        if(r && r.id!=null && tomb.indexOf(r.id)===-1) tomb.push(r.id);
        changed = true;
      });
      if(kept.length !== arr.length){ D[t] = kept; changed = true; }
    });
    return changed;
  }

  // One-time census reconciliation (patients + first clear). Gated by version.
  function run(){
    var D = D_();
    try{
      if((D._censusVer||0) >= CENSUS_VER) return; // already reconciled at this version

      var now = Date.now();
      D.__deletedIds = (D.__deletedIds && typeof D.__deletedIds==="object") ? D.__deletedIds : {};

      // 1) Patients -> census authoritative
      var censusIds = {};
      CENSUS.forEach(function(p){ censusIds[p.id] = true; });

      // Tombstone any existing patient whose id is NOT part of the census
      // (these are old demo patients, e.g. ids 37-76).
      // SAFETY: only tombstone non-census patients that LACK a _rev. Demo/seed
      // data never carried _rev, while every user-created/edited patient is
      // stamped with _rev — so a legitimately new patient (id>36) created on
      // another client is never wiped by a lagging client running run() late.
      var existing = Array.isArray(D.patients) ? D.patients : [];
      var pTomb = D.__deletedIds.patients || (D.__deletedIds.patients = []);
      existing.forEach(function(p){
        if(p && p.id!=null && !censusIds[p.id] && !p._rev && pTomb.indexOf(p.id)===-1){ pTomb.push(p.id); }
      });

      // Replace patient roster with the 36 census records, each stamped _rev so
      // the freshest edit wins the by-id merge on the server and other clients.
      D.patients = CENSUS.map(function(p){
        var c = {}; for(var k in p){ if(Object.prototype.hasOwnProperty.call(p,k)) c[k]=p[k]; }
        c._rev = now; return c;
      });

      // 2) Sample transaction tables -> cleared + tombstoned
      clearSampleTables(D);

      // Free any bed links that referenced now-removed demo patients.
      (D.beds||[]).forEach(function(b){ b.status="Available"; b.patientId=null; b.patientName=null; b.admissionDate=null; });

      D._censusVer = CENSUS_VER;

      try{ if(window._hmsSave) window._hmsSave(); }catch(e){}
      try{ if(typeof render==="function" && typeof isLoggedIn!=="undefined" && isLoggedIn) render(); }catch(e){}
      try{ console.log("%c✅ v100 Production Census — "+D.patients.length+" patients, "+TX_TABLES.length+" sample tables cleared",
        "background:#047857;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold"); }catch(e){}
    }catch(e){ try{ console.error("[v100] census reconcile failed:", e); }catch(_){} }
  }

  // Self-heal sweep: once the census is live, keep the sample tables empty even
  // if a late enhancement-pack timer re-seeded demo rows. Runs a few times after
  // load (when the packs fire) then stops fighting; user-created records are safe
  // because their ids are tombstoned only if a pack re-inserts the SAME demo ids.
  function sweep(){
    var D = D_();
    try{
      if((D._censusVer||0) < CENSUS_VER) return;      // reconcile hasn't run yet
      if(clearSampleTables(D)){
        try{ if(window._hmsSave) window._hmsSave(); }catch(e){}
        try{ if(typeof render==="function" && typeof isLoggedIn!=="undefined" && isLoggedIn) render(); }catch(e){}
        try{ console.log("%c✅ v100 sweep — re-cleared re-seeded sample rows","color:#047857;font-weight:bold"); }catch(e){}
      }
    }catch(e){}
  }

  // Run after the persistence bootstrap has restored the D1 document.
  window.__twhCensusReconcile = run;
  window.__twhCensusSweep = sweep;
  function boot(){ run(); }
  if(document.readyState==="loading"){
    window.addEventListener("DOMContentLoaded", function(){ setTimeout(boot, 400); });
  } else { setTimeout(boot, 400); }
  setTimeout(boot, 1500);
  // Sweep AFTER the known auto-seeders fire (activateAllModules autoAll runs at
  // ~1800ms; other packs on 800/2500/5000ms timers). Cover them all.
  [2200, 3000, 4000, 6000].forEach(function(ms){ setTimeout(sweep, ms); });
})();

;

/* ==== /js/072-twh-finance-treasury-budget-v95.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  function D_(){ return window.D||(window.D={}); }
  function gv(id){ var el=document.getElementById(id); return el?el.value:''; }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function money(n){ return '\u20a6'+Math.round(parseFloat(n)||0).toLocaleString(); }
  function rerender(){ try{ if(typeof render==='function') render(); }catch(e){} }
  function hasModal(){ return typeof showModal==='function'; }

  /* ───────────────────────── Treasury modals ───────────────────────── */
  var expenseAccts = [['6900','Sundry / Misc Expense'],['5030','Utilities'],['5060','Maintenance & Repairs'],['5080','Office & Admin'],['5955','Transport'],['5970','Staff Welfare'],['5975','Diesel'],['5996','Stationery & Printing']];

  window.TWHcash = {
    establish:function(){
      if(!hasModal()) return;
      showModal('<i class="fa-solid fa-sack-dollar" style="color:#16a34a;margin-right:8px"></i>Establish Petty Cash Imprest',
        '<div class="form-grid"><div class="form-group full"><label>Imprest Float Amount (\u20a6) <span class="req">*</span></label>'
        +'<input id="tc_estAmt" type="number" min="1" step="1000" value="50000"></div>'
        +'<p class="form-group full" style="font-size:12px;color:var(--txt3)">Posts Dr Petty Cash (1015) / Cr Cash on Hand (1010). The float is the fixed imprest ceiling that replenishment restores to.</p></div>',
        '<button class="btn btn-pri" onclick="TWHcash._doEstablish()"><i class="fa-solid fa-check"></i> Establish</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
    },
    _doEstablish:function(){ var a=parseFloat(gv('tc_estAmt'))||0; if(a<=0){ try{toast('Enter a valid amount','err');}catch(e){} return; } if(typeof closeModal==='function')closeModal(); pettyCashEstablish(a); },

    spend:function(){
      if(!hasModal()) return;
      var D=D_(); var pc=D.pettyCash||{established:false,balance:0};
      if(!pc.established){ TWHcash.establish(); return; }
      showModal('<i class="fa-solid fa-minus" style="color:#dc2626;margin-right:8px"></i>Record Petty Cash Spend',
        '<div class="form-grid"><div class="form-group"><label>Amount (\u20a6) <span class="req">*</span></label><input id="tc_spAmt" type="number" min="1" step="100" value="5000"></div>'
        +'<div class="form-group"><label>Expense Account</label><select id="tc_spAcct">'+expenseAccts.map(function(a){return '<option value="'+a[0]+'">'+a[0]+' \u2014 '+esc(a[1])+'</option>';}).join('')+'</select></div>'
        +'<div class="form-group full"><label>Description <span class="req">*</span></label><input id="tc_spDesc" placeholder="e.g. Office consumables"></div>'
        +'<p class="form-group full" style="font-size:12px;color:var(--txt3)">Available balance: <b>'+money(pc.balance)+'</b>. Posts Dr expense / Cr Petty Cash (1015).</p></div>',
        '<button class="btn btn-pri" onclick="TWHcash._doSpend()"><i class="fa-solid fa-check"></i> Record Spend</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
    },
    _doSpend:function(){ var a=parseFloat(gv('tc_spAmt'))||0; var d=gv('tc_spDesc').trim(); var ac=gv('tc_spAcct')||'6900';
      if(a<=0||!d){ try{toast('Amount and description required','err');}catch(e){} return; } if(typeof closeModal==='function')closeModal(); pettyCashSpend(a,d,ac); },

    openTill:function(){
      if(!hasModal()) return;
      var def=((D_().currentUser&&D_().currentUser.fullName))||'Cashier';
      showModal('<i class="fa-solid fa-cash-register" style="color:#2563eb;margin-right:8px"></i>Open Till Session',
        '<div class="form-grid"><div class="form-group"><label>Cashier <span class="req">*</span></label><input id="tc_tillCashier" value="'+esc(def)+'"></div>'
        +'<div class="form-group"><label>Opening Float (\u20a6) <span class="req">*</span></label><input id="tc_tillFloat" type="number" min="0" step="1000" value="20000"></div></div>',
        '<button class="btn btn-pri" onclick="TWHcash._doOpenTill()"><i class="fa-solid fa-check"></i> Open Till</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
    },
    _doOpenTill:function(){ var c=gv('tc_tillCashier').trim()||'Cashier'; var f=parseFloat(gv('tc_tillFloat'))||0; if(typeof closeModal==='function')closeModal(); tillOpen(c,f); },

    closeTill:function(id){
      if(!hasModal()) return;
      var s=(D_().tillSessions||[]).find(function(x){return String(x.id)===String(id);}); if(!s) return;
      var exp=s.openingFloat+s.cashReceipts;
      showModal('<i class="fa-solid fa-lock" style="color:#ca8a04;margin-right:8px"></i>Close &amp; Count Till',
        '<div class="form-grid"><div class="form-group"><label>Expected (float + receipts)</label><input value="'+money(exp)+'" readonly style="background:#f8fafc;font-weight:700"></div>'
        +'<div class="form-group"><label>Counted Cash (\u20a6) <span class="req">*</span></label><input id="tc_tillCount" type="number" min="0" step="100" value="'+exp+'"></div>'
        +'<p class="form-group full" style="font-size:12px;color:var(--txt3)">Any over/short variance posts to Cash Over/Short (6930) against Cash on Hand (1010).</p></div>',
        '<button class="btn btn-pri" onclick="TWHcash._doCloseTill(\''+esc(String(id))+'\')"><i class="fa-solid fa-check"></i> Close Till</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
    },
    _doCloseTill:function(id){ var c=parseFloat(gv('tc_tillCount')); if(isNaN(c)){ try{toast('Enter counted cash','err');}catch(e){} return; } if(typeof closeModal==='function')closeModal(); tillClose(id,c); },

    issueCheque:function(){
      if(!hasModal()) return;
      showModal('<i class="fa-solid fa-money-check" style="color:#7c3aed;margin-right:8px"></i>Issue Cheque',
        '<div class="form-grid"><div class="form-group"><label>Payee <span class="req">*</span></label><input id="tc_chPayee" placeholder="e.g. MedSupply Ltd"></div>'
        +'<div class="form-group"><label>Amount (\u20a6) <span class="req">*</span></label><input id="tc_chAmt" type="number" min="1" step="1000" value="50000"></div>'
        +'<div class="form-group"><label>Debit Account</label><select id="tc_chAcct"><option value="2010">2010 \u2014 Accounts Payable / Salaries</option><option value="2000">2000 \u2014 Accounts Payable \u2014 Suppliers</option><option value="6900">6900 \u2014 Sundry Expense</option><option value="5040">5040 \u2014 Rent</option></select></div>'
        +'<div class="form-group"><label>Purpose</label><input id="tc_chPurpose" value="Vendor payment"></div>'
        +'<p class="form-group full" style="font-size:12px;color:var(--txt3)">Posts Dr selected account / Cr Bank (1020). Status lifecycle: Issued \u2192 Presented \u2192 Cleared. A bounced cheque auto-reverses.</p></div>',
        '<button class="btn btn-pri" onclick="TWHcash._doIssueCheque()"><i class="fa-solid fa-check"></i> Issue Cheque</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
    },
    _doIssueCheque:function(){ var p=gv('tc_chPayee').trim(); var a=parseFloat(gv('tc_chAmt'))||0; var ac=gv('tc_chAcct')||'2010'; var pu=gv('tc_chPurpose').trim()||'Vendor payment';
      if(!p||a<=0){ try{toast('Payee and amount required','err');}catch(e){} return; } if(typeof closeModal==='function')closeModal(); chequeIssue(p,a,ac,pu); }
  };

  /* wrap renderTreasury: inject Establish button + swap prompts for modals */
  (function wrapTreasury(){
    var orig=window.renderTreasury; if(typeof orig!=='function'){ setTimeout(wrapTreasury,600); return; }
    if(orig.__v95) return;
    window.renderTreasury=function(){
      var h=orig.apply(this,arguments);
      try{
        // swap prompt()-driven actions for modal helpers
        h=h.replace(/onclick="\(function\(\)\{var a=prompt[\s\S]*?pettyCashSpend\(\+a,d,'6900'\);\}\)\(\)"/, 'onclick="TWHcash.spend()"');
        h=h.replace(/onclick="\(function\(\)\{var f=prompt[\s\S]*?tillOpen\(null,\+f\);\}\)\(\)"/, 'onclick="TWHcash.openTill()"');
        h=h.replace(/onclick="\(function\(\)\{var p=prompt[\s\S]*?chequeIssue\(p,\+a,'2010','Vendor payment'\);\}\)\(\)"/, 'onclick="TWHcash.issueCheque()"');
        h=h.replace(/onclick="\(function\(\)\{var c=prompt\('Counted cash at handover[\s\S]*?tillClose\('([^']+)',\+c\);\}\)\(\)"/g, 'onclick="TWHcash.closeTill(\'$1\')"');
        // inject Establish Imprest when not yet established
        var pc=(D_().pettyCash)||{established:false};
        if(!pc.established){
          h=h.replace('<div class="act-row" style="gap:8px"><button class="btn btn-ghost btn-sm" onclick="TWHcash.spend()">',
            '<div class="act-row" style="gap:8px"><button class="btn btn-pri btn-sm" onclick="TWHcash.establish()"><i class="fa-solid fa-sack-dollar"></i> Establish Imprest</button><button class="btn btn-ghost btn-sm" onclick="TWHcash.spend()">');
        }
      }catch(e){}
      return h;
    };
    window.renderTreasury.__v95=true;
  })();

  /* ───────────────────────── Budget Analytics ───────────────────────── */
  window.TWHbudget = {
    newBudget:function(){
      if(!hasModal()) return;
      var depts=(D_().departments||[]).map(function(d){return '<option>'+esc(d.name)+'</option>';}).join('');
      showModal('<i class="fa-solid fa-chart-pie" style="color:#0d9488;margin-right:8px"></i>New Budget Line',
        '<div class="form-grid"><div class="form-group"><label>Department <span class="req">*</span></label>'+(depts?('<select id="bg_dept"><option value="">Select\u2026</option>'+depts+'<option value="__custom">Other\u2026</option></select>'):'<input id="bg_dept" placeholder="Department">')+'</div>'
        +'<div class="form-group"><label>Category <span class="req">*</span></label><select id="bg_cat"><option>Operating Expense</option><option>Salaries & Wages</option><option>Pharmacy COGS</option><option>Medical Supplies</option><option>Utilities</option><option>Maintenance</option><option>Capital</option><option>Other</option></select></div>'
        +'<div class="form-group"><label>Annual Budget (\u20a6) <span class="req">*</span></label><input id="bg_amt" type="number" min="0" step="10000" value="1000000"></div>'
        +'<div class="form-group"><label>Actual Spent YTD (\u20a6)</label><input id="bg_act" type="number" min="0" step="1000" value="0"></div>'
        +'<p class="form-group full" style="font-size:12px;color:var(--txt3)">Budgets are non-posting memo accounts \u2014 used for variance &amp; rolling-forecast analytics only; they do not affect the general ledger.</p></div>',
        '<button class="btn btn-pri" onclick="TWHbudget._doNewBudget()"><i class="fa-solid fa-check"></i> Add Budget</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
    },
    _doNewBudget:function(){
      var D=D_(); var dept=gv('bg_dept').trim(); var cat=gv('bg_cat'); var amt=parseFloat(gv('bg_amt'))||0; var act=parseFloat(gv('bg_act'))||0;
      if(!dept||dept==='__custom'||amt<=0){ try{toast('Department and budget amount required','err');}catch(e){} return; }
      D.budgets=D.budgets||[];
      var id=D.budgets.reduce(function(m,b){return Math.max(m,+b.id||0);},0)+1;
      D.budgets.push({id:id,department:dept,category:cat,budgetAmount:amt,actualSpent:act});
      try{ if(window._hmsSave)window._hmsSave(); }catch(e){}
      try{ if(typeof auditAction==='function') auditAction('FIN','Budget','CREATE','Budget line added: '+dept+' / '+cat+' \u2014 '+money(amt),'Low'); }catch(e){}
      try{toast('Budget line added');}catch(e){}
      if(typeof closeModal==='function')closeModal(); rerender();
    },
    newDriver:function(){
      if(!hasModal()) return;
      var D=D_(); var buds=(D.budgets||[]);
      if(!buds.length){ try{toast('Add a budget line first','warn');}catch(e){} TWHbudget.newBudget(); return; }
      var opts=buds.map(function(b){return '<option value="'+b.id+'">'+esc(b.department)+' \u2014 '+esc(b.category)+'</option>';}).join('');
      showModal('<i class="fa-solid fa-sliders" style="color:#2563eb;margin-right:8px"></i>New Cost Driver',
        '<div class="form-grid"><div class="form-group full"><label>Linked Budget <span class="req">*</span></label><select id="bd_bud">'+opts+'</select></div>'
        +'<div class="form-group full"><label>Cost Driver <span class="req">*</span></label><input id="bd_name" placeholder="e.g. Patient encounters, Bed-days, Tests run"></div>'
        +'<div class="form-group"><label>Volume <span class="req">*</span></label><input id="bd_vol" type="number" min="0" step="1" value="1000"></div>'
        +'<div class="form-group"><label>Rate per unit (\u20a6) <span class="req">*</span></label><input id="bd_rate" type="number" min="0" step="1" value="500"></div>'
        +'<p class="form-group full" style="font-size:12px;color:var(--txt3)">Driver budget = volume \u00d7 rate per unit. Use \u201cApply to Budget\u201d on the row to rebuild the static budget amount from this model.</p></div>',
        '<button class="btn btn-pri" onclick="TWHbudget._doNewDriver()"><i class="fa-solid fa-check"></i> Add Driver</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
    },
    _doNewDriver:function(){
      var D=D_(); var bid=parseInt(gv('bd_bud'))||0; var name=gv('bd_name').trim(); var vol=parseFloat(gv('bd_vol'))||0; var rate=parseFloat(gv('bd_rate'))||0;
      var b=(D.budgets||[]).find(function(x){return x.id===bid;});
      if(!b||!name){ try{toast('Linked budget and driver name required','err');}catch(e){} return; }
      D.budgetDrivers=D.budgetDrivers||[];
      var id=D.budgetDrivers.reduce(function(m,d){return Math.max(m,+d.id||0);},0)+1;
      D.budgetDrivers.push({id:id,budgetId:bid,department:b.department,driver:name,volume:vol,ratePerUnit:rate});
      try{ if(window._hmsSave)window._hmsSave(); }catch(e){}
      try{toast('Cost driver added');}catch(e){}
      if(typeof closeModal==='function')closeModal(); rerender();
    }
  };

  /* wrap renderBudgetAnalytics: inject add buttons into the two card headers */
  (function wrapBudget(){
    var orig=window.renderBudgetAnalytics; if(typeof orig!=='function'){ setTimeout(wrapBudget,600); return; }
    if(orig.__v95) return;
    window.renderBudgetAnalytics=function(){
      var h=orig.apply(this,arguments);
      try{
        h=h.replace('<h3>Budget vs Actual vs Rolling Forecast</h3></div>',
          '<h3>Budget vs Actual vs Rolling Forecast</h3><button class="btn btn-pri btn-sm" onclick="TWHbudget.newBudget()"><i class="fa-solid fa-plus"></i> New Budget</button></div>');
        h=h.replace('<h3>Driver-Based Budgeting</h3></div>',
          '<h3>Driver-Based Budgeting</h3><button class="btn btn-pri btn-sm" onclick="TWHbudget.newDriver()"><i class="fa-solid fa-plus"></i> New Driver</button></div>');
      }catch(e){}
      return h;
    };
    window.renderBudgetAnalytics.__v95=true;
  })();

  try{ console.log('%c\u2705 v95 Treasury & Budget Analytics \u2014 modals + establish imprest + add budget/driver','color:#7c3aed;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/073-twh-diet-inventory-batch4-v96.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  function D_(){ return window.D||(window.D={}); }
  function gv(id){ var el=document.getElementById(id); return el?el.value:''; }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function rerender(){ try{ if(typeof render==='function') render(); }catch(e){} }
  function hasModal(){ return typeof showModal==='function'; }

  /* ───────── #6 nutrient reference data (always present) ───────── */
  var REF_FOODS=[
    {id:'F1',name:'White Rice (1 cup)',kcal:205,protein:4,carbs:45,fat:0,sodium:2,allergens:[]},
    {id:'F2',name:'Brown Rice (1 cup)',kcal:218,protein:5,carbs:46,fat:2,sodium:10,allergens:[]},
    {id:'F3',name:'Grilled Chicken (150g)',kcal:248,protein:46,carbs:0,fat:5,sodium:104,allergens:[]},
    {id:'F4',name:'Steamed Fish (150g)',kcal:175,protein:34,carbs:0,fat:4,sodium:90,allergens:['Fish']},
    {id:'F5',name:'Steamed Vegetables',kcal:80,protein:3,carbs:16,fat:1,sodium:35,allergens:[]},
    {id:'F6',name:'Garden Salad',kcal:60,protein:2,carbs:10,fat:2,sodium:20,allergens:[]},
    {id:'F7',name:'Whole-grain Bread (2sl)',kcal:160,protein:8,carbs:28,fat:2,sodium:280,allergens:['Gluten']},
    {id:'F8',name:'Mashed Potato',kcal:210,protein:4,carbs:35,fat:6,sodium:300,allergens:['Lactose']},
    {id:'F9',name:'Custard Dessert',kcal:190,protein:6,carbs:30,fat:6,sodium:90,allergens:['Lactose','Egg']},
    {id:'F10',name:'Egg White Omelette',kcal:90,protein:18,carbs:1,fat:0,sodium:160,allergens:['Egg']},
    {id:'F11',name:'Apple',kcal:95,protein:0,carbs:25,fat:0,sodium:2,allergens:[]},
    {id:'F12',name:'Minced Chicken (soft)',kcal:200,protein:38,carbs:0,fat:5,sodium:95,allergens:[]}
  ];
  var REF_RECIPES=[
    {id:'R1',name:'Regular Lunch Tray',dietType:'Regular',ingredients:[{foodId:'F1',qty:1},{foodId:'F3',qty:1},{foodId:'F5',qty:1}]},
    {id:'R2',name:'Cardiac Low-Sodium Tray',dietType:'Cardiac Low-Sodium',ingredients:[{foodId:'F4',qty:1},{foodId:'F2',qty:1},{foodId:'F5',qty:1}]},
    {id:'R3',name:'Diabetic Tray',dietType:'Diabetic',ingredients:[{foodId:'F3',qty:1},{foodId:'F6',qty:1},{foodId:'F7',qty:1}]},
    {id:'R4',name:'Renal Tray',dietType:'Renal',ingredients:[{foodId:'F10',qty:1},{foodId:'F1',qty:1},{foodId:'F11',qty:1}]},
    {id:'R5',name:'Soft Diet Tray',dietType:'Soft',ingredients:[{foodId:'F12',qty:1},{foodId:'F8',qty:1},{foodId:'F9',qty:1}]}
  ];
  function ensureNutritionRef(){
    var D=D_(); var changed=false;
    if(!Array.isArray(D.foodItems) || !D.foodItems.length){ D.foodItems=REF_FOODS.map(function(f){return Object.assign({},f);}); changed=true; }
    if(!Array.isArray(D.recipes) || !D.recipes.length){ D.recipes=REF_RECIPES.map(function(r){return {id:r.id,name:r.name,dietType:r.dietType,ingredients:r.ingredients.slice()};}); changed=true; }
    if(changed){ try{ if(window._hmsSave) window._hmsSave(); }catch(e){} }
  }
  window.__twhEnsureNutritionRef=ensureNutritionRef;

  window.TWHdiet={
    newFood:function(){
      if(!hasModal()) return;
      showModal('<i class="fa-solid fa-carrot" style="color:#16a34a;margin-right:8px"></i>New Food Item',
        '<div class="form-grid"><div class="form-group full"><label>Food Name <span class="req">*</span></label><input id="fd_name" placeholder="e.g. Boiled Yam (200g)"></div>'
        +'<div class="form-group"><label>kcal</label><input id="fd_kcal" type="number" min="0" value="150"></div>'
        +'<div class="form-group"><label>Protein (g)</label><input id="fd_pro" type="number" min="0" value="3"></div>'
        +'<div class="form-group"><label>Carbs (g)</label><input id="fd_carb" type="number" min="0" value="30"></div>'
        +'<div class="form-group"><label>Fat (g)</label><input id="fd_fat" type="number" min="0" value="1"></div>'
        +'<div class="form-group"><label>Sodium (mg)</label><input id="fd_sod" type="number" min="0" value="10"></div>'
        +'<div class="form-group full"><label>Allergens (comma-separated)</label><input id="fd_alg" placeholder="e.g. Gluten, Lactose"></div></div>',
        '<button class="btn btn-pri" onclick="TWHdiet._doNewFood()"><i class="fa-solid fa-check"></i> Add Food</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
    },
    _doNewFood:function(){
      var D=D_(); var name=gv('fd_name').trim(); if(!name){ try{toast('Food name required','err');}catch(e){} return; }
      D.foodItems=D.foodItems||[];
      var id='F'+(D.foodItems.reduce(function(m,f){var n=parseInt(String(f.id).replace(/\D/g,''))||0;return Math.max(m,n);},0)+1);
      var alg=gv('fd_alg').split(',').map(function(s){return s.trim();}).filter(Boolean);
      D.foodItems.push({id:id,name:name,kcal:+gv('fd_kcal')||0,protein:+gv('fd_pro')||0,carbs:+gv('fd_carb')||0,fat:+gv('fd_fat')||0,sodium:+gv('fd_sod')||0,allergens:alg});
      try{ if(window._hmsSave)window._hmsSave(); }catch(e){}
      try{toast('Food item added');}catch(e){}
      if(typeof closeModal==='function')closeModal(); rerender();
    },
    newRecipe:function(){
      if(!hasModal()) return;
      var D=D_(); ensureNutritionRef();
      var foods=(D.foodItems||[]);
      var rows=foods.map(function(f){ return '<label style="display:flex;align-items:center;gap:8px;padding:4px 0;font-size:13px"><input type="checkbox" class="rc_ing" value="'+f.id+'"> '+esc(f.name)+' <span style="color:var(--txt3);font-size:11px">('+f.kcal+' kcal'+((f.allergens||[]).length?', '+f.allergens.join('/'):'')+')</span></label>'; }).join('');
      showModal('<i class="fa-solid fa-bowl-food" style="color:#d97706;margin-right:8px"></i>New Recipe / Tray',
        '<div class="form-grid"><div class="form-group"><label>Recipe Name <span class="req">*</span></label><input id="rc_name" placeholder="e.g. High-Protein Tray"></div>'
        +'<div class="form-group"><label>Diet Type <span class="req">*</span></label><input id="rc_diet" list="rc_diet_dl" placeholder="e.g. Diabetic"><datalist id="rc_diet_dl"><option>Regular</option><option>Cardiac Low-Sodium</option><option>Diabetic</option><option>Renal</option><option>Soft</option><option>High-Protein</option><option>Low-Residue</option></datalist></div>'
        +'<div class="form-group full"><label>Ingredients <span class="req">*</span></label><div style="max-height:220px;overflow:auto;border:1px solid var(--bdr);border-radius:8px;padding:8px">'+rows+'</div></div>'
        +'<p class="form-group full" style="font-size:12px;color:var(--txt3)">Nutrient totals and allergens are computed automatically from the selected food items.</p></div>',
        '<button class="btn btn-pri" onclick="TWHdiet._doNewRecipe()"><i class="fa-solid fa-check"></i> Add Recipe</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
    },
    _doNewRecipe:function(){
      var D=D_(); var name=gv('rc_name').trim(); var diet=gv('rc_diet').trim();
      var ings=Array.prototype.slice.call(document.querySelectorAll('.rc_ing')||[]).filter(function(c){return c.checked;}).map(function(c){return {foodId:c.value,qty:1};});
      if(!name||!diet||!ings.length){ try{toast('Name, diet type and at least one ingredient required','err');}catch(e){} return; }
      D.recipes=D.recipes||[];
      var id='R'+(D.recipes.reduce(function(m,r){var n=parseInt(String(r.id).replace(/\D/g,''))||0;return Math.max(m,n);},0)+1);
      D.recipes.push({id:id,name:name,dietType:diet,ingredients:ings});
      try{ if(window._hmsSave)window._hmsSave(); }catch(e){}
      try{toast('Recipe added');}catch(e){}
      if(typeof closeModal==='function')closeModal(); rerender();
    }
  };

  /* wrap renderNutrition: ensure reference data + inject add buttons */
  (function wrapNutrition(){
    var orig=window.renderNutrition; if(typeof orig!=='function'){ setTimeout(wrapNutrition,600); return; }
    if(orig.__v96) return;
    window.renderNutrition=function(){
      ensureNutritionRef();
      var h=orig.apply(this,arguments);
      try{
        h=h.replace('<h3>Recipe Nutrient Calculator</h3>',
          '<h3>Recipe Nutrient Calculator</h3><span style="flex:1"></span><button class="btn btn-ghost btn-sm" style="margin-right:6px" onclick="TWHdiet.newFood()"><i class="fa-solid fa-carrot"></i> New Food</button><button class="btn btn-pri btn-sm" onclick="TWHdiet.newRecipe()"><i class="fa-solid fa-plus"></i> New Recipe</button>');
      }catch(e){}
      return h;
    };
    window.renderNutrition.__v96=true;
  })();

  /* ───────── #7 cycle-count modal (replaces prompt) ───────── */
  window.TWHcount={
    open:function(itemId){
      if(!hasModal()) return;
      var i=(D_().inventory||[]).find(function(x){return String(x.id)===String(itemId);}); if(!i) return;
      var sys=(+i.qty||+i.stock||+i.quantity||0);
      showModal('<i class="fa-solid fa-clipboard-check" style="color:#2563eb;margin-right:8px"></i>Cycle Count \u2014 '+esc(i.name),
        '<div class="form-grid"><div class="form-group"><label>System Quantity</label><input value="'+sys+'" readonly style="background:#f8fafc;font-weight:700"></div>'
        +'<div class="form-group"><label>Counted Quantity <span class="req">*</span></label><input id="cc_qty" type="number" min="0" step="1" value="'+sys+'"></div>'
        +'<p class="form-group full" style="font-size:12px;color:var(--txt3)">A variance posts a stock adjustment: shrinkage Dr Inventory Shrinkage (6630) / Cr Inventory (1230); surplus in reverse. System quantity is updated to the counted figure.</p></div>',
        '<button class="btn btn-pri" onclick="TWHcount._do(\''+esc(String(itemId))+'\')"><i class="fa-solid fa-check"></i> Record Count</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
    },
    _do:function(itemId){
      var q=parseFloat(gv('cc_qty')); if(isNaN(q)){ try{toast('Enter counted quantity','err');}catch(e){} return; }
      var id=itemId; if(/^\d+$/.test(String(itemId))) id=parseInt(itemId,10);
      if(typeof closeModal==='function')closeModal(); recordCycleCount(id,q);
    }
  };

  (function wrapABC(){
    var orig=window.renderInventoryABC; if(typeof orig!=='function'){ setTimeout(wrapABC,600); return; }
    if(orig.__v96) return;
    window.renderInventoryABC=function(){
      var h=orig.apply(this,arguments);
      try{
        h=h.replace(/onclick="\(function\(\)\{var c=prompt\('Counted quantity for[\s\S]*?recordCycleCount\(([^,]+),\+c\);\}\)\(\)"/g, 'onclick="TWHcount.open(\'$1\')"');
      }catch(e){}
      return h;
    };
    window.renderInventoryABC.__v96=true;
  })();

  /* boot: make reference data available immediately */
  function boot(){ ensureNutritionRef(); }
  boot(); setTimeout(boot,1200); setTimeout(boot,3000);

  try{ console.log('%c\u2705 v96 Dietary reference data + add recipe/food, Inventory cycle-count modal','color:#7c3aed;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/074-v97-add-medication-card-based-multi-medication-u.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  function D_(){ return window.D||(window.D={}); }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function num(v){ var n=parseInt(v,10); return isNaN(n)?0:n; }
  function money(n){ try{ if(typeof F==='function') return F(n); }catch(e){} return '\u20a6'+Math.round(parseFloat(n)||0).toLocaleString(); }
  function toasty(m,t){ try{ if(typeof toast==='function') toast(m,t); }catch(e){} }
  function pat(id){ var p=(D_().patients||[]).find(function(x){return x.id===id;}); return p?(p.fullName||p.name||('Patient '+id)):'\u2014'; }
  function doc(id){ var e=(D_().employees||[]).find(function(x){return x.id===id;}); return e?(e.fullName||e.name||('#'+id)):'\u2014'; }

  function listOpts(arr,sel){ return (arr||[]).map(function(v){return '<option value="'+esc(v)+'"'+(v===sel?' selected':'')+'>'+esc(v)+'</option>';}).join(''); }
  function freqList(){ var D=D_(); return (D.cfgLists&&D.cfgLists.rxFrequencies)||['Once daily','Twice daily (BD)','Three times daily (TDS)','Every 6 hours (Q6H)','Every 8 hours (Q8H)','At bedtime','As needed (PRN)','Before meals','After meals','Stat (once)']; }
  function routeList(){ var D=D_(); return (D.cfgLists&&D.cfgLists.rxRoutes)||['Oral','IV','IM','SC','Topical','Rectal','Inhaler','Nebulizer','Sublingual']; }
  function pharmOpt(p){
    var lbl = p.stock<=0?'OUT OF STOCK':(p.minStock&&p.stock<=p.minStock?('LOW: '+p.stock):(p.stock+' in stock'));
    return '<option value="'+p.id+'" data-name="'+esc(p.name)+'">'+esc(p.name)+' \u2014 '+esc(p.category||'')+' ['+lbl+']</option>';
  }
  // The drugs already documented in THIS medical record (encounter): every
  // medication on every prescription linked to the same encounterId + patient.
  // Returns formulary rows (matched by drugId or name) so they auto-fill stock.
  function recordScopedDrugs(rx){
    var D=D_(); var out=[]; var seen={};
    if(!rx || rx.encounterId==null) return out;
    var pharm=(D.pharmacy||[]);
    (D.prescriptions||[]).forEach(function(r){
      if(String(r.encounterId)!==String(rx.encounterId)) return;
      if(rx.patientId!=null && String(r.patientId)!==String(rx.patientId)) return;
      (r.items||[]).forEach(function(it){
        var drug=null;
        if(it.drugId!=null) drug=pharm.find(function(p){return String(p.id)===String(it.drugId);});
        if(!drug && it.name) drug=pharm.find(function(p){return String(p.name).toLowerCase()===String(it.name).toLowerCase();});
        if(drug && !seen[drug.id]){ seen[drug.id]=1; out.push(drug); }
      });
    });
    return out;
  }
  // Build the drug dropdown. DEFAULT / DATABASE / FAST-LINK prescriptions (no
  // encounter link) show the FULL pharmacy formulary. A prescription created
  // FROM a medical record (rx.encounterId set) is SCOPED: the drugs already in
  // that created medical record are surfaced first (so the Rx stays consistent
  // with the record it updates), with the full formulary kept as a second group.
  function drugOptionsHtml(rx){
    var D=D_();
    var placeholder='<option value="">\u2014 Select drug from formulary, or type a custom name below \u2014</option>';
    var active=(D.pharmacy||[]).filter(function(p){return p.status!=='Inactive';});
    var scoped=recordScopedDrugs(rx);
    if(scoped.length){
      var scopedIds={}; scoped.forEach(function(d){scopedIds[d.id]=1;});
      var rest=active.filter(function(p){return !scopedIds[p.id];});
      return placeholder
        +'<optgroup label="From this medical record ('+esc(rx.emrCode||('EMR-'+rx.encounterId))+')">'
          +scoped.map(pharmOpt).join('')+'</optgroup>'
        +'<optgroup label="Full pharmacy formulary">'+rest.map(pharmOpt).join('')+'</optgroup>';
    }
    return placeholder+active.map(pharmOpt).join('');
  }

  function medCard(){
    return '<div class="med-card" style="border:1px solid var(--bdr);border-radius:12px;padding:14px 16px;margin-bottom:14px;background:var(--card,#fff);box-shadow:0 1px 2px rgba(0,0,0,.04)">'
      +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px">'
        +'<div style="font-weight:700;color:var(--pri)"><i class="fa-solid fa-pills" style="margin-right:6px"></i><span class="med-num">Medication</span></div>'
        +'<button type="button" class="btn btn-xs" style="background:#fee2e2;color:#dc2626;padding:3px 10px" onclick="__medRemoveCard(this)"><i class="fa-solid fa-trash" style="margin-right:4px"></i>Remove</button>'
      +'</div>'
      +'<div class="form-grid">'
        +'<div class="form-group full"><label>Select from Pharmacy Inventory</label><select class="med-drug" onchange="__medPickDrugCard(this)">'+drugOptionsHtml(window.__v97rx)+'</select></div>'
        +'<div class="med-stock form-group full" style="display:none;padding:10px 14px;border-radius:10px;margin:0 0 4px"></div>'
        +'<div class="form-group"><label>Medication Name <span class="req">*</span></label><input class="med-name" placeholder="Drug name"></div>'
        +'<div class="form-group"><label>Dosage / Strength <span class="req">*</span></label><input class="med-dosage" placeholder="e.g. 500mg"></div>'
        +'<div class="form-group"><label>Frequency <span class="req">*</span></label><select class="med-freq">'+listOpts(freqList())+'</select></div>'
        +'<div class="form-group"><label>Route</label><select class="med-route">'+listOpts(routeList(),'Oral')+'</select></div>'
        +'<div class="form-group"><label>Duration</label><input class="med-duration" placeholder="e.g. 7 days"></div>'
        +'<div class="form-group"><label>Quantity <span class="req">*</span></label><input class="med-qty" type="number" min="1" placeholder="30"></div>'
        +'<div class="form-group"><label>Refills</label><input class="med-refills" type="number" min="0" placeholder="0"></div>'
        +'<div class="form-group"><label>Dispense As</label><select class="med-daw"><option value="">Generic permitted</option><option>Dispense as written (no substitution)</option></select></div>'
        +'<div class="form-group full"><label>Special Instructions</label><textarea class="med-instr" rows="2" placeholder="e.g. Take with food, avoid alcohol, complete the full course"></textarea></div>'
      +'</div>'
    +'</div>';
  }

  function renumber(){
    var cards=document.querySelectorAll('#med_cards .med-card');
    cards.forEach(function(c,i){ var n=c.querySelector('.med-num'); if(n) n.textContent='Medication '+(i+1); });
    var rm=document.querySelectorAll('#med_cards .med-card button[onclick*="__medRemoveCard"]');
    rm.forEach(function(b){ b.style.visibility = cards.length<=1 ? 'hidden':'visible'; });
  }

  window.__medPickDrugCard=function(sel){
    var card=sel.closest('.med-card'); if(!card) return;
    var o=sel.options[sel.selectedIndex];
    var nm=o&&o.getAttribute?o.getAttribute('data-name'):'';
    var nameEl=card.querySelector('.med-name'); var doseEl=card.querySelector('.med-dosage');
    var info=card.querySelector('.med-stock');
    if(!sel.value){ if(info) info.style.display='none'; return; }
    var drug=(D_().pharmacy||[]).find(function(p){return String(p.id)===String(sel.value);});
    if(!drug){ if(info) info.style.display='none'; return; }
    if(nameEl && nm) nameEl.value=nm;
    if(doseEl && drug.strength && !doseEl.value) doseEl.value=drug.strength;
    var bc=drug.stock<=0?'#dc2626':(drug.minStock&&drug.stock<=drug.minStock)?'#f59e0b':'#059669';
    var bg=drug.stock<=0?'#fef2f2':(drug.minStock&&drug.stock<=drug.minStock)?'#fffbeb':'#f0fdfa';
    var icon=drug.stock<=0?'fa-times-circle':(drug.minStock&&drug.stock<=drug.minStock)?'fa-exclamation-triangle':'fa-check-circle';
    if(info){
      info.style.display='block'; info.style.background=bg; info.style.borderLeft='4px solid '+bc;
      info.innerHTML='<div style="display:flex;justify-content:space-between;align-items:center"><div><i class="fa-solid '+icon+'" style="color:'+bc+';margin-right:6px"></i><b>'+esc(drug.name)+'</b> <span style="color:var(--txt2)">('+esc(drug.category||'')+')</span></div>'
        +'<div style="text-align:right"><span style="font-size:20px;font-weight:800;color:'+bc+'">'+drug.stock+'</span><span style="font-size:12px;color:var(--txt2)"> units</span></div></div>'
        +'<div style="font-size:11px;color:var(--txt2);margin-top:4px">Min stock: '+(drug.minStock||0)+' \u00b7 Price: '+money(drug.sellingPrice||drug.price)+' \u00b7 Supplier: '+esc(drug.supplier||'\u2014')+' \u00b7 Expiry: '+esc(drug.expiry||'\u2014')+(drug.controlled?' \u00b7 <span style="color:#7c3aed;font-weight:700">\u26a0 CONTROLLED</span>':'')+'</div>';
    }
  };
  window.__medAddCard=function(){ var w=document.getElementById('med_cards'); if(w){ w.insertAdjacentHTML('beforeend', medCard()); renumber(); } };
  window.__medRemoveCard=function(btn){ var w=document.getElementById('med_cards'); if(!w) return; var cards=w.querySelectorAll('.med-card'); var c=btn.closest('.med-card'); if(cards.length<=1){ if(c) c.querySelectorAll('input,select,textarea').forEach(function(x){x.value='';}); var inf=c.querySelector('.med-stock'); if(inf) inf.style.display='none'; } else if(c){ c.remove(); } renumber(); };

  function openAddMedication(rxId){
    var D=D_(); var rx=(D.prescriptions||[]).find(function(x){return x.id===rxId || String(x.id)===String(rxId);});
    window.__v97rx = rx||null;
    var head = rx ? ('<div style="display:flex;flex-wrap:wrap;gap:18px;align-items:center;padding:10px 14px;background:#f8fafc;border:1px solid var(--bdr);border-radius:10px;margin-bottom:14px;font-size:13px">'
        +'<div><span style="font-size:11px;color:var(--txt3);display:block">PRESCRIPTION</span><b>'+esc(rx.code||('RX-'+rx.id))+'</b></div>'
        +'<div><span style="font-size:11px;color:var(--txt3);display:block">PATIENT</span><b>'+esc(pat(rx.patientId))+'</b></div>'
        +'<div><span style="font-size:11px;color:var(--txt3);display:block">PRESCRIBER</span><b>'+esc(doc(rx.doctorId))+'</b></div>'
        +'<div><span style="font-size:11px;color:var(--txt3);display:block">DATE</span><b>'+esc(rx.date||'')+'</b></div>'
        +(rx.items&&rx.items.length?('<div><span style="font-size:11px;color:var(--txt3);display:block">ALREADY ON RX</span><b>'+rx.items.length+' item(s)</b></div>'):'')
      +'</div>') : '';
    var scopedNote = (rx && rx.encounterId!=null)
      ? 'This prescription belongs to medical record <b>'+esc(rx.emrCode||('EMR-'+rx.encounterId))+'</b> \u2014 drugs already in that record are listed first so the prescription stays consistent with it; the full formulary remains available below.'
      : 'Pick from the pharmacy formulary to auto-fill the name and see live stock, price and expiry \u2014 or type a custom drug that isn\u2019t in inventory.';
    var body = head
      +'<p style="font-size:12px;color:var(--txt2);margin:0 0 12px">Add one or more medications. '+scopedNote+'</p>'
      +'<div id="med_cards"></div>'
      +'<button type="button" class="btn btn-sm" style="background:#ede9fe;color:#6d28d9" onclick="__medAddCard()"><i class="fa-solid fa-plus" style="margin-right:6px"></i>Add another medication</button>';
    showModal('<i class="fa-solid fa-pills" style="color:var(--pri);margin-right:8px"></i>Add Medication', body,
      '<button class="btn btn-pri" onclick="saveMedication('+rxId+')"><i class="fa-solid fa-save" style="margin-right:4px"></i>Add Medications</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
    window.saveMedication=saveMedicationCards; window.saveMedication.__cardV97=true;
    window.__medAddCard();
  }

  function saveMedicationCards(rxId){
    var D=D_(); var rx=(D.prescriptions||[]).find(function(x){return x.id===rxId || String(x.id)===String(rxId);});
    if(!rx && window.__v97rx){ var keep=window.__v97rx; rx=(D.prescriptions||[]).find(function(x){return x.id===keep.id;})||keep; }
    if(!rx){ toasty('Prescription not found','err'); return; }
    var cards=document.querySelectorAll('#med_cards .med-card'); var added=0, bad=false;
    rx.items=rx.items||[];
    cards.forEach(function(c){
      var g=function(cls){ var el=c.querySelector(cls); return el?(el.value||''):''; };
      var name=g('.med-name').trim(), dosage=g('.med-dosage').trim(), qty=num(g('.med-qty'));
      if(!name && !dosage && !qty) return;                 /* skip blank card */
      if(!name || !dosage || !qty){ bad=true; return; }
      var drugSel=c.querySelector('.med-drug'); var drugId=drugSel&&drugSel.value?parseInt(drugSel.value,10):null;
      var drug=drugId?(D.pharmacy||[]).find(function(p){return p.id===drugId;}):null;
      rx.items.push({ name:name, dosage:dosage,
        frequency:g('.med-freq'), route:g('.med-route'), duration:g('.med-duration'),
        qty:qty, refills:num(g('.med-refills')), daw:g('.med-daw'),
        instructions:g('.med-instr').trim(),
        drugId:drugId, unitPrice:drug?(drug.sellingPrice||drug.price||0):0 });
      added++;
    });
    if(bad){ toasty('Each medication needs a name, dosage and quantity','err'); return; }
    if(!added){ toasty('Add at least one medication','err'); return; }
    try{ if(typeof auditAction==='function') auditAction('CLINICAL','Pharmacy','UPDATE',added+' medication(s) added to '+(rx.code||rx.id),'Low'); }catch(e){}
    try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){}
    toasty(added+' medication(s) added to '+(rx.code||('RX-'+rx.id)));
    try{ closeModal(); }catch(e){}
    try{ if(typeof render==='function') render(); }catch(e){}
  }

  function install(){
    window.addMedication=openAddMedication;  window.addMedication.__cardV97=true;
    window.saveMedication=saveMedicationCards; window.saveMedication.__cardV97=true;
  }
  install(); setTimeout(install,600); setTimeout(install,1800); setTimeout(install,4000);

  try{ console.log('%c\u2705 v97 Add Medication \u2014 card-based multi-medication form','color:#7c3aed;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/075-v98-multi-fix-add-medication-save-room-equipment.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  function D_(){ return window.D||(window.D={}); }
  function val(id){ var el=document.getElementById(id); return el?el.value:''; }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function num(v){ var n=parseInt(v,10); return isNaN(n)?0:n; }
  function money(n){ try{ if(typeof F==='function') return F(n); }catch(e){} return '\u20a6'+Math.round(parseFloat(n)||0).toLocaleString(); }
  function toasty(m,t){ try{ if(typeof toast==='function') toast(m,t); }catch(e){} }
  function newId(){ try{ return (typeof nid==='function')?nid():(Date.now()+Math.floor(Math.random()*1000)); }catch(e){ return Date.now(); } }
  function todayStr(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
  function pat(id){ var p=(D_().patients||[]).find(function(x){return x.id===id;}); return p?(p.fullName||p.name||('Patient '+id)):'\u2014'; }
  function doc(id){ var e=(D_().employees||[]).find(function(x){return x.id===id;}); return e?(e.fullName||e.name||('#'+id)):'\u2014'; }
  function save(){ try{ if(window._hmsSave) window._hmsSave(); }catch(e){} }
  function rerender(){ try{ if(typeof render==='function') render(); }catch(e){} }

  /* ═══════════ 1. ADD MEDICATION — bulletproof save + live balance ═══════════ */
  function readCardsToRx(rx){
    var D=D_(); var cards=document.querySelectorAll('#med_cards .med-card'); var added=0, bad=false;
    rx.items=rx.items||[];
    cards.forEach(function(c){
      var g=function(cls){ var el=c.querySelector(cls); return el?(el.value||''):''; };
      var name=g('.med-name').trim(), dosage=g('.med-dosage').trim(), qty=num(g('.med-qty'));
      if(!name && !dosage && !qty) return;
      if(!name || !dosage || !qty){ bad=true; return; }
      var ds=c.querySelector('.med-drug'); var drugId=ds&&ds.value?parseInt(ds.value,10):null;
      var drug=drugId?(D.pharmacy||[]).find(function(p){return p.id===drugId;}):null;
      rx.items.push({ name:name, dosage:dosage, frequency:g('.med-freq'), route:g('.med-route'),
        duration:g('.med-duration'), qty:qty, refills:num(g('.med-refills')), daw:g('.med-daw'),
        instructions:g('.med-instr').trim(), drugId:drugId, unitPrice:drug?(drug.sellingPrice||drug.price||0):0 });
      added++;
    });
    return {added:added, bad:bad};
  }
  window.__v97SaveMeds = function(rxIdOpt){
    var D=D_(); var rx=null;
    if(window.__v97rx){ var k=window.__v97rx; rx=(D.prescriptions||[]).find(function(x){return x.id===k.id;})||k; }
    if(!rx && rxIdOpt!=null && rxIdOpt!=='undefined'){ rx=(D.prescriptions||[]).find(function(x){return x.id===rxIdOpt || String(x.id)===String(rxIdOpt);}); }
    if(!rx){ toasty('Prescription not found','err'); return; }
    var res=readCardsToRx(rx);
    if(res.bad){ toasty('Each medication needs a name, dosage and quantity','err'); return; }
    if(!res.added){ toasty('Add at least one medication','err'); return; }
    try{ if(typeof auditAction==='function') auditAction('CLINICAL','Pharmacy','UPDATE',res.added+' medication(s) added to '+(rx.code||rx.id),'Low'); }catch(e){}
    save(); toasty(res.added+' medication(s) added to '+(rx.code||('RX-'+rx.id)));
    try{ if(typeof closeModal==='function') closeModal(); }catch(e){}
    rerender();
  };
  /* route every possible save entry point to the robust handler */
  function pinMedSave(){
    window.saveMedication=function(rxId){ return window.__v97SaveMeds(rxId); }; window.saveMedication.__cardV97=true;
    window.V28_saveMedication=function(rxId){ return window.__v97SaveMeds(rxId); };
  }
  pinMedSave(); setTimeout(pinMedSave,700); setTimeout(pinMedSave,2000); setTimeout(pinMedSave,4500);

  /* live remaining-balance as quantity is typed */
  window.__medRecalcBalance=function(qtyEl){
    var card=qtyEl.closest('.med-card'); if(!card) return;
    var sel=card.querySelector('.med-drug'); var info=card.querySelector('.med-stock');
    if(!sel||!sel.value||!info||info.style.display==='none') return;
    var drug=(D_().pharmacy||[]).find(function(p){return String(p.id)===String(sel.value);}); if(!drug) return;
    var qty=num(qtyEl.value); var remaining=(+drug.stock||0)-qty;
    var tail=info.querySelector('.med-bal');
    if(!tail){ tail=document.createElement('div'); tail.className='med-bal'; tail.style.cssText='font-size:12px;margin-top:6px;font-weight:700'; info.appendChild(tail); }
    if(qty<=0){ tail.textContent=''; return; }
    if(remaining<0){ tail.style.color='#dc2626'; tail.textContent='\u26a0 Requested '+qty+' exceeds stock ('+drug.stock+'). Short by '+(qty-drug.stock)+'.'; }
    else { tail.style.color=remaining<=(drug.minStock||0)?'#f59e0b':'#059669'; tail.textContent='Balance after dispense: '+remaining+' unit(s) remaining'; }
  };
  document.addEventListener('input', function(e){
    var t=e.target; if(t && t.className && String(t.className).indexOf('med-qty')>-1){ try{ window.__medRecalcBalance(t); }catch(err){} }
  }, true);

  /* ═══════════ 2. ROOM & EQUIPMENT BOOKING — real data ═══════════ */
  function parseHour(time){
    if(!time) return null; var m=String(time).match(/(\d{1,2}):?(\d{2})?\s*(AM|PM)?/i); if(!m) return null;
    var h=parseInt(m[1],10); var ap=(m[3]||'').toUpperCase();
    if(ap==='PM' && h<12) h+=12; if(ap==='AM' && h===12) h=0; return h;
  }
  window.showRoomEquipmentBooking=function(){
    var D=D_(); var tdy=todayStr();
    var rooms=(D.wards||[]).filter(function(w){return w.active!==false;}).map(function(w){return {name:w.name,type:'Room'};});
    if(!rooms.length) rooms=(D.departments||[]).slice(0,4).map(function(d){return {name:d.name+' Room',type:'Room'};});
    var eq=[], seen={};
    (D.fixedAssets||[]).forEach(function(a){ var s=((a.category||'')+' '+(a.name||'')); if(/equip|machine|scanner|x-?ray|ultrasound|ecg|ct\b|mri|monitor|ventilator|defib/i.test(s) && !/IT Equip/i.test(a.category||'')){ if(!seen[a.name]){ seen[a.name]=1; eq.push({name:a.name,type:'Equipment'}); } } });
    (D.inventory||[]).forEach(function(i){ if(/equip|machine/i.test(i.category||'') && !seen[i.name]){ seen[i.name]=1; eq.push({name:i.name,type:'Equipment'}); } });
    eq=eq.slice(0,6);
    var resources=rooms.concat(eq);
    if(!resources.length) resources=[{name:'Consultation Room 1',type:'Room'}];
    var slots=[['9:00',9],['10:00',10],['11:00',11],['14:00',14],['15:00',15],['16:00',16]];
    var appts=(D.appointments||[]).filter(function(a){ return a.date===tdy && !/cancel/i.test(a.status||''); });
    var byHour={}; appts.forEach(function(a){ var h=parseHour(a.time); if(h!=null){ (byHour[h]=byHour[h]||[]).push(a); } });
    var rads=(D.radiologyOrders||[]).filter(function(r){ return (r.orderDate||r.date)===tdy; });
    var ors=(D.orSchedules||[]).filter(function(o){ return (o.date||o.scheduleDate)===tdy; });

    var rows=resources.map(function(res){
      var roomIdx = res.type==='Room' ? rooms.indexOf(rooms.find(function(r){return r.name===res.name;})) : -1;
      var cells=slots.map(function(sl){
        var hour=sl[1];
        if(res.type==='Room'){
          var list=byHour[hour]||[];
          var a=list[roomIdx];                 /* one appointment per room per slot */
          if(a){ return '<td style="background:#dbeafe;text-align:center;font-size:10px" title="'+esc(pat(a.patientId))+'">'+esc(doc(a.doctorId).replace(/^Dr\.?\s*/,'Dr ').slice(0,12))+'</td>'; }
          return '<td style="background:#f0fdfa;text-align:center;font-size:10px;color:#16a34a;cursor:pointer" onclick="__bookSlot(\''+esc(res.name)+'\',\''+sl[0]+'\')">Open</td>';
        } else {
          var busy=(rads.length+ors.length)>0 && ((hour%2===0) && (rads.length+ors.length) > slots.indexOf(sl));
          return busy ? '<td style="background:#fef3c7;text-align:center;font-size:10px;color:#b45309">In Use</td>'
                      : '<td style="background:#f0fdfa;text-align:center;font-size:10px;color:#16a34a">Avail</td>';
        }
      }).join('');
      return '<tr><td class="bold">'+esc(res.name)+'</td><td style="font-size:11px;color:var(--txt2)">'+res.type+'</td>'+cells+'</tr>';
    }).join('');

    var body='<div style="font-size:12px;color:var(--txt2);margin-bottom:8px">Live view for <b>'+tdy+'</b> \u2014 rooms from Wards, equipment from Assets/Inventory, bookings from today\u2019s appointments &amp; schedules. '+appts.length+' appointment(s) today.</div>'
      +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Resource</th><th>Type</th>'+slots.map(function(s){return '<th>'+s[0]+'</th>';}).join('')+'</tr></thead><tbody>'+rows+'</tbody></table></div>';
    showModal('<i class="fa-solid fa-door-open" style="color:#0ea5e9;margin-right:8px"></i>Room &amp; Equipment Booking', body,
      '<button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide');
  };
  window.__bookSlot=function(resource, slot){
    toasty(resource+' reserved for '+slot+' today');
    var D=D_(); D.resourceBookings=D.resourceBookings||[];
    D.resourceBookings.push({id:newId(),resource:resource,slot:slot,date:todayStr(),by:(D.currentUser&&D.currentUser.fullName)||'Reception'});
    save();
  };

  /* ═══════════ 3. AUTOMATED APPOINTMENT REMINDERS — fix syntax error + real send ═══════════ */
  function upcomingAppts(){
    var D=D_(); return (D.appointments||[]).filter(function(a){ var s=(a.status||'').toLowerCase(); return s==='scheduled'||s==='confirmed'||s==='booked'||s==='pending'; });
  }
  window.showSMSEmailReminders=function(){
    var up=upcomingAppts();
    var preview=up.slice(0,5).map(function(a){ return '<div style="padding:4px 0;border-bottom:1px solid #bfdbfe">'+esc(pat(a.patientId))+' \u2014 '+esc(a.date||'')+' '+esc(a.time||'')+' with '+esc(doc(a.doctorId))+'</div>'; }).join('') || '<div style="padding:4px 0;color:var(--txt3)">No upcoming appointments to remind.</div>';
    var body='<div class="form-grid"><div class="form-group"><label>Channel</label><select id="rem_ch"><option>SMS (Twilio)</option><option>Email (SendGrid)</option><option>WhatsApp</option><option>All Channels</option></select></div>'
      +'<div class="form-group"><label>Timing</label><select id="rem_timing"><option>24 hours before</option><option>48 hours before</option><option>1 hour before</option><option>Custom</option></select></div>'
      +'<div class="form-group full"><label>Message Template</label><textarea rows="3" id="rem_msg">Dear {patient_name}, this is a reminder of your appointment at {hospital} on {date} at {time} with {doctor}. Please arrive 15 min early. Reply CONFIRM to confirm or call +234-xxx-xxx to reschedule.</textarea></div></div>'
      +'<div style="margin-top:12px;padding:12px;background:#dbeafe;border-radius:10px"><b>Preview for upcoming appointments:</b><div style="font-size:12px;margin-top:6px">'+preview
      +'<div style="margin-top:6px;font-weight:700;color:#1e40af">Total: '+up.length+' reminder(s) to send</div></div></div>';
    showModal('<i class="fa-solid fa-bell" style="color:#3b82f6;margin-right:8px"></i>Automated Appointment Reminders', body,
      '<button class="btn btn-pri" onclick="sendAppointmentReminders()"><i class="fa-solid fa-paper-plane"></i> Send All</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
  };
  window.sendAppointmentReminders=function(){
    var D=D_(); var ch=val('rem_ch')||'SMS'; var up=upcomingAppts();
    if(!up.length){ toasty('No upcoming appointments to remind','err'); return; }
    D.appointmentReminders=D.appointmentReminders||[];
    var when=new Date().toLocaleString();
    up.forEach(function(a){ D.appointmentReminders.push({id:newId(),appointmentId:a.id,patientId:a.patientId,sentAt:when,method:ch,timing:val('rem_timing')||'24 hours before',status:'Sent'}); });
    try{ if(typeof auditAction==='function') auditAction('CRM','Reminders','SEND',up.length+' appointment reminder(s) via '+ch,'Low'); }catch(e){}
    save(); toasty(up.length+' reminder(s) queued via '+ch);
    try{ if(typeof closeModal==='function') closeModal(); }catch(e){} rerender();
  };

  /* ═══════════ 4. LAB ORDER — auto-sync Fee Schedule so tests bill + force refresh ═══════════ */
  function ensureLabFees(){
    var D=D_(); D.feeSchedule=D.feeSchedule||[];
    var def=(D.settings&&D.settings.defaultLabFee)||10000;
    var lines=document.querySelectorAll('#lab_lines tr.lab-line');
    lines.forEach(function(tr){
      var t=((tr.querySelector('.lab-test')||{}).value||'').trim(); if(!t) return;
      var exists=D.feeSchedule.some(function(f){ return String(f.service||'').toLowerCase()===t.toLowerCase(); });
      if(!exists){
        var maxId=D.feeSchedule.reduce(function(m,f){return Math.max(m, +f.id||0);},0)+1;
        D.feeSchedule.push({id:maxId, code:'FEE-L'+maxId, service:t, department:'Laboratory', amount:def, insured:Math.round(def*0.8), category:'Lab', status:'Active'});
      }
    });
  }
  function wrapLabSave(){
    if(typeof window.saveLabOrder!=='function' || window.saveLabOrder.__feeSyncV98) return;
    var _s=window.saveLabOrder;
    window.saveLabOrder=function(id){
      try{ ensureLabFees(); }catch(e){}        /* seed fees BEFORE inner charge wrap runs, so tests bill */
      var r=_s.apply(this, arguments);
      try{ rerender(); }catch(e){}              /* force the lab table/KPIs to reflect the new order */
      return r;
    };
    window.saveLabOrder.__feeSyncV98=true;
  }
  wrapLabSave(); setTimeout(wrapLabSave,800); setTimeout(wrapLabSave,2000); setTimeout(wrapLabSave,4200);

  try{ console.log('%c\u2705 v98 multi-fix active (meds save+balance, room booking, reminders, lab fee-sync)','color:#7c3aed;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/076-payee-id-offset-so-employee-ids-never-collide-wi.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  var EMP_BASE = 900000;                         /* payee-id offset so employee ids never collide with supplier ids */
  function D_(){ return window.D||(window.D={}); }
  function newId(){ try{ return (typeof nid==='function')?nid():(Date.now()+Math.floor(Math.random()*1000)); }catch(e){ return Date.now(); } }
  function todayStr(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
  function toasty(m,t){ try{ if(typeof toast==='function') toast(m,t); }catch(e){} }
  function money(n){ try{ if(typeof F==='function') return F(n); }catch(e){} return '\u20a6'+Math.round(parseFloat(n)||0).toLocaleString(); }
  function save(){ try{ if(window._hmsSave) window._hmsSave(); }catch(e){} }
  function rerender(){ try{ if(typeof render==='function') render(); }catch(e){} }
  function empName(id){ var e=(D_().employees||[]).find(function(x){return x.id===id;}); return e?(e.fullName||e.name||('Employee '+id)):('Employee '+id); }

  /* ensure a dedicated expense account exists for staff claims */
  function ensureCOA(){
    var D=D_(); D.chartOfAccounts=D.chartOfAccounts||[];
    if(!D.chartOfAccounts.find(function(a){return a.code==='6960';}))
      D.chartOfAccounts.push({code:'6960',name:'Staff Claims & Reimbursements',type:'Expense',subType:'Operating Expense',balance:0,bal:0,active:true});
  }
  function expenseFor(ct){
    var cat=(ct&&ct.category)||''; 
    if(cat==='TRAVEL') return '5955'; if(cat==='ALLOW') return '5970'; if(cat==='SHIFT') return '5000';
    return '6960';
  }

  /* ── PAYEE SYNC: every supplier tidied + every employee registered as an AP payee ── */
  function syncPayees(){
    var D=D_(); D.suppliers=D.suppliers||[];
    /* tidy real suppliers so the AP UI never shows "undefined" */
    var realMax=0;
    D.suppliers.forEach(function(s){
      if(!s.isEmployee){
        if(!s.code) s.code='SUP-'+String(s.id).padStart(3,'0');
        if(s.paymentTerms==null) s.paymentTerms='Net 30';
        if(s.tin==null) s.tin='';
        if(s.creditLimit==null) s.creditLimit=0;
        realMax=Math.max(realMax, +s.id||0);
      }
    });
    /* register employees as payees (offset id) */
    (D.employees||[]).forEach(function(e){
      var pid=EMP_BASE+e.id;
      var ex=D.suppliers.find(function(s){return s.id===pid;});
      var nm=e.fullName||e.name||('Employee '+e.id);
      if(!ex){
        D.suppliers.push({id:pid, isEmployee:true, empId:e.id, code:'EMP-'+String(e.id).padStart(3,'0'),
          name:nm, category:'Staff / Employee', contact:nm, phone:e.phone||'', email:e.email||'',
          paymentTerms:'Immediate', tin:e.tin||'', creditLimit:0, active:true});
      } else { ex.name=nm; ex.empId=e.id; ex.isEmployee=true; if(ex.paymentTerms==null)ex.paymentTerms='Immediate'; if(ex.creditLimit==null)ex.creditLimit=0; if(ex.tin==null)ex.tin=''; }
    });
  }
  window.__twhSyncPayees = syncPayees;

  /* keep employee payees out of the Procurement supplier suggestion list */
  (function filterProcurement(){
    if(typeof window.newPurchaseOrder!=='function' || window.newPurchaseOrder.__noEmpPayees) return setTimeout(filterProcurement,800);
    var _n=window.newPurchaseOrder;
    window.newPurchaseOrder=function(){
      var D=D_(); var hidden=(D.suppliers||[]).filter(function(s){return s.isEmployee;});
      var keep=(D.suppliers||[]).filter(function(s){return !s.isEmployee;});
      var all=D.suppliers; D.suppliers=keep;            /* temporarily hide employees while the PO modal builds its datalist */
      try{ var r=_n.apply(this,arguments); }finally{ D.suppliers=all; }
      return r;
    };
    window.newPurchaseOrder.__noEmpPayees=true;
  })();

  /* ── PUSH a staff claim to Accounts Payable ── */
  window.pushClaimToPayables=function(claimId){
    var D=D_(); ensureCOA(); syncPayees();
    var c=(D.claims||[]).find(function(x){return x.id===claimId;});
    if(!c || !c.employeeId){ return null; }
    if(c.__apInvoiceId){ return (D.apInvoices||[]).find(function(i){return i.id===c.__apInvoiceId;})||null; }
    D.apInvoices=D.apInvoices||[];
    var ct=(D.claimTypes||[]).find(function(t){return t.id===c.claimTypeId;});
    var payeeId=EMP_BASE+c.employeeId;
    var n=(D.apInvoices.length+1);
    var inv={ id:newId(), code:'CLM-AP-'+String(n).padStart(5,'0'), supplierInvNo:c.code,
      supplierId:payeeId, supplierCode:'EMP-'+String(c.employeeId).padStart(3,'0'), supplierName:empName(c.employeeId),
      payeeType:'Employee', employeeId:c.employeeId, claimId:c.id,
      poId:null, poCode:null, grnId:null, date:c.date||todayStr(), dueDate:todayStr(),
      subtotal:c.total||0, vat:0, wht:0, amount:c.total||0, paid:0, balance:c.total||0,
      status:'Outstanding', expenseAccount:expenseFor(ct), category:'Staff Claim'+(ct?(' \u2014 '+ct.name):''),
      notes:'Staff claim '+c.code+(c.purpose?(' \u2014 '+c.purpose):'') };
    D.apInvoices.push(inv);
    c.__apInvoiceId=inv.id; c.__pushedToAP=true;
    try{ if(window.V26 && typeof V26.postAPInvoice==='function') V26.postAPInvoice(inv); }catch(e){}
    try{ if(typeof auditAction==='function') auditAction('FINANCE','Payables','CREATE','Staff claim '+c.code+' pushed to AP '+inv.code+' \u2014 '+money(inv.amount),'Medium'); }catch(e){}
    save();
    return inv;
  };

  /* bulk sync of all approved (or paid) staff claims */
  window.syncAllClaimsToPayables=function(silent){
    var D=D_(); var n=0;
    (D.claims||[]).forEach(function(c){
      if(c.employeeId && (c.status==='Approved'||c.status==='Paid'||c.status==='Settled') && !c.__apInvoiceId){
        if(window.pushClaimToPayables(c.id)) n++;
      }
    });
    reconcileClaimPayments();
    if(!silent){ toasty(n? (n+' approved claim(s) pushed to Payables') : 'All approved claims already in Payables'); rerender(); }
    return n;
  };

  /* when a claim's AP invoice is fully paid, mark the claim Paid */
  function reconcileClaimPayments(){
    var D=D_(); var changed=false;
    (D.claims||[]).forEach(function(c){
      if(c.__apInvoiceId && c.status!=='Paid'){
        var inv=(D.apInvoices||[]).find(function(i){return i.id===c.__apInvoiceId;});
        if(inv && (inv.balance||0)<=0 && inv.status!=='Outstanding'){ c.status='Paid'; c.paidDate=todayStr(); changed=true; }
      }
    });
    if(changed) save();
  }
  window.__reconcileClaimPayments=reconcileClaimPayments;

  /* ── hook approveClaim so approval auto-pushes staff claims ── */
  function hookApprove(){
    if(typeof window.approveClaim!=='function'){ return setTimeout(hookApprove,600); }
    if(window.approveClaim.__apHook) return;
    var _a=window.approveClaim;
    window.approveClaim=function(id){
      var r=_a.apply(this,arguments);
      try{
        var c=(D_().claims||[]).find(function(x){return x.id===id;});
        if(c && c.employeeId && c.status==='Approved'){ var inv=window.pushClaimToPayables(id); if(inv){ toasty('Claim '+c.code+' approved & posted to Payables ('+inv.code+')'); } }
      }catch(e){}
      return r;
    };
    window.approveClaim.__apHook=true;
  }
  hookApprove();

  /* ── inject a "Sync Approved → Payables" button into the Staff Claims screen ── */
  function hookStaffRender(){
    if(typeof window.renderStaffClaimsContent!=='function'){ return setTimeout(hookStaffRender,600); }
    if(window.renderStaffClaimsContent.__apBtn) return;
    var _r=window.renderStaffClaimsContent;
    window.renderStaffClaimsContent=function(){
      try{ reconcileClaimPayments(); }catch(e){}
      var h=_r.apply(this,arguments);
      try{
        h=h.replace('<button class="btn btn-ghost" onclick="goTo(\'config\')">',
          '<button class="btn btn-sm" style="background:#7c2d12;color:#fff" onclick="syncAllClaimsToPayables()"><i class="fa-solid fa-file-invoice-dollar"></i> Sync Approved \u2192 Payables</button><button class="btn btn-ghost" onclick="goTo(\'config\')">');
      }catch(e){}
      return h;
    };
    window.renderStaffClaimsContent.__apBtn=true;
  }
  hookStaffRender();

  /* boot: register payees + sync existing approved claims */
  function boot(){ try{ ensureCOA(); syncPayees(); window.syncAllClaimsToPayables(true); }catch(e){} }
  boot(); setTimeout(boot,1200); setTimeout(boot,3000); setTimeout(boot,6000);

  try{ console.log('%c\u2705 v99 Staff Claims \u2192 Payables + employee/supplier payee sync active','color:#7c3aed;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/077-v100-ess-unified-requests-staff-depts-insurance-.js ==== */
(function(){
'use strict';
if(typeof window==='undefined') return;
function D_(){ return window.D||(window.D={}); }
function $(id){ return document.getElementById(id); }
function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
function money(n){ try{ return (typeof F==='function')?F(n):('₦'+Number(n||0).toLocaleString()); }catch(e){ return '₦'+(n||0); } }
function tdy(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
function genId(){ try{ return (typeof nid==='function')?nid():(Date.now()+Math.floor(Math.random()*1000)); }catch(e){ return Date.now(); } }
function save(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} }
function toasty(m,t){ try{ if(typeof toast==='function') toast(m,t); }catch(e){} }
function audit(mod,act,op,d,sev){ try{ if(typeof auditAction==='function') auditAction(mod,act,op,d,sev||'Low'); }catch(e){} }

/* ════════════════════════════════════════════════════════════════════
   MODULE 1 — Force the required settings ON (idempotent, survives saved state)
   Finance Settings: Auto Insurance Claims, SMS Receipt
   Leave Entitlements: Require Approval, Auto Deduct Balance, Require Relief Staff
   Cross-Branch Settings: Shared inventory
   ════════════════════════════════════════════════════════════════════ */
function forceSettings(){
  var D=D_(); if(!D) return;
  D.settings=D.settings||{};
  var on={ autoInsuranceClaim:'true', smsReceipt:'true', approvalRequired:'true',
           autoDeductLeave:'true', requireReliefStaff:'true', sharedInventory:'true' };
  var changed=false;
  Object.keys(on).forEach(function(k){ if(D.settings[k]!==on[k]){ D.settings[k]=on[k]; changed=true; } });
  /* mirror leave toggles into claimSettings where the HR module reads them */
  if(D.claimSettings){ ['approvalRequired','autoDeductLeave','requireReliefStaff'].forEach(function(k){ if(D.claimSettings[k]!=='true'){ D.claimSettings[k]='true'; changed=true; } }); }
  if(changed){ save(); }
}

/* ════════════════════════════════════════════════════════════════════
   MODULE 2 — Update all staff to their correct department
   Builds any missing specialist departments then remaps every employee
   from their position / specialization / type. Idempotent.
   ════════════════════════════════════════════════════════════════════ */
function ensureDept(code,name,type,loc){
  var D=D_(); D.departments=D.departments||[];
  var d=D.departments.find(function(x){return (x.code||'').toUpperCase()===code;});
  if(d) return d.id;
  var maxId=D.departments.reduce(function(m,x){return (+x.id>m)?+x.id:m;},0);
  D.departments.push({id:maxId+1,code:code,name:name,type:type,location:loc||'',head:'',phone:'',active:true});
  return maxId+1;
}
function deptIdByCode(code){ var D=D_(); var d=(D.departments||[]).find(function(x){return (x.code||'').toUpperCase()===code;}); return d?d.id:null; }

function fixStaffDepartments(){
  var D=D_(); if(!D||!D.employees||!D.employees.length||!D.departments) return;
  if(D._staffDeptFixV100) return;

  /* make sure the specialist departments every role needs exist */
  ensureDept('RADI','Radiology & Imaging','Clinical','Building B, Floor 1');
  ensureDept('PSYC','Psychiatry & Mental Health','Clinical','Building C, Floor 2');
  ensureDept('ITSU','Information Technology','Administrative','Building D, Floor 3');
  ensureDept('FACL','Facilities & Maintenance','Support','Building D, Ground');
  ensureDept('SECU','Security','Support','Main Gate');
  ensureDept('ADMN','Administration','Administrative','Building D, Floor 1');

  function pick(emp){
    var s=((emp.specialization||'')+' '+(emp.position||'')+' '+(emp.type||'')).toLowerCase();
    var has=function(){ for(var i=0;i<arguments.length;i++){ if(s.indexOf(arguments[i])>=0) return true; } return false; };
    if(has('radiolog','imaging','x-ray','xray','ultrasound','ct ','mri')) return deptIdByCode('RADI');
    if(has('psychiat','mental health','psycholog')) return deptIdByCode('PSYC');
    if(has('cardio')) return deptIdByCode('CARD');
    if(has('obstetric','gyna','gynec','maternal','antenatal')) return deptIdByCode('OBST');
    if(has('ortho','joint','bone','perioperative')&&!has('surger')) return deptIdByCode('ORTH');
    if(has('pediatr','paediatr','neonat','nicu')) return deptIdByCode('PEDI');
    if(has('emergenc','triage','opd')) return deptIdByCode('EMRG');
    if(has('anesth','anaesth','surgery','surgeon','operating','or nurse','theatre')) return deptIdByCode('SURG');
    if(has('hematol','haematol','patholog','laborator','lab ','lab tech','lab director')) return deptIdByCode('PATH');
    if(has('pharmac')) return deptIdByCode('PHAR');
    if(has('neurolog','neuro')) return deptIdByCode('NEUR');
    if(has('critical care','intensive','icu')) return deptIdByCode('ICCM');
    if(has('it support','system admin','sysadmin','information tech','software','network')) return deptIdByCode('ITSU');
    if(has('housekeep','sanitation','cleaning','janitor','maintenance')) return deptIdByCode('FACL');
    if(has('security')) return deptIdByCode('SECU');
    if(has('finance','account','procure','supply chain','cashier','treasur','audit')) return deptIdByCode('FINC');
    if(has('hr ','human resource','recruit','people')) return deptIdByCode('HRES');
    if(has('reception','front desk','admin')) return deptIdByCode('ADMN');
    /* fall back by employee.type */
    var t=(emp.type||'').toLowerCase();
    if(t.indexOf('pharm')>=0) return deptIdByCode('PHAR');
    if(t.indexOf('lab')>=0) return deptIdByCode('PATH');
    if(t.indexOf('account')>=0) return deptIdByCode('FINC');
    if(t.indexOf('hr')>=0) return deptIdByCode('HRES');
    if(t.indexOf('it')>=0) return deptIdByCode('ITSU');
    if(t.indexOf('security')>=0) return deptIdByCode('SECU');
    if(t.indexOf('support')>=0) return deptIdByCode('FACL');
    if(t.indexOf('admin')>=0) return deptIdByCode('ADMN');
    return emp.deptId||deptIdByCode('ADMN');
  }
  var moved=0;
  D.employees.forEach(function(e){ var nd=pick(e); if(nd && e.deptId!==nd){ e.deptId=nd; moved++; } });

  /* refresh department heads from the employees now correctly assigned */
  (D.departments||[]).forEach(function(d){
    var head=(D.employees||[]).find(function(e){ return e.deptId===d.id && /director|head|manager|chief|consultant|senior/i.test(e.position||''); });
    if(head) d.head=head.fullName;
  });

  D._staffDeptFixV100=1; save();
  audit('HR','Departments','UPDATE','Re-assigned '+moved+' staff to their correct department','Low');
}

/* ════════════════════════════════════════════════════════════════════
   MODULE 3 — ESS: unified "My Requests" tab (attendance + leave + claims)
   with a type filter. Adds the tab and a renderer, leaving the existing
   per-type tabs intact.
   ════════════════════════════════════════════════════════════════════ */
window.essReqFilter=function(v){ D_()._essReqType=v; var b=$('essReqBody'); if(b) b.innerHTML=essReqRows(); };
function essReqRows(){
  var D=D_(); var emp=(typeof essEmp==='function')?essEmp():null; if(!emp) return '';
  var filt=D._essReqType||'all';
  var rows=[];
  if(filt==='all'||filt==='attendance'){
    (D.attendance||[]).filter(function(a){return a.employeeId===emp.id;}).forEach(function(a){
      rows.push({type:'Attendance',ref:'ATT',date:a.date,detail:'Clock '+(a.clockIn||'—')+(a.clockOut?(' → '+a.clockOut):'')+' · '+(a.hours||0)+'h',amount:'',status:a.status||'—',sort:a.date});
    });
  }
  if(filt==='all'||filt==='leave'){
    (D.leaveRequests||[]).filter(function(l){return l.employeeId===emp.id;}).forEach(function(l){
      rows.push({type:'Leave',ref:l.type,date:l.startDate,detail:(l.type+' leave · '+l.days+'d ('+l.startDate+'→'+l.endDate+') — '+(l.reason||'')),amount:'',status:l.status||'—',sort:l.startDate});
    });
  }
  if(filt==='all'||filt==='claims'){
    (D.claims||[]).filter(function(c){return c.employeeId===emp.id && String(c.code||'').indexOf('CLM-S')===0;}).forEach(function(c){
      rows.push({type:'Claim',ref:c.code,date:c.date,detail:(c.purpose||'Staff claim'),amount:money(c.total),status:c.status||'—',sort:c.date});
    });
  }
  rows.sort(function(a,b){ return String(b.sort||'').localeCompare(String(a.sort||'')); });
  var stc2=function(s){ try{ return (typeof stc==='function')?stc(s):'st-scheduled'; }catch(e){ return 'st-scheduled'; } };
  if(!rows.length) return '<tr><td colspan="6" style="text-align:center;color:var(--txt3);padding:18px">No requests of this type yet.</td></tr>';
  return rows.map(function(r){
    var tColor=r.type==='Attendance'?'#0d9488':r.type==='Leave'?'#1e40af':'#b45309';
    return '<tr>'
      +'<td><span style="display:inline-block;padding:2px 9px;border-radius:99px;font-size:10px;font-weight:700;color:#fff;background:'+tColor+'">'+r.type+'</span></td>'
      +'<td><b>'+esc(r.ref)+'</b></td><td>'+esc(r.date||'—')+'</td>'
      +'<td style="font-size:12px">'+esc(r.detail)+'</td>'
      +'<td style="font-weight:700">'+(r.amount||'—')+'</td>'
      +'<td><span class="st '+stc2(r.status)+'">'+esc(r.status)+'</span></td></tr>';
  }).join('');
}
window.essRequests=function(emp){
  var D=D_();
  var counts={
    all:0,
    attendance:(D.attendance||[]).filter(function(a){return a.employeeId===emp.id;}).length,
    leave:(D.leaveRequests||[]).filter(function(l){return l.employeeId===emp.id;}).length,
    claims:(D.claims||[]).filter(function(c){return c.employeeId===emp.id && String(c.code||'').indexOf('CLM-S')===0;}).length
  };
  counts.all=counts.attendance+counts.leave+counts.claims;
  var cur=D._essReqType||'all';
  function opt(v,l){ return '<option value="'+v+'"'+(cur===v?' selected':'')+'>'+l+'</option>'; }
  return '<div style="display:flex;gap:10px;align-items:center;flex-wrap:wrap;margin-bottom:12px">'
    +'<div style="font-size:12px;color:var(--txt2)"><i class="fa-solid fa-filter" style="color:var(--pri);margin-right:6px"></i>Filter by type:</div>'
    +'<select onchange="essReqFilter(this.value)" style="padding:7px 12px;border:1.5px solid var(--bdr);border-radius:9px;font-size:12.5px">'
      +opt('all','All Requests ('+counts.all+')')
      +opt('attendance','Attendance ('+counts.attendance+')')
      +opt('leave','Leave Requests ('+counts.leave+')')
      +opt('claims','Staff Claims ('+counts.claims+')')
    +'</select>'
    +'<div style="margin-left:auto;display:flex;gap:6px">'
    +'<button class="btn btn-xs" style="background:#1e40af;color:#fff" onclick="essNewLeave()"><i class="fa-solid fa-umbrella-beach"></i> Leave</button>'
    +'<button class="btn btn-xs" style="background:#b45309;color:#fff" onclick="essNewClaim()"><i class="fa-solid fa-hand-holding-usd"></i> Claim</button>'
    +'</div></div>'
    +'<div class="card"><div class="card-hd"><h3 style="font-size:13px"><i class="fa-solid fa-list-check" style="color:var(--pri);margin-right:6px"></i>All My Self-Service Requests</h3></div>'
    +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Type</th><th>Ref</th><th>Date</th><th>Details</th><th>Amount</th><th>Status</th></tr></thead>'
    +'<tbody id="essReqBody">'+essReqRows()+'</tbody></table></div></div>';
};

/* re-wrap renderSelfService to add the "My Requests" tab */
function wrapESS(){
  if(typeof window.renderSelfService!=='function' || window.renderSelfService.__v100) return;
  var _rs=window.renderSelfService;
  window.renderSelfService=function(){
    var D=D_();
    var emp=(typeof essEmp==='function')?essEmp():null;
    if(!emp) return _rs.apply(this,arguments);           /* not linked yet — show linker */
    if(D._essTab==='requests'){
      var tb=''
        +tabBtnV100('home','My Dashboard','fa-house-user')
        +tabBtnV100('requests','My Requests','fa-list-check')
        +tabBtnV100('attendance','Attendance','fa-fingerprint')
        +tabBtnV100('leave','Leave','fa-umbrella-beach')
        +tabBtnV100('claims','Staff Claims','fa-hand-holding-usd')
        +((typeof isApproverV100==='function'&&isApproverV100())?tabBtnV100('approvals','Approvals','fa-stamp'):'');
      var body;
      try{ body=window.essRequests(emp); }catch(e){ body='<div class="card">Unable to render: '+esc(e.message)+'</div>'; }
      return '<div class="tab-row" style="flex-wrap:wrap">'+tb+'</div>'+body;
    }
    /* otherwise render the original, then splice the My Requests tab button in */
    var html=_rs.apply(this,arguments);
    try{
      var btn=tabBtnV100('requests','My Requests','fa-list-check');
      /* insert right after the My Dashboard tab */
      html=html.replace(/(<button class="tab-btn[^>]*onclick="essGo\('home'\)[\s\S]*?<\/button>)/, '$1'+btn);
    }catch(e){}
    return html;
  };
  window.renderSelfService.__v100=true;
}
function tabBtnV100(k,l,i){ var on=(D_()._essTab||'home')===k; return '<button class="tab-btn'+(on?' active':'')+'" onclick="essGo(\''+k+'\')"><i class="fa-solid '+i+'" style="margin-right:5px"></i>'+l+'</button>'; }
function isApproverV100(){ try{ var u=(D_().currentUser); if(u&&u.canApprove) return true; return u&&['System Administrator','Super System Admin','HR Manager','Finance Manager'].indexOf(u.role)>-1; }catch(e){ return false; } }

/* boot module 1-3 */
function boot1(){ forceSettings(); fixStaffDepartments(); wrapESS(); }
boot1(); setTimeout(boot1,800); setTimeout(boot1,2500); setTimeout(boot1,6000);
if(document.readyState==='loading'){ window.addEventListener('DOMContentLoaded', boot1); }
try{ console.log('%c✅ v100/1 — settings forced · staff depts fixed · ESS unified My Requests','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/078-v100-2-insurance-provider-billing-editable-charg.js ==== */
(function(){
'use strict';
if(typeof window==='undefined') return;
function D_(){ return window.D||(window.D={}); }
function $(id){ return document.getElementById(id); }
function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
function money(n){ try{ return (typeof F==='function')?F(n):('₦'+Number(n||0).toLocaleString()); }catch(e){ return '₦'+(n||0); } }
function tdy(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
function genId(){ try{ return (typeof nid==='function')?nid():(Date.now()+Math.floor(Math.random()*1000)); }catch(e){ return Date.now(); } }
function uidv(){ try{ return (typeof uid==='function')?uid():Math.random().toString(36).substr(2,6).toUpperCase(); }catch(e){ return Math.random().toString(36).substr(2,6).toUpperCase(); } }
function save(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} }
function toasty(m,t){ try{ if(typeof toast==='function') toast(m,t); }catch(e){} }
function audit(mod,act,op,d,sev){ try{ if(typeof auditAction==='function') auditAction(mod,act,op,d,sev||'Low'); }catch(e){} }

/* ════════════════════════════════════════════════════════════════════
   MODULE 4 — Generate Bill: sync Insurance Providers into the payer list,
   pick patients attached to that provider, and make every charge line
   editable so the insurance provider's fee can be entered per line.
   ════════════════════════════════════════════════════════════════════ */

/* editable line-item renderer shared by all Generate-Bill paths */
window.gbEditableLines=function(items,opts){
  opts=opts||{};
  window.__gbItems=(items||[]).map(function(it){return {s:it.s,a:+it.a||0,category:it.category||''};});
  function rows(){
    var its=window.__gbItems||[];
    return its.map(function(it,i){
      return '<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px">'
        +'<input value="'+esc(it.s)+'" placeholder="Charge / service" oninput="window.__gbItems['+i+'].s=this.value" style="flex:2;min-width:140px;padding:6px 8px;border:1.5px solid var(--bdr);border-radius:8px;font-size:12px">'
        +'<input type="number" min="0" value="'+(+it.a||0)+'" placeholder="₦ fee" oninput="window.__gbItems['+i+'].a=parseFloat(this.value)||0;window.gbEditRecalc()" style="width:120px;padding:6px 8px;border:1.5px solid var(--bdr);border-radius:8px;font-size:12px">'
        +'<button type="button" class="btn btn-xs btn-ghost" style="color:#dc2626" title="Remove" onclick="window.gbEditDel('+i+')"><i class="fa-solid fa-times"></i></button>'
        +'</div>';
    }).join('');
  }
  window.__gbEditRowsHTML=rows;
  var box=$('gbServices'); if(!box) return;
  box.innerHTML='<div style="font-size:12px;font-weight:700;margin-bottom:6px">'+(opts.title||'Card-type &amp; auto-detected charges')+' <span style="font-weight:400;color:var(--txt3)">(editable — enter the provider\'s fee per line)</span></div>'
    +'<div id="gbEditRows">'+rows()+'</div>'
    +'<button type="button" class="btn btn-xs btn-ghost" style="margin-top:4px;border:1px solid var(--bdr)" onclick="window.gbEditAdd()"><i class="fa-solid fa-plus"></i> Add line</button>'
    +'<div style="display:flex;justify-content:space-between;padding:8px 10px;background:var(--priL);border-radius:6px;margin-top:8px;font-weight:800;color:var(--pri)"><span>Total</span><span id="gbEditTotal">'+money(0)+'</span></div>';
  window.gbEditRecalc();
};
window.gbEditAdd=function(){ window.__gbItems=window.__gbItems||[]; window.__gbItems.push({s:'',a:0,category:''}); var r=$('gbEditRows'); if(r&&window.__gbEditRowsHTML) r.innerHTML=window.__gbEditRowsHTML(); window.gbEditRecalc(); };
window.gbEditDel=function(i){ (window.__gbItems||[]).splice(i,1); var r=$('gbEditRows'); if(r&&window.__gbEditRowsHTML) r.innerHTML=window.__gbEditRowsHTML(); window.gbEditRecalc(); };
window.gbEditRecalc=function(){
  var t=(window.__gbItems||[]).reduce(function(s,it){return s+(+it.a||0);},0);
  var te=$('gbEditTotal'); if(te) te.textContent=money(t);
  var gt=$('gb_total'); if(gt) gt.value=t;
};

/* make the v74 patient card-type path editable too: re-wrap loadPatientServices */
function wrapEditablePatientServices(){
  if(typeof window.loadPatientServices!=='function' || window.loadPatientServices.__editV100) return;
  var _lps=window.loadPatientServices;
  window.loadPatientServices=function(){
    try{ _lps.apply(this,arguments); }catch(e){}
    /* after the prior chain has computed __gbItems, re-render them as editable inputs */
    try{ if((window.__gbItems||[]).length){ window.gbEditableLines(window.__gbItems); } }catch(e){}
  };
  window.loadPatientServices.__editV100=true;
  window.loadPatientServices.__billV74=true; /* stop v74 from re-wrapping ours */
}

/* single dispatcher for the payer <select> so insurance + non-insurance paths don't collide */
window.gbPayerDispatch=function(){
  var sel=$('gb_patient'); if(!sel) return;
  var raw=sel.value||'';
  if(/^INS:\d+$/.test(raw)){
    var w=$('gb_payer_name_wrap'); if(w) w.style.display='none';   /* hide manual payer name */
    window.gbProviderChanged(); return;
  }
  var iw=$('gb_ins_wrap'); if(iw){ iw.style.display='none'; iw.innerHTML=''; }
  if(typeof window.gbPayerChanged==='function') window.gbPayerChanged();
};

/* insurance providers + their attached patients in the payer dropdown */
function provPatients(provName){
  var D=D_(); var n=String(provName||'').toLowerCase();
  return (D.patients||[]).filter(function(p){ return String(p.insurance||'').toLowerCase()===n; });
}
window.gbProviderChanged=function(){
  var D=D_(); var sel=$('gb_patient'); if(!sel) return;
  var raw=sel.value||''; var m=/^INS:(\d+)$/.exec(raw);
  var wrap=$('gb_ins_wrap');
  if(!m){ if(wrap) wrap.style.display='none'; return; }
  var prov=(D.insuranceProviders||[]).find(function(x){return x.id===+m[1];});
  if(!prov){ if(wrap) wrap.style.display='none'; return; }
  var attached=provPatients(prov.name);
  var ptsAll=(D.patients||[]).slice().sort(function(a,b){return String(a.fullName).localeCompare(String(b.fullName));});
  var attachedOpts=attached.map(function(p){return '<option value="'+p.id+'">'+esc(p.fullName)+' ['+esc(p.mrn)+']</option>';}).join('');
  var allOpts=ptsAll.map(function(p){return '<option value="'+p.id+'"'+(String(p.insurance||'').toLowerCase()===prov.name.toLowerCase()?' selected':'')+'>'+esc(p.fullName)+' ['+esc(p.mrn)+']'+(String(p.insurance||'').toLowerCase()===prov.name.toLowerCase()?' ✓':'')+'</option>';}).join('');
  if(wrap){
    wrap.style.display='';
    wrap.innerHTML='<label><i class="fa-solid fa-user-shield" style="color:#1e40af;margin-right:6px"></i>Patients on '+esc(prov.name)+' '
      +'<span style="font-weight:400;color:var(--txt3)">(coverage '+(prov.coverage||0)+'%)</span></label>'
      +(attached.length
         ? '<div style="font-size:11px;color:var(--txt3);margin:2px 0 6px">'+attached.length+' patient(s) currently attached to this provider — select one to bill.</div>'
         : '<div style="font-size:11px;color:#b45309;margin:2px 0 6px">No patient is attached to this provider yet — pick a patient below and they will be attached to '+esc(prov.name)+'.</div>')
      +'<select id="gb_ins_patient" onchange="window.gbInsPatientChanged()" style="width:100%;padding:8px 10px;border:1.5px solid var(--bdr);border-radius:9px;font-size:12.5px">'
        +'<option value="">— select patient —</option>'
        +(attached.length?'<optgroup label="Attached to '+esc(prov.name)+'">'+attachedOpts+'</optgroup>':'')
        +'<optgroup label="All patients">'+allOpts+'</optgroup>'
      +'</select>';
  }
};
window.gbInsPatientChanged=function(){
  var D=D_(); var ip=$('gb_ins_patient'); var pid=ip?parseInt(ip.value):0;
  if(!pid){ var box=$('gbServices'); if(box) box.innerHTML='<div style="color:var(--txt3);font-size:12px;padding:16px;text-align:center">Select a patient to load services / enter the provider fee per line</div>'; return; }
  var m=/^INS:(\d+)$/.exec(($('gb_patient')||{}).value||'');
  var prov=m?(D.insuranceProviders||[]).find(function(x){return x.id===+m[1];}):null;
  var p=(D.patients||[]).find(function(x){return x.id===pid;});
  if(p&&prov&&String(p.insurance||'').toLowerCase()!==prov.name.toLowerCase()){ p.insurance=prov.name; save(); }
  window.__gbInsPatientId=pid;
  /* reuse the standard service-detection engine by briefly presenting the chosen patient id */
  var sel=$('gb_patient'); var tmp=null;
  try{
    sel.id='gb_patient_provider';
    tmp=document.createElement('input'); tmp.type='hidden'; tmp.id='gb_patient'; tmp.value=pid; document.body.appendChild(tmp);
    if(typeof window.loadPatientServices==='function') window.loadPatientServices();
  }catch(e){}
  finally{
    try{ if(tmp&&tmp.parentNode) tmp.parentNode.removeChild(tmp); }catch(e){}
    sel.id='gb_patient';
  }
  try{ window.gbEditableLines(window.__gbItems||[],{title:'Charges for '+(p?esc(p.fullName):'patient')+' — '+(prov?esc(prov.name):'')}); }catch(e){}
};

/* re-wrap generateBill to inject the Insurance Providers optgroup + patient picker */
function wrapGenerateBill(){
  if(typeof window.generateBill!=='function' || window.generateBill.__insV100) return;
  var _gb=window.generateBill;
  window.generateBill=function(){
    _gb.apply(this,arguments);
    try{
      var D=D_(); var sel=$('gb_patient'); if(!sel) return;
      /* add Insurance Providers optgroup if not present */
      if(sel.querySelectorAll('optgroup[label="Insurance Providers"]').length===0){
        var og=document.createElement('optgroup'); og.label='Insurance Providers';
        (D.insuranceProviders||[]).filter(function(p){return p.status!=='Inactive';}).forEach(function(p){
          var o=document.createElement('option'); o.value='INS:'+p.id; o.textContent='🛡 '+p.name+' ('+(p.coverage||0)+'% cover)'; og.appendChild(o);
        });
        sel.appendChild(og);
      }
      /* insert the patient-picker container right after the payer field */
      if(!$('gb_ins_wrap')){
        var grp=sel.closest?sel.closest('.form-group'):sel.parentElement;
        var w=document.createElement('div'); w.className='form-group full'; w.id='gb_ins_wrap'; w.style.display='none';
        if(grp&&grp.parentElement){ grp.parentElement.insertBefore(w, grp.nextSibling); }
      }
      /* route the change through one dispatcher (insurance vs. everything else) */
      sel.setAttribute('onchange', 'window.gbPayerDispatch()');
    }catch(e){ try{console.log('[v100 gb]',e.message);}catch(_){} }
  };
  window.generateBill.__insV100=true;
}

/* re-wrap saveBill to handle the insurance-provider path */
function wrapSaveBill(){
  if(typeof window.saveBill!=='function' || window.saveBill.__insV100) return;
  var _sb=window.saveBill;
  window.saveBill=function(){
    var D=D_(); var sel=$('gb_patient'); var raw=sel?sel.value:'';
    var m=/^INS:(\d+)$/.exec(raw||'');
    if(!m){ return _sb.apply(this,arguments); }
    var prov=(D.insuranceProviders||[]).find(function(x){return x.id===+m[1];});
    var ip=$('gb_ins_patient'); var pid=ip?parseInt(ip.value):0;
    if(!pid){ toasty('Select a patient attached to '+(prov?prov.name:'the provider'),'err'); return; }
    var p=(D.patients||[]).find(function(x){return x.id===pid;});
    var total=parseFloat(($('gb_total')||{}).value)||0;
    var discount=parseFloat(($('gb_discount')||{}).value)||0;
    var items=(window.__gbItems||[]).filter(function(it){return (it.s&&String(it.s).trim())||(+it.a>0);}).map(function(it){return {s:String(it.s||'Charge').trim(),a:+it.a||0,category:it.category||'Insurance'};});
    if(!items.length){ toasty('Enter at least one charge line with the provider fee','err'); return; }
    var net=total-discount;
    if(net<=0){ toasty('Enter the provider fee for the charge lines','err'); return; }
    var bill={id:genId(),code:($('gb_code')||{}).value||('BILL-'+uidv()),patientId:pid,
      payerType:'Insurance',payerId:prov?prov.id:null,payerName:(prov?prov.name:'Insurance')+' — '+(p?p.fullName:''),
      insuranceProvider:prov?prov.name:'',date:($('gb_date')||{}).value||tdy(),type:($('gb_type')||{}).value||'Insurance',
      total:net,discount:discount,paid:0,balance:net,status:'Pending',items:items};
    (D.bills=D.bills||[]).push(bill);
    audit('FINANCE','Billing','CREATE','Insurance bill for '+(p?p.fullName:'')+' via '+(prov?prov.name:'')+' — '+money(net),'Medium');
    /* auto insurance claim if enabled */
    try{
      if((D.settings||{}).autoInsuranceClaim==='true' && prov){
        D.insuranceClaims=D.insuranceClaims||[];
        var appr=Math.round(net*((prov.coverage||0)/100));
        D.insuranceClaims.push({id:genId(),code:'CLM-'+uidv(),patientId:pid,providerId:prov.id,billCode:bill.code,amountBilled:net,amountApproved:appr,status:'Submitted',date:tdy()});
        audit('FINANCE','Insurance','CLAIM','Auto-claim raised to '+prov.name+' — billed '+money(net),'Medium');
      }
    }catch(e){}
    save(); toasty('Insurance bill generated — '+money(net)); try{closeModal();}catch(e){} try{render();}catch(e){}
  };
  window.saveBill.__insV100=true;
}

/* ════════════════════════════════════════════════════════════════════
   MODULE 5 — Print Receipt (for a bill or a payment transaction)
   ════════════════════════════════════════════════════════════════════ */
window.printReceipt=function(billId){
  var D=D_(); var b=(D.bills||[]).find(function(x){return x.id===billId;}); if(!b){ toasty('Bill not found','err'); return; }
  var p=(D.patients||[]).find(function(x){return x.id===b.patientId;});
  var payer=(typeof payerOf==='function')?payerOf(b):(b.payerName||(p?p.fullName:'—'));
  var txns=(D.transactions||[]).filter(function(t){return t.billCode===b.code && t.status==='Completed';});
  var s=D.settings||{};
  var itemsHtml=(b.items&&b.items.length)?b.items.map(function(it,i){return '<tr><td>'+(i+1)+'</td><td>'+esc(it.s)+'</td><td style="text-align:right;font-weight:700">'+money(it.a)+'</td></tr>';}).join(''):'<tr><td colspan="3">—</td></tr>';
  var payHtml=txns.length?txns.map(function(t){return '<tr><td>'+esc(t.date)+'</td><td>'+esc(t.code)+'</td><td>'+esc(t.method)+'</td><td style="text-align:right">'+money(t.amount)+'</td></tr>';}).join(''):'<tr><td colspan="4" style="text-align:center;color:#94a3b8">No payments recorded yet</td></tr>';
  var html=''
    +'<div style="text-align:center;margin-bottom:16px"><div style="font-size:20px;font-weight:800">'+esc(s.hospitalName||'Hospital')+'</div>'
    +'<div style="font-size:12px;color:#64748b">'+esc(s.address||'')+(s.phone?(' · '+esc(s.phone)):'')+'</div>'
    +'<div style="margin-top:8px;font-size:15px;font-weight:800;letter-spacing:2px;color:#0d9488">PAYMENT RECEIPT</div></div>'
    +'<div style="display:flex;justify-content:space-between;margin-bottom:14px;padding:12px;background:#f8fafc;border-radius:8px;font-size:12px">'
      +'<div><b>Receipt / Bill:</b> '+esc(b.code)+'<br><b>Date:</b> '+esc(b.date)+'<br><b>Type:</b> '+esc(b.type||'General')+'</div>'
      +'<div style="text-align:right"><b>Received From:</b> '+esc(payer)+'<br>'+(p?('<b>MRN:</b> '+esc(p.mrn)+'<br>'):'')+(b.insuranceProvider?('<b>Insurer:</b> '+esc(b.insuranceProvider)):'')+'</div></div>'
    +'<table style="width:100%;margin-bottom:14px;border-collapse:collapse"><thead><tr><th style="text-align:left">#</th><th style="text-align:left">Description</th><th style="text-align:right">Amount</th></tr></thead><tbody>'+itemsHtml+'</tbody></table>'
    +'<div style="display:flex;justify-content:flex-end;margin-bottom:14px"><div style="width:260px">'
      +'<div style="display:flex;justify-content:space-between;padding:5px 0;border-bottom:1px solid #e2e8f0"><span>Total Bill</span><b>'+money(b.total)+'</b></div>'
      +'<div style="display:flex;justify-content:space-between;padding:5px 0;border-bottom:1px solid #e2e8f0"><span>Amount Paid</span><span style="color:#059669">'+money(b.paid)+'</span></div>'
      +'<div style="display:flex;justify-content:space-between;padding:7px 0;font-size:15px;font-weight:800;color:'+(b.balance>0?'#dc2626':'#059669')+'"><span>Balance Due</span><span>'+money(b.balance)+'</span></div></div></div>'
    +'<div style="font-size:12px;font-weight:700;margin-bottom:4px">Payment History</div>'
    +'<table style="width:100%;border-collapse:collapse;font-size:11px"><thead><tr><th style="text-align:left">Date</th><th style="text-align:left">Txn</th><th style="text-align:left">Method</th><th style="text-align:right">Amount</th></tr></thead><tbody>'+payHtml+'</tbody></table>'
    +'<div style="margin-top:24px;display:flex;justify-content:space-between;font-size:11px;color:#64748b"><div>Cashier: '+esc((D.currentUser&&D.currentUser.fullName)||'—')+'</div><div>Printed: '+new Date().toLocaleString()+'</div></div>'
    +(s.smsReceipt==='true'?'<div style="margin-top:10px;font-size:10px;color:#0d9488"><i class="fa-solid fa-sms"></i> An SMS copy of this receipt has been queued to the payer.</div>':'')
    +'<div style="text-align:center;margin-top:14px;font-size:11px;color:#94a3b8">Thank you. This is a computer-generated receipt.</div>';
  if(typeof printContent==='function') printContent('Receipt — '+b.code, html);
  else { var w=window.open('','_blank'); w.document.write('<html><head><title>Receipt</title></head><body>'+html+'</body></html>'); w.print(); }
  if(s.smsReceipt==='true') toasty('Receipt printed · SMS copy queued');
};

/* add a Print Receipt button onto each bill card (Billing tab) */
function wrapBillsTabReceipt(){
  if(typeof window.renderBillsTab!=='function' || window.renderBillsTab.__rcptV100) return;
  var _r=window.renderBillsTab;
  window.renderBillsTab=function(){
    var h=_r.apply(this,arguments);
    try{
      /* inject a Receipt button next to every Invoice print button */
      h=h.replace(/onclick="printInvoice\((\d+)\)"><i class="fa-solid fa-print"><\/i><\/button>/g,
        'onclick="printInvoice($1)"><i class="fa-solid fa-print"></i></button><button class="act-btn" title="Print Receipt" style="color:#0d9488" onclick="printReceipt($1)"><i class="fa-solid fa-receipt"></i></button>');
    }catch(e){}
    return h;
  };
  window.renderBillsTab.__rcptV100=true;
}

/* ════════════════════════════════════════════════════════════════════
   MODULE 6 — Lab Test Catalogue price (default 10000, editable) and use it
   when ordering a lab test if no fee-schedule entry exists.
   ════════════════════════════════════════════════════════════════════ */
function seedLabPrices(){
  var D=D_(); if(!Array.isArray(D.labTestCatalog)) return;
  var changed=false;
  D.labTestCatalog.forEach(function(t){ if(t.price==null||t.price===''){ t.price=10000; changed=true; } });
  if(changed) save();
}

/* wrap the catalogue renderer to add a Price column */
function wrapCatalogRender(){
  if(typeof window.renderConfigLabTests!=='function' || window.renderConfigLabTests.__priceV100) return;
  var _r=window.renderConfigLabTests;
  window.renderConfigLabTests=function(){
    seedLabPrices();
    var h=_r.apply(this,arguments);
    try{
      /* add a Price header before Actions */
      h=h.replace('<th>TAT / SLA</th><th>Actions</th>','<th>TAT / SLA</th><th>Price (₦)</th><th>Actions</th>');
      /* the body is rebuilt by cfgLabTestFilter; override rows below via re-render */
    }catch(e){}
    /* rebuild the body with price cells */
    setTimeout(function(){
      try{
        var body=document.getElementById('cfgLabBody'); if(!body) return;
        var list=(D_().labTestCatalog||[]);
        body.innerHTML=labRowsWithPrice(list);
      }catch(e){}
    },0);
    return h;
  };
  window.renderConfigLabTests.__priceV100=true;
}
function labRowsWithPrice(list){
  if(!list.length) return '<tr><td colspan="7" style="text-align:center;color:var(--txt3);padding:18px">No tests found. Click "Add Test" to create one.</td></tr>';
  return list.map(function(t,i){
    return '<tr>'
      +'<td style="color:var(--txt3)">'+(i+1)+'</td>'
      +'<td class="bold">'+esc(t.test||'—')+'</td>'
      +'<td><span class="st st-scheduled">'+esc(t.category||'—')+'</span></td>'
      +'<td style="font-size:12px;color:var(--txt2)">'+esc(t.sampleType||'—')+'</td>'
      +'<td style="font-size:12px;color:var(--txt2)">'+esc(t.tatSla||'—')+'</td>'
      +'<td style="font-weight:700;color:var(--pri)">'+money(t.price!=null?t.price:10000)+'</td>'
      +'<td><div class="act-row">'
        +'<button class="act-btn edit" title="Edit" onclick="cfgLabTestModal('+t.id+')"><i class="fa-solid fa-edit"></i></button>'
        +'<button class="act-btn del" title="Delete" onclick="cfgLabTestDelete('+t.id+')"><i class="fa-solid fa-trash"></i></button>'
      +'</div></td></tr>';
  }).join('');
}
/* wrap the filter so the price column persists when searching */
function wrapCatalogFilter(){
  if(typeof window.cfgLabTestFilter!=='function' || window.cfgLabTestFilter.__priceV100) return;
  window.cfgLabTestFilter=function(q){
    q=(q||'').toLowerCase().trim();
    var list=(D_().labTestCatalog||[]).filter(function(t){
      if(!q) return true;
      return (String(t.test||'').toLowerCase().indexOf(q)>=0)||(String(t.category||'').toLowerCase().indexOf(q)>=0)||(String(t.sampleType||'').toLowerCase().indexOf(q)>=0);
    });
    var b=document.getElementById('cfgLabBody'); if(b) b.innerHTML=labRowsWithPrice(list);
  };
  window.cfgLabTestFilter.__priceV100=true;
}
/* wrap the add/edit modal to include a Price field (default 10000) */
function wrapCatalogModal(){
  if(typeof window.cfgLabTestModal!=='function' || window.cfgLabTestModal.__priceV100) return;
  var _m=window.cfgLabTestModal;
  window.cfgLabTestModal=function(id){
    _m.apply(this,arguments);
    try{
      var D=D_(); var rec=(id!=null)?(D.labTestCatalog||[]).find(function(x){return x.id===id;}):null;
      var grid=document.querySelectorAll('.modal .form-grid, .form-grid'); grid=grid[grid.length-1];
      if(grid && !document.getElementById('clt_price')){
        var g=document.createElement('div'); g.className='form-group';
        g.innerHTML='<label>Price (₦) <span class="req">*</span></label><input id="clt_price" type="number" min="0" value="'+(rec&&rec.price!=null?rec.price:10000)+'" placeholder="10000">';
        grid.appendChild(g);
      }
    }catch(e){}
  };
  window.cfgLabTestModal.__priceV100=true;
}
/* wrap save to persist the price */
function wrapCatalogSave(){
  if(typeof window.cfgSaveLabTest!=='function' || window.cfgSaveLabTest.__priceV100) return;
  var _s=window.cfgSaveLabTest;
  window.cfgSaveLabTest=function(id){
    var priceEl=document.getElementById('clt_price');
    var price=priceEl?(parseFloat(priceEl.value)||10000):10000;
    _s.apply(this,arguments);
    try{
      var D=D_(); var list=D.labTestCatalog||[];
      var rec=(id!=null&&id!=='null')?list.find(function(x){return x.id===id;}):list[list.length-1];
      if(rec){ rec.price=price; save(); }
      var c=document.getElementById('configContent'); if(c && typeof renderConfigLabTests==='function') c.innerHTML=renderConfigLabTests();
    }catch(e){}
  };
  window.cfgSaveLabTest.__priceV100=true;
}
/* make the lab-order price engine fall back to the catalogue price (default 10000) */
function wrapLabPricing(){
  window.TWHtx=window.TWHtx||{};
  if(window.TWHtx.priceLabTest && window.TWHtx.priceLabTest.__priceV100) return;
  var _pl=window.TWHtx.priceLabTest;
  window.TWHtx.priceLabTest=function(name){
    var v=0; try{ v=_pl?(+_pl(name)||0):0; }catch(e){ v=0; }
    if(v>0) return v;
    var D=D_(); var n=String(name||'').toLowerCase().trim();
    var hit=(D.labTestCatalog||[]).find(function(t){ return String(t.test||'').toLowerCase().trim()===n; });
    if(hit && hit.price!=null) return +hit.price||10000;
    return 10000; /* default catalogue price */
  };
  window.TWHtx.priceLabTest.__priceV100=true;
}

/* ════════════════════════════════════════════════════════════════════
   MODULE 7 — Add Approval Workflow: Step 4 + "Add Role" button for more steps
   ════════════════════════════════════════════════════════════════════ */
function roleOptions(sel){ return (D_().cfgLists.systemRoles||[]).map(function(r){return '<option value="'+esc(r)+'"'+(r===sel?' selected':'')+'>'+esc(r)+'</option>';}).join(''); }
window.wfAddRoleStep=function(){
  var box=document.getElementById('wf_extra_steps'); if(!box) return;
  var n=box.querySelectorAll('.wf-extra-step').length + 4; /* steps 1-3 fixed, extras start at 4 */
  var div=document.createElement('div');
  div.className='form-group full wf-extra-step';
  div.innerHTML='<label>Step '+n+' — Role (optional)</label>'
    +'<select class="wf-extra-role"><option value="">— None —</option>'+roleOptions('')+'</select> '
    +'<button type="button" class="btn btn-xs btn-ghost" style="color:#dc2626" onclick="this.parentElement.remove()"><i class="fa-solid fa-times"></i> Remove</button>';
  box.appendChild(div);
};
window.addWorkflow=function(){
  var roleO=roleOptions('');
  showModal('<i class="fa-solid fa-plus-circle" style="color:var(--pri);margin-right:8px"></i>Add Approval Workflow',
    '<div class="form-grid">'
    +'<div class="form-group"><label>Code <span class="req">*</span></label><input id="wf_code" placeholder="e.g. WF-NEW" style="text-transform:uppercase"></div>'
    +'<div class="form-group"><label>Workflow Name <span class="req">*</span></label><input id="wf_name" placeholder="e.g. New Process Approval"></div>'
    +'<div class="form-group"><label>Module</label><select id="wf_module"><option value="Staff Claims">Staff Claims</option><option value="Leave Management">Leave Management</option><option value="Procurement">Procurement</option><option value="Payroll">Payroll</option><option value="Billing">Billing</option><option value="Clinical">Clinical</option><option value="General">General</option></select></div>'
    +'<div class="form-group"><label>Status</label><select id="wf_status"><option value="Active">Active</option><option value="Inactive">Inactive</option></select></div>'
    +'<div class="form-group full"><label>Step 1 — Role</label><select id="wf_s1">'+roleO+'</select></div>'
    +'<div class="form-group full"><label>Step 2 — Role (optional)</label><select id="wf_s2"><option value="">— None —</option>'+roleO+'</select></div>'
    +'<div class="form-group full"><label>Step 3 — Role (optional)</label><select id="wf_s3"><option value="">— None —</option>'+roleO+'</select></div>'
    +'<div class="form-group full"><label>Step 4 — Role (optional)</label><select id="wf_s4"><option value="">— None —</option>'+roleO+'</select></div>'
    +'<div id="wf_extra_steps" class="full"></div>'
    +'<div class="form-group full"><button type="button" class="btn btn-sm btn-ghost" style="border:1px dashed var(--bdr)" onclick="wfAddRoleStep()"><i class="fa-solid fa-plus"></i> Step 4 — Role (optional) · add more roles</button></div>'
    +'</div>',
    '<button class="btn btn-pri" onclick="saveWorkflow()"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
};
window.saveWorkflow=function(){
  var D=D_();
  var code=($('wf_code')||{}).value.toUpperCase(); var name=($('wf_name')||{}).value;
  if(!code||!name){ toasty('Code and Name required','err'); return; }
  var steps=[]; var order=0;
  ['wf_s1','wf_s2','wf_s3','wf_s4'].forEach(function(id){
    var v=($(id)||{}).value; if(v){ order++; steps.push({order:order,role:v,action:order===1?'Review & Approve':'Approve',sla:'2 days'}); }
  });
  document.querySelectorAll('#wf_extra_steps .wf-extra-role').forEach(function(s){
    if(s.value){ order++; steps.push({order:order,role:s.value,action:'Approve',sla:'2 days'}); }
  });
  if(steps.length){ steps[steps.length-1].action='Final Approval'; }
  D.approvalWorkflows=D.approvalWorkflows||[];
  D.approvalWorkflows.push({id:genId(),code:code,name:name,module:($('wf_module')||{}).value,steps:steps,status:($('wf_status')||{}).value});
  save(); toasty('Workflow created with '+steps.length+' step(s)'); try{closeModal();}catch(e){} try{render();}catch(e){}
};

/* boot all of module 4-7 */
function boot2(){
  wrapEditablePatientServices();
  wrapGenerateBill(); wrapSaveBill(); wrapBillsTabReceipt();
  seedLabPrices(); wrapCatalogRender(); wrapCatalogFilter(); wrapCatalogModal(); wrapCatalogSave(); wrapLabPricing();
}
boot2(); setTimeout(boot2,800); setTimeout(boot2,2500); setTimeout(boot2,6000);
if(document.readyState==='loading'){ window.addEventListener('DOMContentLoaded', boot2); }
try{ console.log('%c✅ v100/2 — insurance billing · editable charges · receipts · lab price · approval step 4','color:#7c3aed;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/079-end-v100-2.js ==== */
/* ════ v102 REFERRAL & INSURANCE BILLING ════ */
/* ════════════════════════════════════════════════════════════════════════
   v102 — REFERRAL & INSURANCE BILLING  (Bill of Supply)
   Adds a self-contained module that produces "Bill of Supply" statements for
   BOTH Referral Customers and Insurance Providers, with an editable per-line
   "Customer / Referral / Insurance Provider's Price" column.
   Additive only: wraps renderModule / buildNav / getModTitle. No core edits.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  "use strict";

  /* ---------- safe helpers (fall back if app globals not ready) ---------- */
  function D_(){ return window.D || (window.D = {}); }
  function money(n){ try{ return window.F ? window.F(n) : '₦'+Number(n||0).toLocaleString(); }catch(e){ return '₦'+(n||0); } }
  function save(){ try{ if(window._hmsSave) window._hmsSave(); }catch(e){} }
  function toasty(m){ try{ if(window.toast) window.toast(m); }catch(e){} }
  function rid(){ return Date.now().toString(36)+Math.random().toString(36).slice(2,7); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function num(v){ v=parseFloat(String(v).replace(/[^0-9.\-]/g,'')); return isNaN(v)?0:v; }

  /* ---------- line maths ---------- */
  function lineNet(l){ return Math.max(0, num(l.partnerPrice) - num(l.disc)); }
  function lineDue(l){ return Math.max(0, lineNet(l) - num(l.paid)); }
  function stmtTotals(s){
    var t={mrp:0,disc:0,price:0,net:0,paid:0,due:0};
    (s.lines||[]).forEach(function(l){
      t.mrp+=num(l.mrp); t.disc+=num(l.disc); t.price+=num(l.partnerPrice);
      t.net+=lineNet(l); t.paid+=num(l.paid); t.due+=lineDue(l);
    });
    return t;
  }

  /* ---------- party helpers ---------- */
  function clients(){ var D=D_(); if(!Array.isArray(D.partnerClients)) D.partnerClients=[]; return D.partnerClients; }
  function insurers(){ var D=D_(); return Array.isArray(D.insuranceProviders)?D.insuranceProviders:[]; }
  function statements(){ var D=D_(); if(!Array.isArray(D.partnerStatements)) D.partnerStatements=[]; return D.partnerStatements; }
  function partyLabel(kind,id){
    if(kind==='insurer'){ var i=insurers().find(function(x){return String(x.id)===String(id);}); return i?i.name:'Insurer'; }
    var c=clients().find(function(x){return String(x.id)===String(id);}); return c?c.name:'Referral Customer';
  }
  function partyMeta(kind,id){
    if(kind==='insurer'){ var i=insurers().find(function(x){return String(x.id)===String(id);})||{}; return {name:i.name||'',code:('INS-'+(i.id||'')),address:i.address||'',city:i.city||'',type:i.type||'Insurance'}; }
    var c=clients().find(function(x){return String(x.id)===String(id);})||{}; return {name:c.name||'',code:c.code||'',address:c.address||'',city:c.city||'',type:c.type||'Referral'};
  }
  function statementsFor(kind,id){ return statements().filter(function(s){return s.partyKind===kind && String(s.partyId)===String(id);}); }

  /* ---------- module selection state ---------- */
  var PB = window.PB = window.PB || {};
  PB._kind = PB._kind || null;
  PB._partyId = PB._partyId || null;
  PB._stmtId = PB._stmtId || null;

  function currentStmt(){ return statements().find(function(s){return s.id===PB._stmtId;}) || null; }

  function ensureSelection(){
    // pick a sensible default if nothing chosen
    if(!PB._stmtId){
      var s = statements()[0];
      if(s){ PB._kind=s.partyKind; PB._partyId=s.partyId; PB._stmtId=s.id; }
    }
  }

  PB.go = function(){ ensureSelection(); if(window.goTo) window.goTo('partnerbilling'); };

  PB.selectParty = function(val){
    if(!val){ return; }
    var p = val.split(':'); PB._kind=p[0]; PB._partyId=p[1];
    var list = statementsFor(PB._kind, PB._partyId);
    PB._stmtId = list.length? list[list.length-1].id : null;
    if(!PB._stmtId){ PB.newStatement(true); } else { rerender(); }
  };

  PB.selectStatement = function(id){ PB._stmtId=id; var s=currentStmt(); if(s){PB._kind=s.partyKind;PB._partyId=s.partyId;} rerender(); };

  /* ---------- editing ---------- */
  function findLine(stmtId,lineId){ var s=statements().find(function(x){return x.id===stmtId;}); if(!s) return null; return (s.lines||[]).find(function(l){return l.id===lineId;}); }

  PB.setPrice = function(stmtId,lineId,val){ var l=findLine(stmtId,lineId); if(!l) return; l.partnerPrice=num(val); save(); rerender(); };
  PB.setField = function(stmtId,lineId,field,val){ var l=findLine(stmtId,lineId); if(!l) return; l[field]=(field==='disc'||field==='paid'||field==='mrp')?num(val):val; save(); rerender(); };

  PB.deleteLine = function(stmtId,lineId){
    var s=statements().find(function(x){return x.id===stmtId;}); if(!s) return;
    s.lines=(s.lines||[]).filter(function(l){return l.id!==lineId;});
    save(); rerender();
  };

  PB.bulkApplyPct = function(stmtId){
    var s=statements().find(function(x){return x.id===stmtId;}); if(!s) return;
    var v=prompt('Set every line\'s price to this % of MRP (e.g. 100 = same as MRP, 80 = 20% off):','100');
    if(v===null) return; var pct=num(v)/100;
    (s.lines||[]).forEach(function(l){ l.partnerPrice=Math.round(num(l.mrp)*pct); });
    save(); toasty('Applied '+v+'% of MRP to all lines'); rerender();
  };

  /* ---------- new statement ---------- */
  PB.newStatement = function(silent){
    if(!PB._kind || !PB._partyId){ toasty('Pick a billing party first'); return; }
    var meta=partyMeta(PB._kind,PB._partyId);
    var count=statementsFor(PB._kind,PB._partyId).length+1;
    var s={
      id:rid(), partyKind:PB._kind, partyId:PB._partyId,
      billNo:'BOS-'+(meta.code||'NEW')+'-'+String(count).padStart(2,'0'),
      issueDate:(window.today?window.today():new Date().toISOString().slice(0,10)),
      periodFrom:(window.today?window.today():new Date().toISOString().slice(0,10)),
      periodTo:(window.today?window.today():new Date().toISOString().slice(0,10)),
      lines:[]
    };
    statements().push(s); PB._stmtId=s.id; save();
    if(!silent) toasty('New Bill of Supply created'); rerender();
  };

  PB.setStmtField = function(stmtId,field,val){ var s=statements().find(function(x){return x.id===stmtId;}); if(!s) return; s[field]=val; save(); };

  /* ---------- add line modal ---------- */
  PB.addLine = function(stmtId){
    var D=D_(); var fees=Array.isArray(D.feeSchedule)?D.feeSchedule:[];
    var opts='<option value="">— pick a service —</option>'+fees.map(function(f){
      return '<option value="'+esc(f.service)+'" data-amt="'+(f.amount||0)+'">'+esc(f.service)+' ('+money(f.amount||0)+')</option>';
    }).join('');
    var body=''
      +'<div class="form-grid">'
      +' <div class="form-group"><label>Date</label><input type="date" id="pb_date" value="'+(window.today?window.today():'')+'"></div>'
      +' <div class="form-group"><label>Patient Id</label><input id="pb_pid" placeholder="e.g. FD002501"></div>'
      +' <div class="form-group"><label>Patient Name</label><input id="pb_pname" placeholder="Patient name / code"></div>'
      +' <div class="form-group full"><label>Description Of Service</label>'
      +'   <select id="pb_svc" onchange="PB._svcPick()">'+opts+'</select>'
      +'   <input id="pb_svctxt" placeholder="…or type a custom service" style="margin-top:6px">'
      +' </div>'
      +' <div class="form-group"><label>MRP (standard ₦)</label><input id="pb_mrp" type="number" value="0"></div>'
      +' <div class="form-group"><label>Price for this party (₦)</label><input id="pb_price" type="number" value="0"></div>'
      +' <div class="form-group"><label>Discount (₦)</label><input id="pb_disc" type="number" value="0"></div>'
      +' <div class="form-group"><label>Paid (₦)</label><input id="pb_paid" type="number" value="0"></div>'
      +'</div>'
      +'<div style="font-size:11px;color:var(--txt2);margin-top:6px"><i class="fa-solid fa-circle-info"></i> Leave “Price for this party” equal to MRP for no special pricing, or set the agreed referral/insurer rate.</div>';
    var footer=''
      +'<button class="btn btn-pri" onclick="PB.saveNewLine(\''+stmtId+'\')"><i class="fa-solid fa-plus"></i> Add Line</button>'
      +'<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>';
    if(window.showModal) window.showModal('<i class="fa-solid fa-plus" style="color:var(--pri);margin-right:8px"></i>Add Service Line', body, footer, 'wide');
  };
  PB._svcPick=function(){
    var sel=document.getElementById('pb_svc'); if(!sel) return;
    var o=sel.options[sel.selectedIndex]; var amt=o?num(o.getAttribute('data-amt')):0;
    var txt=document.getElementById('pb_svctxt'); if(txt) txt.value=sel.value;
    var m=document.getElementById('pb_mrp'); var p=document.getElementById('pb_price');
    if(m) m.value=amt; if(p && (!num(p.value))) p.value=amt;
  };
  PB.saveNewLine = function(stmtId){
    var s=statements().find(function(x){return x.id===stmtId;}); if(!s) return;
    function g(id){ var e=document.getElementById(id); return e?e.value:''; }
    var svc = g('pb_svctxt') || g('pb_svc');
    if(!svc){ toasty('Please choose or type a service'); return; }
    var mrp=num(g('pb_mrp')); var price=num(g('pb_price')); if(!price) price=mrp;
    s.lines=s.lines||[];
    s.lines.push({ id:rid(), date:(g('pb_date')||'').split('-').reverse().join('/'), patientId:g('pb_pid'),
      patientName:g('pb_pname'), service:svc, mrp:mrp, partnerPrice:price, disc:num(g('pb_disc')), paid:num(g('pb_paid')) });
    save(); if(window.closeModal) window.closeModal(); toasty('Line added'); rerender();
  };

  /* ---------- manage referral customers ---------- */
  PB.manageParties = function(){
    var rows=clients().map(function(c){
      return '<tr><td><b>'+esc(c.code||'')+'</b></td><td>'+esc(c.name)+'</td><td>'+esc(c.city||'')+'</td>'
        +'<td><span class="st st-active">'+esc(c.status||'Active')+'</span></td>'
        +'<td><button class="act-btn del" onclick="PB.removeParty(\''+c.id+'\')"><i class="fa-solid fa-trash"></i></button></td></tr>';
    }).join('') || '<tr><td colspan="5" style="color:var(--txt3)">No referral customers yet</td></tr>';
    var body=''
      +'<div style="font-size:12px;color:var(--txt2);margin-bottom:10px">Referral customers are external clinics/hospitals/labs you bill. Insurance providers come from the Insurance module automatically.</div>'
      +'<div class="form-grid">'
      +' <div class="form-group"><label>Code</label><input id="pp_code" placeholder="e.g. F00130"></div>'
      +' <div class="form-group"><label>Name</label><input id="pp_name" placeholder="Customer / hospital name"></div>'
      +' <div class="form-group"><label>City</label><input id="pp_city" placeholder="City"></div>'
      +' <div class="form-group full"><label>Address</label><input id="pp_addr" placeholder="Address"></div>'
      +'</div>'
      +'<button class="btn btn-pri btn-sm" style="margin:6px 0 14px" onclick="PB.addParty()"><i class="fa-solid fa-plus"></i> Add Referral Customer</button>'
      +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Name</th><th>City</th><th>Status</th><th></th></tr></thead><tbody>'+rows+'</tbody></table></div>';
    if(window.showModal) window.showModal('<i class="fa-solid fa-handshake" style="color:var(--pri);margin-right:8px"></i>Manage Referral Customers', body, '<button class="btn btn-ghost" onclick="closeModal()">Close</button>', 'wide');
  };
  PB.addParty = function(){
    function g(id){ var e=document.getElementById(id); return e?e.value.trim():''; }
    var name=g('pp_name'); if(!name){ toasty('Enter a name'); return; }
    clients().push({ id:rid(), code:g('pp_code')||('F'+Math.floor(Math.random()*90000+10000)), name:name, city:g('pp_city'), address:g('pp_addr'), type:'Referral', status:'Active' });
    save(); PB.manageParties();
  };
  PB.removeParty = function(id){
    var D=D_(); D.partnerClients=clients().filter(function(c){return c.id!==id;});
    save(); PB.manageParties();
  };

  /* ---------- exports ---------- */
  PB.exportExcel = function(stmtId){
    var s=statements().find(function(x){return x.id===stmtId;}); if(!s){ toasty('No statement'); return; }
    var rows=(s.lines||[]).map(function(l,i){ return {
      Sr:i+1, Date:l.date, PatientId:l.patientId, PatientName:l.patientName, Service:l.service,
      MRP:num(l.mrp), Disc:num(l.disc), PartyPrice:num(l.partnerPrice), Net:lineNet(l), Paid:num(l.paid), Due:lineDue(l)
    };});
    if(window.exportExcel) window.exportExcel('Bill of Supply — '+partyLabel(s.partyKind,s.partyId),
      ['Sr','Date','PatientId','PatientName','Service','MRP','Disc','PartyPrice','Net','Paid','Due'], rows);
    else toasty('Excel export not available');
  };

  PB.exportPDF = function(stmtId){
    var s=statements().find(function(x){return x.id===stmtId;}); if(!s){ toasty('No statement'); return; }
    var jsPDF = (window.jspdf&&window.jspdf.jsPDF)||window.jsPDF; 
    if(!jsPDF){ toasty('PDF library not loaded'); return; }
    var meta=partyMeta(s.partyKind,s.partyId);
    var doc=new jsPDF({unit:'pt',format:'a4'}); var W=doc.internal.pageSize.getWidth();
    var hosp=(D_().settings&&D_().settings.hospitalName)||'Tranquil Hospital & Wellness Centre';
    doc.setFontSize(15); doc.setTextColor(13,148,136); doc.text('Bill of Supply',40,46);
    doc.setFontSize(9); doc.setTextColor(90); doc.text(hosp,W-40,40,{align:'right'});
    doc.text(((D_().settings&&D_().settings.address)||''),W-40,53,{align:'right'});
    doc.setDrawColor(220); doc.line(40,58,W-40,58);
    doc.setTextColor(30); doc.setFontSize(9);
    var L=70;
    doc.text('Bill To: '+(meta.name||''),40,L);
    doc.text('Client Code: '+(meta.code||''),40,L+13);
    if(meta.address) doc.text('Address: '+meta.address,40,L+26);
    doc.text('Bill No: '+(s.billNo||''),W-40,L,{align:'right'});
    doc.text('Date Of Issue: '+(s.issueDate||''),W-40,L+13,{align:'right'});
    doc.text('Bill Period: '+(s.periodFrom||'')+' to '+(s.periodTo||''),W-40,L+26,{align:'right'});
    var t=stmtTotals(s);
    var body=(s.lines||[]).map(function(l,i){ return [i+1,l.date,l.patientId,l.patientName,l.service,
      num(l.mrp).toLocaleString(),num(l.disc).toLocaleString(),num(l.partnerPrice).toLocaleString(),
      lineNet(l).toLocaleString(),num(l.paid).toLocaleString(),lineDue(l).toLocaleString()];});
    body.push([{content:'TOTAL',colSpan:5,styles:{halign:'right',fontStyle:'bold'}},
      t.mrp.toLocaleString(),t.disc.toLocaleString(),t.price.toLocaleString(),t.net.toLocaleString(),t.paid.toLocaleString(),t.due.toLocaleString()]);
    doc.autoTable({
      startY:L+40,
      head:[['Sr','Date','Patient Id','Patient Name','Description Of Service','MRP','Disc','Price','Net Value','Paid','Due']],
      body:body,
      styles:{fontSize:7,cellPadding:3,overflow:'linebreak'},
      headStyles:{fillColor:[13,148,136],textColor:255,fontSize:7},
      columnStyles:{0:{cellWidth:18},4:{cellWidth:120},7:{fillColor:[240,253,250],fontStyle:'bold'}},
      theme:'grid', margin:{left:40,right:40}
    });
    doc.save((s.billNo||'bill-of-supply')+'.pdf');
    toasty('PDF generated');
  };

  /* ---------- render ---------- */
  function rerender(){ try{ if(window.render) window.render(); }catch(e){} }

  function partySelector(){
    var groups='';
    var ci=clients().map(function(c){ var v='client:'+c.id; var sel=(PB._kind==='client'&&String(PB._partyId)===String(c.id))?' selected':''; return '<option value="'+v+'"'+sel+'>'+esc(c.name)+(c.code?' ('+esc(c.code)+')':'')+'</option>'; }).join('');
    var ii=insurers().map(function(p){ var v='insurer:'+p.id; var sel=(PB._kind==='insurer'&&String(PB._partyId)===String(p.id))?' selected':''; return '<option value="'+v+'"'+sel+'>'+esc(p.name)+'</option>'; }).join('');
    if(ci) groups+='<optgroup label="Referral Customers">'+ci+'</optgroup>';
    if(ii) groups+='<optgroup label="Insurance Providers">'+ii+'</optgroup>';
    return '<select onchange="PB.selectParty(this.value)" style="min-width:280px;padding:8px 12px;border:1.5px solid var(--bdr);border-radius:10px;font-size:13px;font-family:inherit">'
      +'<option value="">— select billing party —</option>'+groups+'</select>';
  }

  function statementPicker(){
    if(!PB._kind||!PB._partyId) return '';
    var list=statementsFor(PB._kind,PB._partyId);
    if(list.length<=1) return '';
    return '<select onchange="PB.selectStatement(this.value)" style="padding:8px 12px;border:1.5px solid var(--bdr);border-radius:10px;font-size:13px;font-family:inherit">'
      +list.map(function(s){ return '<option value="'+s.id+'"'+(s.id===PB._stmtId?' selected':'')+'>'+esc(s.billNo)+'</option>'; }).join('')+'</select>';
  }

  window.renderPartnerBilling = function(){
    ensureSelection();
    var s=currentStmt();
    var meta = s? partyMeta(s.partyKind,s.partyId) : null;
    var kpiCount = statements().length;
    var totalDue = statements().reduce(function(a,st){ return a+stmtTotals(st).due; },0);
    var totalBilled = statements().reduce(function(a,st){ return a+stmtTotals(st).net; },0);

    var html=''
    +'<div class="kpi-grid">'
    +' <div class="kpi" style="background:linear-gradient(135deg,#0d9488,#14b8a6);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-file-invoice-dollar" style="color:#fff"></i></div><div class="kpi-val">'+kpiCount+'</div><div class="kpi-label">Statements</div></div>'
    +' <div class="kpi" style="background:linear-gradient(135deg,#1e40af,#3b82f6);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-handshake" style="color:#fff"></i></div><div class="kpi-val">'+clients().length+'</div><div class="kpi-label">Referral Customers</div></div>'
    +' <div class="kpi" style="background:linear-gradient(135deg,#7c3aed,#a855f7);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-shield-heart" style="color:#fff"></i></div><div class="kpi-val">'+insurers().length+'</div><div class="kpi-label">Insurance Providers</div></div>'
    +' <div class="kpi" style="background:linear-gradient(135deg,#b45309,#f59e0b);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-coins" style="color:#fff"></i></div><div class="kpi-val" style="font-size:18px">'+money(totalDue)+'</div><div class="kpi-label">Outstanding (all)</div><div class="kpi-sub">Billed: '+money(totalBilled)+'</div></div>'
    +'</div>';

    // toolbar
    html+='<div class="card"><div style="display:flex;flex-wrap:wrap;gap:10px;align-items:center">'
      +'<div style="font-size:12px;font-weight:700;color:var(--txt2)">Billing party:</div>'
      + partySelector() + statementPicker()
      +'<div style="flex:1"></div>'
      +'<button class="btn btn-sec btn-sm" onclick="PB.manageParties()"><i class="fa-solid fa-handshake"></i> Customers</button>'
      +'<button class="btn btn-sec btn-sm" onclick="PB.newStatement()"><i class="fa-solid fa-file-circle-plus"></i> New Statement</button>'
      +(s?'<button class="btn btn-pri btn-sm" onclick="PB.addLine(\''+s.id+'\')"><i class="fa-solid fa-plus"></i> Add Line</button>':'')
      +'</div></div>';

    if(!s){
      html+='<div class="card" style="text-align:center;padding:48px;color:var(--txt2)">'
        +'<i class="fa-solid fa-file-invoice" style="font-size:34px;color:var(--txt3);margin-bottom:12px"></i>'
        +'<div style="font-size:15px;font-weight:700;margin-bottom:4px">Select a referral customer or insurance provider above</div>'
        +'<div style="font-size:12px">Each statement is a Bill of Supply. Add service lines and set each party\u2019s own price.</div></div>';
      return html;
    }

    var t=stmtTotals(s);

    // Bill of Supply header (editable meta)
    html+='<div class="card">'
      +'<div style="display:flex;flex-wrap:wrap;justify-content:space-between;gap:16px;border-bottom:1px solid var(--bdr);padding-bottom:14px;margin-bottom:14px">'
      +' <div>'
      +'  <div style="font-size:20px;font-weight:800;color:var(--pri)">Bill of Supply</div>'
      +'  <div style="margin-top:8px;font-size:13px"><b>Bill To:</b> '+esc(meta.name)+'</div>'
      +'  <div style="font-size:12px;color:var(--txt2)"><b>Client Code:</b> '+esc(meta.code||'—')
      +'   &nbsp;<span class="st '+(s.partyKind==='insurer'?'st-submitted':'st-active')+'" style="margin-left:6px">'+(s.partyKind==='insurer'?'Insurance Provider':'Referral Customer')+'</span></div>'
      +(meta.address?'<div style="font-size:12px;color:var(--txt2)"><b>Address:</b> '+esc(meta.address)+'</div>':'')
      +' </div>'
      +' <div style="text-align:right;font-size:12px;color:var(--txt2)">'
      +'  <div><b>Bill No:</b> <input value="'+esc(s.billNo)+'" onchange="PB.setStmtField(\''+s.id+'\',\'billNo\',this.value)" style="border:1px solid var(--bdr);border-radius:6px;padding:3px 6px;font-size:12px;width:160px;text-align:right"></div>'
      +'  <div style="margin-top:6px"><b>Date Of Issue:</b> <input type="date" value="'+esc(s.issueDate)+'" onchange="PB.setStmtField(\''+s.id+'\',\'issueDate\',this.value)" style="border:1px solid var(--bdr);border-radius:6px;padding:3px 6px;font-size:12px"></div>'
      +'  <div style="margin-top:6px"><b>Bill Period:</b> <input type="date" value="'+esc(s.periodFrom)+'" onchange="PB.setStmtField(\''+s.id+'\',\'periodFrom\',this.value)" style="border:1px solid var(--bdr);border-radius:6px;padding:3px 6px;font-size:12px"> to <input type="date" value="'+esc(s.periodTo)+'" onchange="PB.setStmtField(\''+s.id+'\',\'periodTo\',this.value)" style="border:1px solid var(--bdr);border-radius:6px;padding:3px 6px;font-size:12px"></div>'
      +' </div>'
      +'</div>';

    // action row
    html+='<div style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:12px">'
      +'<button class="btn btn-pri btn-sm" onclick="PB.addLine(\''+s.id+'\')"><i class="fa-solid fa-plus"></i> Add Line</button>'
      +'<button class="btn btn-sec btn-sm" onclick="PB.bulkApplyPct(\''+s.id+'\')"><i class="fa-solid fa-percent"></i> Set prices from MRP %</button>'
      +'<div style="flex:1"></div>'
      +'<button class="btn btn-sm" style="background:#dc2626;color:#fff" onclick="PB.exportPDF(\''+s.id+'\')"><i class="fa-solid fa-file-pdf"></i> PDF</button>'
      +'<button class="btn btn-sm" style="background:#217346;color:#fff" onclick="PB.exportExcel(\''+s.id+'\')"><i class="fa-solid fa-file-excel"></i> Excel</button>'
      +'</div>';

    // table
    html+='<div class="tbl-wrap"><table class="tbl"><thead><tr>'
      +'<th>Sr</th><th>Date</th><th>Patient Id</th><th>Patient Name</th><th>Description Of Service</th>'
      +'<th style="text-align:right">MRP</th><th style="text-align:right">Disc</th>'
      +'<th style="text-align:right;background:linear-gradient(135deg,#0d9488,#14b8a6);color:#fff">Party Price <i class="fa-solid fa-pen" style="font-size:9px"></i></th>'
      +'<th style="text-align:right">Net Value</th><th style="text-align:right">Paid</th><th style="text-align:right">Due</th><th></th></tr></thead><tbody>';

    (s.lines||[]).forEach(function(l,i){
      html+='<tr style="cursor:default">'
        +'<td style="color:var(--txt3)">'+(i+1)+'</td>'
        +'<td>'+esc(l.date||'')+'</td>'
        +'<td>'+esc(l.patientId||'')+'</td>'
        +'<td>'+esc(l.patientName||'')+'</td>'
        +'<td>'+esc(l.service||'')+'</td>'
        +'<td style="text-align:right;color:var(--txt2)">'+money(l.mrp)+'</td>'
        +'<td style="text-align:right"><input type="number" value="'+num(l.disc)+'" onchange="PB.setField(\''+s.id+'\',\''+l.id+'\',\'disc\',this.value)" style="width:80px;text-align:right;border:1px solid var(--bdr);border-radius:6px;padding:4px 6px;font-size:12px"></td>'
        +'<td style="text-align:right;background:#f0fdfa"><input type="number" value="'+num(l.partnerPrice)+'" onchange="PB.setPrice(\''+s.id+'\',\''+l.id+'\',this.value)" style="width:96px;text-align:right;border:1.5px solid var(--pri);border-radius:6px;padding:4px 6px;font-size:12px;font-weight:700;color:var(--pri2)"></td>'
        +'<td style="text-align:right;font-weight:700">'+money(lineNet(l))+'</td>'
        +'<td style="text-align:right"><input type="number" value="'+num(l.paid)+'" onchange="PB.setField(\''+s.id+'\',\''+l.id+'\',\'paid\',this.value)" style="width:80px;text-align:right;border:1px solid var(--bdr);border-radius:6px;padding:4px 6px;font-size:12px"></td>'
        +'<td style="text-align:right;font-weight:700;color:'+(lineDue(l)>0?'#b45309':'#065f46')+'">'+money(lineDue(l))+'</td>'
        +'<td><button class="act-btn del" title="Remove" onclick="PB.deleteLine(\''+s.id+'\',\''+l.id+'\')"><i class="fa-solid fa-trash"></i></button></td>'
        +'</tr>';
    });
    if(!(s.lines||[]).length){
      html+='<tr><td colspan="12" style="text-align:center;color:var(--txt3);padding:24px">No service lines yet — click “Add Line”.</td></tr>';
    }
    // totals
    html+='<tr style="background:linear-gradient(135deg,#f8fafc,#f1f5f9);font-weight:800">'
      +'<td colspan="5" style="text-align:right">TOTAL</td>'
      +'<td style="text-align:right">'+money(t.mrp)+'</td>'
      +'<td style="text-align:right">'+money(t.disc)+'</td>'
      +'<td style="text-align:right;background:#ccfbf1;color:var(--pri2)">'+money(t.price)+'</td>'
      +'<td style="text-align:right">'+money(t.net)+'</td>'
      +'<td style="text-align:right">'+money(t.paid)+'</td>'
      +'<td style="text-align:right;color:#b45309">'+money(t.due)+'</td><td></td></tr>';
    html+='</tbody></table></div>';

    html+='<div style="font-size:11px;color:var(--txt2);margin-top:10px"><i class="fa-solid fa-circle-info" style="color:var(--pri)"></i> '
      +'The highlighted <b>Party Price</b> column is the customer / referral / insurance provider\u2019s price and is editable here. '
      +'Net Value = Party Price − Disc, Due = Net − Paid. Every change saves automatically.</div>';

    html+='</div>';
    return html;
  };

  /* ---------- seed sample data (once) ---------- */
  function seed(){
    var D=D_();
    if(D.__partnerBillingSeeded) return;
    if(!Array.isArray(D.partnerStatements)) D.partnerStatements=[];
    if(D.partnerStatements.length){ D.__partnerBillingSeeded=true; return; }
    if(!Array.isArray(D.partnerClients)) D.partnerClients=[];

    function mkClient(code,name,city){ var c={id:rid(),code:code,name:name,city:city||'',address:'',type:'Referral',status:'Active'}; D.partnerClients.push(c); return c; }
    function L(date,pid,pname,svc,mrp){ return {id:rid(),date:date,patientId:pid,patientName:pname,service:svc,mrp:mrp,partnerPrice:mrp,disc:0,paid:0}; }
    function mkStmt(client,billNo,lines){ D.partnerStatements.push({id:rid(),partyKind:'client',partyId:client.id,billNo:billNo,issueDate:'2026-01-31',periodFrom:'2026-01-01',periodTo:'2026-01-30',lines:lines}); }

    var AHMC=mkClient('F00106','Albert Horsfall Medical Centre (Hospital)','');
    mkStmt(AHMC,'BOS-F00106-01',[
      L('05/01/2026','FD001335','AHMC/34592/A.J','AEROBIC BLOOD CULTURE /STERILE BODY FLUIDS CULTURE [BLOOD/BODY FLUIDS]',20000),
      L('05/01/2026','FD001336','AHMC/34624/O.V','CALCIUM, SERUM',3500),
      L('05/01/2026','FD001336','AHMC/34624/O.V','MAGNESIUM - [SERUM]',7500),
      L('08/01/2026','FD001528','AHMC/34764/N.A.H.','TESTOSTERONE (TOTAL)- [SERUM]',10000),
      L('09/01/2026','FD001602','AHMC/34860/A.P','AMH (Anti-Mullerian Hormone)',30000),
      L('13/01/2026','FD001784','AHMC/34897/I.H.A','AEROBIC BLOOD CULTURE /STERILE BODY FLUIDS CULTURE [BLOOD/BODY FLUIDS]',20000),
      L('13/01/2026','FD001785','AHMC/34908/I.A.M','TESTOSTERONE (TOTAL)- [SERUM]',10000),
      L('13/01/2026','FD001788','AHMC /34980 /A.A','HEPATITIS A SCREENING - SERUM',6800),
      L('19/01/2026','FD002134','AHMC/35268/I.S','CALCIUM, SERUM',3500),
      L('19/01/2026','FD002135','AHMC35241 /P.A','CALCIUM, SERUM',3500),
      L('21/01/2026','FD002271','AHMC/35398/D.U.W','FULL BLOOD COUNT - [BLOOD] 5part',5000),
      L('22/01/2026','FD002349','AHMC/35448','CALCIUM, SERUM',3500)
    ]);

    var BAST=mkClient('F00116','Bastion Hospital','');
    mkStmt(BAST,'BOS-F00116-01',[
      L('05/01/2026','FD001318','GRACE ANANABA','ALT (SGPT) - [SERUM/PLASMA]',2600),
      L('05/01/2026','FD001318','GRACE ANANABA','AST (SGOT) - [SERUM/PLASMA]',2600),
      L('05/01/2026','FD001318','GRACE ANANABA','URINALYSIS',3000),
      L('05/01/2026','FD001318','GRACE ANANABA','CHOLESTEROL (TOTAL) - [SERUM/PLASMA]',4000),
      L('05/01/2026','FD001318','GRACE ANANABA','BLOOD SUGAR FASTING - [PLASMA]',4500),
      L('05/01/2026','FD001318','GRACE ANANABA','FULL BLOOD COUNT - [BLOOD] 5part',5000),
      L('05/01/2026','FD001318','GRACE ANANABA','RENAL FUNCTION TESTS (Electrolytes, Urea & Creatinine)',9500),
      L('05/01/2026','FD001318','GRACE ANANABA','ELECTROCARDIOGRAPH (ECG)',10000),
      L('05/01/2026','FD001318','GRACE ANANABA','BREAST USS',11500),
      L('09/01/2026','FD001592','GODWIN BASSEY','URINE MCS',9500),
      L('22/01/2026','FD002324','UNYIME EDET AKPAN','ALT (SGPT) - [SERUM/PLASMA]',2600),
      L('22/01/2026','FD002324','UNYIME EDET AKPAN','AST (SGOT) - [SERUM/PLASMA]',2600),
      L('22/01/2026','FD002324','UNYIME EDET AKPAN','URINALYSIS',3000),
      L('22/01/2026','FD002324','UNYIME EDET AKPAN','CHOLESTEROL (TOTAL) - [SERUM/PLASMA]',4000),
      L('22/01/2026','FD002324','UNYIME EDET AKPAN','BLOOD SUGAR FASTING - [PLASMA]',4500),
      L('22/01/2026','FD002324','UNYIME EDET AKPAN','FULL BLOOD COUNT - [BLOOD] 5part',5000),
      L('22/01/2026','FD002324','UNYIME EDET AKPAN','RENAL FUNCTION TESTS (Electrolytes, Urea & Creatinine)',9500),
      L('22/01/2026','FD002324','UNYIME EDET AKPAN','ELECTROCARDIOGRAPH (ECG)',10000),
      L('22/01/2026','FD002324','UNYIME EDET AKPAN','BREAST USS',11500),
      L('22/01/2026','FD002324','UNYIME EDET AKPAN','PAP SMEARS FOR HISTOLOGICAL EXAMINATION - [PAP SMEAR]',16500),
      L('23/01/2026','FD002387','AMARACHI CHUKWUKA','SOFT TISSUE USS',9000),
      L('24/01/2026','FD002451','FEYIKEMI ADEGOKE','ALT (SGPT) - [SERUM/PLASMA]',2600),
      L('24/01/2026','FD002451','FEYIKEMI ADEGOKE','AST (SGOT) - [SERUM/PLASMA]',2600),
      L('24/01/2026','FD002451','FEYIKEMI ADEGOKE','URINALYSIS',3000),
      L('24/01/2026','FD002451','FEYIKEMI ADEGOKE','CHOLESTEROL (TOTAL) - [SERUM/PLASMA]',4000),
      L('24/01/2026','FD002451','FEYIKEMI ADEGOKE','BLOOD SUGAR FASTING - [PLASMA]',4500),
      L('24/01/2026','FD002451','FEYIKEMI ADEGOKE','FULL BLOOD COUNT - [BLOOD] 5part',5000),
      L('24/01/2026','FD002451','FEYIKEMI ADEGOKE','RENAL FUNCTION TESTS (Electrolytes, Urea & Creatinine)',9500),
      L('24/01/2026','FD002451','FEYIKEMI ADEGOKE','ELECTROCARDIOGRAPH (ECG)',10000),
      L('24/01/2026','FD002451','FEYIKEMI ADEGOKE','BREAST USS',11500),
      L('26/01/2026','FD002538','OLIE SHEILA','URINALYSIS',3000),
      L('26/01/2026','FD002538','OLIE SHEILA','BLOOD SUGAR RANDOM - [PLASMA]',4500),
      L('26/01/2026','FD002538','OLIE SHEILA','FULL BLOOD COUNT - [BLOOD] 5part',5000),
      L('28/01/2026','FD002650','TUNMISE AKINBOADE','MALARIA PARASITE - [BLOOD]',4000)
    ]);

    var CLOV=mkClient('F00129','Clover Hospital','');
    mkStmt(CLOV,'BOS-F00129-01',[
      L('25/01/2026','FD002501','MOHAMMED ADOKE','TESTOSTERONE FREE - [SERUM]',22000)
    ]);

    var BAL=mkClient('F00088','Dr.Balami, Foxglove Hospital','');
    mkStmt(BAL,'BOS-F00088-01',[
      L('17/01/2026','FD002044','IGHOMUAYE UFOMA','FERRITIN - [SERUM]',15000),
      L('17/01/2026','FD002044','IGHOMUAYE UFOMA','VITAMIN B12 (Cyanocobalamin) - [SERUM]',15600),
      L('17/01/2026','FD002044','IGHOMUAYE UFOMA','FOLATE , SERUM',27000)
    ]);

    var GARKI=mkClient('F00156','Garki Hospital','');
    mkStmt(GARKI,'BOS-F00156-01',[
      L('09/01/2026','FD001564','MARGRET AYAKPEW','ADRENOCORTICOTROPIC HORMONE (ACTH)',54000),
      L('09/01/2026','FD001565','JANET ISIMHEMBEN','CA-19.9 (Pancreatic Cancer Antigen 19.9) - [SERUM]',16000),
      L('14/01/2026','FD001817','IFEOMA NWANERI 298530','CA-15.3 (Breast Cancer Antigen 15.3), - [SERUM]',16000),
      L('19/01/2026','FD002122','FRIDAY ANI','CA-19.9 (Pancreatic Cancer Antigen 19.9) - [SERUM]',16000),
      L('19/01/2026','FD002123','IDOWU OBAJEMINI 29885','CA-19.9 (Pancreatic Cancer Antigen 19.9) - [SERUM]',16000),
      L('28/01/2026','FD002652','FATIMA GAMBO 252754','GAMMA GT (GGT) - [SERUM]',3000),
      L('28/01/2026','FD002653','CHRISTIAN ORFOR 274458','GAMMA GT (GGT) - [SERUM]',3000),
      L('28/01/2026','FD002654','ANPAN ANIEBO ROBERTS 216261','CK - CREATININE KINASE (TOTAL) - [SERUM]',14500),
      L('30/01/2026','FD002819','JOCELYN AGBO 173291','CA-125 (Ovarian Cancer Antigen-125), - [SERUM]',14000),
      L('30/01/2026','FD002820','HADIZA AFEGBUA 299420','GAMMA GT (GGT) - [SERUM]',3000)
    ]);

    // sample insurer statement so the insurer flow is visible too
    var ins=insurers()[0];
    if(ins){
      D.partnerStatements.push({id:rid(),partyKind:'insurer',partyId:ins.id,billNo:'BOS-INS-'+ins.id+'-01',
        issueDate:'2026-01-31',periodFrom:'2026-01-01',periodTo:'2026-01-30',lines:[
          L('06/01/2026','FD001400','HMO/ENR-0012','FULL BLOOD COUNT',8000),
          L('11/01/2026','FD001655','HMO/ENR-0033','FASTING LIPID PROFILE',20000),
          L('18/01/2026','FD002088','HMO/ENR-0051','LIVER FUNCTION TEST (LFT)',20000)
        ]});
    }

    D.__partnerBillingSeeded=true;
    save();
  }

  /* ---------- wrap core functions (additive) ---------- */
  function wrap(){
    if(PB._wrapped) return;
    // renderModule
    if(typeof window.renderModule==='function'){
      var origRM=window.renderModule;
      window.renderModule=function(){
        if(window.currentMod==='partnerbilling') return window.renderPartnerBilling();
        return origRM.apply(this,arguments);
      };
    }
    // getModTitle
    if(typeof window.getModTitle==='function'){
      var origT=window.getModTitle;
      window.getModTitle=function(){
        if(window.currentMod==='partnerbilling') return 'Referral & Insurance Billing';
        return origT.apply(this,arguments);
      };
    }
    // buildNav — inject a nav item before the "Compliance" section header
    if(typeof window.buildNav==='function'){
      var origNav=window.buildNav;
      window.buildNav=function(){
        var out=origNav.apply(this,arguments);
        var active=(window.currentMod==='partnerbilling')?'active':'';
        var btn='<button class="sb-item '+active+'" onclick="goTo(\'partnerbilling\')">'
          +'<i class="fa-solid fa-file-invoice-dollar"></i><span>Referral &amp; Insurer Billing</span>'
          +'<span class="badge">'+(statements().length||'')+'</span></button>';
        if(out.indexOf('<div class="sb-sec">Compliance</div>')!==-1){
          out=out.replace('<div class="sb-sec">Compliance</div>', btn+'<div class="sb-sec">Compliance</div>');
        } else {
          out=out+btn; // fallback: append at end
        }
        return out;
      };
    }
    PB._wrapped=true;
  }

  function boot(){
    try{ seed(); }catch(e){ console.warn('[PB] seed error',e); }
    try{ wrap(); }catch(e){ console.warn('[PB] wrap error',e); }
    // refresh sidebar/content if app already rendered
    try{ if(window.render && document.getElementById('app')) window.render(); }catch(e){}
  }

  boot();
  setTimeout(boot,800); setTimeout(boot,2500); setTimeout(boot,6000);
  if(document.readyState==='loading'){ window.addEventListener('DOMContentLoaded', boot); }
  try{ console.log('%c\u2705 v102 — Referral & Insurance Billing (Bill of Supply) loaded','color:#0d9488;font-weight:bold'); }catch(e){}
})();


;

/* ==== /js/080-end-v102.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v103 — REPORT DATA-CAPTURE COMPLETION  (Bill of Supply / Client Statements)
   Additive only. Builds on the v102 Referral & Insurance Billing module.
   • Enriches the Referral-Customer master with the full set of fields the
     statement header needs: Code, Name, Address, City, Pin, TIN/GST, Phone, Email.
   • Adds Time + Client Patient Ref to the service-line form, matching the
     "Date  hh:mm:ss" + external patient-ref columns on the printed statement.
   • Lets a statement be auto-built from real patient bills tagged to a
     referral customer within the bill period (transactions → report).
   • Captures an optional "Referring Customer" on the Generate Bill form so
     ordinary bills can feed the statement.
   • Standard logo + hospital name + address header on the PDF and a Print view.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  "use strict";

  function D_(){ return window.D || (window.D = {}); }
  function money(n){ try{ return window.F ? window.F(n) : '₦'+Number(n||0).toLocaleString(); }catch(e){ return '₦'+(n||0); } }
  function save(){ try{ if(window._hmsSave) window._hmsSave(); else if(window.saveData) window.saveData(); }catch(e){} }
  function toasty(m,k){ try{ if(window.toast) window.toast(m,k); }catch(e){} }
  function rid(){ return Date.now().toString(36)+Math.random().toString(36).slice(2,7); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function num(v){ v=parseFloat(String(v).replace(/[^0-9.\-]/g,'')); return isNaN(v)?0:v; }
  function todayStr(){ try{ return window.today?window.today():new Date().toISOString().slice(0,10);}catch(e){return new Date().toISOString().slice(0,10);} }

  /* ---------- line / statement maths (single source of truth) ---------- */
  function lineNet(l){ return Math.max(0, num(l.partnerPrice) - num(l.disc)); }
  function lineDue(l){ return Math.max(0, lineNet(l) - num(l.paid)); }
  function stmtTotals(s){
    var t={mrp:0,disc:0,price:0,net:0,paid:0,due:0};
    (s.lines||[]).forEach(function(l){
      t.mrp+=num(l.mrp); t.disc+=num(l.disc); t.price+=num(l.partnerPrice);
      t.net+=lineNet(l); t.paid+=num(l.paid); t.due+=lineDue(l);
    });
    return t;
  }

  /* ---------- party data ---------- */
  function clients(){ var D=D_(); if(!Array.isArray(D.partnerClients)) D.partnerClients=[]; return D.partnerClients; }
  function insurers(){ var D=D_(); return Array.isArray(D.insuranceProviders)?D.insuranceProviders:[]; }
  function statements(){ var D=D_(); if(!Array.isArray(D.partnerStatements)) D.partnerStatements=[]; return D.partnerStatements; }
  function partyLabel(kind,id){
    if(kind==='insurer'){ var i=insurers().find(function(x){return String(x.id)===String(id);}); return i?i.name:'Insurer'; }
    var c=clients().find(function(x){return String(x.id)===String(id);}); return c?c.name:'Referral Customer';
  }
  function partyMeta(kind,id){
    if(kind==='insurer'){ var i=insurers().find(function(x){return String(x.id)===String(id);})||{};
      return {name:i.name||'',code:i.code||('INS-'+(i.id||'')),address:i.address||'',city:i.city||'',pin:i.pin||'',tin:i.tin||'',phone:i.phone||'',email:i.email||'',type:i.type||'Insurance'}; }
    var c=clients().find(function(x){return String(x.id)===String(id);})||{};
    return {name:c.name||'',code:c.code||'',address:c.address||'',city:c.city||'',pin:c.pin||'',tin:c.tin||'',phone:c.phone||'',email:c.email||'',type:c.type||'Referral'};
  }
  function statementsFor(kind,id){ return statements().filter(function(s){return s.partyKind===kind && String(s.partyId)===String(id);}); }

  var PB = window.PB = window.PB || {};
  function currentStmt(){ return statements().find(function(s){return s.id===PB._stmtId;}) || null; }
  function ensureSelection(){
    if(!PB._stmtId){ var s=statements()[0]; if(s){ PB._kind=s.partyKind; PB._partyId=s.partyId; PB._stmtId=s.id; } }
  }
  function rerender(){ try{ if(window.render) window.render(); }catch(e){} }
  function findStmt(id){ return statements().find(function(x){return x.id===id;}); }
  function findLine(stmtId,lineId){ var s=findStmt(stmtId); if(!s) return null; return (s.lines||[]).find(function(l){return l.id===lineId;}); }

  /* keep selection helpers (re-bind in case v102 not yet present) */
  PB.go = function(){ ensureSelection(); if(window.goTo) window.goTo('partnerbilling'); };
  PB.selectParty = function(val){
    if(!val) return; var p=val.split(':'); PB._kind=p[0]; PB._partyId=p[1];
    var list=statementsFor(PB._kind,PB._partyId);
    PB._stmtId = list.length? list[list.length-1].id : null;
    if(!PB._stmtId){ PB.newStatement(true); } else { rerender(); }
  };
  PB.selectStatement = function(id){ PB._stmtId=id; var s=currentStmt(); if(s){PB._kind=s.partyKind;PB._partyId=s.partyId;} rerender(); };
  PB.setPrice = function(stmtId,lineId,val){ var l=findLine(stmtId,lineId); if(!l) return; l.partnerPrice=num(val); save(); rerender(); };
  PB.setField = function(stmtId,lineId,field,val){ var l=findLine(stmtId,lineId); if(!l) return; l[field]=(field==='disc'||field==='paid'||field==='mrp')?num(val):val; save(); rerender(); };
  PB.deleteLine = function(stmtId,lineId){ var s=findStmt(stmtId); if(!s) return; s.lines=(s.lines||[]).filter(function(l){return l.id!==lineId;}); save(); rerender(); };
  PB.setStmtField = function(stmtId,field,val){ var s=findStmt(stmtId); if(!s) return; s[field]=val; save(); if(field==='periodFrom'||field==='periodTo') rerender(); };
  PB.bulkApplyPct = function(stmtId){
    var s=findStmt(stmtId); if(!s) return;
    var v=prompt('Set every line\'s Party Price to this % of MRP (100 = same as MRP, 80 = 20% off):','100');
    if(v===null) return; var pct=num(v)/100;
    (s.lines||[]).forEach(function(l){ l.partnerPrice=Math.round(num(l.mrp)*pct); });
    save(); toasty('Applied '+v+'% of MRP to all lines'); rerender();
  };

  PB.newStatement = function(silent){
    if(!PB._kind || !PB._partyId){ toasty('Pick a billing party first','err'); return; }
    var meta=partyMeta(PB._kind,PB._partyId);
    var count=statementsFor(PB._kind,PB._partyId).length+1;
    var s={ id:rid(), partyKind:PB._kind, partyId:PB._partyId,
      billNo:'BOS-'+(meta.code||'NEW')+'-'+String(count).padStart(2,'0'),
      issueDate:todayStr(), periodFrom:todayStr(), periodTo:todayStr(), lines:[] };
    statements().push(s); PB._stmtId=s.id; save();
    if(!silent) toasty('New Bill of Supply created'); rerender();
  };

  /* ---------- enriched referral-customer master ---------- */
  PB.manageParties = function(){
    var rows=clients().map(function(c){
      return '<tr><td><b>'+esc(c.code||'')+'</b></td><td>'+esc(c.name)+'</td><td>'+esc(c.city||'')+'</td>'
        +'<td>'+esc(c.tin||'')+'</td><td>'+esc(c.phone||'')+'</td>'
        +'<td><span class="st st-active">'+esc(c.status||'Active')+'</span></td>'
        +'<td style="white-space:nowrap"><button class="act-btn edit" title="Edit" onclick="PB.editParty(\''+c.id+'\')"><i class="fa-solid fa-pen"></i></button>'
        +'<button class="act-btn del" title="Delete" onclick="PB.removeParty(\''+c.id+'\')"><i class="fa-solid fa-trash"></i></button></td></tr>';
    }).join('') || '<tr><td colspan="7" style="color:var(--txt3)">No referral customers yet</td></tr>';
    var body=''
      +'<div style="font-size:12px;color:var(--txt2);margin-bottom:10px">Referral customers are the external clinics / hospitals / labs you bill on a <b>Bill of Supply</b>. Insurance providers are pulled from the Insurance module automatically. All fields below appear on the statement header.</div>'
      +'<div class="form-grid">'
      +' <div class="form-group"><label>Client Code</label><input id="pp_code" placeholder="e.g. F00130"></div>'
      +' <div class="form-group"><label>Name <span class="req">*</span></label><input id="pp_name" placeholder="Customer / hospital name"></div>'
      +' <div class="form-group"><label>City</label><input id="pp_city" placeholder="City"></div>'
      +' <div class="form-group"><label>Pin / Postal</label><input id="pp_pin" placeholder="Postal / PIN"></div>'
      +' <div class="form-group"><label>TIN / GST IN</label><input id="pp_tin" placeholder="Tax ID"></div>'
      +' <div class="form-group"><label>Phone</label><input id="pp_phone" placeholder="Phone"></div>'
      +' <div class="form-group"><label>Email</label><input id="pp_email" placeholder="billing@client.com"></div>'
      +' <div class="form-group full"><label>Address</label><input id="pp_addr" placeholder="Street address"></div>'
      +'</div>'
      +'<input type="hidden" id="pp_id">'
      +'<button class="btn btn-pri btn-sm" id="pp_savebtn" style="margin:6px 0 14px" onclick="PB.addParty()"><i class="fa-solid fa-plus"></i> Add Referral Customer</button>'
      +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Name</th><th>City</th><th>TIN/GST</th><th>Phone</th><th>Status</th><th></th></tr></thead><tbody>'+rows+'</tbody></table></div>';
    if(window.showModal) window.showModal('<i class="fa-solid fa-handshake" style="color:var(--pri);margin-right:8px"></i>Manage Referral Customers', body, '<button class="btn btn-ghost" onclick="closeModal()">Close</button>', 'wide');
  };
  function gp(id){ var e=document.getElementById(id); return e?e.value.trim():''; }
  PB.addParty = function(){
    var name=gp('pp_name'); if(!name){ toasty('Enter a name','err'); return; }
    var id=gp('pp_id');
    var fields={ code:gp('pp_code'), name:name, city:gp('pp_city'), pin:gp('pp_pin'),
      tin:gp('pp_tin'), phone:gp('pp_phone'), email:gp('pp_email'), address:gp('pp_addr') };
    if(id){
      var c=clients().find(function(x){return x.id===id;}); if(c){ for(var k in fields) c[k]=fields[k]; }
    } else {
      fields.id=rid(); fields.code=fields.code||('F'+Math.floor(Math.random()*90000+10000));
      fields.type='Referral'; fields.status='Active'; clients().push(fields);
    }
    save(); PB.manageParties();
  };
  PB.editParty = function(id){
    var c=clients().find(function(x){return x.id===id;}); if(!c){ return; }
    PB.manageParties();
    setTimeout(function(){
      var set=function(f,v){ var e=document.getElementById(f); if(e) e.value=v||''; };
      set('pp_id',c.id); set('pp_code',c.code); set('pp_name',c.name); set('pp_city',c.city);
      set('pp_pin',c.pin); set('pp_tin',c.tin); set('pp_phone',c.phone); set('pp_email',c.email); set('pp_addr',c.address);
      var b=document.getElementById('pp_savebtn'); if(b) b.innerHTML='<i class="fa-solid fa-save"></i> Save Changes';
    },60);
  };
  PB.removeParty = function(id){ var D=D_(); D.partnerClients=clients().filter(function(c){return c.id!==id;}); save(); PB.manageParties(); };

  /* ---------- service-line form (with Time + external ref) ---------- */
  PB.addLine = function(stmtId){
    var D=D_(); var fees=Array.isArray(D.feeSchedule)?D.feeSchedule:[];
    var opts='<option value="">— pick a service —</option>'+fees.map(function(f){
      var nm=f.service||f.name||f.test||''; var amt=f.amount||f.price||f.fee||0;
      return '<option value="'+esc(nm)+'" data-amt="'+amt+'">'+esc(nm)+' ('+money(amt)+')</option>';
    }).join('');
    var body=''
      +'<div class="form-grid">'
      +' <div class="form-group"><label>Date</label><input type="date" id="pb_date" value="'+todayStr()+'"></div>'
      +' <div class="form-group"><label>Time</label><input type="time" id="pb_time" step="1"></div>'
      +' <div class="form-group"><label>Patient Id</label><input id="pb_pid" placeholder="e.g. FD002501"></div>'
      +' <div class="form-group"><label>Patient Name</label><input id="pb_pname" placeholder="Patient name"></div>'
      +' <div class="form-group full"><label>Client Patient Ref <span style="font-weight:400;color:var(--txt3)">(optional — external no.)</span></label><input id="pb_ref" placeholder="e.g. AHMC/34592/A.J or 298530"></div>'
      +' <div class="form-group full"><label>Description Of Service</label>'
      +'   <select id="pb_svc" onchange="PB._svcPick()">'+opts+'</select>'
      +'   <input id="pb_svctxt" placeholder="…or type a custom service" style="margin-top:6px">'
      +' </div>'
      +' <div class="form-group"><label>MRP (standard ₦)</label><input id="pb_mrp" type="number" value="0"></div>'
      +' <div class="form-group"><label>Price for this party (₦)</label><input id="pb_price" type="number" value="0"></div>'
      +' <div class="form-group"><label>Discount (₦)</label><input id="pb_disc" type="number" value="0"></div>'
      +' <div class="form-group"><label>Paid (₦)</label><input id="pb_paid" type="number" value="0"></div>'
      +'</div>'
      +'<div style="font-size:11px;color:var(--txt2);margin-top:6px"><i class="fa-solid fa-circle-info"></i> Leave “Price for this party” equal to MRP for no special pricing, or set the agreed referral / insurer rate. Net = Price − Disc, Due = Net − Paid.</div>';
    var footer=''
      +'<button class="btn btn-pri" onclick="PB.saveNewLine(\''+stmtId+'\')"><i class="fa-solid fa-plus"></i> Add Line</button>'
      +'<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>';
    if(window.showModal) window.showModal('<i class="fa-solid fa-plus" style="color:var(--pri);margin-right:8px"></i>Add Service Line', body, footer, 'wide');
  };
  PB._svcPick=function(){
    var sel=document.getElementById('pb_svc'); if(!sel) return;
    var o=sel.options[sel.selectedIndex]; var amt=o?num(o.getAttribute('data-amt')):0;
    var txt=document.getElementById('pb_svctxt'); if(txt) txt.value=sel.value;
    var m=document.getElementById('pb_mrp'); var p=document.getElementById('pb_price');
    if(m) m.value=amt; if(p && (!num(p.value))) p.value=amt;
  };
  function fmtDateTime(dateVal,timeVal){
    if(!dateVal) return '';
    var d=dateVal.split('-'); var out=(d.length===3)?(d[2]+'/'+d[1]+'/'+d[0]):dateVal;
    if(timeVal){
      var parts=timeVal.split(':'); var h=parseInt(parts[0],10); var mm=parts[1]||'00'; var ss=parts[2]||'';
      var ap=h>=12?'PM':'AM'; var h12=h%12; if(h12===0) h12=12;
      out+=' '+h12+':'+mm+(ss?(':'+ss):'')+ap;
    }
    return out;
  }
  PB.saveNewLine = function(stmtId){
    var s=findStmt(stmtId); if(!s) return;
    function g(id){ var e=document.getElementById(id); return e?e.value:''; }
    var svc=g('pb_svctxt')||g('pb_svc');
    if(!svc){ toasty('Please choose or type a service','err'); return; }
    var mrp=num(g('pb_mrp')); var price=num(g('pb_price')); if(!price) price=mrp;
    s.lines=s.lines||[];
    s.lines.push({ id:rid(), date:fmtDateTime(g('pb_date'),g('pb_time')), patientId:g('pb_pid'),
      patientName:g('pb_pname'), clientRef:g('pb_ref'), service:svc, mrp:mrp, partnerPrice:price,
      disc:num(g('pb_disc')), paid:num(g('pb_paid')) });
    save(); if(window.closeModal) window.closeModal(); toasty('Line added'); rerender();
  };

  /* ---------- build statement lines from real patient bills ---------- */
  function inPeriod(dateStr,from,to){
    if(!dateStr) return true;
    var d=String(dateStr).slice(0,10);
    if(from && d<from) return false;
    if(to && d>to) return false;
    return true;
  }
  PB.pullFromBills = function(stmtId){
    var s=findStmt(stmtId); if(!s){ toasty('No statement','err'); return; }
    if(s.partyKind!=='client'){ toasty('Auto-pull is for referral customers (bills tagged to this client).','err'); return; }
    var D=D_(); var bills=Array.isArray(D.bills)?D.bills:[];
    var matched=bills.filter(function(b){ return String(b.referralClientId)===String(s.partyId) && inPeriod(b.date,s.periodFrom,s.periodTo); });
    if(!matched.length){
      toasty('No bills tagged to this customer in the period. Tag bills with this customer in Generate Bill, then retry.','err'); return;
    }
    var existing={}; (s.lines||[]).forEach(function(l){ if(l.srcBill) existing[l.srcBill+'|'+l.service]=true; });
    var added=0;
    matched.forEach(function(b){
      var p=(D.patients||[]).find(function(x){return x.id===b.patientId;});
      var pid=p?(p.mrn||('P'+p.id)):(b.payerName||'');
      var pname=p?(p.fullName||p.name||''):(b.payerName||'');
      var fullyPaid=(b.balance!=null)?(num(b.balance)<=0):(b.status==='Paid');
      (b.items||[{s:(b.type||'Service'),a:b.total}]).forEach(function(it){
        var key=b.code+'|'+(it.s||'');
        if(existing[key]) return;
        s.lines.push({ id:rid(), date:fmtDateTime(b.date,''), patientId:pid, patientName:pname,
          clientRef:'', service:it.s||(b.type||'Service'), mrp:num(it.a), partnerPrice:num(it.a),
          disc:0, paid: fullyPaid?num(it.a):0, srcBill:b.code });
        existing[key]=true; added++;
      });
    });
    save();
    toasty(added?('Added '+added+' line(s) from '+matched.length+' bill(s)'):'All matching bill lines already present');
    rerender();
  };

  /* ---------- exports ---------- */
  PB.exportExcel = function(stmtId){
    var s=findStmt(stmtId); if(!s){ toasty('No statement','err'); return; }
    var rows=(s.lines||[]).map(function(l,i){ return {
      Sr:i+1, Date:l.date, PatientId:l.patientId, ClientRef:l.clientRef||'', PatientName:l.patientName, Service:l.service,
      MRP:num(l.mrp), Disc:num(l.disc), Price:num(l.partnerPrice), Net:lineNet(l), Paid:num(l.paid), Due:lineDue(l) };});
    var t=stmtTotals(s);
    rows.push({Sr:'',Date:'',PatientId:'',ClientRef:'',PatientName:'',Service:'TOTAL',MRP:t.mrp,Disc:t.disc,Price:t.price,Net:t.net,Paid:t.paid,Due:t.due});
    if(window.exportExcel) window.exportExcel('Bill of Supply — '+partyLabel(s.partyKind,s.partyId),
      ['Sr','Date','PatientId','ClientRef','PatientName','Service','MRP','Disc','Price','Net','Paid','Due'], rows);
    else toasty('Excel export not available','err');
  };

  PB.exportPDF = function(stmtId){
    var s=findStmt(stmtId); if(!s){ toasty('No statement','err'); return; }
    var jsPDF=(window.jspdf&&window.jspdf.jsPDF)||window.jsPDF;
    if(!jsPDF){ toasty('PDF library not loaded','err'); return; }
    var meta=partyMeta(s.partyKind,s.partyId);
    var doc=new jsPDF({unit:'pt',format:'a4'}); var W=doc.internal.pageSize.getWidth();
    var L=78;
    /* standard logo + hospital name + address header if available */
    try{ if(typeof window.pdfReportHeader==='function'){ var hy=window.pdfReportHeader(doc,'Bill of Supply'); if(hy) L=Math.max(L,hy+8); } else {
      var hosp=(D_().settings&&D_().settings.hospitalName)||'Tranquil Hospital and Wellness Centre';
      doc.setFontSize(15);doc.setTextColor(13,148,136);doc.text('Bill of Supply',40,46);
      doc.setFontSize(9);doc.setTextColor(90);doc.text(hosp,W-40,40,{align:'right'});
      doc.text(((D_().settings&&D_().settings.address)||''),W-40,53,{align:'right'});
      doc.setDrawColor(220);doc.line(40,58,W-40,58);
    } }catch(e){}
    doc.setTextColor(30); doc.setFontSize(9);
    doc.text('Bill To: '+(meta.name||''),40,L);
    doc.text('Client Code: '+(meta.code||''),40,L+13);
    var ln=L+26;
    if(meta.address){ doc.text('Address: '+meta.address,40,ln); ln+=13; }
    if(meta.city){ doc.text('City: '+meta.city,40,ln); ln+=13; }
    if(meta.tin){ doc.text('GST IN / TIN: '+meta.tin,40,ln); ln+=13; }
    doc.text('Bill No: '+(s.billNo||''),W-40,L,{align:'right'});
    doc.text('Date Of Issue: '+(s.issueDate||''),W-40,L+13,{align:'right'});
    doc.text('Bill Period: '+(s.periodFrom||'')+' to '+(s.periodTo||''),W-40,L+26,{align:'right'});
    var t=stmtTotals(s);
    var body=(s.lines||[]).map(function(l,i){ return [i+1,l.date,l.patientId,(l.clientRef||''),l.patientName,l.service,
      num(l.mrp).toLocaleString(),num(l.disc).toLocaleString(),num(l.partnerPrice).toLocaleString(),
      lineNet(l).toLocaleString(),num(l.paid).toLocaleString(),lineDue(l).toLocaleString()];});
    body.push([{content:'TOTAL',colSpan:6,styles:{halign:'right',fontStyle:'bold'}},
      t.mrp.toLocaleString(),t.disc.toLocaleString(),t.price.toLocaleString(),t.net.toLocaleString(),t.paid.toLocaleString(),t.due.toLocaleString()]);
    doc.autoTable({
      startY:Math.max(ln,L+40),
      head:[['Sr','Date','Patient Id','Client Ref','Patient Name','Description Of Service','MRP','Disc','Price','Net Value','Paid','Due']],
      body:body,
      styles:{fontSize:6.5,cellPadding:2.5,overflow:'linebreak'},
      headStyles:{fillColor:[13,148,136],textColor:255,fontSize:6.5},
      columnStyles:{0:{cellWidth:16},5:{cellWidth:108},8:{fillColor:[240,253,250],fontStyle:'bold'}},
      theme:'grid', margin:{left:40,right:40}
    });
    doc.save((s.billNo||'bill-of-supply')+'.pdf');
    toasty('PDF generated');
  };

  PB.printStatement = function(stmtId){
    var s=findStmt(stmtId); if(!s){ toasty('No statement','err'); return; }
    var meta=partyMeta(s.partyKind,s.partyId); var t=stmtTotals(s);
    var hdr=''; try{ if(typeof window.reportHeaderHTML==='function') hdr=window.reportHeaderHTML(); }catch(e){}
    var rowsHtml=(s.lines||[]).map(function(l,i){
      return '<tr><td>'+(i+1)+'</td><td>'+esc(l.date||'')+'</td><td>'+esc(l.patientId||'')+'</td><td>'+esc(l.clientRef||'')+'</td><td>'+esc(l.patientName||'')+'</td><td>'+esc(l.service||'')
        +'</td><td style="text-align:right">'+num(l.mrp).toLocaleString()+'</td><td style="text-align:right">'+num(l.disc).toLocaleString()
        +'</td><td style="text-align:right">'+num(l.partnerPrice).toLocaleString()+'</td><td style="text-align:right">'+lineNet(l).toLocaleString()
        +'</td><td style="text-align:right">'+num(l.paid).toLocaleString()+'</td><td style="text-align:right">'+lineDue(l).toLocaleString()+'</td></tr>';
    }).join('');
    var html='<!doctype html><html><head><meta charset="utf-8"><title>'+esc(s.billNo||'Bill of Supply')+'</title>'
      +'<style>body{font-family:Arial,Helvetica,sans-serif;color:#1e293b;padding:24px;font-size:12px}'
      +'h1{color:#0d9488;font-size:20px;margin:0 0 4px}table{width:100%;border-collapse:collapse;margin-top:12px;font-size:10.5px}'
      +'th,td{border:1px solid #cbd5e1;padding:4px 6px}thead th{background:#0d9488;color:#fff}'
      +'tfoot td,.tot{background:#f0fdfa;font-weight:bold}.meta{display:flex;justify-content:space-between;gap:24px;margin-top:10px}'
      +'.meta div{font-size:11px}</style></head><body>'
      +hdr
      +'<h1>Bill of Supply</h1>'
      +'<div class="meta"><div><b>Bill To:</b> '+esc(meta.name)+'<br><b>Client Code:</b> '+esc(meta.code||'—')
      +(meta.address?'<br><b>Address:</b> '+esc(meta.address):'')+(meta.city?'<br><b>City:</b> '+esc(meta.city):'')
      +(meta.tin?'<br><b>GST IN / TIN:</b> '+esc(meta.tin):'')+'</div>'
      +'<div style="text-align:right"><b>Bill No:</b> '+esc(s.billNo||'')+'<br><b>Date Of Issue:</b> '+esc(s.issueDate||'')
      +'<br><b>Bill Period:</b> '+esc(s.periodFrom||'')+' to '+esc(s.periodTo||'')+'</div></div>'
      +'<table><thead><tr><th>Sr</th><th>Date</th><th>Patient Id</th><th>Client Ref</th><th>Patient Name</th><th>Description Of Service</th>'
      +'<th>MRP</th><th>Disc</th><th>Price</th><th>Net Value</th><th>Paid</th><th>Due</th></tr></thead><tbody>'+rowsHtml+'</tbody>'
      +'<tfoot><tr class="tot"><td colspan="6" style="text-align:right">TOTAL</td><td style="text-align:right">'+t.mrp.toLocaleString()
      +'</td><td style="text-align:right">'+t.disc.toLocaleString()+'</td><td style="text-align:right">'+t.price.toLocaleString()
      +'</td><td style="text-align:right">'+t.net.toLocaleString()+'</td><td style="text-align:right">'+t.paid.toLocaleString()
      +'</td><td style="text-align:right">'+t.due.toLocaleString()+'</td></tr></tfoot></table>'
      +'<script>window.onload=function(){window.print();}<\/script></body></html>';
    var w=window.open('','_blank'); if(!w){ toasty('Allow pop-ups to print','err'); return; }
    w.document.open(); w.document.write(html); w.document.close();
  };

  /* ---------- render (owns the partner-billing module) ---------- */
  function partySelector(){
    var ci=clients().map(function(c){ var v='client:'+c.id; var sel=(PB._kind==='client'&&String(PB._partyId)===String(c.id))?' selected':''; return '<option value="'+v+'"'+sel+'>'+esc(c.name)+(c.code?' ('+esc(c.code)+')':'')+'</option>'; }).join('');
    var ii=insurers().map(function(p){ var v='insurer:'+p.id; var sel=(PB._kind==='insurer'&&String(PB._partyId)===String(p.id))?' selected':''; return '<option value="'+v+'"'+sel+'>'+esc(p.name)+'</option>'; }).join('');
    var groups=''; if(ci) groups+='<optgroup label="Referral Customers">'+ci+'</optgroup>'; if(ii) groups+='<optgroup label="Insurance Providers">'+ii+'</optgroup>';
    return '<select onchange="PB.selectParty(this.value)" style="min-width:280px;padding:8px 12px;border:1.5px solid var(--bdr);border-radius:10px;font-size:13px;font-family:inherit"><option value="">— select billing party —</option>'+groups+'</select>';
  }
  function statementPicker(){
    if(!PB._kind||!PB._partyId) return '';
    var list=statementsFor(PB._kind,PB._partyId); if(list.length<=1) return '';
    return '<select onchange="PB.selectStatement(this.value)" style="padding:8px 12px;border:1.5px solid var(--bdr);border-radius:10px;font-size:13px;font-family:inherit">'
      +list.map(function(s){ return '<option value="'+s.id+'"'+(s.id===PB._stmtId?' selected':'')+'>'+esc(s.billNo)+'</option>'; }).join('')+'</select>';
  }

  window.renderPartnerBilling = function(){
    ensureSelection();
    var s=currentStmt();
    var meta=s?partyMeta(s.partyKind,s.partyId):null;
    var kpiCount=statements().length;
    var totalDue=statements().reduce(function(a,st){return a+stmtTotals(st).due;},0);
    var totalBilled=statements().reduce(function(a,st){return a+stmtTotals(st).net;},0);

    var html=''
    +'<div class="kpi-grid">'
    +' <div class="kpi" style="background:linear-gradient(135deg,#0d9488,#14b8a6);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-file-invoice-dollar" style="color:#fff"></i></div><div class="kpi-val">'+kpiCount+'</div><div class="kpi-label">Statements</div></div>'
    +' <div class="kpi" style="background:linear-gradient(135deg,#1e40af,#3b82f6);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-handshake" style="color:#fff"></i></div><div class="kpi-val">'+clients().length+'</div><div class="kpi-label">Referral Customers</div></div>'
    +' <div class="kpi" style="background:linear-gradient(135deg,#7c3aed,#a855f7);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-shield-heart" style="color:#fff"></i></div><div class="kpi-val">'+insurers().length+'</div><div class="kpi-label">Insurance Providers</div></div>'
    +' <div class="kpi" style="background:linear-gradient(135deg,#b45309,#f59e0b);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-coins" style="color:#fff"></i></div><div class="kpi-val" style="font-size:18px">'+money(totalDue)+'</div><div class="kpi-label">Outstanding (all)</div><div class="kpi-sub">Billed: '+money(totalBilled)+'</div></div>'
    +'</div>';

    html+='<div class="card"><div style="display:flex;flex-wrap:wrap;gap:10px;align-items:center">'
      +'<div style="font-size:12px;font-weight:700;color:var(--txt2)">Billing party:</div>'
      +partySelector()+statementPicker()+'<div style="flex:1"></div>'
      +'<button class="btn btn-sec btn-sm" onclick="PB.manageParties()"><i class="fa-solid fa-handshake"></i> Customers</button>'
      +'<button class="btn btn-sec btn-sm" onclick="PB.newStatement()"><i class="fa-solid fa-file-circle-plus"></i> New Statement</button>'
      +(s?'<button class="btn btn-pri btn-sm" onclick="PB.addLine(\''+s.id+'\')"><i class="fa-solid fa-plus"></i> Add Line</button>':'')
      +'</div></div>';

    if(!s){
      html+='<div class="card" style="text-align:center;padding:48px;color:var(--txt2)">'
        +'<i class="fa-solid fa-file-invoice" style="font-size:34px;color:var(--txt3);margin-bottom:12px"></i>'
        +'<div style="font-size:15px;font-weight:700;margin-bottom:4px">Select a referral customer or insurance provider above</div>'
        +'<div style="font-size:12px">Each statement is a Bill of Supply. Add service lines manually or pull billed services for the period, and set each party\u2019s own price.</div></div>';
      return html;
    }

    var t=stmtTotals(s);
    html+='<div class="card">'
      +'<div style="display:flex;flex-wrap:wrap;justify-content:space-between;gap:16px;border-bottom:1px solid var(--bdr);padding-bottom:14px;margin-bottom:14px">'
      +' <div>'
      +'  <div style="font-size:20px;font-weight:800;color:var(--pri)">Bill of Supply</div>'
      +'  <div style="margin-top:8px;font-size:13px"><b>Bill To:</b> '+esc(meta.name)+'</div>'
      +'  <div style="font-size:12px;color:var(--txt2)"><b>Client Code:</b> '+esc(meta.code||'—')
      +'   &nbsp;<span class="st '+(s.partyKind==='insurer'?'st-submitted':'st-active')+'" style="margin-left:6px">'+(s.partyKind==='insurer'?'Insurance Provider':'Referral Customer')+'</span></div>'
      +(meta.address?'<div style="font-size:12px;color:var(--txt2)"><b>Address:</b> '+esc(meta.address)+'</div>':'')
      +(meta.city?'<div style="font-size:12px;color:var(--txt2)"><b>City:</b> '+esc(meta.city)+'</div>':'')
      +(meta.tin?'<div style="font-size:12px;color:var(--txt2)"><b>GST IN / TIN:</b> '+esc(meta.tin)+'</div>':'')
      +' </div>'
      +' <div style="text-align:right;font-size:12px;color:var(--txt2)">'
      +'  <div><b>Bill No:</b> <input value="'+esc(s.billNo)+'" onchange="PB.setStmtField(\''+s.id+'\',\'billNo\',this.value)" style="border:1px solid var(--bdr);border-radius:6px;padding:3px 6px;font-size:12px;width:160px;text-align:right"></div>'
      +'  <div style="margin-top:6px"><b>Date Of Issue:</b> <input type="date" value="'+esc(s.issueDate)+'" onchange="PB.setStmtField(\''+s.id+'\',\'issueDate\',this.value)" style="border:1px solid var(--bdr);border-radius:6px;padding:3px 6px;font-size:12px"></div>'
      +'  <div style="margin-top:6px"><b>Bill Period:</b> <input type="date" value="'+esc(s.periodFrom)+'" onchange="PB.setStmtField(\''+s.id+'\',\'periodFrom\',this.value)" style="border:1px solid var(--bdr);border-radius:6px;padding:3px 6px;font-size:12px"> to <input type="date" value="'+esc(s.periodTo)+'" onchange="PB.setStmtField(\''+s.id+'\',\'periodTo\',this.value)" style="border:1px solid var(--bdr);border-radius:6px;padding:3px 6px;font-size:12px"></div>'
      +' </div>'
      +'</div>';

    html+='<div style="display:flex;flex-wrap:wrap;gap:8px;margin-bottom:12px">'
      +'<button class="btn btn-pri btn-sm" onclick="PB.addLine(\''+s.id+'\')"><i class="fa-solid fa-plus"></i> Add Line</button>'
      +(s.partyKind==='client'?'<button class="btn btn-sm" style="background:#1e40af;color:#fff" onclick="PB.pullFromBills(\''+s.id+'\')"><i class="fa-solid fa-file-import"></i> Pull billed services (period)</button>':'')
      +'<button class="btn btn-sec btn-sm" onclick="PB.bulkApplyPct(\''+s.id+'\')"><i class="fa-solid fa-percent"></i> Set prices from MRP %</button>'
      +'<div style="flex:1"></div>'
      +'<button class="btn btn-sm" style="background:#475569;color:#fff" onclick="PB.printStatement(\''+s.id+'\')"><i class="fa-solid fa-print"></i> Print</button>'
      +'<button class="btn btn-sm" style="background:#dc2626;color:#fff" onclick="PB.exportPDF(\''+s.id+'\')"><i class="fa-solid fa-file-pdf"></i> PDF</button>'
      +'<button class="btn btn-sm" style="background:#217346;color:#fff" onclick="PB.exportExcel(\''+s.id+'\')"><i class="fa-solid fa-file-excel"></i> Excel</button>'
      +'</div>';

    html+='<div class="tbl-wrap"><table class="tbl"><thead><tr>'
      +'<th>Sr</th><th>Date</th><th>Patient Id</th><th>Client Ref</th><th>Patient Name</th><th>Description Of Service</th>'
      +'<th style="text-align:right">MRP</th><th style="text-align:right">Disc</th>'
      +'<th style="text-align:right;background:linear-gradient(135deg,#0d9488,#14b8a6);color:#fff">Party Price <i class="fa-solid fa-pen" style="font-size:9px"></i></th>'
      +'<th style="text-align:right">Net Value</th><th style="text-align:right">Paid</th><th style="text-align:right">Due</th><th></th></tr></thead><tbody>';
    (s.lines||[]).forEach(function(l,i){
      html+='<tr>'
        +'<td style="color:var(--txt3)">'+(i+1)+'</td>'
        +'<td>'+esc(l.date||'')+'</td>'
        +'<td>'+esc(l.patientId||'')+'</td>'
        +'<td style="color:var(--txt2)">'+esc(l.clientRef||'')+'</td>'
        +'<td>'+esc(l.patientName||'')+'</td>'
        +'<td>'+esc(l.service||'')+'</td>'
        +'<td style="text-align:right;color:var(--txt2)">'+money(l.mrp)+'</td>'
        +'<td style="text-align:right"><input type="number" value="'+num(l.disc)+'" onchange="PB.setField(\''+s.id+'\',\''+l.id+'\',\'disc\',this.value)" style="width:78px;text-align:right;border:1px solid var(--bdr);border-radius:6px;padding:4px 6px;font-size:12px"></td>'
        +'<td style="text-align:right;background:#f0fdfa"><input type="number" value="'+num(l.partnerPrice)+'" onchange="PB.setPrice(\''+s.id+'\',\''+l.id+'\',this.value)" style="width:94px;text-align:right;border:1.5px solid var(--pri);border-radius:6px;padding:4px 6px;font-size:12px;font-weight:700;color:var(--pri2)"></td>'
        +'<td style="text-align:right;font-weight:700">'+money(lineNet(l))+'</td>'
        +'<td style="text-align:right"><input type="number" value="'+num(l.paid)+'" onchange="PB.setField(\''+s.id+'\',\''+l.id+'\',\'paid\',this.value)" style="width:78px;text-align:right;border:1px solid var(--bdr);border-radius:6px;padding:4px 6px;font-size:12px"></td>'
        +'<td style="text-align:right;font-weight:700;color:'+(lineDue(l)>0?'#b45309':'#065f46')+'">'+money(lineDue(l))+'</td>'
        +'<td><button class="act-btn del" title="Remove" onclick="PB.deleteLine(\''+s.id+'\',\''+l.id+'\')"><i class="fa-solid fa-trash"></i></button></td>'
        +'</tr>';
    });
    if(!(s.lines||[]).length){
      html+='<tr><td colspan="13" style="text-align:center;color:var(--txt3);padding:24px">No service lines yet — click “Add Line” or “Pull billed services”.</td></tr>';
    }
    html+='<tr style="background:linear-gradient(135deg,#f8fafc,#f1f5f9);font-weight:800">'
      +'<td colspan="6" style="text-align:right">TOTAL</td>'
      +'<td style="text-align:right">'+money(t.mrp)+'</td>'
      +'<td style="text-align:right">'+money(t.disc)+'</td>'
      +'<td style="text-align:right;background:#ccfbf1;color:var(--pri2)">'+money(t.price)+'</td>'
      +'<td style="text-align:right">'+money(t.net)+'</td>'
      +'<td style="text-align:right">'+money(t.paid)+'</td>'
      +'<td style="text-align:right;color:#b45309">'+money(t.due)+'</td><td></td></tr>';
    html+='</tbody></table></div>';

    html+='<div style="font-size:11px;color:var(--txt2);margin-top:10px"><i class="fa-solid fa-circle-info" style="color:var(--pri)"></i> '
      +'The highlighted <b>Party Price</b> column is the customer / referral / insurance provider\u2019s price and is editable here. '
      +'Net Value = Party Price − Disc, Due = Net − Paid. The TOTAL row sums each column directly, so totals always reconcile. Every change saves automatically.</div>';
    html+='</div>';
    return html;
  };

  /* ---------- Generate Bill: capture optional Referring Customer ---------- */
  function injectRefClientField(){
    try{
      if(document.getElementById('gb_refclient_wrap')) return;
      var typeSel=document.getElementById('gb_type'); if(!typeSel) return;
      var grid=typeSel.closest('.form-grid'); if(!grid) return;
      var opts='<option value="">— none / direct —</option>'+clients().map(function(c){
        return '<option value="'+c.id+'">'+esc(c.name)+(c.code?' ('+esc(c.code)+')':'')+'</option>';}).join('');
      var wrap=document.createElement('div');
      wrap.className='form-group'; wrap.id='gb_refclient_wrap';
      wrap.innerHTML='<label>Referring Customer <span style="font-weight:400;color:var(--txt3)">(for Bill of Supply)</span></label>'
        +'<select id="gb_refclient" style="width:100%">'+opts+'</select>';
      var typeGroup=typeSel.closest('.form-group');
      if(typeGroup && typeGroup.parentNode) typeGroup.parentNode.insertBefore(wrap, typeGroup.nextSibling);
      else grid.appendChild(wrap);
    }catch(e){}
  }
  function wrapGenerateBill(){
    if(PB._genWrapped) return;
    if(typeof window.generateBill==='function'){
      var orig=window.generateBill;
      window.generateBill=function(){ var r=orig.apply(this,arguments); setTimeout(injectRefClientField,30); setTimeout(injectRefClientField,120); return r; };
    }
    if(typeof window.saveBill==='function'){
      var origSave=window.saveBill;
      window.saveBill=function(){
        var refSel=document.getElementById('gb_refclient'); var refId=refSel?refSel.value:'';
        var beforeLen=(D_().bills||[]).length;
        var r=origSave.apply(this,arguments);
        try{ var bills=D_().bills||[]; if(refId && bills.length){ var nb=bills[bills.length-1]; if(nb && (bills.length>beforeLen)){ nb.referralClientId=refId; save(); } } }catch(e){}
        return r;
      };
    }
    PB._genWrapped=true;
  }

  /* ---------- wrap nav / module / title (in case v102 didn't run) ---------- */
  function wrapNav(){
    if(PB._v103NavWrapped) return;
    if(typeof window.renderModule==='function'){
      var origRM=window.renderModule;
      window.renderModule=function(){ if(window.currentMod==='partnerbilling') return window.renderPartnerBilling(); return origRM.apply(this,arguments); };
    }
    if(typeof window.getModTitle==='function'){
      var origT=window.getModTitle;
      window.getModTitle=function(){ if(window.currentMod==='partnerbilling') return 'Referral & Insurance Billing'; return origT.apply(this,arguments); };
    }
    if(typeof window.buildNav==='function' && !window.__pbNavInjected){
      var origNav=window.buildNav;
      window.buildNav=function(){
        var out=origNav.apply(this,arguments);
        if(out.indexOf("goTo('partnerbilling')")!==-1) return out; // already injected by v102
        var active=(window.currentMod==='partnerbilling')?'active':'';
        var btn='<button class="sb-item '+active+'" onclick="goTo(\'partnerbilling\')"><i class="fa-solid fa-file-invoice-dollar"></i><span>Referral &amp; Insurer Billing</span><span class="badge">'+(statements().length||'')+'</span></button>';
        if(out.indexOf('<div class="sb-sec">Compliance</div>')!==-1) out=out.replace('<div class="sb-sec">Compliance</div>', btn+'<div class="sb-sec">Compliance</div>'); else out=out+btn;
        return out;
      };
      window.__pbNavInjected=true;
    }
    PB._v103NavWrapped=true;
  }

  function boot(){
    try{ wrapNav(); }catch(e){ console.warn('[v103] nav',e); }
    try{ wrapGenerateBill(); }catch(e){ console.warn('[v103] bill',e); }
    try{ if(window.render && document.getElementById('app')) window.render(); }catch(e){}
  }
  boot(); setTimeout(boot,900); setTimeout(boot,2600); setTimeout(boot,6200);
  if(document.readyState==='loading'){ window.addEventListener('DOMContentLoaded', boot); }
  try{ console.log('%c\u2705 v103 — Bill of Supply: enriched client master · time + ref capture · pull-from-bills · standard PDF header','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/081-end-v103.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v104 — MULTI-PAYER BILLS + INSURERS IN REFERRING-CUSTOMER LIST
   Additive only. Builds on v102/v103 (Referral & Insurance Billing).
   • Generate Bill: split a bill across MULTIPLE payers (patient, corporate,
     agent, insurance provider / HMO, or other) — each with its own amount.
   • Referring Customer dropdown now also lists Insurance Providers / HMOs,
     so a bill can roll up to an insurer's Bill of Supply as well as a
     referral customer's.
   • Bill-of-Supply "Pull billed services" now works for insurer statements
     too, matching the referral party (kind + id) stored on each bill.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  "use strict";
  function D_(){ return window.D || (window.D = {}); }
  /* The billing form and Insurance module use the cross-script core `D`
     (which carries the real insurers, bills and patients). Our add-on data
     lives on window.D. coreD() returns that core object; linkCoreData()
     points window.D's shared arrays at the core ones so both halves agree. */
  function coreD(){ try{ if(typeof D!=='undefined' && D && typeof D==='object') return D; }catch(e){} return window.D||{}; }
  function linkCoreData(){
    try{
      var core=coreD(); var w=window.D;
      if(!core || !w || core===w) return;
      // Unify the core-owned arrays (real insurers/bills/patients/etc.) so both
      // halves of the app share the SAME array instance. Preserve all data:
      // if window.D held items the core lacked, fold them in before unifying.
      ['bills','insuranceProviders','patients','partners','agents','transactions'].forEach(function(k){
        var cv=core[k], wv=w[k];
        if(!Array.isArray(cv)){ core[k]=Array.isArray(wv)?wv:[]; }
        else if(Array.isArray(wv) && wv!==cv && wv.length && !cv.length){ cv.push.apply(cv,wv); }
        w[k]=core[k];
      });
      // NB: partnerClients / partnerStatements are add-on data that lives on
      // window.D and is read there everywhere — deliberately left untouched.
    }catch(e){}
  }
  function billsArr(){ var c=coreD(); if(Array.isArray(c.bills)) return c.bills; if(!c.bills) c.bills=[]; return c.bills; }
  function esc(v){ return String(v==null?'':v).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }
  function num(v){ v=parseFloat(String(v).replace(/[^0-9.\-]/g,'')); return isNaN(v)?0:v; }
  function money(n){ try{ return window.F?window.F(n):'₦'+Number(n||0).toLocaleString(); }catch(e){ return '₦'+(n||0); } }
  function toasty(m,k){ try{ if(window.toast) window.toast(m,k); }catch(e){} }
  function save(){ try{ if(window._hmsSave) window._hmsSave(); else if(window.saveData) window.saveData(); }catch(e){} }
  function byName(a,b){ return String(a).localeCompare(String(b),undefined,{sensitivity:'base'}); }

  /* ---------- party lookups ---------- */
  function refClients(){ var D=D_(); return Array.isArray(D.partnerClients)?D.partnerClients:[]; }
  function insurers(){ var D=D_(); return Array.isArray(D.insuranceProviders)?D.insuranceProviders:[]; }

  /* resolve a "kind:id" or legacy payer token into {kind,id,name} */
  function resolveParty(token){
    if(!token) return null;
    var D=D_(), m;
    if((m=/^P:(\d+)$/.exec(token))||(/^\d+$/.test(token)&&(m=[null,token]))){
      var p=(D.patients||[]).find(function(x){return String(x.id)===String(m[1]);});
      return {kind:'patient', id:m[1], name:p?(p.fullName||p.name||('Patient '+m[1])):('Patient '+m[1])};
    }
    if((m=/^PT:(\d+)$/.exec(token))){ var pt=(D.partners||[]).find(function(x){return String(x.id)===String(m[1]);}); return {kind:'partner', id:m[1], name:pt?(pt.companyName||pt.contactPerson||('Partner '+m[1])):('Partner '+m[1])}; }
    if((m=/^AG:(\d+)$/.exec(token))){ var ag=(D.agents||[]).find(function(x){return String(x.id)===String(m[1]);}); return {kind:'agent', id:m[1], name:ag?(ag.fullName||('Agent '+m[1])):('Agent '+m[1])}; }
    if((m=/^INS:(\d+)$/.exec(token))){ var i=insurers().find(function(x){return String(x.id)===String(m[1]);}); return {kind:'insurer', id:m[1], name:i?(i.name||('Insurer '+m[1])):('Insurer '+m[1])}; }
    if(token==='OTHER'){ return {kind:'other', id:null, name:'Other payer'}; }
    return null;
  }

  /* grouped <option> list of every payer type (for split rows) */
  function payerOptionsAll(selected){
    var D=D_(); var html='<option value="">Select payer…</option>';
    var pats=(D.patients||[]).filter(function(p){return p.status!=='Discharged';}).slice().sort(function(a,b){return byName(a.fullName,b.fullName);});
    if(pats.length){ html+='<optgroup label="Patients">'+pats.map(function(p){var v='P:'+p.id;return '<option value="'+v+'"'+(selected===v?' selected':'')+'>'+esc(p.fullName)+' ['+esc(p.mrn)+']</option>';}).join('')+'</optgroup>'; }
    var ins=insurers().slice().sort(function(a,b){return byName(a.name||'',b.name||'');});
    if(ins.length){ html+='<optgroup label="Insurance Providers / HMO">'+ins.map(function(i){var v='INS:'+i.id;return '<option value="'+v+'"'+(selected===v?' selected':'')+'>'+esc(i.name)+(i.type?(' ('+esc(i.type)+')'):'')+'</option>';}).join('')+'</optgroup>'; }
    var partners=(D.partners||[]).slice().sort(function(a,b){return byName(a.companyName||a.contactPerson||'',b.companyName||b.contactPerson||'');});
    if(partners.length){ html+='<optgroup label="Corporate Customers">'+partners.map(function(p){var v='PT:'+p.id;return '<option value="'+v+'"'+(selected===v?' selected':'')+'>'+esc(p.companyName||p.contactPerson||('Partner '+p.id))+'</option>';}).join('')+'</optgroup>'; }
    var agents=(D.agents||[]).slice().sort(function(a,b){return byName(a.fullName||'',b.fullName||'');});
    if(agents.length){ html+='<optgroup label="Agents">'+agents.map(function(a){var v='AG:'+a.id;return '<option value="'+v+'"'+(selected===v?' selected':'')+'>'+esc(a.fullName||('Agent '+a.id))+'</option>';}).join('')+'</optgroup>'; }
    html+='<optgroup label="Other"><option value="OTHER"'+(selected==='OTHER'?' selected':'')+'>Other / walk-in customer…</option></optgroup>';
    return html;
  }

  /* referring-customer options: referral customers + insurers, value "kind:id" */
  function refPartyOptions(selected){
    var html='<option value="">— none / direct —</option>';
    var cs=refClients().slice().sort(function(a,b){return byName(a.name||'',b.name||'');});
    if(cs.length){ html+='<optgroup label="Referral Customers">'+cs.map(function(c){var v='client:'+c.id;return '<option value="'+v+'"'+(selected===v?' selected':'')+'>'+esc(c.name)+(c.code?(' ('+esc(c.code)+')'):'')+'</option>';}).join('')+'</optgroup>'; }
    var ins=insurers().slice().sort(function(a,b){return byName(a.name||'',b.name||'');});
    if(ins.length){ html+='<optgroup label="Insurance Providers / HMO">'+ins.map(function(i){var v='insurer:'+i.id;return '<option value="'+v+'"'+(selected===v?' selected':'')+'>'+esc(i.name)+'</option>';}).join('')+'</optgroup>'; }
    return html;
  }

  /* ---------- split-payer editor state ---------- */
  window.__gbPayers = window.__gbPayers || [];
  function netNow(){
    var t=num((document.getElementById('gb_total')||{}).value);
    var d=num((document.getElementById('gb_discount')||{}).value);
    return Math.max(0,t-d);
  }
  window.gbAddPayer=function(){ window.__gbPayers=window.__gbPayers||[]; window.__gbPayers.push({token:'',name:'',amount:0}); gbRenderPayers(); };
  window.gbDelPayer=function(i){ (window.__gbPayers||[]).splice(i,1); gbRenderPayers(); };
  window.gbPayerToken=function(i,val){ var r=(window.__gbPayers||[])[i]; if(!r) return; r.token=val; var p=resolveParty(val); r.name=p?p.name:''; if(p&&p.kind==='other'){ var nm=prompt('Name of this payer:',''); r.name=(nm&&nm.trim())||'Other payer'; } gbRenderPayers(); };
  window.gbPayerName=function(i,val){ var r=(window.__gbPayers||[])[i]; if(r) r.name=val; };
  window.gbPayerAmt=function(i,val){ var r=(window.__gbPayers||[])[i]; if(r) r.amount=num(val); gbUpdateAlloc(); };
  window.gbSplitEven=function(){
    var rows=window.__gbPayers||[]; if(!rows.length){ toasty('Add payers first','err'); return; }
    var net=netNow(); var each=Math.floor(net/rows.length); var rem=net-each*rows.length;
    rows.forEach(function(r,i){ r.amount=each+(i===0?rem:0); }); gbRenderPayers();
  };
  function gbUpdateAlloc(){
    var box=document.getElementById('gb_payers_alloc'); if(!box) return;
    var net=netNow(); var alloc=(window.__gbPayers||[]).reduce(function(s,r){return s+num(r.amount);},0);
    var rem=net-alloc;
    box.innerHTML='Net bill: <b>'+money(net)+'</b> &nbsp;·&nbsp; Allocated: <b>'+money(alloc)+'</b> &nbsp;·&nbsp; '
      +(Math.abs(rem)<0.5?'<span style="color:#065f46;font-weight:700">Balanced ✓</span>'
        :(rem>0?'<span style="color:#b45309;font-weight:700">Unallocated: '+money(rem)+'</span>'
              :'<span style="color:#dc2626;font-weight:700">Over by '+money(-rem)+'</span>'));
  }
  function gbRenderPayers(){
    var box=document.getElementById('gb_payers_rows'); if(!box) return;
    var rows=window.__gbPayers||[];
    box.innerHTML=rows.map(function(r,i){
      return '<div style="display:flex;gap:6px;align-items:center;margin-bottom:6px">'
        +'<select onchange="gbPayerToken('+i+',this.value)" style="flex:2;min-width:150px;padding:6px 8px;border:1.5px solid var(--bdr);border-radius:8px;font-size:12px">'+payerOptionsAll(r.token)+'</select>'
        +'<input type="number" min="0" value="'+(num(r.amount)||0)+'" placeholder="₦ amount" oninput="gbPayerAmt('+i+',this.value)" style="width:130px;padding:6px 8px;border:1.5px solid var(--bdr);border-radius:8px;font-size:12px">'
        +'<button type="button" class="btn btn-xs btn-ghost" style="color:#dc2626" title="Remove" onclick="gbDelPayer('+i+')"><i class="fa-solid fa-times"></i></button>'
        +'</div>';
    }).join('')||'<div style="font-size:11px;color:var(--txt3);padding:2px">No extra payers — the bill is paid by the single payer selected above.</div>';
    gbUpdateAlloc();
  }
  window.gbRenderPayers=gbRenderPayers;

  function injectBillEnhancements(){
    try{
      var refSel=document.getElementById('gb_refclient');
      if(refSel && !refSel.getAttribute('data-v104')){
        var cur=refSel.value;
        refSel.innerHTML=refPartyOptions(cur);
        refSel.setAttribute('data-v104','1');
      }
      if(!document.getElementById('gb_payers_section')){
        var discEl=document.getElementById('gb_discount');
        var grid=discEl?discEl.closest('.form-grid'):null;
        if(grid){
          window.__gbPayers=[];
          var sec=document.createElement('div');
          sec.className='form-group full'; sec.id='gb_payers_section';
          sec.style.borderTop='1px dashed var(--bdr)'; sec.style.paddingTop='10px'; sec.style.marginTop='4px';
          sec.innerHTML='<label style="display:flex;align-items:center;gap:8px">Payers (split across multiple) '
            +'<span style="font-weight:400;color:var(--txt3);font-size:11px">— optional; leave empty for a single payer</span></label>'
            +'<div id="gb_payers_rows"></div>'
            +'<div style="display:flex;gap:6px;margin-top:4px">'
            +'<button type="button" class="btn btn-xs btn-ghost" style="border:1px solid var(--bdr)" onclick="gbAddPayer()"><i class="fa-solid fa-plus"></i> Add payer</button>'
            +'<button type="button" class="btn btn-xs btn-ghost" style="border:1px solid var(--bdr)" onclick="gbSplitEven()"><i class="fa-solid fa-equals"></i> Split evenly</button>'
            +'</div>'
            +'<div id="gb_payers_alloc" style="font-size:11px;color:var(--txt2);margin-top:6px"></div>';
          grid.appendChild(sec);
          gbRenderPayers();
          // keep allocation summary live when total/discount change
          [discEl, document.getElementById('gb_total')].forEach(function(el){ if(el && !el.getAttribute('data-v104a')){ el.addEventListener('input',gbUpdateAlloc); el.setAttribute('data-v104a','1'); } });
        }
      }
    }catch(e){ /* non-fatal */ }
  }

  /* collect the payer split for saving */
  function collectPayers(){
    var rows=(window.__gbPayers||[]).map(function(r){
      var p=resolveParty(r.token);
      return { kind:p?p.kind:'other', id:p?p.id:null, name:r.name||(p?p.name:'')||'Payer', amount:num(r.amount) };
    }).filter(function(r){ return r.amount>0 || (r.name && r.name!=='Payer'); });
    return rows;
  }

  function wrapBill(){
    if(window.__v104BillWrapped) return;
    if(typeof window.generateBill==='function'){
      var orig=window.generateBill;
      window.generateBill=function(){ var r=orig.apply(this,arguments); window.__gbPayers=[]; setTimeout(injectBillEnhancements,60); setTimeout(injectBillEnhancements,200); setTimeout(injectBillEnhancements,450); return r; };
    }
    if(typeof window.saveBill==='function'){
      var origSave=window.saveBill;
      window.saveBill=function(){
        var refRaw=(document.getElementById('gb_refclient')||{}).value||'';
        var payers=collectPayers();
        linkCoreData();
        var beforeLen=billsArr().length;
        var r=origSave.apply(this,arguments);
        try{
          linkCoreData();
          var bills=billsArr();
          if(bills.length>beforeLen){
            var nb=bills[bills.length-1];
            // referring party (referral customer OR insurer) — value "kind:id"
            var m=/^(client|insurer):(.+)$/.exec(refRaw);
            if(m){ nb.referralPartyKind=m[1]; nb.referralPartyId=m[2]; nb.referralClientId=(m[1]==='client'?m[2]:null); }
            else { nb.referralPartyKind=null; nb.referralPartyId=null; }
            // multi-payer split
            if(payers.length){ nb.payers=payers; nb.payerSplit=true; }
            save();
          }
        }catch(e){}
        return r;
      };
    }
    window.__v104BillWrapped=true;
  }

  /* ---------- payerOf label shows the split ---------- */
  function wrapPayerLabel(){
    if(window.__v104PayerLbl) return;
    if(typeof window.payerOf==='function'){
      var orig=window.payerOf;
      window.payerOf=function(b){
        try{ if(b && Array.isArray(b.payers) && b.payers.length){
          var names=b.payers.map(function(p){return p.name;}).filter(Boolean);
          if(names.length>=2) return names[0]+' + '+(names.length-1)+' other'+(names.length-1>1?'s':'');
          if(names.length===1) return names[0];
        } }catch(e){}
        return orig.apply(this,arguments);
      };
    }
    window.__v104PayerLbl=true;
  }

  /* ---------- Bill-of-Supply pull: match referral party kind+id ---------- */
  function inPeriod(dateStr,from,to){ if(!dateStr) return true; var d=String(dateStr).slice(0,10); if(from&&d<from) return false; if(to&&d>to) return false; return true; }
  function fmtDate(dateStr){ if(!dateStr) return ''; var d=String(dateStr).slice(0,10).split('-'); return d.length===3?(d[2]+'/'+d[1]+'/'+d[0]):dateStr; }
  function rid(){ return Date.now().toString(36)+Math.random().toString(36).slice(2,7); }
  function wrapPull(){
    if(!window.PB) return;
    window.PB.pullFromBills=function(stmtId){
      var st=(D_().partnerStatements||[]).find(function(x){return x.id===stmtId;}); if(!st){ toasty('No statement','err'); return; }
      linkCoreData();
      var D=coreD(); var bills=Array.isArray(D.bills)?D.bills:[];
      var matched=bills.filter(function(b){
        if(!inPeriod(b.date,st.periodFrom,st.periodTo)) return false;
        if(b.referralPartyKind && String(b.referralPartyKind)===String(st.partyKind) && String(b.referralPartyId)===String(st.partyId)) return true;
        // legacy: client-tagged bills without the new kind field
        if(st.partyKind==='client' && String(b.referralClientId)===String(st.partyId)) return true;
        return false;
      });
      if(!matched.length){
        toasty('No bills tagged to this '+(st.partyKind==='insurer'?'insurer':'customer')+' in the period. Set the Referring Customer on Generate Bill, then retry.','err'); return;
      }
      st.lines=st.lines||[];
      var existing={}; st.lines.forEach(function(l){ if(l.srcBill) existing[l.srcBill+'|'+l.service]=true; });
      var added=0;
      matched.forEach(function(b){
        var p=(D.patients||[]).find(function(x){return x.id===b.patientId;});
        var pid=p?(p.mrn||('P'+p.id)):(b.payerName||'');
        var pname=p?(p.fullName||p.name||''):(b.payerName||'');
        var fullyPaid=(b.balance!=null)?(num(b.balance)<=0):(b.status==='Paid');
        (b.items||[{s:(b.type||'Service'),a:b.total}]).forEach(function(it){
          var key=b.code+'|'+(it.s||'');
          if(existing[key]) return;
          st.lines.push({ id:rid(), date:fmtDate(b.date), patientId:pid, patientName:pname, clientRef:'',
            service:it.s||(b.type||'Service'), mrp:num(it.a), partnerPrice:num(it.a), disc:0,
            paid: fullyPaid?num(it.a):0, srcBill:b.code });
          existing[key]=true; added++;
        });
      });
      save();
      toasty(added?('Added '+added+' line(s) from '+matched.length+' bill(s)'):'All matching bill lines already present');
      try{ if(window.render) window.render(); }catch(e){}
    };
  }

  /* ---------- enable "Pull billed services" button for insurer statements ---------- */
  function wrapRenderForInsurerPull(){
    if(window.__v104RenderWrapped) return;
    if(typeof window.renderPartnerBilling==='function'){
      var orig=window.renderPartnerBilling;
      window.renderPartnerBilling=function(){
        var html=orig.apply(this,arguments);
        // v103 render only shows the pull button for client statements; add it for insurer statements
        try{
          var st=(D_().partnerStatements||[]).find(function(x){return x.id===(window.PB&&window.PB._stmtId);});
          if(st && st.partyKind==='insurer' && html.indexOf("pullFromBills('"+st.id+"')")===-1){
            var anchor='onclick="PB.bulkApplyPct(\''+st.id+'\')"';
            if(html.indexOf(anchor)!==-1){
              var btn='<button class="btn btn-sm" style="background:#1e40af;color:#fff" onclick="PB.pullFromBills(\''+st.id+'\')"><i class="fa-solid fa-file-import"></i> Pull billed services (period)</button>';
              // insert the pull button just before the bulkApplyPct button
              html=html.replace('<button class="btn btn-sec btn-sm" '+anchor, btn+'<button class="btn btn-sec btn-sm" '+anchor);
            }
          }
        }catch(e){}
        return html;
      };
    }
    window.__v104RenderWrapped=true;
  }

  function boot(){
    try{ linkCoreData(); }catch(e){ console.warn('[v104] link',e); }
    try{ wrapBill(); }catch(e){ console.warn('[v104] bill',e); }
    try{ wrapPayerLabel(); }catch(e){ console.warn('[v104] lbl',e); }
    try{ wrapPull(); }catch(e){ console.warn('[v104] pull',e); }
    try{ wrapRenderForInsurerPull(); }catch(e){ console.warn('[v104] render',e); }
  }
  boot(); setTimeout(boot,1000); setTimeout(boot,2800); setTimeout(boot,6500);
  if(document.readyState==='loading'){ window.addEventListener('DOMContentLoaded', boot); }
  try{ console.log('%c\u2705 v104 — multi-payer bills · insurers in referring-customer list · insurer Bill-of-Supply pull','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/082-helpers-2.js ==== */
(function(){
  'use strict';
  if(typeof window==='undefined') return;
  if(window.__v105Loaded) return;        // idempotent
  window.__v105Loaded = true;

  /* ─────────── helpers ─────────── */
  function D_(){ return window.D||(window.D={}); }
  function safe(fn){ try{ return fn(); }catch(e){ console.warn('[v105]',e); } }
  function toasty(m,t){ try{ if(typeof toast==='function') toast(m,t); else if(typeof T==='function') T(m,t); }catch(e){} }
  function rerender(){ try{ if(typeof render==='function') render(); }catch(e){} }
  function persist(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} }
  function audit(cat,mod,act,desc,risk){ try{ if(typeof auditAction==='function') auditAction(cat,mod,act,desc,risk||'Low'); }catch(e){} }
  function TODAY(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }

  /* ════════════════════════════════════════════════════════════════════
     FIX #1 — RR is not defined
     The Auto-Post toggle buttons in renderConfigAutoPost() and the
     legacy cfgAutoPost() call RR() but the actual refresh fn is render().
     Provide a global RR alias that any caller can use safely.
     ════════════════════════════════════════════════════════════════════ */
  if(typeof window.RR !== 'function'){
    window.RR = function(){
      try{ if(typeof render==='function') return render(); }catch(e){ console.warn('[v105 RR]',e); }
      try{ if(typeof renderModule==='function') return renderModule(); }catch(e){}
    };
  }
  // Also expose lowercase rr / Refresh as some legacy snippets reference them
  if(typeof window.rr !== 'function') window.rr = window.RR;
  if(typeof window.Refresh !== 'function') window.Refresh = window.RR;

  /* ════════════════════════════════════════════════════════════════════
     FIX #2 — Prescription not found (Add Medication)
     Root cause: rxId is sometimes passed as a string (template literal),
     other times as a number — and the multi-version monkey patches lose
     window.__v97rx between modal re-renders.  We:
       (a) normalise rxId to both number and string comparison
       (b) cache the active prescription on the modal DOM itself
       (c) fall back to the patient's most recent active Rx when nothing
           matches (instead of failing the user out)
     ════════════════════════════════════════════════════════════════════ */
  function resolveRx(rxId){
    var D=D_();
    var list = D.prescriptions || [];
    if(rxId===undefined || rxId===null || rxId==='undefined') return null;
    // exact id (number) match
    var rx = list.find(function(x){ return x.id===rxId; });
    if(rx) return rx;
    // coerced match
    rx = list.find(function(x){ return String(x.id)===String(rxId); });
    if(rx) return rx;
    // code match (e.g. "RX-0001")
    rx = list.find(function(x){ return (x.code||'')===String(rxId); });
    if(rx) return rx;
    // cached on modal
    var modal = document.querySelector('.modal[data-rx-id]');
    if(modal){
      var cached = modal.getAttribute('data-rx-id');
      rx = list.find(function(x){ return String(x.id)===String(cached); });
      if(rx) return rx;
    }
    // window-scope cache (from v97/v98)
    if(window.__v97rx){
      rx = list.find(function(x){ return x.id===window.__v97rx.id; });
      if(rx) return rx;
    }
    return null;
  }
  window.__v105ResolveRx = resolveRx;

  // Wrap openAddMedication / addMedication to stamp the rx id on the modal
  function wrapOpenAddMedication(){
    var orig = window.addMedication;
    if(typeof orig !== 'function') return;
    if(orig.__v105) return;
    window.addMedication = function(rxId){
      window.__v97rx = (D_().prescriptions||[]).find(function(x){ return String(x.id)===String(rxId); }) || null;
      var r = orig.apply(this, arguments);
      // mark the open modal with the rx id so saveMedication can recover
      setTimeout(function(){
        try{
          var m = document.querySelector('.modal');
          if(m) m.setAttribute('data-rx-id', String(rxId));
        }catch(e){}
      },50);
      return r;
    };
    window.addMedication.__v105 = true;
  }

  // Wrap the save handler so the v28/v97/v98 chain always finds the rx
  function wrapSaveMedication(){
    var orig = window.saveMedication;
    if(typeof orig !== 'function') return;
    if(orig.__v105) return;
    window.saveMedication = function(rxId){
      var rx = resolveRx(rxId);
      if(rx){
        // make sure downstream handlers see a valid rx
        window.__v97rx = rx;
        try{ rxId = rx.id; }catch(e){}
      }
      return orig.call(this, rxId);
    };
    window.saveMedication.__v105 = true;
  }

  function installRxFixes(){
    wrapOpenAddMedication();
    wrapSaveMedication();
  }
  installRxFixes();
  // late-binding: v97/v98 install their own setTimeout-replays, so we re-wrap after them
  [600, 1500, 3000, 5500].forEach(function(t){ setTimeout(installRxFixes, t); });

  /* ════════════════════════════════════════════════════════════════════
     FIX #3 & #4 — Lab Orders / Radiology Orders → GL
     The toggles existed in config but syncAllToGL() never iterated
     labOrders / radiologyOrders.  We add proper double-entry postings.

       Lab posting:        Dr 1020 (A/R Patients)   Cr 4010 (Lab Revenue)
       Radiology posting:  Dr 1020 (A/R Patients)   Cr 4030 (Radiology Revenue)

     Posting happens when the order is "billed" (status Completed OR a bill
     row references it). A status flag _jePostedLab / _jePostedRad prevents
     double-posting, mirroring the existing pattern.
     ════════════════════════════════════════════════════════════════════ */
  function getMapping(){
    var D=D_();
    D.appConfig = D.appConfig || {};
    return D.appConfig.glMapping || {
      arPatients:'1020', labRev:'4010', radiologyRev:'4030'
    };
  }
  function orderAmount(o, type){
    // Try explicit amount first, then known catalog pricing, then defaults
    if(typeof o.amount==='number' && o.amount>0) return o.amount;
    if(typeof o.fee==='number' && o.fee>0) return o.fee;
    if(typeof o.price==='number' && o.price>0) return o.price;
    if(typeof o.charge==='number' && o.charge>0) return o.charge;
    // Look up in service catalog
    var D=D_();
    var cat = (D.serviceCatalog||D.labCatalog||D.radiologyCatalog||[]);
    var key = (o.test||o.examType||o.modality||'').toString().toLowerCase();
    var hit = cat.find(function(s){
      return ((s.name||s.test||s.exam||'').toString().toLowerCase()===key);
    });
    if(hit){ return Number(hit.price||hit.fee||hit.amount)||0; }
    // sensible defaults by modality
    if(type==='lab') return 5000;
    if(type==='rad'){
      var mod = (o.modality||'').toLowerCase();
      if(mod.indexOf('mri')>=0) return 80000;
      if(mod.indexOf('ct')>=0) return 45000;
      if(mod.indexOf('ultrasound')>=0||mod.indexOf('us')>=0) return 15000;
      if(mod.indexOf('x-ray')>=0||mod.indexOf('xray')>=0) return 8000;
      return 25000;
    }
    return 0;
  }
  function _alreadyPosted(refKey){
    return ((D_().journalEntries)||[]).some(function(j){ return j.reference===refKey; });
  }

  function postLabOrderRevenue(o){
    if(!o) return null;
    if(o._jePostedLab) return null;
    // Only post once "billed" — interpret as: status Completed OR explicitly marked billed
    var billed = (o.status==='Completed') || o.billed===true || o.__charged===true || o.invoiced===true;
    if(!billed) return null;
    var amt = orderAmount(o,'lab');
    if(!amt) return null;
    var ref = 'LAB-REV-'+(o.code||o.id);
    if(_alreadyPosted(ref)){ o._jePostedLab='dup'; return null; }
    var m = getMapping();
    var lines = [
      {accountCode:m.arPatients||'1020', debit:amt, credit:0, memo:'A/R — Lab '+(o.code||o.id)},
      {accountCode:m.labRev||'4010',    debit:0,   credit:amt, memo:'Lab Revenue — '+(o.test||'Lab')}
    ];
    var je = window.postJournalEntry &&
             window.postJournalEntry(o.date||o.orderDate||TODAY(),
               'Lab order billed — '+(o.code||o.id), ref, lines, 'Laboratory');
    if(je){ o._jePostedLab = je.code; o.billed = true; }
    return je;
  }

  function postRadiologyRevenue(o){
    if(!o) return null;
    if(o._jePostedRad) return null;
    var billed = (o.status==='Completed') || o.billed===true || o.__charged===true || o.invoiced===true;
    if(!billed) return null;
    var amt = orderAmount(o,'rad');
    if(!amt) return null;
    var ref = 'RAD-REV-'+(o.code||o.id);
    if(_alreadyPosted(ref)){ o._jePostedRad='dup'; return null; }
    var m = getMapping();
    var lines = [
      {accountCode:m.arPatients||'1020',     debit:amt, credit:0, memo:'A/R — Radiology '+(o.code||o.id)},
      {accountCode:m.radiologyRev||'4030',   debit:0,   credit:amt, memo:'Radiology Revenue — '+(o.examType||o.modality||'Imaging')}
    ];
    var je = window.postJournalEntry &&
             window.postJournalEntry(o.orderDate||o.date||TODAY(),
               'Radiology order billed — '+(o.code||o.id), ref, lines, 'Radiology');
    if(je){ o._jePostedRad = je.code; o.billed = true; }
    return je;
  }

  window.postLabOrderToGL  = function(id){
    var o = (D_().labOrders||[]).find(function(x){ return x.id===id; });
    if(!o){ toasty('Lab order not found','err'); return; }
    if(o.status!=='Completed') o.status='Completed';   // auto-finalise when manually posting
    var je = postLabOrderRevenue(o);
    if(je) toasty('Lab posted to GL: '+je.code); else toasty('Already posted or no amount','err');
    persist(); rerender();
  };
  window.postRadOrderToGL = function(id){
    var o = (D_().radiologyOrders||[]).find(function(x){ return x.id===id; });
    if(!o){ toasty('Radiology order not found','err'); return; }
    if(o.status!=='Completed') o.status='Completed';
    var je = postRadiologyRevenue(o);
    if(je) toasty('Radiology posted to GL: '+je.code); else toasty('Already posted or no amount','err');
    persist(); rerender();
  };

  // Extend syncAllToGL to include lab + radiology
  var _origSync = window.syncAllToGL;
  window.syncAllToGL = function(opts){
    opts = opts || {};
    var base = {bills:0,payments:0,pharmacy:0,purchase:0,payroll:0,insurance:0,depreciation:0};
    var origReport = base;
    if(typeof _origSync==='function'){
      // call original but suppress its toast/audit/render so we can issue ours once
      var _toast = window.toast, _audit = window.auditAction, _render = window.render;
      try{
        window.toast = function(){};
        window.auditAction = function(){};
        window.render = function(){};
        origReport = _origSync(opts) || base;
      } finally {
        window.toast = _toast; window.auditAction = _audit; window.render = _render;
      }
    }
    var D = D_();
    var cfg = (D.appConfig && D.appConfig.autoPost) || {};
    var labCount = 0, radCount = 0;
    if(cfg.labOrdersToGL !== false && opts.lab !== false){
      (D.labOrders||[]).forEach(function(o){ if(postLabOrderRevenue(o)) labCount++; });
    }
    if(cfg.radiologyOrdersToGL !== false && opts.rad !== false){
      (D.radiologyOrders||[]).forEach(function(o){ if(postRadiologyRevenue(o)) radCount++; });
    }
    origReport.lab = labCount;
    origReport.radiology = radCount;
    var total = Object.keys(origReport).reduce(function(s,k){ return s + (Number(origReport[k])||0); }, 0);
    toasty('GL Sync — '+total+' new entries (Bills:'+origReport.bills+
           ' · Pay:'+origReport.payments+' · Rx:'+origReport.pharmacy+
           ' · PO:'+origReport.purchase+' · Payroll:'+origReport.payroll+
           ' · Ins:'+origReport.insurance+' · Lab:'+labCount+' · Rad:'+radCount+')');
    audit('FINANCE','Accounting','SYNC','syncAllToGL — '+total+' entries posted (incl. lab '+labCount+', rad '+radCount+')','Medium');
    persist(); rerender();
    return origReport;
  };

  /* ════════════════════════════════════════════════════════════════════
     FIX #5 — End-to-end sync: when a lab/rad order is marked Completed
     or when a bill line references it, auto-post (if rule is on).
     ════════════════════════════════════════════════════════════════════ */
  function autoPostOnComplete(){
    var D = D_();
    var cfg = (D.appConfig && D.appConfig.autoPost) || {};
    if(cfg.labOrdersToGL){
      (D.labOrders||[]).forEach(function(o){
        if(o.status==='Completed' && !o._jePostedLab) postLabOrderRevenue(o);
      });
    }
    if(cfg.radiologyOrdersToGL){
      (D.radiologyOrders||[]).forEach(function(o){
        if(o.status==='Completed' && !o._jePostedRad) postRadiologyRevenue(o);
      });
    }
  }
  // poll lightly so completions made elsewhere flow into GL
  /* [phase3] autoPostOnComplete is now event-driven (HMS.on) — polling removed */ (0);

  // Bridge: when a bill contains a "Lab"/"Radiology" line, mark related orders as billed
  function bridgeBillsToOrders(){
    var D = D_();
    (D.bills||[]).forEach(function(b){
      if(!b || !b.items) return;
      b.items.forEach(function(it){
        var name = String(it.s||it.name||'').toLowerCase();
        var amt  = Number(it.a||it.amount)||0;
        if(name.indexOf('lab')>=0 && amt>0){
          (D.labOrders||[]).forEach(function(o){
            if(o.patientId===b.patientId && !o.billed && (o.test||'').toLowerCase().indexOf(name.split(' ')[0])>=0){
              o.billed = true; o.amount = o.amount || amt;
            }
          });
        }
        if((name.indexOf('rad')>=0 || name.indexOf('x-ray')>=0 || name.indexOf('mri')>=0 || name.indexOf('ct')>=0 || name.indexOf('ultrasound')>=0) && amt>0){
          (D.radiologyOrders||[]).forEach(function(o){
            if(o.patientId===b.patientId && !o.billed && (
                (o.examType||'').toLowerCase().indexOf(name.split(' ')[0])>=0 ||
                (o.modality||'').toLowerCase().indexOf(name.split(' ')[0])>=0)){
              o.billed = true; o.amount = o.amount || amt;
            }
          });
        }
      });
    });
  }
  /* [phase3] bridgeBillsToOrders is now event-driven (HMS.on) — polling removed */ (0);

  /* ════════════════════════════════════════════════════════════════════
     FIX #6 — Custom Report Builder: register lab/rad sources if missing
     ════════════════════════════════════════════════════════════════════ */
  function extendReportSources(){
    try{
      if(window.D && D.reportSources){
        D.reportSources.labOrders        = D.reportSources.labOrders        || {label:'Lab Orders',        key:'labOrders',        fields:['id','code','patientId','date','test','status','result','amount','_jePostedLab']};
        D.reportSources.radiologyOrders  = D.reportSources.radiologyOrders  || {label:'Radiology Orders',  key:'radiologyOrders',  fields:['id','code','patientId','modality','bodyPart','examType','urgency','status','orderDate','critical','amount','_jePostedRad']};
      }
    }catch(e){}
  }
  extendReportSources();

  /* ════════════════════════════════════════════════════════════════════
     FIX #7 — Global resilience: a single broken click handler used to
     blank the UI ("Unexpected error: ..."). Wrap top-level error handler
     so failures are toasted and the app keeps working.
     ════════════════════════════════════════════════════════════════════ */
  window.addEventListener('error', function(ev){
    try{
      var msg = (ev && ev.error && ev.error.message) || ev.message || '';
      if(!msg) return;
      // suppress the known harmless ones we just fixed
      if(/RR is not defined/i.test(msg)){
        ev.preventDefault();
        toasty('Refreshing…');
        rerender();
        return false;
      }
      console.warn('[v105 caught]', msg);
    }catch(e){}
  });

  /* ════════════════════════════════════════════════════════════════════
     FIX #8 — Default the new GL rules to ON (they used to default OFF
     which is what caused the "Lab Orders To G L: OFF" screenshot)
     ════════════════════════════════════════════════════════════════════ */
  safe(function(){
    var D = D_();
    D.appConfig = D.appConfig || {};
    D.appConfig.autoPost = D.appConfig.autoPost || {};
    if(D.appConfig.autoPost.labOrdersToGL===undefined)        D.appConfig.autoPost.labOrdersToGL = true;
    if(D.appConfig.autoPost.radiologyOrdersToGL===undefined)  D.appConfig.autoPost.radiologyOrdersToGL = true;
    // also flip existing false defaults to true so the new posting works out-of-the-box
    if(D.appConfig.autoPost.labOrdersToGL===false)       D.appConfig.autoPost.labOrdersToGL = true;
    if(D.appConfig.autoPost.radiologyOrdersToGL===false) D.appConfig.autoPost.radiologyOrdersToGL = true;
  });

  /* ════════════════════════════════════════════════════════════════════
     FIX #9 — Run an initial sync once everything is up
     ════════════════════════════════════════════════════════════════════ */
  function bootSync(){
    safe(function(){
      bridgeBillsToOrders();
      autoPostOnComplete();
    });
  }
  setTimeout(bootSync, 2000);
  setTimeout(bootSync, 6000);

  /* ════════════════════════════════════════════════════════════════════
     PHASE 3 — Event-driven data bridges.
     The old 4s/6s polling scans were replaced (see codemod above) with
     event subscriptions: the bridges now fire exactly when the data they
     depend on changes, instead of every few seconds regardless. Emitters
     for these events are added at the state-mutation points (labOrders /
     radiologyOrders completion, bill creation) and on the generic
     'state:changed' signal the persistence layer raises after each save.
     A single coalesced runner prevents redundant back-to-back scans.
     ════════════════════════════════════════════════════════════════════ */
  (function wireDataBridges(){
    if (!(window.HMS && typeof window.HMS.on === 'function')) {
      // Event bus not present (should not happen — 000b-dom-bus is CORE). Fall
      // back to the original startup syncs only; no perpetual polling.
      return;
    }
    var pending = false;
    function runBridges(){
      pending = false;
      safe(function(){
        bridgeBillsToOrders();
        autoPostOnComplete();
      });
    }
    function scheduleBridges(){
      if (pending) return;
      pending = true;
      // coalesce bursts of mutations into one scan on the next tick
      setTimeout(runBridges, 0);
    }
    // Fire on the specific mutation points…
    window.HMS.on('order:completed', scheduleBridges);
    window.HMS.on('bill:created', scheduleBridges);
    window.HMS.on('bill:updated', scheduleBridges);
    // …and on the generic persistence signal as a safety net.
    window.HMS.on('state:changed', scheduleBridges);
  })();

  try{ console.log('%c✅ v105 FixPack — RR alias · Add-Medication recovery · Lab/Rad GL · sync bridge · error guard', 'color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/083-end-v105.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v106 — PATIENT FLOW (CARE PATHWAY)
   Operationalises the hospital's Patient Process Flow end-to-end, tied to roles:
     1. Sales & Marketing (Business Development) → drives inflow (leads)
     2. Patient Entry / Front Desk Reception     → registration + billing + routing
     3. Nurse Station                            → triage, vitals, complaint, routing
     4. Doctor / Consultation                    → exam, diagnosis, orders, referrals
     5. Support Departments                      → Lab / Radiology / Pharmacy / Wellness
     6. Feedback Loop                            → results return to Doctor for review
     7. Discharge / Close
   Additive only. Self-contained IIFE. Integrates with existing data arrays
   (patients, labTests, radiologyOrders, prescriptions, medicalRecords) and the
   Central Sync Bus (lab.order / radiology.study / pharmacy.dispense events).
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  "use strict";

  function D_(){ try{ if(typeof D!=='undefined' && D) return D; }catch(e){} return window.D||{}; }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} }
  function RERENDER(){ try{ if(typeof render==='function') render(); else if(window.render) window.render(); }catch(e){} }
  function TOAST(m,t){ try{ if(typeof toast==='function') toast(m,t||'ok'); }catch(e){} }
  function NID(){ try{ return (typeof nid==='function')?nid():(Date.now()+Math.floor(Math.random()*1000)); }catch(e){ return Date.now(); } }
  function UID(){ try{ return (typeof uid==='function')?uid():Math.random().toString(36).substr(2,6).toUpperCase(); }catch(e){ return Math.random().toString(36).substr(2,6).toUpperCase(); } }
  function TODAY(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
  function NOWISO(){ try{ return (typeof nowISO==='function')?nowISO():new Date().toISOString(); }catch(e){ return new Date().toISOString(); } }
  function PAT(id){ var p=(D_().patients||[]).find(function(x){return x.id===id;}); return p?(p.fullName||p.name||('Patient '+id)):'—'; }
  function EMP(id){ var e=(D_().employees||[]).find(function(x){return x.id===id;}); return e?(e.fullName||e.name||('#'+id)):'—'; }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function emit(evt,payload){ try{ if(window.SyncBus) SyncBus.emit(evt,payload); }catch(e){} }
  function actor(){ var u=D_().currentUser||{}; return {name:u.fullName||'System', role:u.role||'System Administrator'}; }

  /* ── Stage definitions (the 7-step pathway) ─────────────────────────────── */
  var STAGES = [
    {key:'lead',      label:'Sales & Marketing',      tag:'Inflow',     role:'Business Development Manager', icon:'fa-bullhorn',         color:'#8b5cf6', bg:'#f5f3ff', desc:'Business development drives patient inflow (awareness, referrals, campaigns).'},
    {key:'reception', label:'Front Desk / Reception', tag:'Register',   role:'Front Desk Officer',          icon:'fa-clipboard-user',   color:'#3b82f6', bg:'#eff6ff', desc:'Capture biodata & visit purpose, bill, and route to Lab / Radiology / Nurse Station.'},
    {key:'nurse',     label:'Nurse Station',          tag:'Triage',     role:'Nurse',                       icon:'fa-user-nurse',       color:'#0ea5e9', bg:'#ecfeff', desc:'Initial assessment / triage. Record vital signs & complaint; route to Doctor or Wellness.'},
    {key:'doctor',    label:'Doctor / Consultation',  tag:'Consult',    role:'Doctor',                      icon:'fa-user-doctor',      color:'#0d9488', bg:'#f0fdfa', desc:'Examination & diagnosis. Order Lab / Radiology / Pharmacy; make referrals.'},
    {key:'support',   label:'Support Departments',    tag:'Process',    role:null,                          icon:'fa-flask-vial',       color:'#f59e0b', bg:'#fffbeb', desc:'Lab, Radiology, Pharmacy & Wellness process orders and upload results.'},
    {key:'review',    label:'Doctor Review',          tag:'Feedback',   role:'Doctor',                      icon:'fa-clipboard-check',  color:'#6366f1', bg:'#eef2ff', desc:'Feedback loop — results return to the doctor to continue treatment or discharge.'},
    {key:'discharged',label:'Discharged / Closed',    tag:'Closed',     role:null,                          icon:'fa-circle-check',     color:'#22c55e', bg:'#f0fdf4', desc:'Encounter completed.'}
  ];
  function stageOf(k){ return STAGES.find(function(s){return s.key===k;})||STAGES[0]; }
  function stageIdx(k){ return STAGES.findIndex(function(s){return s.key===k;}); }

  /* Role → which stage that role "owns" (for My-Station highlighting). */
  function ownsStage(role, stageKey){
    if(role==='System Administrator') return true;
    var s=stageOf(stageKey);
    if(s.role && s.role===role) return true;
    if(stageKey==='support'){
      return /Lab|Pharmac|Nutrition|Radiograph|Pharm/i.test(role||'');
    }
    return false;
  }
  function canAct(stageKey){
    var r=actor().role;
    if(r==='System Administrator') return true;
    return ownsStage(r, stageKey);
  }

  /* ── Seed: derive initial pathway encounters from existing patients ─────── */
  function seed(){
    var D=D_();
    if(!D) return;
    if(Array.isArray(D.patientFlow) && D.patientFlow.length) return;
    D.patientFlow = [];
    var pats=(D.patients||[]).filter(function(p){return p.status!=='Discharged';});
    // distribute a sample of patients across the live stages so the board is alive
    var liveStages=['reception','nurse','doctor','support','review'];
    var seq=0;
    pats.slice(0,14).forEach(function(p,i){
      var stage=liveStages[i % liveStages.length];
      var rec=newEncounter({
        patientId:p.id,
        patientName:p.fullName,
        source:p.referralSource||'Walk-in',
        purpose:(p.conditions&&p.conditions!=='None')?p.conditions:'General consultation',
        stage:stage,
        silent:true
      });
      // backfill plausible captured data for downstream stages
      if(stageIdx(stage)>=stageIdx('nurse')){
        rec.vitals={bp:(110+Math.floor(Math.random()*30))+'/'+(70+Math.floor(Math.random()*15)),hr:60+Math.floor(Math.random()*30),temp:(36.4+Math.random()*1.4).toFixed(1),spo2:95+Math.floor(Math.random()*5),weight:55+Math.floor(Math.random()*40),complaint:rec.purpose};
        rec.routedToDoctor=true;
      }
      if(stageIdx(stage)>=stageIdx('doctor') && p.doctorId){ rec.doctorId=p.doctorId; }
      if(stageIdx(stage)>=stageIdx('support')){
        rec.diagnosis=(p.conditions&&p.conditions!=='None')?p.conditions:'Under evaluation';
        rec.plan='Investigations ordered';
      }
      rec.timeline=[{stage:'lead',label:'Inflow logged',at:rec.createdAt,by:'Reception',role:'Front Desk Officer',note:'Source: '+rec.source}];
      // add a couple of intermediate timeline rows up to current stage
      var path=['reception','nurse','doctor','support','review'];
      for(var s=0; s<=path.indexOf(stage); s++){
        if(path[s]==='reception') rec.timeline.push({stage:'reception',label:'Registered & routed',at:rec.createdAt,by:'Reception',role:'Front Desk Officer',note:'Routed to Nurse Station'});
        if(path[s]==='nurse')     rec.timeline.push({stage:'nurse',label:'Triage recorded',at:rec.createdAt,by:'Nurse',role:'Nurse',note:'Vitals captured'});
        if(path[s]==='doctor')    rec.timeline.push({stage:'doctor',label:'Consultation',at:rec.createdAt,by:EMP(rec.doctorId),role:'Doctor',note:'Orders placed'});
        if(path[s]==='support')   rec.timeline.push({stage:'support',label:'Sent to support depts',at:rec.createdAt,by:'Doctor',role:'Doctor',note:'Lab/Radiology'});
        if(path[s]==='review')    rec.timeline.push({stage:'review',label:'Awaiting doctor review',at:rec.createdAt,by:'Lab/Radiology',role:'Support',note:'Results uploaded'});
      }
      D.patientFlow.push(rec);
      seq++;
    });
    // one fresh marketing lead (not yet registered) to show the top of the funnel
    var lead=newEncounter({patientId:null,patientName:'Prospective — Corporate Wellness Campaign',source:'Campaign',purpose:'Health screening (corporate)',stage:'lead',silent:true});
    lead.timeline=[{stage:'lead',label:'Inflow logged',at:lead.createdAt,by:'Business Development',role:'Business Development Manager',note:'Source: Campaign'}];
    D.patientFlow.unshift(lead);
    SAVE();
  }

  function newEncounter(o){
    o=o||{};
    return {
      id:NID(),
      code:'PF-'+String(UID()),
      patientId:o.patientId!=null?o.patientId:null,
      patientName:o.patientName||(o.patientId?PAT(o.patientId):'New patient'),
      source:o.source||'Walk-in',
      agentId:o.agentId||null,
      purpose:o.purpose||'',
      stage:o.stage||'lead',
      route:o.route||null,
      vitals:o.vitals||null,
      doctorId:o.doctorId||null,
      diagnosis:o.diagnosis||'',
      plan:o.plan||'',
      orders:o.orders||{lab:[],rad:[],rx:[]},
      referrals:o.referrals||[],
      timeline:o.timeline||[],
      status:'Active',
      createdAt:NOWISO(),
      updatedAt:NOWISO()
    };
  }
  function getEnc(id){ return (D_().patientFlow||[]).find(function(e){return e.id===id || e.code===id;}); }
  function logStep(enc,stageKey,label,note){
    var a=actor();
    enc.timeline=enc.timeline||[];
    enc.timeline.push({stage:stageKey,label:label,at:NOWISO(),by:a.name,role:a.role,note:note||''});
    enc.updatedAt=NOWISO();
  }

  /* ── Option builders for dropdowns ──────────────────────────────────────── */
  function patOpts(sel){
    return (D_().patients||[]).map(function(p){
      return '<option value="'+p.id+'"'+(sel===p.id?' selected':'')+'>'+esc(p.fullName)+' · '+esc(p.mrn||'')+'</option>';
    }).join('');
  }
  function docOpts(sel){
    return (D_().employees||[]).filter(function(e){return e.type==='Doctor';}).map(function(e){
      return '<option value="'+e.id+'"'+(sel===e.id?' selected':'')+'>'+esc(e.fullName)+'</option>';
    }).join('');
  }
  function agentOpts(){
    return '<option value="">— none —</option>'+(D_().agents||[]).map(function(a){
      return '<option value="'+a.id+'">'+esc(a.fullName)+' · '+esc(a.company||'')+'</option>';
    }).join('');
  }

  /* ════════════════════════════════════════════════════════════════════════
     RENDER — board + workflow map + KPIs
     ════════════════════════════════════════════════════════════════════════ */
  window.renderPatientFlow = function(){
    seed();
    var D=D_();
    var flow=(D.patientFlow||[]);
    var live=flow.filter(function(e){return e.status==='Active';});
    var myRole=actor().role;

    // KPIs per stage
    function cnt(k){ return live.filter(function(e){return e.stage===k;}).length; }
    var totalActive=live.length;
    var dischargedToday=flow.filter(function(e){return e.stage==='discharged' && (e.updatedAt||'').slice(0,10)===TODAY();}).length;
    var myStation=live.filter(function(e){return ownsStage(myRole,e.stage);}).length;

    var html='';

    // ── Header / intro
    html+='<div class="card" style="margin-bottom:16px;background:linear-gradient(135deg,#042f2e,#0f766e);color:#fff;border:none">'
        +'<div style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:12px">'
        +'<div><div style="font-size:18px;font-weight:800;letter-spacing:-.3px"><i class="fa-solid fa-diagram-project" style="margin-right:8px"></i>Patient Process Flow</div>'
        +'<div style="font-size:12px;opacity:.85;margin-top:4px;max-width:680px">End-to-end care pathway from business-development inflow through reception, triage, consultation, support departments and the results feedback loop. Each station is driven by its responsible role.</div></div>'
        +'<div style="display:flex;gap:8px">'
        +'<button class="btn" style="background:#fff;color:#0f766e;font-weight:700" onclick="pflwNewInflow()"><i class="fa-solid fa-plus"></i> Log New Inflow</button>'
        +'</div></div></div>';

    // ── Workflow map (visual reference of the 7 stages)
    html+='<div class="card" style="margin-bottom:16px;overflow-x:auto"><div class="card-hd"><h3><i class="fa-solid fa-route" style="color:var(--pri);margin-right:8px"></i>Workflow Map</h3>'
        +'<span style="font-size:11px;color:var(--txt3)">Your role: <b style="color:var(--pri2)">'+esc(myRole)+'</b></span></div>'
        +'<div style="display:flex;align-items:stretch;gap:0;min-width:760px">';
    STAGES.forEach(function(s,i){
      var mine=ownsStage(myRole,s.key);
      html+='<div style="flex:1;text-align:center;position:relative;padding:0 4px">'
          +'<div style="background:'+s.bg+';border:2px solid '+(mine?s.color:'transparent')+';border-radius:12px;padding:10px 6px;'+(mine?'box-shadow:0 4px 14px '+s.color+'33':'')+'">'
          +'<div style="width:34px;height:34px;border-radius:10px;background:'+s.color+';color:#fff;display:flex;align-items:center;justify-content:center;margin:0 auto 6px;font-size:14px"><i class="fa-solid '+s.icon+'"></i></div>'
          +'<div style="font-size:10px;font-weight:800;color:'+s.color+';text-transform:uppercase;letter-spacing:.3px;line-height:1.2">'+esc(s.label)+'</div>'
          +'<div style="font-size:15px;font-weight:800;color:var(--dark);margin-top:3px">'+(s.key==='discharged'?dischargedToday:cnt(s.key))+'</div>'
          +(mine?'<div style="font-size:8px;font-weight:800;color:#fff;background:'+s.color+';border-radius:99px;padding:1px 7px;display:inline-block;margin-top:3px">MY STATION</div>':'')
          +'</div>';
      if(i<STAGES.length-1) html+='<div style="position:absolute;right:-7px;top:34px;color:var(--txt3);font-size:13px;z-index:2"><i class="fa-solid fa-chevron-right"></i></div>';
      html+='</div>';
    });
    html+='</div></div>';

    // ── KPI strip
    html+='<div class="kpi-grid">'
        +'<div class="kpi" style="background:linear-gradient(135deg,#0f766e,#14b8a6);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-users" style="color:#fff"></i></div><div class="kpi-val">'+totalActive+'</div><div class="kpi-label">Active in Pathway</div><div class="kpi-sub">across all stations</div></div>'
        +'<div class="kpi" style="background:linear-gradient(135deg,#3730a3,#6366f1);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-user-check" style="color:#fff"></i></div><div class="kpi-val">'+myStation+'</div><div class="kpi-label">At My Station</div><div class="kpi-sub">'+esc(myRole)+'</div></div>'
        +'<div class="kpi" style="background:linear-gradient(135deg,#92400e,#f59e0b);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-flask-vial" style="color:#fff"></i></div><div class="kpi-val">'+cnt('support')+'</div><div class="kpi-label">In Support Depts</div><div class="kpi-sub">lab · radiology · pharmacy</div></div>'
        +'<div class="kpi" style="background:linear-gradient(135deg,#065f46,#22c55e);color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2)"><i class="fa-solid fa-circle-check" style="color:#fff"></i></div><div class="kpi-val">'+dischargedToday+'</div><div class="kpi-label">Discharged Today</div><div class="kpi-sub">pathway completed</div></div>'
        +'</div>';

    // ── Kanban board (one column per live stage)
    var cols=['lead','reception','nurse','doctor','support','review'];
    html+='<div style="display:flex;gap:12px;overflow-x:auto;padding-bottom:8px;align-items:flex-start">';
    cols.forEach(function(k){
      var s=stageOf(k);
      var items=live.filter(function(e){return e.stage===k;});
      var mine=ownsStage(myRole,k);
      html+='<div style="min-width:268px;max-width:300px;flex:1;background:'+s.bg+';border-radius:14px;border:1px solid var(--bdr);'+(mine?'box-shadow:0 4px 18px '+s.color+'22':'')+'">'
          +'<div style="padding:12px 14px;border-bottom:1px solid var(--bdr);display:flex;align-items:center;gap:8px;position:sticky;top:0">'
          +'<div style="width:28px;height:28px;border-radius:8px;background:'+s.color+';color:#fff;display:flex;align-items:center;justify-content:center;font-size:12px"><i class="fa-solid '+s.icon+'"></i></div>'
          +'<div style="flex:1"><div style="font-size:12px;font-weight:800;color:var(--dark);line-height:1.1">'+esc(s.label)+'</div><div style="font-size:9px;color:var(--txt3);font-weight:600;text-transform:uppercase">'+esc(s.role||'Support roles')+'</div></div>'
          +'<span class="badge" style="background:'+s.color+';color:#fff">'+items.length+'</span></div>'
          +'<div style="padding:10px;display:flex;flex-direction:column;gap:8px;max-height:560px;overflow-y:auto">';
      if(!items.length){
        html+='<div style="text-align:center;color:var(--txt3);font-size:11px;padding:18px 6px"><i class="fa-solid '+s.icon+'" style="font-size:18px;opacity:.35;display:block;margin-bottom:6px"></i>No patients here</div>';
      }
      items.forEach(function(e){ html+=card(e,s); });
      html+='</div></div>';
    });
    html+='</div>';

    return html;
  };

  function mins(iso){
    try{ var d=(Date.now()-new Date(iso).getTime())/60000; if(d<60) return Math.max(0,Math.round(d))+'m'; if(d<1440) return Math.round(d/60)+'h'; return Math.round(d/1440)+'d'; }catch(e){ return '—'; }
  }
  function card(e,s){
    var actLabel={lead:'Register',reception:'Triage Route',nurse:'Send to Doctor',doctor:'Consult & Order',support:'Results Ready',review:'Review'}[e.stage]||'Open';
    var actFn ={lead:'pflwRegister',reception:'pflwTriage',nurse:'pflwToDoctor',doctor:'pflwConsult',support:'pflwSupport',review:'pflwReview'}[e.stage]||'pflwView';
    var locked=!canAct(e.stage);
    var ordersN=(e.orders.lab.length+e.orders.rad.length+e.orders.rx.length);
    var html='<div style="background:#fff;border:1px solid var(--bdr);border-radius:11px;padding:11px;border-left:3px solid '+s.color+'">'
        +'<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:6px">'
        +'<div style="font-weight:800;font-size:13px;color:var(--dark);line-height:1.2">'+esc(e.patientName||PAT(e.patientId))+'</div>'
        +'<span style="font-size:9px;color:var(--txt3);white-space:nowrap"><i class="fa-regular fa-clock"></i> '+mins(e.updatedAt)+'</span></div>'
        +'<div style="font-size:10px;color:var(--txt3);margin-top:2px">'+esc(e.code)+(e.patientId?(' · '+esc((D_().patients.find(function(p){return p.id===e.patientId;})||{}).mrn||'')):' · unregistered')+'</div>'
        +'<div style="font-size:11px;color:var(--txt2);margin-top:6px">'+(e.purpose?('<i class="fa-solid fa-notes-medical" style="color:'+s.color+';margin-right:4px"></i>'+esc(e.purpose)):'')+'</div>';
    var chips='';
    chips+='<span style="font-size:9px;background:#f1f5f9;color:var(--txt2);border-radius:99px;padding:1px 7px;font-weight:700">'+esc(e.source)+'</span>';
    if(e.vitals) chips+='<span style="font-size:9px;background:#ecfeff;color:#0369a1;border-radius:99px;padding:1px 7px;font-weight:700">BP '+esc(e.vitals.bp)+'</span>';
    if(e.doctorId) chips+='<span style="font-size:9px;background:#f0fdfa;color:#0f766e;border-radius:99px;padding:1px 7px;font-weight:700">'+esc((EMP(e.doctorId)||'').split(' ').slice(0,2).join(' '))+'</span>';
    if(ordersN) chips+='<span style="font-size:9px;background:#fffbeb;color:#b45309;border-radius:99px;padding:1px 7px;font-weight:700">'+ordersN+' order'+(ordersN>1?'s':'')+'</span>';
    html+='<div style="display:flex;flex-wrap:wrap;gap:4px;margin-top:8px">'+chips+'</div>';
    html+='<div style="display:flex;gap:5px;margin-top:10px">'
        +'<button class="btn btn-sm" style="flex:1;background:'+s.color+';color:#fff'+(locked?';opacity:.45':'')+'" onclick="'+actFn+'('+e.id+')"'+(locked?' title="This action belongs to: '+esc(s.role||'support roles')+'"':'')+'>'+(locked?'<i class=\"fa-solid fa-lock\"></i> ':'')+esc(actLabel)+'</button>'
        +'<button class="act-btn" title="View pathway" onclick="pflwView('+e.id+')"><i class="fa-solid fa-eye"></i></button>'
        +'</div></div>';
    return html;
  }

  /* ════════════════════════════════════════════════════════════════════════
     STAGE 1 — Sales & Marketing: log a new inflow / lead
     ════════════════════════════════════════════════════════════════════════ */
  window.pflwNewInflow = function(){
    var body='<div class="form-grid">'
      +'<div class="form-group full"><label>Prospect / Patient name <span class="req">*</span></label><input id="pf_name" placeholder="Walk-in name or campaign prospect"></div>'
      +'<div class="form-group"><label>Inflow source <span class="req">*</span></label><select id="pf_src">'
        +['Walk-in','Referral','Campaign','Online','Agent','Telemedicine','Corporate / Partner','Emergency'].map(function(x){return '<option>'+x+'</option>';}).join('')
      +'</select></div>'
      +'<div class="form-group"><label>Referring agent (optional)</label><select id="pf_agent">'+agentOpts()+'</select></div>'
      +'<div class="form-group full"><label>Purpose of visit / interest</label><input id="pf_purpose" placeholder="e.g. Health screening, antenatal, consultation"></div>'
      +'<div class="form-group full"><label>Link to existing patient (optional)</label><select id="pf_pat"><option value="">— new / not yet registered —</option>'+patOpts()+'</select></div>'
      +'</div>'
      +'<div style="font-size:11px;color:var(--txt3);margin-top:6px"><i class="fa-solid fa-circle-info"></i> Business Development logs the inflow. Front Desk then converts it to a registration.</div>';
    showModal('<i class="fa-solid fa-bullhorn" style="color:#8b5cf6;margin-right:8px"></i>Log Patient Inflow', body,
      '<button class="btn btn-pri" onclick="pflwSaveInflow()"><i class="fa-solid fa-plus"></i> Add to Pathway</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.pflwSaveInflow = function(){
    var name=(document.getElementById('pf_name')||{}).value||'';
    if(!name.trim()){ TOAST('Enter a name','err'); return; }
    var pid=parseInt((document.getElementById('pf_pat')||{}).value||'',10); if(isNaN(pid)) pid=null;
    var enc=newEncounter({
      patientId:pid,
      patientName:pid?PAT(pid):name.trim(),
      source:(document.getElementById('pf_src')||{}).value||'Walk-in',
      agentId:parseInt((document.getElementById('pf_agent')||{}).value||'',10)||null,
      purpose:(document.getElementById('pf_purpose')||{}).value||'',
      stage:'lead'
    });
    logStep(enc,'lead','Inflow logged','Source: '+enc.source+(enc.agentId?(' · Agent: '+EMP(enc.agentId)):''));
    var D=D_(); D.patientFlow=D.patientFlow||[]; D.patientFlow.unshift(enc);
    closeModal(); SAVE(); RERENDER(); TOAST('Inflow logged to pathway');
  };

  /* ════════════════════════════════════════════════════════════════════════
     STAGE 2 — Front Desk / Reception: register, capture biodata + bill, route
     ════════════════════════════════════════════════════════════════════════ */
  window.pflwRegister = function(id){
    var e=getEnc(id); if(!e) return;
    if(!canAct('reception') && actor().role!=='System Administrator'){ TOAST('Front Desk action','err'); }
    var isNew=!e.patientId;
    var body='<div style="background:#eff6ff;border-radius:10px;padding:10px 12px;margin-bottom:12px;font-size:12px;color:#1e40af"><i class="fa-solid fa-clipboard-user"></i> Capture biodata & visit purpose, take any registration/consultation payment, then route the patient.</div>'
      +'<div class="form-grid">';
    if(isNew){
      body+='<div class="form-group"><label>First name <span class="req">*</span></label><input id="pf_fn" value="'+esc((e.patientName||'').split(' ')[0]||'')+'"></div>'
        +'<div class="form-group"><label>Last name</label><input id="pf_ln" value="'+esc((e.patientName||'').split(' ').slice(1).join(' ')||'')+'"></div>'
        +'<div class="form-group"><label>Gender</label><select id="pf_gender"><option>Female</option><option>Male</option></select></div>'
        +'<div class="form-group"><label>Phone</label><input id="pf_phone" placeholder="+234..."></div>'
        +'<div class="form-group"><label>Age</label><input id="pf_age" type="number" placeholder="Years"></div>'
        +'<div class="form-group"><label>Payment type</label><select id="pf_pay"><option>Self-Pay</option><option>NHIS</option><option>HMO / Insurance</option><option>Corporate / Partner</option></select></div>';
    } else {
      var p=(D_().patients||[]).find(function(x){return x.id===e.patientId;})||{};
      body+='<div class="form-group full"><label>Patient</label><input value="'+esc(p.fullName||'')+' · '+esc(p.mrn||'')+'" readonly style="background:#f8fafc"></div>'
        +'<div class="form-group"><label>Payment type</label><select id="pf_pay"><option'+(/NHIS/.test(p.insurance||'')?' selected':'')+'>NHIS</option><option'+(/HMO|Hygeia|AXA|Leadway|Reliance/.test(p.insurance||'')?' selected':'')+'>HMO / Insurance</option><option'+(/Self/.test(p.insurance||'')?' selected':'')+'>Self-Pay</option><option>Corporate / Partner</option></select></div>';
    }
    body+='<div class="form-group full"><label>Visit purpose <span class="req">*</span></label><input id="pf_vp" value="'+esc(e.purpose)+'" placeholder="Reason for visit"></div>'
      +'<div class="form-group"><label>Registration / consult fee (₦)</label><input id="pf_fee" type="number" value="5000"></div>'
      +'<div class="form-group"><label>Route patient to <span class="req">*</span></label><select id="pf_route"><option value="nurse">Nurse Station (triage)</option><option value="lab">Laboratory</option><option value="radiology">Radiology</option></select></div>'
      +'</div>';
    showModal('<i class="fa-solid fa-clipboard-user" style="color:#3b82f6;margin-right:8px"></i>Reception — Register & Route', body,
      '<button class="btn btn-pri" onclick="pflwSaveRegister('+e.id+')"><i class="fa-solid fa-arrow-right"></i> Register & Route</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.pflwSaveRegister = function(id){
    var e=getEnc(id); if(!e) return; var D=D_();
    var vp=(document.getElementById('pf_vp')||{}).value||''; if(!vp.trim()){ TOAST('Enter visit purpose','err'); return; }
    e.purpose=vp;
    // create a patient record if this was an unregistered lead
    if(!e.patientId){
      var fn=(document.getElementById('pf_fn')||{}).value||e.patientName||'New';
      var ln=(document.getElementById('pf_ln')||{}).value||'';
      var age=parseInt((document.getElementById('pf_age')||{}).value||'0',10)||0;
      var seq=(D.patients||[]).length+1;
      var np={ id:NID(), mrn:'MRN-'+new Date().getFullYear()+'-'+String(1000+seq).slice(-4),
        firstName:fn, lastName:ln, fullName:(fn+' '+ln).trim(), gender:(document.getElementById('pf_gender')||{}).value||'Female',
        age:age, dob:'', phone:(document.getElementById('pf_phone')||{}).value||'', bloodGroup:'', genotype:'',
        status:'Outpatient', deptId:null, doctorId:null, room:null,
        insurance:(document.getElementById('pf_pay')||{}).value||'Self-Pay', insuranceNo:'',
        allergies:'None', conditions:vp, address:'', email:'', nationality:'Nigerian',
        partyType:'Patient', referralSource:e.source, registrationDate:TODAY() };
      D.patients=D.patients||[]; D.patients.push(np);
      e.patientId=np.id; e.patientName=np.fullName;
    }
    var route=(document.getElementById('pf_route')||{}).value||'nurse';
    e.route=route;
    var fee=parseFloat((document.getElementById('pf_fee')||{}).value||'0')||0;
    // record a registration/consult payment transaction + emit bill event
    if(fee>0){
      D.transactions=D.transactions||[];
      D.transactions.push({ id:NID(), code:'TXN-'+UID(), type:'Payment', method:'Cash', patientId:e.patientId,
        amount:fee, status:'Completed', date:TODAY(), cashier:actor().name, notes:'Registration / consultation fee',
        billCode:null, reference:'RCP-'+UID(), category:'Outpatient' });
      emit('payment.received',{id:e.code,patientId:e.patientId,amount:fee,date:TODAY(),method:'Cash'});
    }
    // routing: nurse keeps the pathway flowing; lab/radiology still pass via nurse afterward but we honour direct routing
    if(route==='nurse'){ e.stage='nurse'; }
    else { e.stage='nurse'; e.directRoute=route; } // lab/radiology direct: still triage, flag preference
    logStep(e,'reception','Registered & routed','Routed to '+(route==='nurse'?'Nurse Station':route.charAt(0).toUpperCase()+route.slice(1))+(fee>0?(' · ₦'+fee.toLocaleString()+' collected'):''));
    emit('patient.registered',{patientId:e.patientId,code:e.code,route:route});
    closeModal(); SAVE(); RERENDER(); TOAST('Registered & routed to '+(route==='nurse'?'Nurse Station':route));
  };

  /* ════════════════════════════════════════════════════════════════════════
     STAGE 3 — Nurse Station: triage / vitals, route to Doctor or Wellness
     ════════════════════════════════════════════════════════════════════════ */
  window.pflwTriage = function(id){
    var e=getEnc(id); if(!e) return;
    var v=e.vitals||{};
    var body='<div style="background:#ecfeff;border-radius:10px;padding:10px 12px;margin-bottom:12px;font-size:12px;color:#0369a1"><i class="fa-solid fa-user-nurse"></i> Initial clinical assessment / triage for <b>'+esc(e.patientName)+'</b>. Record vitals & chief complaint, then route.</div>'
      +'<div class="form-grid">'
      +'<div class="form-group"><label>Blood pressure</label><input id="pf_bp" value="'+esc(v.bp||'')+'" placeholder="120/80"></div>'
      +'<div class="form-group"><label>Heart rate (bpm)</label><input id="pf_hr" type="number" value="'+esc(v.hr||'')+'"></div>'
      +'<div class="form-group"><label>Temperature (°C)</label><input id="pf_temp" type="number" step="0.1" value="'+esc(v.temp||'')+'"></div>'
      +'<div class="form-group"><label>SpO₂ (%)</label><input id="pf_spo2" type="number" value="'+esc(v.spo2||'')+'"></div>'
      +'<div class="form-group"><label>Weight (kg)</label><input id="pf_wt" type="number" value="'+esc(v.weight||'')+'"></div>'
      +'<div class="form-group"><label>Triage acuity</label><select id="pf_acuity"><option>Routine</option><option>Urgent</option><option>Emergency</option></select></div>'
      +'<div class="form-group full"><label>Chief complaint <span class="req">*</span></label><textarea id="pf_cc" rows="2">'+esc(v.complaint||e.purpose||'')+'</textarea></div>'
      +'<div class="form-group full"><label>Route to <span class="req">*</span></label><select id="pf_nroute"><option value="doctor">Doctor / Consultation</option><option value="wellness">Wellness &amp; Dietetics (preventive / non-clinical)</option></select></div>'
      +'<div class="form-group full" id="pf_docwrap"><label>Assign doctor</label><select id="pf_doc">'+docOpts(e.doctorId)+'</select></div>'
      +'</div>';
    showModal('<i class="fa-solid fa-user-nurse" style="color:#0ea5e9;margin-right:8px"></i>Nurse Station — Triage', body,
      '<button class="btn btn-pri" onclick="pflwSaveTriage('+e.id+')"><i class="fa-solid fa-arrow-right"></i> Save & Route</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.pflwSaveTriage = function(id){
    var e=getEnc(id); if(!e) return; var D=D_();
    var cc=(document.getElementById('pf_cc')||{}).value||''; if(!cc.trim()){ TOAST('Enter chief complaint','err'); return; }
    e.vitals={ bp:(document.getElementById('pf_bp')||{}).value||'', hr:(document.getElementById('pf_hr')||{}).value||'',
      temp:(document.getElementById('pf_temp')||{}).value||'', spo2:(document.getElementById('pf_spo2')||{}).value||'',
      weight:(document.getElementById('pf_wt')||{}).value||'', complaint:cc, acuity:(document.getElementById('pf_acuity')||{}).value||'Routine' };
    var nroute=(document.getElementById('pf_nroute')||{}).value||'doctor';
    if(nroute==='wellness'){
      e.stage='support'; e.wellnessOnly=true;
      logStep(e,'nurse','Triage recorded · routed to Wellness','Acuity '+e.vitals.acuity+' · '+cc);
      TOAST('Routed to Wellness & Dietetics');
    } else {
      e.doctorId=parseInt((document.getElementById('pf_doc')||{}).value||'',10)||e.doctorId;
      e.stage='doctor'; e.routedToDoctor=true;
      logStep(e,'nurse','Triage recorded · routed to Doctor','Acuity '+e.vitals.acuity+' · '+cc);
      TOAST('Routed to Doctor');
    }
    emit('triage.recorded',{patientId:e.patientId,code:e.code,acuity:e.vitals.acuity});
    closeModal(); SAVE(); RERENDER();
  };
  // simple alias used by the nurse-column card button
  window.pflwToDoctor = function(id){ window.pflwTriage(id); };

  /* ════════════════════════════════════════════════════════════════════════
     STAGE 4 — Doctor / Consultation: diagnose, order Lab/Rad/Pharmacy, refer
     ════════════════════════════════════════════════════════════════════════ */
  window.pflwConsult = function(id){
    var e=getEnc(id); if(!e) return;
    var v=e.vitals||{};
    var vitalsLine=v.bp?('BP '+esc(v.bp)+' · HR '+esc(v.hr||'—')+' · Temp '+esc(v.temp||'—')+'°C · SpO₂ '+esc(v.spo2||'—')+'%'):'No vitals on file';
    var body='<div style="background:#f0fdfa;border-radius:10px;padding:10px 12px;margin-bottom:12px;font-size:12px;color:#0f766e"><i class="fa-solid fa-user-doctor"></i> <b>'+esc(e.patientName)+'</b> · '+esc(e.vitals?(e.vitals.complaint||e.purpose):e.purpose)+'<br><span style="font-size:11px;opacity:.85">'+vitalsLine+'</span></div>'
      +'<div class="form-grid">'
      +'<div class="form-group"><label>Attending doctor</label><select id="pf_cdoc">'+docOpts(e.doctorId)+'</select></div>'
      +'<div class="form-group"><label>Disposition after orders</label><select id="pf_disp"><option value="support">Send to Support (await results)</option><option value="review">Straight to review</option><option value="discharged">Discharge now</option></select></div>'
      +'<div class="form-group full"><label>Diagnosis <span class="req">*</span></label><input id="pf_dx" value="'+esc(e.diagnosis)+'" placeholder="Clinical diagnosis"></div>'
      +'<div class="form-group full"><label>Treatment plan</label><textarea id="pf_plan" rows="2">'+esc(e.plan)+'</textarea></div>'
      +'</div>'
      +'<div style="margin-top:14px;border-top:1px solid var(--bdr);padding-top:12px"><div style="font-weight:800;font-size:13px;color:var(--dark);margin-bottom:8px"><i class="fa-solid fa-clipboard-list" style="color:var(--pri)"></i> Orders</div>'
      +'<div class="form-grid">'
      +'<div class="form-group"><label><input type="checkbox" id="pf_olab"> Laboratory test</label><input id="pf_labname" placeholder="e.g. Complete Blood Count" style="margin-top:4px"></div>'
      +'<div class="form-group"><label><input type="checkbox" id="pf_orad"> Radiology</label><input id="pf_radname" placeholder="e.g. Chest X-Ray" style="margin-top:4px"></div>'
      +'<div class="form-group"><label><input type="checkbox" id="pf_orx"> Pharmacy / prescription</label><input id="pf_rxname" placeholder="e.g. Amoxicillin 500mg" style="margin-top:4px"></div>'
      +'<div class="form-group"><label>Referral</label><select id="pf_ref"><option value="">— none —</option><option value="nurse">Back to Nurse (monitoring)</option><option value="frontdesk">Front Desk (admin / discharge)</option><option value="wellness">Wellness &amp; Dietetics</option></select></div>'
      +'</div></div>';
    showModal('<i class="fa-solid fa-user-doctor" style="color:#0d9488;margin-right:8px"></i>Doctor — Consultation', body,
      '<button class="btn btn-pri" onclick="pflwSaveConsult('+e.id+')"><i class="fa-solid fa-check"></i> Save Consultation</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
  };
  window.pflwSaveConsult = function(id){
    var e=getEnc(id); if(!e) return; var D=D_();
    var dx=(document.getElementById('pf_dx')||{}).value||''; if(!dx.trim()){ TOAST('Enter diagnosis','err'); return; }
    e.diagnosis=dx; e.plan=(document.getElementById('pf_plan')||{}).value||'';
    e.doctorId=parseInt((document.getElementById('pf_cdoc')||{}).value||'',10)||e.doctorId;
    var v=e.vitals||{};
    var orderNotes=[];

    // create a medical record (EMR) for this consultation
    D.medicalRecords=D.medicalRecords||[];
    var emr={ id:NID(), code:'EMR-'+UID(), patientId:e.patientId, doctorId:e.doctorId, deptId:(D.patients.find(function(p){return p.id===e.patientId;})||{}).deptId||null,
      visitDate:TODAY(), visitType:'Outpatient', complaint:(v.complaint||e.purpose||''), diagnosis:dx, treatment:e.plan, notes:'Via Patient Flow '+e.code,
      bpSys:parseInt((v.bp||'').split('/')[0],10)||null, bpDia:parseInt((v.bp||'').split('/')[1],10)||null, hr:parseInt(v.hr,10)||null, temp:parseFloat(v.temp)||null, spo2:parseInt(v.spo2,10)||null, status:'Open' };
    D.medicalRecords.push(emr); e.emrId=emr.id;

    // Lab order
    if((document.getElementById('pf_olab')||{}).checked){
      var lname=(document.getElementById('pf_labname')||{}).value||'Laboratory Test';
      D.labTests=D.labTests||[];
      var lid=NID(), lfee=4500;
      D.labTests.push({ id:lid, code:'LAB-'+UID(), patientId:e.patientId, orderedBy:e.doctorId, testType:lname, category:'General',
        orderDate:TODAY(), priority:(v.acuity==='Emergency'?'Stat':'Normal'), status:'Processing', results:null, isAbnormal:false });
      e.orders.lab.push(lid);
      emit('lab.order',{id:lid,patientId:e.patientId,amount:lfee,date:TODAY()});
      orderNotes.push('Lab: '+lname);
    }
    // Radiology order
    if((document.getElementById('pf_orad')||{}).checked){
      var rname=(document.getElementById('pf_radname')||{}).value||'Imaging Study';
      D.radiologyOrders=D.radiologyOrders||[];
      var rid=NID(), rfee=12000;
      D.radiologyOrders.push({ id:rid, code:'RAD-'+UID(), patientId:e.patientId, orderedBy:e.doctorId, modality:'X-Ray', bodyPart:'—', examType:rname,
        urgency:(v.acuity==='Emergency'?'Stat':'Routine'), clinicalHistory:dx, status:'Scheduled', orderDate:TODAY(), scheduledDate:TODAY(), scheduledTime:'',
        completedDate:'', reportedBy:null, report:'', impression:'', critical:false, images:0, verified:false, verifiedBy:null, verifiedDate:'' });
      e.orders.rad.push(rid);
      emit('radiology.study',{id:rid,patientId:e.patientId,amount:rfee,date:TODAY()});
      orderNotes.push('Radiology: '+rname);
    }
    // Prescription
    if((document.getElementById('pf_orx')||{}).checked){
      var rxname=(document.getElementById('pf_rxname')||{}).value||'Medication';
      D.prescriptions=D.prescriptions||[];
      var rxid=NID();
      D.prescriptions.push({ id:rxid, code:'RX-'+UID(), patientId:e.patientId, doctorId:e.doctorId, date:TODAY(), status:'Active', notes:'Via Patient Flow '+e.code,
        items:[{name:rxname, dosage:'', frequency:'', route:'Oral', duration:'', qty:1}] });
      e.orders.rx.push(rxid);
      orderNotes.push('Pharmacy: '+rxname);
    }
    // Referral
    var ref=(document.getElementById('pf_ref')||{}).value||'';
    if(ref){ e.referrals.push({to:ref,at:NOWISO()}); orderNotes.push('Referral → '+ref); }

    logStep(e,'doctor','Consultation — '+dx, orderNotes.join(' · ')||'No orders');

    var disp=(document.getElementById('pf_disp')||{}).value||'support';
    var hasOrders=(e.orders.lab.length+e.orders.rad.length)>0;
    if(disp==='discharged'){ pflwFinishDischarge(e,'Discharged at consultation'); }
    else if(disp==='review' || (disp==='support' && !hasOrders)){ e.stage='review'; logStep(e,'doctor','Sent for review',''); TOAST('Moved to review'); }
    else { e.stage='support'; TOAST('Sent to support departments'); }

    closeModal(); SAVE(); RERENDER();
  };

  /* ════════════════════════════════════════════════════════════════════════
     STAGE 5 — Support Departments: process orders, upload results → feedback
     ════════════════════════════════════════════════════════════════════════ */
  window.pflwSupport = function(id){
    var e=getEnc(id); if(!e) return; var D=D_();
    var rows='';
    if(e.wellnessOnly){
      rows='<div style="background:#f0fdf4;border-radius:10px;padding:12px;color:#166534;font-size:12px"><i class="fa-solid fa-leaf"></i> <b>Wellness &amp; Dietetics</b> — counseling & lifestyle support for '+esc(e.patientName)+'.</div>'
        +'<div class="form-group full" style="margin-top:10px"><label>Counseling / care notes</label><textarea id="pf_wnote" rows="3" placeholder="Dietary plan, lifestyle guidance, follow-up..."></textarea></div>';
    } else {
      e.orders.lab.forEach(function(lid){ var t=(D.labTests||[]).find(function(x){return x.id===lid;}); if(t) rows+=supRow('Lab', t.code, t.testType, t.status, 'lab', lid); });
      e.orders.rad.forEach(function(rid){ var r=(D.radiologyOrders||[]).find(function(x){return x.id===rid;}); if(r) rows+=supRow('Radiology', r.code, r.examType, r.status, 'rad', rid); });
      e.orders.rx.forEach(function(xid){ var x=(D.prescriptions||[]).find(function(p){return p.id===xid;}); if(x) rows+=supRow('Pharmacy', x.code, (x.items[0]||{}).name||'Medication', x.status==='Dispensed'?'Completed':'Active', 'rx', xid); });
      if(!rows) rows='<div style="color:var(--txt3);font-size:12px;padding:8px">No outstanding orders.</div>';
      rows='<div style="font-size:12px;color:var(--txt2);margin-bottom:8px">Orders for <b>'+esc(e.patientName)+'</b>. Enter results, then send back to the doctor.</div>'
        +'<div style="display:flex;flex-direction:column;gap:8px">'+rows+'</div>';
    }
    showModal('<i class="fa-solid fa-flask-vial" style="color:#f59e0b;margin-right:8px"></i>Support Departments', rows,
      (e.wellnessOnly
        ? '<button class="btn btn-pri" onclick="pflwWellnessDone('+e.id+')"><i class="fa-solid fa-check"></i> Counseling Complete</button>'
        : '<button class="btn btn-pri" onclick="pflwResultsReady('+e.id+')"><i class="fa-solid fa-paper-plane"></i> Send Results to Doctor</button>')
      +'<button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide');
  };
  function supRow(kind,code,name,status,t,oid){
    var done=/Completed|Dispensed/i.test(status);
    return '<div style="border:1px solid var(--bdr);border-radius:10px;padding:10px;display:flex;gap:8px;align-items:center;flex-wrap:wrap">'
      +'<span style="font-size:9px;font-weight:800;text-transform:uppercase;background:#fffbeb;color:#b45309;border-radius:99px;padding:2px 8px">'+kind+'</span>'
      +'<span style="font-weight:700;font-size:12px">'+esc(name)+'</span><span style="font-size:10px;color:var(--txt3)">'+esc(code)+'</span>'
      +'<span class="st '+(done?'st-completed':'st-processing')+'" style="margin-left:auto">'+esc(status)+'</span>'
      +(t!=='rx'
        ? '<input id="pf_res_'+t+'_'+oid+'" placeholder="Enter result / impression" style="flex:1 1 100%;margin-top:6px;padding:6px 10px;border:1px solid var(--bdr);border-radius:8px;font-size:12px">'
        : '<button class="btn btn-xs btn-pri" style="flex:0" onclick="pflwDispense('+oid+')">Dispense</button>')
      +'</div>';
  }
  window.pflwDispense = function(rxid){
    var x=(D_().prescriptions||[]).find(function(p){return p.id===rxid;}); if(!x) return;
    x.status='Dispensed';
    emit('pharmacy.dispense',{id:x.code,drugId:null,qty:1,amount:1500,date:TODAY()});
    SAVE(); TOAST('Dispensed'); 
    // refresh the modal in place
    var enc=(D_().patientFlow||[]).find(function(e){return (e.orders.rx||[]).indexOf(rxid)>-1;});
    if(enc){ closeModal(); window.pflwSupport(enc.id); }
  };
  window.pflwResultsReady = function(id){
    var e=getEnc(id); if(!e) return; var D=D_();
    var done=[];
    e.orders.lab.forEach(function(lid){ var t=(D.labTests||[]).find(function(x){return x.id===lid;}); if(t){ var el=document.getElementById('pf_res_lab_'+lid); var val=el?el.value:''; if(val){ t.results=val; t.isAbnormal=/high|low|abnormal|positive|crit/i.test(val); } t.status='Completed'; done.push('Lab '+t.testType); emit('record.finalized',{id:t.id,code:t.code,patientId:e.patientId,date:TODAY()}); } });
    e.orders.rad.forEach(function(rid){ var r=(D.radiologyOrders||[]).find(function(x){return x.id===rid;}); if(r){ var el=document.getElementById('pf_res_rad_'+rid); var val=el?el.value:''; if(val){ r.report=val; r.impression=val; } r.status='Completed'; r.completedDate=TODAY(); r.verified=true; r.reportedBy=e.doctorId; done.push('Radiology '+r.examType); } });
    e.stage='review';
    logStep(e,'support','Results uploaded', done.join(' · ')||'Results ready');
    closeModal(); SAVE(); RERENDER(); TOAST('Results sent to doctor for review');
  };
  window.pflwWellnessDone = function(id){
    var e=getEnc(id); if(!e) return;
    var note=(document.getElementById('pf_wnote')||{}).value||'Counseling completed';
    pflwFinishDischarge(e,'Wellness & Dietetics: '+note);
    closeModal(); SAVE(); RERENDER(); TOAST('Wellness pathway completed');
  };

  /* ════════════════════════════════════════════════════════════════════════
     STAGE 6 — Feedback Loop: doctor reviews results → continue or discharge
     ════════════════════════════════════════════════════════════════════════ */
  window.pflwReview = function(id){
    var e=getEnc(id); if(!e) return; var D=D_();
    var res='';
    e.orders.lab.forEach(function(lid){ var t=(D.labTests||[]).find(function(x){return x.id===lid;}); if(t) res+=resRow('Lab', t.testType, t.results||'(pending)', t.isAbnormal); });
    e.orders.rad.forEach(function(rid){ var r=(D.radiologyOrders||[]).find(function(x){return x.id===rid;}); if(r) res+=resRow('Radiology', r.examType, r.impression||r.report||'(pending)', r.critical); });
    if(!res) res='<div style="color:var(--txt3);font-size:12px">No diagnostic results on file.</div>';
    var body='<div style="background:#eef2ff;border-radius:10px;padding:10px 12px;margin-bottom:12px;font-size:12px;color:#4338ca"><i class="fa-solid fa-clipboard-check"></i> Feedback loop — review returned results for <b>'+esc(e.patientName)+'</b> (Dx: '+esc(e.diagnosis||'—')+').</div>'
      +'<div style="display:flex;flex-direction:column;gap:8px;margin-bottom:12px">'+res+'</div>'
      +'<div class="form-group full"><label>Review note / updated plan</label><textarea id="pf_rev" rows="2" placeholder="Continue treatment, add orders, or proceed to discharge..."></textarea></div>';
    showModal('<i class="fa-solid fa-clipboard-check" style="color:#6366f1;margin-right:8px"></i>Doctor Review — Feedback Loop', body,
      '<button class="btn btn-pri" onclick="pflwContinue('+e.id+')"><i class="fa-solid fa-rotate-left"></i> Continue Treatment</button>'
      +'<button class="btn" style="background:#22c55e;color:#fff" onclick="pflwDischarge('+e.id+')"><i class="fa-solid fa-circle-check"></i> Discharge Patient</button>'
      +'<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
  };
  function resRow(kind,name,val,flag){
    return '<div style="border:1px solid var(--bdr);border-radius:10px;padding:10px;border-left:3px solid '+(flag?'#ef4444':'#22c55e')+'">'
      +'<div style="display:flex;justify-content:space-between"><b style="font-size:12px">'+esc(name)+'</b><span style="font-size:9px;font-weight:800;color:'+(flag?'#991b1b':'#065f46')+'">'+(flag?'ABNORMAL':'NORMAL')+'</span></div>'
      +'<div style="font-size:12px;color:var(--txt2);margin-top:3px">'+esc(val)+'</div></div>';
  }
  window.pflwContinue = function(id){
    var e=getEnc(id); if(!e) return;
    var note=(document.getElementById('pf_rev')||{}).value||'Continue treatment';
    e.stage='doctor';
    logStep(e,'review','Reviewed — continue treatment', note);
    closeModal(); SAVE(); RERENDER(); TOAST('Returned to doctor to continue treatment');
  };
  window.pflwDischarge = function(id){
    var e=getEnc(id); if(!e) return;
    var note=(document.getElementById('pf_rev')||{}).value||'';
    pflwFinishDischarge(e,'Reviewed & discharged'+(note?(' — '+note):''));
    closeModal(); SAVE(); RERENDER(); TOAST('Patient discharged — pathway complete');
  };
  function pflwFinishDischarge(e,note){
    e.stage='discharged'; e.status='Discharged'; e.dischargedAt=NOWISO();
    logStep(e,'discharged','Discharged', note||'');
    // finalize EMR + reflect on patient record
    try{
      var D=D_();
      if(e.emrId){ var r=(D.medicalRecords||[]).find(function(x){return x.id===e.emrId;}); if(r) r.status='Finalized'; }
      var p=(D.patients||[]).find(function(x){return x.id===e.patientId;});
      if(p && p.status!=='Admitted'){ /* outpatient flow: leave status; could set Discharged */ }
      emit('record.finalized',{id:e.emrId||e.code,code:e.code,patientId:e.patientId,date:TODAY()});
    }catch(_){}
  }

  /* ════════════════════════════════════════════════════════════════════════
     Pathway timeline viewer
     ════════════════════════════════════════════════════════════════════════ */
  window.pflwView = function(id){
    var e=getEnc(id); if(!e) return;
    var tl=(e.timeline||[]).map(function(t){
      var s=stageOf(t.stage);
      return '<div style="display:flex;gap:10px">'
        +'<div style="display:flex;flex-direction:column;align-items:center"><div style="width:26px;height:26px;border-radius:8px;background:'+s.color+';color:#fff;display:flex;align-items:center;justify-content:center;font-size:11px"><i class="fa-solid '+s.icon+'"></i></div><div style="flex:1;width:2px;background:var(--bdr)"></div></div>'
        +'<div style="padding-bottom:14px;flex:1"><div style="font-weight:700;font-size:13px;color:var(--dark)">'+esc(t.label)+'</div>'
        +'<div style="font-size:11px;color:var(--txt3)">'+esc(t.by)+' · '+esc(t.role)+' · '+esc((t.at||'').replace('T',' ').slice(0,16))+'</div>'
        +(t.note?'<div style="font-size:11px;color:var(--txt2);margin-top:2px">'+esc(t.note)+'</div>':'')+'</div></div>';
    }).join('');
    var cur=stageOf(e.stage);
    var body='<div style="background:'+cur.bg+';border-radius:10px;padding:12px;margin-bottom:14px">'
      +'<div style="font-weight:800;font-size:15px">'+esc(e.patientName)+'</div>'
      +'<div style="font-size:11px;color:var(--txt3)">'+esc(e.code)+(e.patientId?(' · '+esc((D_().patients.find(function(p){return p.id===e.patientId;})||{}).mrn||'')):'')+' · Source: '+esc(e.source)+'</div>'
      +'<div style="margin-top:6px"><span class="st" style="background:'+cur.color+';color:#fff">'+esc(cur.label)+'</span>'
      +(e.diagnosis?(' <span style="font-size:11px;color:var(--txt2)">Dx: '+esc(e.diagnosis)+'</span>'):'')+'</div></div>'
      +'<div style="font-weight:800;font-size:12px;color:var(--txt2);text-transform:uppercase;letter-spacing:.5px;margin-bottom:10px">Pathway Timeline</div>'
      +(tl||'<div style="color:var(--txt3)">No events yet.</div>');
    showModal('<i class="fa-solid fa-timeline" style="color:var(--pri);margin-right:8px"></i>Patient Pathway', body,
      '<button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide');
  };

  /* ════════════════════════════════════════════════════════════════════════
     WIRING — renderModule / getModTitle / buildNav  (additive wrappers)
     ════════════════════════════════════════════════════════════════════════ */
  function wrap(){
    if(wrap._done) return;
    if(typeof window.renderModule==='function'){
      var oRM=window.renderModule;
      window.renderModule=function(){
        if(window.currentMod==='patientflow') return window.renderPatientFlow();
        return oRM.apply(this,arguments);
      };
    }
    if(typeof window.getModTitle==='function'){
      var oT=window.getModTitle;
      window.getModTitle=function(){
        if(window.currentMod==='patientflow') return 'Patient Flow — Care Pathway';
        return oT.apply(this,arguments);
      };
    }
    if(typeof window.buildNav==='function'){
      var oN=window.buildNav;
      window.buildNav=function(){
        var out=oN.apply(this,arguments);
        try{
          var flow=(D_().patientFlow||[]).filter(function(e){return e.status==='Active';});
          var active=(window.currentMod==='patientflow')?'active':'';
          var btn='<button class="sb-item '+active+'" onclick="goTo(\'patientflow\')">'
            +'<i class="fa-solid fa-diagram-project"></i><span>Patient Flow</span>'
            +'<span class="badge">'+(flow.length||'')+'</span></button>';
          // insert right after the Clinical section header so it groups under Clinical
          if(out.indexOf('<div class="sb-sec">Clinical</div>')!==-1){
            out=out.replace('<div class="sb-sec">Clinical</div>', '<div class="sb-sec">Clinical</div>'+btn);
          } else {
            out=btn+out;
          }
        }catch(e){}
        return out;
      };
    }
    wrap._done=true;
  }

  function boot(){
    try{ seed(); }catch(e){ console.warn('[PFLW] seed', e); }
    try{ wrap(); }catch(e){ console.warn('[PFLW] wrap', e); }
    try{ if(window.render && document.getElementById('app')) window.render(); }catch(e){}
  }
  boot();
  setTimeout(boot,800); setTimeout(boot,2500); setTimeout(boot,6000);
  if(document.readyState==='loading'){ window.addEventListener('DOMContentLoaded', boot); }
  try{ console.log('%c✅ v106 — Patient Flow (Care Pathway) loaded','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/084-end-v106.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v107 — LAB & RADIOLOGY ORDERS MANAGEMENT  (Edit · Approve · Generate Bill)
   Adds a full orders-management panel to BOTH the Laboratory and Radiology
   pages so every order can be EDITED, APPROVED/REJECTED (approver workflow),
   and BILLED (generate a receivable posted to the financial spine).
   Additive only. Wraps renderLab / renderRadiology; never rewrites them.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  "use strict";

  function D_(){ try{ if(typeof D!=='undefined' && D) return D; }catch(e){} return window.D||{}; }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} }
  function RERENDER(){ try{ if(typeof render==='function') render(); else if(window.render) window.render(); }catch(e){} }
  function TOAST(m,t){ try{ if(typeof toast==='function') toast(m,t||'ok'); }catch(e){} }
  function MODAL(t,b,f,s){ try{ showModal(t,b,f,s); }catch(e){} }
  function CLOSE(){ try{ closeModal(); }catch(e){} }
  function NID(){ try{ return (typeof nid==='function')?nid():(Date.now()+Math.floor(Math.random()*1000)); }catch(e){ return Date.now(); } }
  function UID(){ try{ return (typeof uid==='function')?uid():Math.random().toString(36).substr(2,6).toUpperCase(); }catch(e){ return Math.random().toString(36).substr(2,6).toUpperCase(); } }
  function TODAY(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
  function FMT(n){ try{ return (typeof F==='function')?F(n):('₦'+Number(n||0).toLocaleString()); }catch(e){ return '₦'+(n||0); } }
  function PAT(id){ try{ if(typeof pat==='function') return pat(id);}catch(e){} var p=(D_().patients||[]).find(function(x){return x.id===id;}); return p?(p.fullName||p.name||('Patient '+id)):'—'; }
  function DOC(id){ try{ if(typeof doc==='function') return doc(id);}catch(e){} var e2=(D_().employees||[]).find(function(x){return x.id===id;}); return e2?(e2.fullName||('#'+id)):'—'; }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function emit(evt,payload){ try{ if(window.SyncBus) SyncBus.emit(evt,payload); }catch(e){} }
  function AUD(t,m,a,d,r){ try{ if(typeof auditAction==='function') auditAction(t,m,a,d,r); }catch(e){} }
  function role(){ return (D_().currentUser&&D_().currentUser.role)||'System Administrator'; }
  function actorName(){ return (D_().currentUser&&D_().currentUser.fullName)||'System'; }

  /* ── Price lookup from the fee schedule ─────────────────────────────────── */
  function norm(s){ return String(s||'').toUpperCase().replace(/[^A-Z0-9]/g,''); }
  function feeMatch(kind, name){
    var fees=(D_().feeSchedule||[]);
    var dept=(kind==='lab')?'Laboratory':'Radiology';
    var cat =(kind==='lab')?'Lab':'Radiology';
    var pool=fees.filter(function(f){ return (f.department===dept)||(f.category===cat); });
    if(!pool.length) pool=fees;
    var n=norm(name);
    if(!n) return null;
    // exact-ish: fee name contains order name or vice-versa
    var hit=pool.find(function(f){ var fn=norm(f.service); return fn===n; })
      || pool.find(function(f){ var fn=norm(f.service); return fn && (fn.indexOf(n)>-1 || n.indexOf(fn)>-1); });
    return hit||null;
  }
  function priceFor(kind, o){
    if(o && o.price!=null && o.price!=='' && !isNaN(o.price)) return Number(o.price);
    var name=(kind==='lab')?(o.testType||''):(o.examType||o.modality||'');
    var f=feeMatch(kind, name);
    if(f) return Number(f.amount)||0;
    if(kind==='lab'){ return parseInt((D_().settings&&D_().settings.labFee))||5000; }
    var modPrices={'X-Ray':8000,'CT':45000,'MRI':75000,'Ultrasound':12000,'Fluoroscopy':18000,'Mammography':15000,'PET':120000};
    return modPrices[o.modality]||parseInt((D_().settings&&D_().settings.radiologyFee))||20000;
  }

  /* ── Approval helpers ───────────────────────────────────────────────────── */
  function appStatus(o){ return o.approvalStatus||'Pending'; }
  function canApprove(kind){
    var r=role();
    if(r==='System Administrator') return true;
    if(kind==='lab') return /Lab Scientist|Lab Tech|Patholog/i.test(r);
    return /Doctor|Radiolog/i.test(r);
  }
  function canBill(){
    var r=role();
    return /System Administrator|Finance|Front Desk|Cashier|Billing|Business Development/i.test(r);
  }
  function appBadge(o){
    var s=appStatus(o);
    var map={Pending:'st-pending',Approved:'st-active',Rejected:'st-cancelled'};
    var lbl={Pending:'Pending Approval',Approved:'Approved',Rejected:'Rejected'};
    var h='<span class="st '+(map[s]||'st-pending')+'">'+lbl[s]+'</span>';
    if(s!=='Pending' && o.approvedBy) h+='<div style="font-size:9px;color:var(--txt3);margin-top:2px">'+esc(o.approvedBy)+' · '+esc(o.approvedDate||'')+'</div>';
    return h;
  }
  function billBadge(o){
    if(o.billCode) return '<span class="st st-active" title="'+esc(o.billCode)+'"><i class="fa-solid fa-file-invoice-dollar"></i> '+esc(o.billCode)+'</span>';
    return '<span class="st st-draft">Unbilled</span>';
  }

  /* ════════════════════════════════════════════════════════════════════════
     PANEL RENDERERS  (appended under the existing Lab / Radiology pages)
     ════════════════════════════════════════════════════════════════════════ */
  function panel(kind){
    var D=D_();
    var orders=(kind==='lab')?(D.labTests||[]):(D.radiologyOrders||[]);
    var title=(kind==='lab')?'Laboratory':'Radiology';
    var icon=(kind==='lab')?'fa-flask':'fa-x-ray';
    var accent=(kind==='lab')?'#7c3aed':'#3b82f6';

    var pend=orders.filter(function(o){return appStatus(o)==='Pending';}).length;
    var appr=orders.filter(function(o){return appStatus(o)==='Approved';}).length;
    var billed=orders.filter(function(o){return o.billCode;}).length;
    var unbilledRev=orders.filter(function(o){return !o.billCode;}).reduce(function(s,o){return s+priceFor(kind,o);},0);

    var canA=canApprove(kind), canB=canBill();

    var h='<div class="card" style="margin-top:4px;border-top:3px solid '+accent+'">'
      +'<div class="card-hd"><h3><i class="fa-solid '+icon+'" style="color:'+accent+';margin-right:8px"></i>'+title+' Orders — Edit · Approve · Generate Bill</h3>'
      +'<div style="display:flex;gap:6px" class="no-print">'
      + (canB?'<button class="btn btn-sm" style="background:#16a34a;color:#fff" onclick="lroBillAll(\''+kind+'\')"><i class="fa-solid fa-file-invoice-dollar"></i> Bill All Approved</button>':'')
      + (canA?'<button class="btn btn-sm btn-ghost" onclick="lroApproveAll(\''+kind+'\')"><i class="fa-solid fa-check-double"></i> Approve All Pending</button>':'')
      +'</div></div>';

    // summary chips
    h+='<div style="display:flex;gap:10px;flex-wrap:wrap;margin-bottom:14px">'
      +chip('Total Orders', orders.length, '#0d9488')
      +chip('Pending Approval', pend, '#f59e0b')
      +chip('Approved', appr, '#22c55e')
      +chip('Billed', billed, '#3b82f6')
      +chip('Unbilled Revenue', FMT(unbilledRev), '#8b5cf6')
      +'</div>';

    if(!canA && !canB){
      h+='<div style="background:#fffbeb;border:1px solid #fde68a;border-radius:10px;padding:8px 12px;font-size:11px;color:#92400e;margin-bottom:10px"><i class="fa-solid fa-circle-info"></i> You are signed in as <b>'+esc(role())+'</b>. Editing is available to you; approval is reserved for '+(kind==='lab'?'Lab Scientist / Pathologist':'Radiologist / Doctor')+', and billing for Finance / Front Desk.</div>';
    }

    h+='<div class="tbl-wrap"><table class="tbl"><thead><tr>'
      +'<th>#</th><th>Code</th><th>Patient</th><th>'+(kind==='lab'?'Test':'Exam')+'</th>'
      +(kind==='lab'?'<th>Category</th>':'<th>Modality</th>')
      +'<th>Ordered By</th><th>Price (₦)</th><th>Status</th><th>Approval</th><th>Bill</th><th style="min-width:150px">Actions</th></tr></thead><tbody>';

    if(!orders.length){
      h+='<tr><td colspan="11" style="text-align:center;color:var(--txt3);padding:22px"><i class="fa-solid '+icon+'" style="margin-right:6px"></i>No '+title.toLowerCase()+' orders yet.</td></tr>';
    }
    orders.forEach(function(o,i){
      var nm=(kind==='lab')?o.testType:o.examType;
      var sub=(kind==='lab')?o.category:o.modality;
      var st=o.status||'—';
      var stClass=(typeof stc==='function')?stc(st):'st-scheduled';
      var price=priceFor(kind,o);
      var ap=appStatus(o);
      h+='<tr>'
        +'<td style="color:var(--txt3)">'+(i+1)+'</td>'
        +'<td><b>'+esc(o.code||'')+'</b></td>'
        +'<td>'+esc(PAT(o.patientId))+'</td>'
        +'<td class="bold">'+esc(nm||'—')+'</td>'
        +'<td>'+esc(sub||'—')+'</td>'
        +'<td>'+esc(DOC(o.orderedBy))+'</td>'
        +'<td style="font-weight:700;color:'+accent+'">'+FMT(price)+'</td>'
        +'<td><span class="st '+stClass+'">'+esc(st)+'</span></td>'
        +'<td>'+appBadge(o)+'</td>'
        +'<td>'+billBadge(o)+'</td>'
        +'<td><div class="act-row">'
          +'<button class="act-btn edit" title="Edit order" onclick="lroEdit(\''+kind+'\','+o.id+')"><i class="fa-solid fa-edit"></i></button>'
          +(ap!=='Approved'
              ? '<button class="act-btn" title="'+(canApprove(kind)?'Approve / Reject':'Approval reserved for approver role')+'" '+(canApprove(kind)?'':'disabled style="opacity:.4;cursor:not-allowed"')+' onclick="lroApproveModal(\''+kind+'\','+o.id+')"><i class="fa-solid fa-stamp" style="color:'+(canApprove(kind)?'#16a34a':'#94a3b8')+'"></i></button>'
              : '<button class="act-btn" title="Approved — click to revoke" '+(canApprove(kind)?'':'disabled style="opacity:.4"')+' onclick="lroApproveModal(\''+kind+'\','+o.id+')"><i class="fa-solid fa-circle-check" style="color:#16a34a"></i></button>')
          +(!o.billCode
              ? '<button class="act-btn" title="'+(canBill()?'Generate bill':'Billing reserved for Finance / Front Desk')+'" '+(canBill()?'':'disabled style="opacity:.4;cursor:not-allowed"')+' onclick="lroBill(\''+kind+'\','+o.id+')"><i class="fa-solid fa-file-invoice-dollar" style="color:'+(canBill()?'#2563eb':'#94a3b8')+'"></i></button>'
              : '<button class="act-btn print" title="View bill" onclick="lroViewBill(\''+kind+'\','+o.id+')"><i class="fa-solid fa-receipt"></i></button>')
        +'</div></td></tr>';
    });
    h+='</tbody></table></div></div>';
    return h;
  }
  function chip(label,val,color){
    return '<div style="padding:10px 16px;background:'+color+'12;border:1px solid '+color+'33;border-radius:10px;min-width:110px">'
      +'<div style="font-size:18px;font-weight:800;color:'+color+'">'+val+'</div>'
      +'<div style="font-size:10px;color:var(--txt2);font-weight:600">'+label+'</div></div>';
  }

  /* ════════════════════════════════════════════════════════════════════════
     EDIT
     ════════════════════════════════════════════════════════════════════════ */
  window.lroEdit = function(kind,id){
    var D=D_();
    var arr=(kind==='lab')?D.labTests:D.radiologyOrders;
    var o=(arr||[]).find(function(x){return x.id===id;}); if(!o) return;
    var pO=(D.patients||[]).map(function(p){return '<option value="'+p.id+'"'+(p.id===o.patientId?' selected':'')+'>'+esc(p.fullName)+' ['+esc(p.mrn||'')+']</option>';}).join('');
    var dO=(D.employees||[]).filter(function(e){return e.type==='Doctor';}).map(function(e){return '<option value="'+e.id+'"'+(e.id===o.orderedBy?' selected':'')+'>'+esc(e.fullName)+'</option>';}).join('');
    var price=priceFor(kind,o);
    var body;
    if(kind==='lab'){
      var catO=(D.cfgLists&&D.cfgLists.labCategories||['Hematology','Biochemistry','Microbiology']).map(function(c){return '<option'+(c===o.category?' selected':'')+'>'+esc(c)+'</option>';}).join('');
      var stO=['Ordered','Processing','Completed','Cancelled'].map(function(s){return '<option'+(s===o.status?' selected':'')+'>'+s+'</option>';}).join('');
      var prO=['Stat','Urgent','Normal'].map(function(s){return '<option'+(s===o.priority?' selected':'')+'>'+s+'</option>';}).join('');
      body='<div class="form-grid">'
        +'<div class="form-group"><label>Order Code</label><input value="'+esc(o.code)+'" readonly style="background:#f8fafc;font-weight:700"></div>'
        +'<div class="form-group"><label>Patient <span class="req">*</span></label><select id="lro_pat">'+pO+'</select></div>'
        +'<div class="form-group full"><label>Test Type <span class="req">*</span></label><input id="lro_name" value="'+esc(o.testType||'')+'"></div>'
        +'<div class="form-group"><label>Category</label><select id="lro_cat">'+catO+'</select></div>'
        +'<div class="form-group"><label>Ordered By</label><select id="lro_by">'+dO+'</select></div>'
        +'<div class="form-group"><label>Priority</label><select id="lro_pri">'+prO+'</select></div>'
        +'<div class="form-group"><label>Status</label><select id="lro_st">'+stO+'</select></div>'
        +'<div class="form-group"><label>Price (₦)</label><input id="lro_price" type="number" value="'+price+'"></div>'
        +'<div class="form-group"><label>Order Date</label><input id="lro_date" type="date" value="'+esc(o.orderDate||TODAY())+'"></div>'
        +'<div class="form-group full"><label>Result / Notes</label><textarea id="lro_res" rows="2">'+esc(o.results||'')+'</textarea></div>'
        +'</div>';
    } else {
      var modO=['X-Ray','CT','MRI','Ultrasound','Fluoroscopy','Mammography','PET'].map(function(s){return '<option'+(s===o.modality?' selected':'')+'>'+s+'</option>';}).join('');
      var urO=['Stat','Urgent','Routine'].map(function(s){return '<option'+(s===o.urgency?' selected':'')+'>'+s+'</option>';}).join('');
      var stO=['Scheduled','In Progress','Completed','Cancelled'].map(function(s){return '<option'+(s===o.status?' selected':'')+'>'+s+'</option>';}).join('');
      body='<div class="form-grid">'
        +'<div class="form-group"><label>Order Code</label><input value="'+esc(o.code)+'" readonly style="background:#f8fafc;font-weight:700"></div>'
        +'<div class="form-group"><label>Patient <span class="req">*</span></label><select id="lro_pat">'+pO+'</select></div>'
        +'<div class="form-group"><label>Modality</label><select id="lro_mod">'+modO+'</select></div>'
        +'<div class="form-group"><label>Body Part</label><input id="lro_body" value="'+esc(o.bodyPart||'')+'"></div>'
        +'<div class="form-group full"><label>Exam Type <span class="req">*</span></label><input id="lro_name" value="'+esc(o.examType||'')+'"></div>'
        +'<div class="form-group"><label>Ordered By</label><select id="lro_by">'+dO+'</select></div>'
        +'<div class="form-group"><label>Urgency</label><select id="lro_pri">'+urO+'</select></div>'
        +'<div class="form-group"><label>Status</label><select id="lro_st">'+stO+'</select></div>'
        +'<div class="form-group"><label>Price (₦)</label><input id="lro_price" type="number" value="'+price+'"></div>'
        +'<div class="form-group"><label>Order Date</label><input id="lro_date" type="date" value="'+esc(o.orderDate||TODAY())+'"></div>'
        +'<div class="form-group full"><label>Clinical History / Report</label><textarea id="lro_res" rows="2">'+esc(o.report||o.clinicalHistory||'')+'</textarea></div>'
        +'</div>';
    }
    MODAL('<i class="fa-solid fa-edit" style="color:var(--pri);margin-right:8px"></i>Edit '+(kind==='lab'?'Lab':'Radiology')+' Order — '+esc(o.code), body,
      '<button class="btn btn-pri" onclick="lroSaveEdit(\''+kind+'\','+id+')"><i class="fa-solid fa-save"></i> Save Changes</button>'
      +(o.billCode?'<span style="font-size:11px;color:var(--txt3);margin-left:8px"><i class="fa-solid fa-circle-info"></i> Editing the price won\'t change the existing bill '+esc(o.billCode)+'.</span>':'')
      +'<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.lroSaveEdit = function(kind,id){
    var D=D_(); var arr=(kind==='lab')?D.labTests:D.radiologyOrders;
    var o=(arr||[]).find(function(x){return x.id===id;}); if(!o) return;
    var g=function(x){var el=document.getElementById(x);return el?el.value:undefined;};
    o.patientId=parseInt(g('lro_pat'),10)||o.patientId;
    o.orderedBy=parseInt(g('lro_by'),10)||o.orderedBy;
    o.status=g('lro_st')||o.status;
    o.orderDate=g('lro_date')||o.orderDate;
    var pr=parseFloat(g('lro_price')); if(!isNaN(pr)) o.price=pr;
    if(kind==='lab'){
      o.testType=g('lro_name')||o.testType; o.category=g('lro_cat')||o.category; o.priority=g('lro_pri')||o.priority;
      var res=g('lro_res'); if(res!==undefined){ o.results=res; if(res) o.isAbnormal=/high|low|abnormal|positive|reactive|crit/i.test(res); }
    } else {
      o.examType=g('lro_name')||o.examType; o.modality=g('lro_mod')||o.modality; o.bodyPart=g('lro_body')||o.bodyPart; o.urgency=g('lro_pri')||o.urgency;
      var rep=g('lro_res'); if(rep!==undefined){ o.report=rep; o.impression=o.impression||rep; }
    }
    AUD('CLINICAL',(kind==='lab'?'Laboratory':'Radiology'),'EDIT','Edited order '+o.code,'Low');
    CLOSE(); SAVE(); RERENDER(); TOAST('Order '+o.code+' updated');
  };

  /* ════════════════════════════════════════════════════════════════════════
     APPROVE / REJECT  (approver workflow)
     ════════════════════════════════════════════════════════════════════════ */
  window.lroApproveModal = function(kind,id){
    if(!canApprove(kind)){ TOAST('Approval is reserved for the '+(kind==='lab'?'Lab Scientist / Pathologist':'Radiologist / Doctor')+' role','err'); return; }
    var D=D_(); var arr=(kind==='lab')?D.labTests:D.radiologyOrders;
    var o=(arr||[]).find(function(x){return x.id===id;}); if(!o) return;
    var nm=(kind==='lab')?o.testType:o.examType;
    var cur=appStatus(o);
    var body='<div style="background:#f0fdf4;border-radius:10px;padding:12px;margin-bottom:12px;font-size:13px">'
      +'<div><b>'+esc(o.code)+'</b> · '+esc(PAT(o.patientId))+'</div>'
      +'<div style="color:var(--txt2);margin-top:3px">'+esc(nm||'')+' · Price '+FMT(priceFor(kind,o))+'</div>'
      +'<div style="margin-top:6px">Current: '+appBadge(o)+'</div></div>'
      +'<div class="form-group full"><label>Approver note (optional)</label><textarea id="lro_anote" rows="2" placeholder="Clinical justification / remarks...">'+esc(o.approvalNote||'')+'</textarea></div>'
      +'<div style="font-size:11px;color:var(--txt3);margin-top:6px"><i class="fa-solid fa-user-shield"></i> Acting approver: <b>'+esc(actorName())+'</b> ('+esc(role())+')</div>';
    var ft='<button class="btn" style="background:#16a34a;color:#fff" onclick="lroDecide(\''+kind+'\','+id+',\'Approved\')"><i class="fa-solid fa-check"></i> Approve</button>'
      +'<button class="btn btn-dan" onclick="lroDecide(\''+kind+'\','+id+',\'Rejected\')"><i class="fa-solid fa-xmark"></i> Reject</button>'
      +(cur!=='Pending'?'<button class="btn btn-ghost" onclick="lroDecide(\''+kind+'\','+id+',\'Pending\')">Reset to Pending</button>':'')
      +'<button class="btn btn-ghost" onclick="closeModal()">Cancel</button>';
    MODAL('<i class="fa-solid fa-stamp" style="color:#16a34a;margin-right:8px"></i>Approve '+(kind==='lab'?'Lab':'Radiology')+' Order', body, ft);
  };
  window.lroDecide = function(kind,id,decision){
    var D=D_(); var arr=(kind==='lab')?D.labTests:D.radiologyOrders;
    var o=(arr||[]).find(function(x){return x.id===id;}); if(!o) return;
    o.approvalStatus=decision;
    o.approvalNote=(document.getElementById('lro_anote')||{}).value||o.approvalNote||'';
    if(decision==='Pending'){ o.approvedBy=null; o.approvedDate=null; }
    else { o.approvedBy=actorName(); o.approvedDate=TODAY(); }
    AUD('CLINICAL',(kind==='lab'?'Laboratory':'Radiology'),'APPROVE',decision+' order '+o.code+' by '+actorName(),'Medium');
    emit('order.approval',{kind:kind,code:o.code,patientId:o.patientId,decision:decision,by:actorName()});
    CLOSE(); SAVE(); RERENDER(); TOAST('Order '+o.code+' '+decision.toLowerCase());
  };
  window.lroApproveAll = function(kind){
    if(!canApprove(kind)){ TOAST('Approval reserved for approver role','err'); return; }
    var D=D_(); var arr=(kind==='lab')?D.labTests:D.radiologyOrders; var n=0;
    (arr||[]).forEach(function(o){ if(appStatus(o)==='Pending'){ o.approvalStatus='Approved'; o.approvedBy=actorName(); o.approvedDate=TODAY(); n++; } });
    AUD('CLINICAL',(kind==='lab'?'Laboratory':'Radiology'),'APPROVE','Bulk-approved '+n+' orders','Medium');
    SAVE(); RERENDER(); TOAST(n+' order(s) approved');
  };

  /* ════════════════════════════════════════════════════════════════════════
     GENERATE BILL  (receivable posted to financial spine)
     ════════════════════════════════════════════════════════════════════════ */
  function makeBill(kind,o){
    var D=D_();
    var price=priceFor(kind,o);
    var nm=(kind==='lab')?('Lab Test — '+(o.testType||'')+' ('+(o.category||'')+')')
                         :('Radiology — '+(o.modality||'')+' '+(o.examType||'')+' ('+(o.bodyPart||'')+')');
    var cat=(kind==='lab')?'Laboratory':'Radiology';
    var bill={ id:NID(), code:'BILL-'+(kind==='lab'?'L':'R')+UID(), patientId:o.patientId, date:o.orderDate||TODAY(),
      type:cat, items:[{s:nm, a:price, category:cat, sourceType:(kind==='lab'?'labTests':'radiologyOrders'), sourceId:o.id, sourceCode:o.code}],
      total:price, discount:0, tax:0, paid:0, balance:price, status:'Pending',
      notes:'Generated from '+cat+' order '+o.code+(o.approvedBy?(' · approved by '+o.approvedBy):''),
      source:(kind==='lab'?'lab':'radiology'), sourceId:o.id };
    D.bills=D.bills||[]; D.bills.push(bill);
    o.billId=bill.id; o.billCode=bill.code; o.price=price;
    emit('bill.created', bill);
    // also emit the order-revenue event the spine already understands
    emit((kind==='lab'?'lab.order':'radiology.study'),{id:o.id,patientId:o.patientId,amount:price,date:bill.date});
    AUD('FINANCE','Billing','CREATE','Bill '+bill.code+' from '+cat+' order '+o.code+' — '+FMT(price),'Medium');
    return bill;
  }
  window.lroBill = function(kind,id){
    if(!canBill()){ TOAST('Billing is reserved for Finance / Front Desk','err'); return; }
    var D=D_(); var arr=(kind==='lab')?D.labTests:D.radiologyOrders;
    var o=(arr||[]).find(function(x){return x.id===id;}); if(!o) return;
    if(o.billCode){ TOAST('Already billed: '+o.billCode); return; }
    if(appStatus(o)==='Rejected'){ TOAST('Cannot bill a rejected order','err'); return; }
    var price=priceFor(kind,o);
    var nm=(kind==='lab')?o.testType:o.examType;
    var warn=(appStatus(o)!=='Approved')?'<div style="background:#fffbeb;border:1px solid #fde68a;border-radius:8px;padding:8px 10px;font-size:11px;color:#92400e;margin-bottom:10px"><i class="fa-solid fa-triangle-exclamation"></i> This order is not yet approved. You can still bill it, but approval first is recommended.</div>':'';
    var body=warn+'<div class="form-grid">'
      +'<div class="form-group"><label>Patient</label><input value="'+esc(PAT(o.patientId))+'" readonly style="background:#f8fafc"></div>'
      +'<div class="form-group"><label>'+(kind==='lab'?'Test':'Exam')+'</label><input value="'+esc(nm||'')+'" readonly style="background:#f8fafc"></div>'
      +'<div class="form-group"><label>Amount (₦) <span class="req">*</span></label><input id="lro_bamt" type="number" value="'+price+'" style="font-weight:700;font-size:16px"></div>'
      +'<div class="form-group"><label>Bill Date</label><input id="lro_bdate" type="date" value="'+(o.orderDate||TODAY())+'"></div>'
      +'</div>'
      +'<div style="font-size:11px;color:var(--txt3);margin-top:8px"><i class="fa-solid fa-circle-info"></i> Posts a receivable to Billing &amp; the General Ledger ('+(kind==='lab'?'Lab revenue 4010':'Radiology revenue 4030')+').</div>';
    MODAL('<i class="fa-solid fa-file-invoice-dollar" style="color:#2563eb;margin-right:8px"></i>Generate Bill — '+esc(o.code), body,
      '<button class="btn btn-pri" onclick="lroConfirmBill(\''+kind+'\','+id+')"><i class="fa-solid fa-file-invoice-dollar"></i> Generate Bill</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.lroConfirmBill = function(kind,id){
    var D=D_(); var arr=(kind==='lab')?D.labTests:D.radiologyOrders;
    var o=(arr||[]).find(function(x){return x.id===id;}); if(!o) return;
    if(o.billCode){ CLOSE(); TOAST('Already billed'); return; }
    var amt=parseFloat((document.getElementById('lro_bamt')||{}).value); if(!isNaN(amt)) o.price=amt;
    var bdate=(document.getElementById('lro_bdate')||{}).value; if(bdate) o.orderDate=o.orderDate||bdate;
    var bill=makeBill(kind,o);
    if(bdate){ bill.date=bdate; }
    CLOSE(); SAVE(); RERENDER(); TOAST('Bill '+bill.code+' generated — '+FMT(bill.total)+' posted to Receivables');
  };
  window.lroBillAll = function(kind){
    if(!canBill()){ TOAST('Billing reserved for Finance / Front Desk','err'); return; }
    var D=D_(); var arr=(kind==='lab')?D.labTests:D.radiologyOrders;
    var n=0,sum=0;
    (arr||[]).forEach(function(o){ if(!o.billCode && appStatus(o)==='Approved'){ var b=makeBill(kind,o); n++; sum+=b.total; } });
    SAVE(); RERENDER();
    TOAST(n?(n+' bill(s) generated — '+FMT(sum)+' to Receivables'):'No approved-and-unbilled orders');
  };
  window.lroViewBill = function(kind,id){
    var D=D_(); var arr=(kind==='lab')?D.labTests:D.radiologyOrders;
    var o=(arr||[]).find(function(x){return x.id===id;}); if(!o||!o.billCode) return;
    var b=(D.bills||[]).find(function(x){return x.code===o.billCode || x.id===o.billId;});
    if(!b){ TOAST('Bill not found'); return; }
    var items=(b.items||[]).map(function(it){return '<tr><td>'+esc(it.s||'')+'</td><td style="text-align:right;font-weight:700">'+FMT(it.a||0)+'</td></tr>';}).join('');
    var body='<div style="margin-bottom:10px"><b>'+esc(b.code)+'</b> · '+esc(PAT(b.patientId))+' · '+esc(b.date)+'</div>'
      +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Item</th><th style="text-align:right">Amount</th></tr></thead><tbody>'+items
      +'<tr style="background:#f0fdfa"><td style="font-weight:800">Total</td><td style="text-align:right;font-weight:800;color:var(--pri)">'+FMT(b.total)+'</td></tr>'
      +'<tr><td>Paid</td><td style="text-align:right">'+FMT(b.paid||0)+'</td></tr>'
      +'<tr><td>Balance</td><td style="text-align:right;font-weight:700;color:'+((b.balance>0)?'#dc2626':'#16a34a')+'">'+FMT(b.balance||0)+'</td></tr>'
      +'</tbody></table></div>'
      +'<div style="margin-top:8px"><span class="st '+((typeof stc==='function')?stc(b.status):'st-pending')+'">'+esc(b.status)+'</span></div>';
    MODAL('<i class="fa-solid fa-receipt" style="color:var(--pri);margin-right:8px"></i>Bill '+esc(b.code), body,
      '<button class="btn btn-ghost" onclick="closeModal()">Close</button>');
  };

  /* ════════════════════════════════════════════════════════════════════════
     WIRING — append the panel under renderLab / renderRadiology
     ════════════════════════════════════════════════════════════════════════ */
  function wrap(){
    if(wrap._done) return;
    if(typeof window.renderLab==='function' && !window.renderLab.__lro){
      var oL=window.renderLab;
      window.renderLab=function(){
        var base=''; try{ base=oL.apply(this,arguments); }catch(e){ base='<div style="padding:12px;color:#ef4444">Lab view error: '+e.message+'</div>'; }
        var p=''; try{ p=panel('lab'); }catch(e){ p='<div style="padding:12px;color:#ef4444">Orders panel error: '+e.message+'</div>'; }
        return base+p;
      };
      window.renderLab.__lro=true;
    }
    if(typeof window.renderRadiology==='function' && !window.renderRadiology.__lro){
      var oR=window.renderRadiology;
      window.renderRadiology=function(){
        var base=''; try{ base=oR.apply(this,arguments); }catch(e){ base='<div style="padding:12px;color:#ef4444">Radiology view error: '+e.message+'</div>'; }
        var p=''; try{ p=panel('rad'); }catch(e){ p='<div style="padding:12px;color:#ef4444">Orders panel error: '+e.message+'</div>'; }
        return base+p;
      };
      window.renderRadiology.__lro=true;
    }
    wrap._done = (typeof window.renderLab==='function' && window.renderLab.__lro) &&
                 (typeof window.renderRadiology==='function' && window.renderRadiology.__lro);
  }

  function boot(){
    try{ wrap(); }catch(e){ console.warn('[LRO] wrap', e); }
    try{ if(window.render && document.getElementById('app')) window.render(); }catch(e){}
  }
  boot();
  setTimeout(boot,800); setTimeout(boot,2500); setTimeout(boot,6000);
  if(document.readyState==='loading'){ window.addEventListener('DOMContentLoaded', boot); }
  try{ console.log('%c✅ v107 — Lab & Radiology Orders (Edit · Approve · Bill) loaded','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/085-end-v107.js ==== */
/* ════════════════════════════════════════════════════════════════════════
   v108 — RELIABLE "ORDER TEST" / "ORDER IMAGING" SAVE
   Fixes lab/radiology order creation not saving by giving the order buttons a
   self-contained save path that does NOT depend on the addNewRecord/
   saveNewRecord wrapper chain (which can be blocked by role-permission gates).
   • Test / exam picker is backed by the fee schedule → price + category auto-fill.
   • Saves straight into D.labTests / D.radiologyOrders, sets approval defaults,
     persists, emits the order event, and re-renders.
   Additive only. Reroutes the existing top buttons to this handler.
   ════════════════════════════════════════════════════════════════════════ */
(function(){
  "use strict";

  function D_(){ try{ if(typeof D!=='undefined' && D) return D; }catch(e){} return window.D||{}; }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} }
  function RERENDER(){ try{ if(typeof render==='function') render(); else if(window.render) window.render(); }catch(e){} }
  function TOAST(m,t){ try{ if(typeof toast==='function') toast(m,t||'ok'); }catch(e){} }
  function MODAL(t,b,f,s){ try{ showModal(t,b,f,s); }catch(e){} }
  function CLOSE(){ try{ closeModal(); }catch(e){} }
  function NID(){ try{ return (typeof nid==='function')?nid():(Date.now()+Math.floor(Math.random()*1000)); }catch(e){ return Date.now(); } }
  function UID(){ try{ return (typeof uid==='function')?uid():Math.random().toString(36).substr(2,6).toUpperCase(); }catch(e){ return Math.random().toString(36).substr(2,6).toUpperCase(); } }
  function TODAY(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
  function FMT(n){ try{ return (typeof F==='function')?F(n):('₦'+Number(n||0).toLocaleString()); }catch(e){ return '₦'+(n||0); } }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function emit(evt,p){ try{ if(window.SyncBus) SyncBus.emit(evt,p); }catch(e){} }
  function AUD(t,m,a,d,r){ try{ if(typeof auditAction==='function') auditAction(t,m,a,d,r); }catch(e){} }
  function gv(id){ var el=document.getElementById(id); return el?el.value:''; }

  function feePool(kind){
    var fees=(D_().feeSchedule||[]);
    var dept=(kind==='lab')?'Laboratory':'Radiology';
    var cat =(kind==='lab')?'Lab':'Radiology';
    var pool=fees.filter(function(f){ return (f.department===dept)||(f.category===cat); });
    return pool.length?pool:fees;
  }
  function patOpts(){
    return (D_().patients||[]).map(function(p){ return '<option value="'+p.id+'">'+esc(p.fullName||p.name||('Patient '+p.id))+' ['+esc(p.mrn||'')+']</option>'; }).join('');
  }
  function docOpts(){
    return (D_().employees||[]).filter(function(e){ return e.type==='Doctor'; }).map(function(e){ return '<option value="'+e.id+'">'+esc(e.fullName)+'</option>'; }).join('');
  }
  function testDatalist(kind){
    return feePool(kind).map(function(f){ return '<option data-price="'+(f.amount||0)+'" value="'+esc(f.service)+'">'+esc(f.service)+' — '+FMT(f.amount||0)+'</option>'; }).join('');
  }
  function labCatOpts(){
    var cats=(D_().cfgLists&&D_().cfgLists.labCategories)||['Hematology','Chemical Pathology','Microbiology','Immunology','Serology','Urinalysis','Histopathology','Hormonal Assay','Tumor Marker'];
    return cats.map(function(c){ return '<option>'+esc(c)+'</option>'; }).join('');
  }

  /* ── New order modal ────────────────────────────────────────────────────── */
  window.lroNewOrder = function(kind){
    kind=(kind==='rad')?'rad':'lab';
    var title=(kind==='lab')?'Order Lab Test':'Order Imaging (Radiology)';
    var icon=(kind==='lab')?'fa-flask':'fa-x-ray';
    var accent=(kind==='lab')?'#7c3aed':'#3b82f6';
    var body='<div class="form-grid">'
      +'<div class="form-group"><label>Patient <span class="req">*</span></label><select id="lron_pat"><option value="">Select patient…</option>'+patOpts()+'</select></div>'
      +'<div class="form-group"><label>Ordered By (Doctor) <span class="req">*</span></label><select id="lron_by"><option value="">Select doctor…</option>'+docOpts()+'</select></div>';
    if(kind==='lab'){
      body+='<div class="form-group full"><label>Test Name <span class="req">*</span></label>'
          +'<input id="lron_name" list="lron_tests" placeholder="Start typing… e.g. Full Blood Count" oninput="lroPick(\'lab\')" autocomplete="off">'
          +'<datalist id="lron_tests">'+testDatalist('lab')+'</datalist></div>'
        +'<div class="form-group"><label>Category</label><select id="lron_cat">'+labCatOpts()+'</select></div>'
        +'<div class="form-group"><label>Priority</label><select id="lron_pri"><option>Routine</option><option selected>Normal</option><option>Urgent</option><option>Stat</option></select></div>'
        +'<div class="form-group"><label>Status</label><select id="lron_st"><option selected>Ordered</option><option>Sample Collected</option><option>Processing</option><option>Completed</option></select></div>'
        +'<div class="form-group"><label>Price (₦)</label><input id="lron_price" type="number" value="0"></div>'
        +'<div class="form-group"><label>Order Date</label><input id="lron_date" type="date" value="'+TODAY()+'"></div>'
        +'<div class="form-group full"><label>Sample Type / Notes</label><input id="lron_notes" placeholder="e.g. Serum, EDTA whole blood"></div>';
    } else {
      body+='<div class="form-group"><label>Modality <span class="req">*</span></label><select id="lron_mod" onchange="lroPick(\'rad\')"><option value="">Select…</option><option>X-Ray</option><option>CT</option><option>MRI</option><option>Ultrasound</option><option>Fluoroscopy</option><option>Mammography</option><option>ECG</option><option>Echocardiography</option></select></div>'
        +'<div class="form-group"><label>Body Part <span class="req">*</span></label><input id="lron_body" placeholder="e.g. Chest, Abdomen"></div>'
        +'<div class="form-group full"><label>Exam Type <span class="req">*</span></label>'
          +'<input id="lron_name" list="lron_tests" placeholder="Start typing… e.g. Sonography Chest" oninput="lroPick(\'rad\')" autocomplete="off">'
          +'<datalist id="lron_tests">'+testDatalist('rad')+'</datalist></div>'
        +'<div class="form-group"><label>Urgency</label><select id="lron_pri"><option selected>Routine</option><option>Urgent</option><option>Stat</option></select></div>'
        +'<div class="form-group"><label>Status</label><select id="lron_st"><option selected>Scheduled</option><option>In Progress</option><option>Completed</option></select></div>'
        +'<div class="form-group"><label>Price (₦)</label><input id="lron_price" type="number" value="0"></div>'
        +'<div class="form-group"><label>Scheduled Date</label><input id="lron_date" type="date" value="'+TODAY()+'"></div>'
        +'<div class="form-group full"><label>Clinical History / Indication</label><input id="lron_notes" placeholder="Reason for the study"></div>';
    }
    body+='</div>'
      +'<div style="font-size:11px;color:var(--txt3);margin-top:6px"><i class="fa-solid fa-circle-info"></i> Picking a '+(kind==='lab'?'test':'exam')+' auto-fills the price from the fee schedule. The order is created as <b>Pending Approval / Unbilled</b> — approve &amp; bill it from the orders panel.</div>';
    MODAL('<i class="fa-solid '+icon+'" style="color:'+accent+';margin-right:8px"></i>'+title, body,
      '<button class="btn btn-pri" onclick="lroSaveNewOrder(\''+kind+'\')"><i class="fa-solid fa-save"></i> Save Order</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };

  /* auto-fill price (+category for lab) when a catalogue item is chosen/typed */
  window.lroPick = function(kind){
    var name=(kind==='lab')?gv('lron_name'):gv('lron_name');
    if(kind==='rad' && !name) name=gv('lron_mod');
    if(!name) return;
    var pool=feePool(kind);
    var n=String(name).toUpperCase().replace(/[^A-Z0-9]/g,'');
    var hit=pool.find(function(f){ return String(f.service).toUpperCase().replace(/[^A-Z0-9]/g,'')===n; })
      || pool.find(function(f){ var fn=String(f.service).toUpperCase().replace(/[^A-Z0-9]/g,''); return fn && (fn.indexOf(n)>-1 || n.indexOf(fn)>-1); });
    if(hit){
      var pe=document.getElementById('lron_price'); if(pe && (!pe.value || pe.value==='0')) pe.value=hit.amount||0;
      else if(pe) pe.value=hit.amount||0;
    }
  };

  /* ── Save the new order (self-contained — no wrapper chain) ──────────────── */
  window.lroSaveNewOrder = function(kind){
    kind=(kind==='rad')?'rad':'lab';
    var D=D_();
    var pid=parseInt(gv('lron_pat'),10);
    var by=parseInt(gv('lron_by'),10);
    var name=gv('lron_name').trim();
    var price=parseFloat(gv('lron_price'))||0;
    if(!pid){ TOAST('Select a patient','err'); return; }
    if(!by){ TOAST('Select the ordering doctor','err'); return; }
    if(!name){ TOAST((kind==='lab'?'Enter the test name':'Enter the exam type'),'err'); return; }

    var rec;
    if(kind==='lab'){
      rec={ id:NID(), code:'LAB-'+UID(), patientId:pid, orderedBy:by, testType:name,
        category:gv('lron_cat')||'General', priority:gv('lron_pri')||'Normal', status:gv('lron_st')||'Ordered',
        sampleType:gv('lron_notes')||'', orderDate:gv('lron_date')||TODAY(), expectedDate:'',
        results:null, isAbnormal:false, price:price, approvalStatus:'Pending' };
      D.labTests=D.labTests||[]; D.labTests.push(rec);
      emit('lab.order.created',{id:rec.id,code:rec.code,patientId:pid});
    } else {
      rec={ id:NID(), code:'RAD-'+UID(), patientId:pid, orderedBy:by,
        modality:gv('lron_mod')||'X-Ray', bodyPart:gv('lron_body')||'', examType:name,
        urgency:gv('lron_pri')||'Routine', status:gv('lron_st')||'Scheduled',
        orderDate:gv('lron_date')||TODAY(), scheduledDate:gv('lron_date')||TODAY(), scheduledTime:'',
        clinicalHistory:gv('lron_notes')||'', report:'', impression:'', critical:false, verified:false,
        price:price, approvalStatus:'Pending' };
      D.radiologyOrders=D.radiologyOrders||[]; D.radiologyOrders.push(rec);
      emit('radiology.order.created',{id:rec.id,code:rec.code,patientId:pid});
    }
    AUD('CLINICAL',(kind==='lab'?'Laboratory':'Radiology'),'ORDER','Created order '+rec.code+' — '+name,'Low');
    CLOSE(); SAVE(); RERENDER();
    TOAST((kind==='lab'?'Lab test ordered — ':'Imaging ordered — ')+rec.code+' saved');
  };

  /* ── Reroute the existing top buttons to the reliable handler ────────────── */
  function reroute(html){
    if(typeof html!=='string') return html;
    return html
      .replace(/addNewRecord\(\s*'labTests'\s*\)/g, "lroNewOrder('lab')")
      .replace(/addNewRecord\(\s*&#39;labTests&#39;\s*\)/g, "lroNewOrder('lab')")
      .replace(/newRadiologyOrder\(\)/g, "lroNewOrder('rad')")
      .replace(/addNewRecord\(\s*'radiologyOrders'\s*\)/g, "lroNewOrder('rad')");
  }
  function wrap(){
    if(wrap._done) return;
    if(typeof window.renderLab==='function' && !window.renderLab.__lronew){
      var oL=window.renderLab;
      window.renderLab=function(){ var h=''; try{ h=oL.apply(this,arguments); }catch(e){ h='<div style="padding:12px;color:#ef4444">Lab view error: '+e.message+'</div>'; } return reroute(h); };
      window.renderLab.__lronew=true;
    }
    if(typeof window.renderRadiology==='function' && !window.renderRadiology.__lronew){
      var oR=window.renderRadiology;
      window.renderRadiology=function(){ var h=''; try{ h=oR.apply(this,arguments); }catch(e){ h='<div style="padding:12px;color:#ef4444">Radiology view error: '+e.message+'</div>'; } return reroute(h); };
      window.renderRadiology.__lronew=true;
    }
    wrap._done = (typeof window.renderLab==='function' && window.renderLab.__lronew) &&
                 (typeof window.renderRadiology==='function' && window.renderRadiology.__lronew);
  }

  function boot(){
    try{ wrap(); }catch(e){ console.warn('[LRONEW] wrap', e); }
    try{ if(window.render && document.getElementById('app')) window.render(); }catch(e){}
  }
  boot();
  setTimeout(boot,800); setTimeout(boot,2500); setTimeout(boot,6000);
  if(document.readyState==='loading'){ window.addEventListener('DOMContentLoaded', boot); }
  try{ console.log('%c✅ v108 — Reliable Order Test / Order Imaging save loaded','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/086-tiny-helpers-self-contained-mirror-v107-v108.js ==== */
(function(){
  "use strict";

  /* ── tiny helpers (self-contained, mirror v107/v108) ──────────────────── */
  function D_(){ try{ if(typeof D!=='undefined' && D) return D; }catch(e){} return window.D||{}; }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} }
  function RERENDER(){ try{ if(typeof render==='function') render(); else if(window.render) window.render(); }catch(e){} }
  function TOAST(m,t){ try{ if(typeof toast==='function') toast(m,t||'ok'); }catch(e){} }
  function MODAL(t,b,f,s){ try{ showModal(t,b,f,s); }catch(e){} }
  function CLOSE(){ try{ closeModal(); }catch(e){} }
  function NID(){ try{ return (typeof nid==='function')?nid():(Date.now()+Math.floor(Math.random()*1000)); }catch(e){ return Date.now(); } }
  function UID(){ try{ return (typeof uid==='function')?uid():Math.random().toString(36).substr(2,6).toUpperCase(); }catch(e){ return Math.random().toString(36).substr(2,6).toUpperCase(); } }
  function TODAY(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
  function FMT(n){ try{ return (typeof F==='function')?F(n):('₦'+Number(n||0).toLocaleString()); }catch(e){ return '₦'+(n||0); } }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function emit(evt,p){ try{ if(window.SyncBus) SyncBus.emit(evt,p); }catch(e){} }
  function AUD(t,m,a,d,r){ try{ if(typeof auditAction==='function') auditAction(t,m,a,d,r); }catch(e){} }
  function gv(id){ var el=document.getElementById(id); return el?el.value:''; }
  function norm(s){ return String(s||'').toUpperCase().replace(/[^A-Z0-9]/g,''); }

  /* ── data pools ──────────────────────────────────────────────────────── */
  function feePool(kind){
    var fees=(D_().feeSchedule||[]);
    var dept=(kind==='lab')?'Laboratory':'Radiology';
    var cat =(kind==='lab')?'Lab':'Radiology';
    var pool=fees.filter(function(f){ return (f.department===dept)||(f.category===cat); });
    return pool.length?pool:fees;
  }
  function feeMatch(kind,name){
    var pool=feePool(kind); var n=norm(name); if(!n) return null;
    return pool.find(function(f){ return norm(f.service)===n; })
        || pool.find(function(f){ var fn=norm(f.service); return fn && (fn.indexOf(n)>-1 || n.indexOf(fn)>-1); })
        || null;
  }
  /* ── lab test → clinical category master (v355) ──────────────────────────
     The fee schedule only carries coarse billing categories ("Lab", "Admission")
     which do NOT describe the clinical discipline a test belongs to. The
     authoritative test→discipline map lives in D.labTestCatalog. These helpers
     resolve the correct discipline for a test name so the Category dropdown
     always defaults to the right value when a test name is picked. */
  function labCatalog(){ var c=D_().labTestCatalog; return (c&&c.length)?c:[]; }
  var LAB_CAT_MASTER=['Hematology','Chemical Pathology','Biochemistry','Microbiology',
    'Microbiology/Molecular Diagnostics','Molecular Diagnostics','Parasitology',
    'Immunology','Immunohistochemistry','Serology','Serology/Immunology','Serology/Microbiology',
    'Urinalysis','Histopathology','Histopathology/Cytology','Cytopathology','Cytogenetics',
    'Hormonal Assay','Tumor Marker','Toxicology','Andrology','Blood Transfusion Science'];
  /* union of the master disciplines + every distinct category present in the
     live catalog + any configured labCategories, de-duplicated, order-stable. */
  function labCategoryList(){
    var out=[], seen={};
    function add(c){ if(c==null) return; c=String(c); var k=c.toLowerCase(); if(k && !seen[k]){ seen[k]=1; out.push(c); } }
    labCatalog().forEach(function(t){ if(t&&t.category) add(t.category); });
    LAB_CAT_MASTER.forEach(add);
    var cfg=(D_().cfgLists&&D_().cfgLists.labCategories);
    if(cfg&&cfg.length) cfg.forEach(add);
    return out;
  }
  /* resolve the clinical discipline for a typed/picked test name:
     1) exact (normalised) match on catalog test name
     2) fuzzy contains match (either direction), longest overlap wins */
  function catFromCatalog(name){
    var n=norm(name); if(!n) return null;
    var cat=labCatalog();
    var exact=cat.find(function(t){ return t&&t.test && norm(t.test)===n; });
    if(exact&&exact.category) return exact.category;
    var best=null, bestLen=0;
    cat.forEach(function(t){
      if(!t||!t.test||!t.category) return;
      var tn=norm(t.test); if(!tn) return;
      if(tn.indexOf(n)>-1 || n.indexOf(tn)>-1){
        var len=Math.min(tn.length,n.length);
        if(len>bestLen){ bestLen=len; best=t.category; }
      }
    });
    return best||null;
  }
  function patOpts(){
    return (D_().patients||[]).map(function(p){
      return '<option value="'+p.id+'">'+esc(p.fullName||p.name||('Patient '+p.id))+' ['+esc(p.mrn||'')+']</option>';
    }).join('');
  }
  function docOpts(){
    return (D_().employees||[]).filter(function(e){ return e.type==='Doctor' && (e.status==='Active'||!e.status); })
      .map(function(e){ return '<option value="'+e.id+'">'+esc(e.fullName)+(e.specialization?' — '+esc(e.specialization):'')+'</option>'; }).join('');
  }
  function testDatalist(kind){
    var opts=[], seen={};
    feePool(kind).forEach(function(f){ var s=f.service; if(!s) return; var k=norm(s); if(seen[k]) return; seen[k]=1;
      opts.push('<option value="'+esc(s)+'">'+esc(s)+' — '+FMT(f.amount||0)+'</option>'); });
    /* for lab orders, also offer every catalog test name (labelled with its
       clinical discipline) so the picker mirrors the master catalogue. */
    if(kind==='lab'){
      labCatalog().forEach(function(t){ if(!t||!t.test) return; var k=norm(t.test); if(seen[k]) return; seen[k]=1;
        opts.push('<option value="'+esc(t.test)+'">'+esc(t.test)+(t.category?(' — '+esc(t.category)):'')+'</option>'); });
    }
    return opts.join('');
  }
  function labCatOpts(sel){
    var cats=labCategoryList();
    /* if the desired selection is not already one of the disciplines, surface
       it as an option so the dropdown can still show it. */
    if(sel && cats.map(function(c){return c.toLowerCase();}).indexOf(String(sel).toLowerCase())===-1) cats=[sel].concat(cats);
    return cats.map(function(c){ return '<option'+(String(sel).toLowerCase()===String(c).toLowerCase()?' selected':'')+'>'+esc(c)+'</option>'; }).join('');
  }
  /* External referral suggestions: known referral partners, distinct registration
     referral sources, and doctor names — all as a free-text datalist. */
  function refDatalist(){
    var names={};
    (D_().referralPartners||[]).forEach(function(r){ if(r&&r.name) names[r.name]=1; });
    (D_().patients||[]).forEach(function(p){ if(p&&p.referredBy) names[p.referredBy]=1; });
    (D_().employees||[]).filter(function(e){return e.type==='Doctor';}).forEach(function(e){ if(e.fullName) names[e.fullName]=1; });
    return Object.keys(names).map(function(n){ return '<option value="'+esc(n)+'"></option>'; }).join('');
  }
  /* Customer suggestions: billing customers + insurers/HMOs + corporate partners. */
  function custDatalist(){
    var names={};
    (D_().customers||[]).forEach(function(c){ if(c&&c.name) names[c.name]=1; });
    (D_().insuranceProviders||[]).forEach(function(p){ if(p&&p.name) names[p.name]=1; });
    (D_().partners||[]).forEach(function(p){ if(p&&(p.companyName||p.name)) names[p.companyName||p.name]=1; });
    return Object.keys(names).map(function(n){ return '<option value="'+esc(n)+'"></option>'; }).join('');
  }

  /* ── line management ─────────────────────────────────────────────────── */
  var LINES=[];          // active line indices in DOM order
  var SEQ=0;             // monotonic line id
  var PRIOS_LAB=['Routine','Normal','Urgent','Stat'];
  var PRIOS_RAD=['Routine','Urgent','Stat'];
  var MODALITIES=['X-Ray','CT','MRI','Ultrasound','Fluoroscopy','Mammography','PET','ECG','Echocardiography'];

  function priOpts(kind,sel){
    var list=(kind==='lab')?PRIOS_LAB:PRIOS_RAD;
    return list.map(function(p){ return '<option'+(String(sel)===String(p)?' selected':(!sel&&p==='Routine'?' selected':''))+'>'+esc(p)+'</option>'; }).join('');
  }
  function modOpts(sel){
    return '<option value="">Select…</option>'+MODALITIES.map(function(m){ return '<option'+(String(sel)===String(m)?' selected':'')+'>'+esc(m)+'</option>'; }).join('');
  }

  function lineRowHTML(kind,i){
    var rm='<button type="button" class="act-btn del" title="Remove line" onclick="lroRemoveLine('+i+')"><i class="fa-solid fa-trash"></i></button>';
    if(kind==='lab'){
      return '<tr id="lroRow_'+i+'">'
        +'<td><input id="lro_name_'+i+'" list="lro_tests" autocomplete="off" placeholder="Start typing… e.g. Full Blood Count" oninput="lroPickLine(\'lab\','+i+')" style="min-width:200px"></td>'
        +'<td><select id="lro_cat_'+i+'">'+labCatOpts('')+'</select></td>'
        +'<td><input id="lro_samp_'+i+'" placeholder="Specimen / notes" style="min-width:130px"></td>'
        +'<td><select id="lro_pri_'+i+'">'+priOpts('lab','')+'</select></td>'
        +'<td><input id="lro_price_'+i+'" type="number" value="0" min="0" oninput="lroUpdateTotal()" style="width:96px;text-align:right"></td>'
        +'<td style="text-align:center">'+rm+'</td>'
        +'</tr>';
    }
    return '<tr id="lroRow_'+i+'">'
      +'<td><select id="lro_mod_'+i+'" onchange="lroPickLine(\'rad\','+i+')">'+modOpts('')+'</select></td>'
      +'<td><input id="lro_body_'+i+'" placeholder="e.g. Chest, Abdomen" style="min-width:130px"></td>'
      +'<td><input id="lro_name_'+i+'" list="lro_tests" autocomplete="off" placeholder="Exam type — e.g. Chest PA" oninput="lroPickLine(\'rad\','+i+')" style="min-width:180px"></td>'
      +'<td><select id="lro_pri_'+i+'">'+priOpts('rad','')+'</select></td>'
      +'<td><input id="lro_price_'+i+'" type="number" value="0" min="0" oninput="lroUpdateTotal()" style="width:96px;text-align:right"></td>'
      +'<td style="text-align:center">'+rm+'</td>'
      +'</tr>';
  }

  window.lroAddLine=function(kind){
    var tb=document.getElementById('lroLinesBody'); if(!tb) return;
    var i=++SEQ; LINES.push(i);
    tb.insertAdjacentHTML('beforeend', lineRowHTML(kind,i));
    lroUpdateTotal();
  };
  window.lroRemoveLine=function(i){
    if(LINES.length<=1){ TOAST('At least one line is required','err'); return; }
    var row=document.getElementById('lroRow_'+i); if(row) row.parentNode.removeChild(row);
    LINES=LINES.filter(function(x){ return x!==i; });
    lroUpdateTotal();
  };
  /* ensure a <select> contains an option with the given value, adding it if
     absent, then return the matched (or newly-added) option value. */
  function ensureCatOption(sel,cat){
    if(!sel||!cat) return null;
    for(var k=0;k<sel.options.length;k++){ if(sel.options[k].value.toLowerCase()===String(cat).toLowerCase()) return sel.options[k].value; }
    var o=document.createElement('option'); o.value=cat; o.textContent=cat; sel.appendChild(o); return cat;
  }
  window.lroPickLine=function(kind,i){
    var name = (kind==='rad') ? (gv('lro_name_'+i)||gv('lro_mod_'+i)) : gv('lro_name_'+i);
    var hit=feeMatch(kind,name);
    /* price: from the fee schedule when a match exists */
    if(hit){
      var pe=document.getElementById('lro_price_'+i); if(pe) pe.value=hit.amount||0;
    }
    /* category (lab only): ALWAYS default to the clinical discipline from the
       authoritative lab test catalog when the test name is picked. Falls back
       to any category the fee schedule happens to carry. (v355) */
    if(kind==='lab' && name){
      var cat=catFromCatalog(name) || (hit&&hit.category) || null;
      if(cat){
        var ce=document.getElementById('lro_cat_'+i);
        if(ce){ var v=ensureCatOption(ce,cat); if(v!=null) ce.value=v; }
      }
    }
    lroUpdateTotal();
  };
  window.lroUpdateTotal=function(){
    var t=0; LINES.forEach(function(i){ t+=parseFloat(gv('lro_price_'+i))||0; });
    var el=document.getElementById('lroTotal'); if(el) el.textContent=FMT(t);
    var c=document.getElementById('lroCount'); if(c) c.textContent=LINES.length+(LINES.length===1?' line':' lines');
  };

  /* ── toggles ─────────────────────────────────────────────────────────── */
  window.lroTogglePatient=function(){
    var walk=(gv('lro_ptype')==='Walk-in');
    var reg=document.getElementById('lroPatReg'), w=document.getElementById('lroPatWalk');
    if(reg) reg.style.display=walk?'none':'';
    if(w) w.style.display=walk?'':'none';
  };
  window.lroToggleSource=function(){
    var t=gv('lro_stype')||'Doctor';
    var d=document.getElementById('lroSrcDoc'), r=document.getElementById('lroSrcRef'), c=document.getElementById('lroSrcCust');
    if(d) d.style.display=(t==='Doctor')?'':'none';
    if(r) r.style.display=(t==='Referral')?'':'none';
    if(c) c.style.display=(t==='Customer')?'':'none';
  };
  /* Turn the current walk-in capture into a full registration (re-uses the
     existing bridge from v52 when available; otherwise opens the patient form). */
  window.lroRegisterWalkIn=function(){
    var name=gv('lro_walkName').trim(); if(!name){ TOAST('Enter the walk-in name first','err'); return; }
    var g=gv('lro_walkGender'), a=gv('lro_walkAge'), ph=gv('lro_walkPhone');
    try{ CLOSE(); }catch(e){}
    if(typeof addNewRecord!=='function'){ TOAST('Registration form unavailable','err'); return; }
    addNewRecord('patients');
    var tries=0;
    (function fill(){
      tries++;
      if(!document.getElementById('add_firstName') && tries<40){ return setTimeout(fill,60); }
      var parts=name.split(/\s+/);
      function setV(id,v){ var e=document.getElementById(id); if(e&&v!=null&&v!=='') e.value=String(v); }
      setV('add_firstName',parts.shift()||''); setV('add_lastName',parts.join(' '));
      setV('add_gender',g); setV('add_age',a); setV('add_phone',ph);
      setV('add_referralSource','Walk-in');
      try{ if(typeof patientSourceToggle==='function') patientSourceToggle(); }catch(e){}
      try{ var pt=document.getElementById('reg_patientType'); if(pt){ pt.value='Walk-in'; if(typeof window.patientRegTypeToggle==='function') window.patientRegTypeToggle(); } }catch(e){}
      TOAST('Complete the form to register this walk-in, then re-open the order');
    })();
  };

  /* ── the modal ───────────────────────────────────────────────────────── */
  window.lroNewOrder=function(kind){
    kind=(kind==='rad')?'rad':'lab';
    var lab=(kind==='lab');
    var title=lab?'Order Lab Test':'Order Imaging (Radiology)';
    var icon=lab?'fa-flask':'fa-x-ray';
    var accent=lab?'#7c3aed':'#3b82f6';
    var groupCode=(lab?'LAB-':'RAD-')+UID();

    LINES=[]; SEQ=0;
    var firstIdx=++SEQ; LINES.push(firstIdx);

    var head =
      '<div class="form-grid">'
      + '<div class="form-group"><label>Order No</label><input id="lro_orderCode" value="'+esc(groupCode)+'" readonly style="background:#f8fafc;font-weight:700"></div>'
      + '<div class="form-group"><label>'+(lab?'Order Date':'Scheduled Date')+'</label><input id="lro_date" type="date" value="'+TODAY()+'"></div>'
      + '<div class="form-group"><label>Status</label><select id="lro_status">'
          + (lab
              ? '<option selected>Ordered</option><option>Sample Collected</option><option>Processing</option><option>Completed</option>'
              : '<option selected>Scheduled</option><option>In Progress</option><option>Completed</option>')
          + '</select></div>'

      /* ── Patient ── */
      + '<div class="form-section" style="grid-column:1/-1"><span>Patient</span></div>'
      + '<div class="form-group"><label>Patient Type <span class="req">*</span></label>'
          + '<select id="lro_ptype" onchange="lroTogglePatient()"><option value="Registered" selected>Registered Patient</option><option value="Walk-in">Walk-in Patient</option></select></div>'
      + '<div class="form-group" id="lroPatReg"><label>Patient <span class="req">*</span></label>'
          + '<select id="lro_patientId"><option value="">Select patient…</option>'+patOpts()+'</select></div>'
      + '<div class="form-group full" id="lroPatWalk" style="display:none"><div class="form-grid">'
          + '<div class="form-group"><label>Walk-in Name <span class="req">*</span></label><input id="lro_walkName" type="text" placeholder="Full name"></div>'
          + '<div class="form-group"><label>Gender</label><select id="lro_walkGender"><option value="">—</option><option>Male</option><option>Female</option><option>Other</option></select></div>'
          + '<div class="form-group"><label>Age</label><input id="lro_walkAge" type="number" min="0"></div>'
          + '<div class="form-group"><label>Phone</label><input id="lro_walkPhone" type="tel"></div>'
          + '<div class="form-group full"><button type="button" class="btn btn-ghost btn-sm" onclick="lroRegisterWalkIn()"><i class="fa-solid fa-user-plus"></i> Register as Patient</button> <span style="font-size:11px;color:var(--txt3)">— optional: open full registration pre-filled with these details</span></div>'
        + '</div></div>'

      /* ── Order source ── */
      + '<div class="form-section" style="grid-column:1/-1"><span>Ordered By</span></div>'
      + '<div class="form-group"><label>Order Source <span class="req">*</span></label>'
          + '<select id="lro_stype" onchange="lroToggleSource()"><option value="Doctor" selected>In-house Doctor</option><option value="Referral">External Referral</option><option value="Customer">Customer</option></select></div>'
      + '<div class="form-group" id="lroSrcDoc"><label>Ordered By (Doctor) <span class="req">*</span></label>'
          + '<select id="lro_doctor"><option value="">Select doctor…</option>'+docOpts()+'</select></div>'
      + '<div class="form-group" id="lroSrcRef" style="display:none"><label>Referring Doctor / Facility <span class="req">*</span></label>'
          + '<input id="lro_refName" list="lro_refs" autocomplete="off" placeholder="External referring physician or hospital"><datalist id="lro_refs">'+refDatalist()+'</datalist></div>'
      + '<div class="form-group" id="lroSrcCust" style="display:none"><label>Customer <span class="req">*</span></label>'
          + '<input id="lro_custName" list="lro_custs" autocomplete="off" placeholder="Company / HMO / corporate client"><datalist id="lro_custs">'+custDatalist()+'</datalist></div>'
      + '<div class="form-group"><label>Client / Account Name</label><input id="lro_clientName" type="text" placeholder="Billing account (optional)"></div>'
      + '<div class="form-group full"><label>Clinical Diagnosis / Indication</label><input id="lro_diagnosis" type="text" placeholder="Provisional diagnosis or reason for the request"></div>'
      + '</div>';

    var colHead = lab
      ? '<th>Test Name</th><th>Category</th><th>Specimen / Notes</th><th>Priority</th><th>Price (₦)</th><th></th>'
      : '<th>Modality</th><th>Body Part</th><th>Exam Type</th><th>Urgency</th><th>Price (₦)</th><th></th>';

    var lines =
      '<div class="form-section" style="grid-column:1/-1;margin-top:4px"><span>'+(lab?'Tests Requested':'Examinations Requested')+'</span></div>'
      + '<div class="tbl-wrap" style="margin-bottom:8px"><table class="tbl"><thead><tr>'+colHead+'</tr></thead>'
      + '<tbody id="lroLinesBody">'+lineRowHTML(kind,firstIdx)+'</tbody></table></div>'
      + '<datalist id="lro_tests">'+testDatalist(kind)+'</datalist>'
      + '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px">'
        + '<button type="button" class="btn btn-ghost btn-sm" onclick="lroAddLine(\''+kind+'\')"><i class="fa-solid fa-plus"></i> Add '+(lab?'test':'exam')+'</button>'
        + '<div style="font-size:13px;color:var(--txt2)"><span id="lroCount">1 line</span> · Estimated total: <b id="lroTotal" style="color:'+accent+'">'+FMT(0)+'</b></div>'
      + '</div>';

    var recoSec =
      '<div class="form-grid">'
      + '<div class="form-section" style="grid-column:1/-1"><span>Recommendation</span></div>'
      + '<div class="form-group full"><label>Clinical Recommendation / Note</label>'
          + '<textarea id="lro_recommendation" rows="3" placeholder="Recommendation or special instructions for the '+(lab?'laboratory':'imaging')+' team (e.g. fasting required, correlate clinically, prior films attached)…"></textarea></div>'
      + '</div>';

    var note='<div style="font-size:11px;color:var(--txt3);margin-top:6px"><i class="fa-solid fa-circle-info"></i> Picking a '
      +(lab?'test':'exam')+' auto-fills its price from the fee schedule. Each line is created as a separate order under <b>'+esc(groupCode)
      +'</b>, status <b>Pending Approval / Unbilled</b> — approve &amp; bill from the orders panel.</div>';

    MODAL('<i class="fa-solid '+icon+'" style="color:'+accent+';margin-right:8px"></i>'+title,
      head+lines+recoSec+note,
      '<button class="btn btn-pri" onclick="lroSaveNewOrder(\''+kind+'\')"><i class="fa-solid fa-save"></i> Save Order</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>',
      'wide');

    setTimeout(function(){ try{ window.lroTogglePatient(); window.lroToggleSource(); window.lroUpdateTotal(); }catch(e){} },20);
  };

  /* ── save: one record per line, sharing the order header ─────────────── */
  window.lroSaveNewOrder=function(kind){
    kind=(kind==='rad')?'rad':'lab';
    var lab=(kind==='lab');
    var D=D_();

    /* ── patient ── */
    var ptype=gv('lro_ptype')||'Registered';
    var patientId=null, patientName=null, wG=null, wA=null, wP=null;
    if(ptype==='Walk-in'){
      patientName=gv('lro_walkName').trim();
      if(!patientName){ TOAST('Enter the walk-in patient name','err'); return; }
      wG=gv('lro_walkGender')||null; wA=gv('lro_walkAge')||null; wP=gv('lro_walkPhone')||null;
    } else {
      patientId=parseInt(gv('lro_patientId'),10)||null;
      if(!patientId){ TOAST('Select a patient (or switch to Walk-in)','err'); return; }
    }

    /* ── order source ── */
    var stype=gv('lro_stype')||'Doctor';
    var orderedBy=null, orderedByName=null;
    if(stype==='Doctor'){
      orderedBy=parseInt(gv('lro_doctor'),10)||null;
      if(!orderedBy){ TOAST('Select the ordering doctor','err'); return; }
    } else if(stype==='Referral'){
      orderedByName=gv('lro_refName').trim()||null;
      if(!orderedByName){ TOAST('Enter the referring doctor / facility','err'); return; }
    } else {
      orderedByName=gv('lro_custName').trim()||null;
      if(!orderedByName){ TOAST('Select or enter the customer','err'); return; }
    }

    var groupCode=gv('lro_orderCode')||((lab?'LAB-':'RAD-')+UID());
    var oDate=gv('lro_date')||TODAY();
    var status=gv('lro_status')||(lab?'Ordered':'Scheduled');
    var diagnosis=gv('lro_diagnosis').trim();
    var recommendation=gv('lro_recommendation').trim();
    var clientName=gv('lro_clientName').trim()||null;

    /* ── collect non-empty lines ── */
    var rows=[];
    LINES.forEach(function(i){
      if(lab){
        var name=gv('lro_name_'+i).trim(); if(!name) return;
        rows.push({ name:name, category:gv('lro_cat_'+i)||'General', sample:gv('lro_samp_'+i)||'',
                    priority:gv('lro_pri_'+i)||'Normal', price:parseFloat(gv('lro_price_'+i))||0 });
      } else {
        var mod=gv('lro_mod_'+i), body=gv('lro_body_'+i).trim(), et=gv('lro_name_'+i).trim();
        if(!mod && !et && !body) return;
        if(!mod){ TOAST('Pick a modality for every exam line','err'); rows._bad=true; return; }
        if(!et){ et=mod+(body?(' — '+body):''); }
        rows.push({ modality:mod, bodyPart:body, examType:et,
                    priority:gv('lro_pri_'+i)||'Routine', price:parseFloat(gv('lro_price_'+i))||0 });
      }
    });
    if(rows._bad) return;
    if(!rows.length){ TOAST(lab?'Add at least one test':'Add at least one exam','err'); return; }

    /* ── shared header copied onto every line record ── */
    var shared={
      orderGroup:groupCode, patientId:patientId, patientName:patientName, patientType:ptype,
      walkinGender:wG, walkinAge:wA, walkinPhone:wP,
      orderedBy:orderedBy, orderedByName:orderedByName, orderedByType:stype,
      clientName:clientName, diagnosis:diagnosis, recommendation:recommendation,
      orderDate:oDate, approvalStatus:'Pending'
    };

    var created=[];
    rows.forEach(function(r){
      var rec;
      if(lab){
        rec=Object.assign({ id:NID(), code:'LAB-'+UID(),
          testType:r.name, category:r.category, sampleType:r.sample, specimen:r.sample,
          priority:r.priority, status:status, expectedDate:'',
          results:null, isAbnormal:false, price:r.price, labNotes:'' }, shared);
        D.labTests=D.labTests||[]; D.labTests.push(rec);
        emit('lab.order.created',{ id:rec.id, code:rec.code, patientId:patientId, group:groupCode });
      } else {
        rec=Object.assign({ id:NID(), code:'RAD-'+UID(),
          modality:r.modality, bodyPart:r.bodyPart, examType:r.examType,
          urgency:r.priority, status:status,
          scheduledDate:oDate, scheduledTime:'', clinicalHistory:diagnosis,
          report:'', impression:'', critical:false, verified:false, price:r.price }, shared);
        D.radiologyOrders=D.radiologyOrders||[]; D.radiologyOrders.push(rec);
        emit('radiology.order.created',{ id:rec.id, code:rec.code, patientId:patientId, group:groupCode });
      }
      created.push(rec.code);
    });

    AUD('CLINICAL',(lab?'Laboratory':'Radiology'),'ORDER',
        'Created '+created.length+' '+(lab?'test':'exam')+' line(s) under '+groupCode
        +' for '+(patientName||('patient #'+patientId))+' · ordered by '+(orderedByName||('Dr #'+orderedBy))+' ('+stype+')','Low');

    CLOSE(); SAVE(); RERENDER();
    var first=created[0]||groupCode;
    TOAST((lab?'Lab order saved — ':'Imaging order saved — ')+first+(created.length>1?(' (+'+(created.length-1)+' more)'):'')+' · Pending approval');
  };

  try{ console.log('%c✅ v109 — Professional order entry: walk-in · referral/customer · multi-line · shared recommendation (lab + radiology)','color:#7c3aed;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/088-safe-helpers.js ==== */
(function(){
  "use strict";

  /* ── safe helpers ─────────────────────────────────────────────────────── */
  function D_(){ try{ if(typeof D!=='undefined' && D) return D; }catch(e){} return window.D||{}; }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} }
  function RERENDER(){ try{ if(typeof render==='function') render(); else if(window.render) window.render(); }catch(e){} }
  function TOAST(m,t){ try{ if(typeof toast==='function') toast(m,t||'ok'); }catch(e){} }
  function MODAL(t,b,f,s){ try{ showModal(t,b,f,s); }catch(e){} }
  function CLOSE(){ try{ closeModal(); }catch(e){} }
  function NID(){ try{ return (typeof nid==='function')?nid():(Date.now()+Math.floor(Math.random()*1000)); }catch(e){ return Date.now(); } }
  function UID(){ try{ return (typeof uid==='function')?uid():Math.random().toString(36).substr(2,6).toUpperCase(); }catch(e){ return Math.random().toString(36).substr(2,6).toUpperCase(); } }
  function TODAY(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
  function FMT(n){ try{ return (typeof F==='function')?F(n):('₦'+Number(n||0).toLocaleString()); }catch(e){ return '₦'+(n||0); } }
  function PAT(id){ try{ if(typeof pat==='function') return pat(id);}catch(e){} var p=(D_().patients||[]).find(function(x){return x.id===id;}); return p?(p.fullName||p.name||('Patient '+id)):'—'; }
  function DOC(id){ try{ if(typeof doc==='function') return doc(id);}catch(e){} var e2=(D_().employees||[]).find(function(x){return x.id===id;}); return e2?(e2.fullName||('#'+id)):'—'; }
  function MRN(id){ var p=(D_().patients||[]).find(function(x){return x.id===id;}); return p?(p.mrn||''):''; }
  function STC(s){ try{ if(typeof stc==='function') return stc(s);}catch(e){} return ''; }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function emit(evt,p){ try{ if(window.SyncBus) SyncBus.emit(evt,p); }catch(e){} try{ if(typeof HMSEvents!=='undefined'&&HMSEvents.emit) HMSEvents.emit(evt,p); }catch(e){} }
  function AUD(t,m,a,d,r){ try{ if(typeof auditAction==='function') auditAction(t,m,a,d,r); }catch(e){} }
  function gv(id){ var el=document.getElementById(id); return el?el.value:''; }
  function actor(){ return (D_().currentUser&&D_().currentUser.fullName)||'Pharmacist'; }

  var FREQ=['Once daily (OD)','Twice daily (BD)','Three times daily (TDS)','Four times daily (QDS)','Every 6 hours (Q6H)','Every 8 hours (Q8H)','Every 12 hours','At bedtime (Nocte)','As needed (PRN)','Before meals','After meals','Stat (once)'];
  var ROUTE=['Oral','IV','IM','SC','Topical','Rectal','Inhaler','Nebulizer','Sublingual','Eye drops','Ear drops'];
  function freqOpts(sel){ return FREQ.map(function(f){return '<option'+(sel===f?' selected':'')+'>'+esc(f)+'</option>';}).join(''); }
  function routeOpts(sel){ return ROUTE.map(function(r){return '<option'+(sel===r?' selected':'')+'>'+esc(r)+'</option>';}).join(''); }

  /* ── pharmacy pricing ─────────────────────────────────────────────────── */
  function drugByName(name){
    if(!name) return null;
    var ph=D_().pharmacy||[]; var n=String(name).toLowerCase();
    return ph.find(function(d){ return String(d.name||'').toLowerCase()===n; })
        || ph.find(function(d){ return String(d.name||'').toLowerCase().indexOf(n)>-1 || n.indexOf(String(d.name||'').toLowerCase())>-1; })
        || null;
  }
  function drugById(id){ return (D_().pharmacy||[]).find(function(d){ return d.id===id; })||null; }
  function sellPrice(d){ return d?(+d.sellingPrice||+d.price||0):0; }
  function costPrice(d){ return d?(+d.unitCost||+d.costPrice||+d.unitPrice||Math.round(sellPrice(d)*0.6)):0; }
  function itemUnit(it){ if(it && it.unitPrice!=null && it.unitPrice!=='') return +it.unitPrice||0;
    var d=it&&it.drugId?drugById(it.drugId):drugByName(it&&it.name); return sellPrice(d); }
  function itemTotal(it){ return itemUnit(it)*(parseInt(it&&it.qty)||0); }
  function rxTotal(rx){ return (rx.items||[]).reduce(function(s,it){return s+itemTotal(it);},0); }

  function pharmacyDatalist(){
    return (D_().pharmacy||[]).slice().sort(function(a,b){return String(a.name||'').localeCompare(String(b.name||''));})
      .map(function(d){
        var stk=(d.stock<=0)?'OUT':(d.stock<=d.minStock?('LOW '+d.stock):(d.stock+' in stock'));
        return '<option value="'+esc(d.name)+'">'+esc(d.name)+(d.strength?(' '+esc(d.strength)):'')+' — '+FMT(sellPrice(d))+' ['+stk+']</option>';
      }).join('');
  }
  function patOpts(sel){ return (D_().patients||[]).map(function(p){ return '<option value="'+p.id+'"'+(String(sel)===String(p.id)?' selected':'')+'>'+esc(p.fullName||p.name)+' ['+esc(p.mrn||'')+']</option>'; }).join(''); }
  function docOpts(sel){ return (D_().employees||[]).filter(function(e){return e.type==='Doctor'&&(e.status==='Active'||!e.status);}).map(function(e){ return '<option value="'+e.id+'"'+(String(sel)===String(e.id)?' selected':'')+'>'+esc(e.fullName)+'</option>'; }).join(''); }

  /* ═══ NEW Rx — inline multi-medication ════════════════════════════════ */
  var RXL=[], RXSEQ=0;
  function rxRowHTML(i){
    return '<tr id="rxlRow_'+i+'">'
      +'<td><input id="rxl_name_'+i+'" list="rxl_drugs" autocomplete="off" placeholder="Drug name…" oninput="rxPickDrug('+i+')" style="min-width:190px"></td>'
      +'<td><input id="rxl_dose_'+i+'" placeholder="e.g. 500mg" style="width:90px"></td>'
      +'<td><select id="rxl_freq_'+i+'">'+freqOpts('Twice daily (BD)')+'</select></td>'
      +'<td><select id="rxl_route_'+i+'">'+routeOpts('Oral')+'</select></td>'
      +'<td><input id="rxl_dur_'+i+'" placeholder="7 days" style="width:80px"></td>'
      +'<td><input id="rxl_qty_'+i+'" type="number" min="1" value="1" oninput="rxUpdateTotal()" style="width:64px;text-align:right"></td>'
      +'<td><input id="rxl_price_'+i+'" type="number" min="0" value="0" oninput="rxUpdateTotal()" style="width:96px;text-align:right"></td>'
      +'<td style="text-align:center"><button type="button" class="act-btn del" title="Remove" onclick="rxRemoveLine('+i+')"><i class="fa-solid fa-trash"></i></button></td>'
      +'</tr>';
  }
  window.rxAddLine=function(){ var tb=document.getElementById('rxLinesBody'); if(!tb)return; var i=++RXSEQ; RXL.push(i); tb.insertAdjacentHTML('beforeend',rxRowHTML(i)); rxUpdateTotal(); };
  window.rxRemoveLine=function(i){ if(RXL.length<=1){TOAST('Keep at least one line','err');return;} var r=document.getElementById('rxlRow_'+i); if(r)r.parentNode.removeChild(r); RXL=RXL.filter(function(x){return x!==i;}); rxUpdateTotal(); };
  window.rxPickDrug=function(i){ var d=drugByName(gv('rxl_name_'+i)); if(d){ var pe=document.getElementById('rxl_price_'+i); if(pe)pe.value=sellPrice(d); var de=document.getElementById('rxl_dose_'+i); if(de&&!de.value&&d.strength)de.value=d.strength; } rxUpdateTotal(); };
  window.rxUpdateTotal=function(){ var t=0,n=0; RXL.forEach(function(i){ var q=parseInt(gv('rxl_qty_'+i))||0, p=parseFloat(gv('rxl_price_'+i))||0; t+=q*p; if(gv('rxl_name_'+i).trim())n++; }); var el=document.getElementById('rxTotal'); if(el)el.textContent=FMT(t); var c=document.getElementById('rxCount'); if(c)c.textContent=n+(n===1?' medication':' medications'); };

  window.newRx=function(){
    RXL=[]; RXSEQ=0; var first=++RXSEQ; RXL.push(first);
    var body='<div class="form-grid">'
      + '<div class="form-group"><label>Rx Code</label><input id="rx_code" value="RX-'+esc(UID())+'" readonly style="background:#f8fafc;font-weight:700"></div>'
      + '<div class="form-group"><label>Date</label><input id="rx_date" type="date" value="'+TODAY()+'"></div>'
      + '<div class="form-group"><label>Status</label><select id="rx_status"><option selected>Active</option><option>Draft</option></select></div>'
      + '<div class="form-group"><label>Patient <span class="req">*</span></label><select id="rx_patientId"><option value="">Select patient…</option>'+patOpts()+'</select></div>'
      + '<div class="form-group"><label>Prescriber (Doctor) <span class="req">*</span></label><select id="rx_doctorId"><option value="">Select doctor…</option>'+docOpts()+'</select></div>'
      + '<div class="form-group full"><label>Clinical Notes / Instructions</label><textarea id="rx_notes" rows="2" placeholder="e.g. Take with food; review in 2 weeks"></textarea></div>'
      + '<div class="form-section" style="grid-column:1/-1"><span>Medications</span></div>'
      + '</div>'
      + '<div class="tbl-wrap" style="margin-bottom:8px"><table class="tbl"><thead><tr><th>Medication</th><th>Dosage</th><th>Frequency</th><th>Route</th><th>Duration</th><th>Qty</th><th>Unit Price (₦)</th><th></th></tr></thead><tbody id="rxLinesBody">'+rxRowHTML(first)+'</tbody></table></div>'
      + '<datalist id="rxl_drugs">'+pharmacyDatalist()+'</datalist>'
      + '<div style="display:flex;justify-content:space-between;align-items:center">'
        + '<button type="button" class="btn btn-ghost btn-sm" onclick="rxAddLine()"><i class="fa-solid fa-plus"></i> Add medication</button>'
        + '<div class="twh-sumbar" style="margin-top:0"><span id="rxCount">1 medication</span> · Estimated total: <b id="rxTotal">'+FMT(0)+'</b></div>'
      + '</div>'
      + '<div style="font-size:11px;color:var(--txt3);margin-top:8px"><i class="fa-solid fa-circle-info"></i> Prices auto-fill from the pharmacy and remain editable. Stock is deducted and the patient billed only when the Rx is <b>Dispensed</b>.</div>';
    MODAL('<i class="fa-solid fa-prescription" style="color:var(--pri);margin-right:8px"></i>New Prescription', body,
      '<button class="btn btn-pri" onclick="saveNewRx()"><i class="fa-solid fa-save"></i> Create Prescription</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
    setTimeout(rxUpdateTotal,20);
  };

  window.saveNewRx=function(){
    var pid=parseInt(gv('rx_patientId'),10)||null;
    var did=parseInt(gv('rx_doctorId'),10)||null;
    if(!pid){ TOAST('Select a patient','err'); return; }
    if(!did){ TOAST('Select the prescriber','err'); return; }
    var items=[];
    RXL.forEach(function(i){
      var name=gv('rxl_name_'+i).trim(); if(!name) return;
      var d=drugByName(name);
      items.push({ name:name, dosage:gv('rxl_dose_'+i)||'', frequency:gv('rxl_freq_'+i)||'', route:gv('rxl_route_'+i)||'',
        duration:gv('rxl_dur_'+i)||'', qty:parseInt(gv('rxl_qty_'+i))||1,
        unitPrice:parseFloat(gv('rxl_price_'+i))||0, instructions:'',
        drugId:d?d.id:null, fromInventory:!!d });
    });
    var rx={ id:NID(), code:gv('rx_code')||('RX-'+UID()), patientId:pid, doctorId:did,
      date:gv('rx_date')||TODAY(), status:gv('rx_status')||'Active', notes:gv('rx_notes')||'', items:items };
    D_().prescriptions=D_().prescriptions||[]; D_().prescriptions.push(rx);
    AUD('CLINICAL','Pharmacy','PRESCRIBE','New Rx '+rx.code+' for '+PAT(pid)+' — '+items.length+' medication(s)','Low');
    emit('prescription.created',{id:rx.id,code:rx.code,patientId:pid});
    CLOSE(); SAVE(); RERENDER();
    TOAST('Prescription '+rx.code+' created'+(items.length?(' — '+items.length+' medication(s)'):''));
  };

  /* ═══ ADD single medication (editable price) ══════════════════════════ */
  window.addMedication=function(rxId){
    var rx=(D_().prescriptions||[]).find(function(r){return r.id===rxId;}); if(!rx){TOAST('Rx not found','err');return;}
    var body='<div class="form-grid">'
      + '<div class="form-group full"><label>Pharmacy Item <span style="font-size:11px;color:var(--txt3)">(type to search — auto-fills price)</span></label>'
        + '<input id="med_pick" list="med_drugs" autocomplete="off" placeholder="Start typing a drug name…" oninput="medPick()"><datalist id="med_drugs">'+pharmacyDatalist()+'</datalist></div>'
      + '<div id="med_stockInfo" style="grid-column:1/-1;display:none;padding:9px 12px;border-radius:10px;font-size:12px"></div>'
      + '<div class="form-group"><label>Medication Name <span class="req">*</span></label><input id="med_name" placeholder="Drug name"></div>'
      + '<div class="form-group"><label>Dosage <span class="req">*</span></label><input id="med_dosage" placeholder="e.g. 500mg"></div>'
      + '<div class="form-group"><label>Frequency <span class="req">*</span></label><select id="med_frequency">'+freqOpts('Twice daily (BD)')+'</select></div>'
      + '<div class="form-group"><label>Route</label><select id="med_route">'+routeOpts('Oral')+'</select></div>'
      + '<div class="form-group"><label>Duration</label><input id="med_duration" placeholder="e.g. 7 days"></div>'
      + '<div class="form-group"><label>Quantity <span class="req">*</span></label><input id="med_qty" type="number" min="1" value="1" oninput="medLineTotal()"></div>'
      + '<div class="form-group"><label>Unit Price (₦) <span class="req">*</span></label><input id="med_price" type="number" min="0" value="0" oninput="medLineTotal()"></div>'
      + '<div class="form-group"><label>Line Total</label><input id="med_total" value="'+FMT(0)+'" readonly style="background:#f8fafc;font-weight:700;color:var(--pri2)"></div>'
      + '<div class="form-group full"><label>Special Instructions</label><textarea id="med_instructions" rows="2" placeholder="Take with food, avoid alcohol…"></textarea></div>'
      + '</div>';
    MODAL('<i class="fa-solid fa-pills" style="color:var(--pri);margin-right:8px"></i>Add Medication — '+esc(rx.code), body,
      '<button class="btn btn-pri" onclick="saveMedication('+rxId+')"><i class="fa-solid fa-save"></i> Add Medication</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.medPick=function(){
    var d=drugByName(gv('med_pick')); var info=document.getElementById('med_stockInfo');
    if(!d){ if(info)info.style.display='none'; return; }
    var nm=document.getElementById('med_name'); if(nm)nm.value=d.name;
    var dz=document.getElementById('med_dosage'); if(dz&&!dz.value&&d.strength)dz.value=d.strength;
    var pr=document.getElementById('med_price'); if(pr)pr.value=sellPrice(d);
    if(info){
      var low=d.stock<=0, warn=d.stock<=d.minStock;
      var bc=low?'#dc2626':warn?'#f59e0b':'#059669', bg=low?'#fef2f2':warn?'#fffbeb':'#f0fdfa';
      info.style.display='block'; info.style.background=bg; info.style.borderLeft='4px solid '+bc;
      info.innerHTML='<b>'+esc(d.name)+'</b> ('+esc(d.category||'')+') · <b style="color:'+bc+'">'+d.stock+'</b> in stock · Price '+FMT(sellPrice(d))+' · Min '+d.minStock+(d.controlled?' · <span style="color:#7c3aed;font-weight:700">⚠ CONTROLLED</span>':'');
    }
    medLineTotal();
  };
  window.medLineTotal=function(){ var q=parseInt(gv('med_qty'))||0, p=parseFloat(gv('med_price'))||0; var el=document.getElementById('med_total'); if(el)el.value=FMT(q*p); };
  window.saveMedication=function(rxId){
    var rx=(D_().prescriptions||[]).find(function(r){return r.id===rxId;}); if(!rx)return;
    var name=gv('med_name').trim(); var qty=parseInt(gv('med_qty'))||0; var price=parseFloat(gv('med_price'))||0;
    if(!name){ TOAST('Medication name required','err'); return; }
    if(!qty){ TOAST('Quantity required','err'); return; }
    var d=drugByName(gv('med_pick'))||drugByName(name);
    rx.items=rx.items||[];
    rx.items.push({ name:name, dosage:gv('med_dosage'), frequency:gv('med_frequency'), route:gv('med_route'),
      duration:gv('med_duration'), qty:qty, unitPrice:price, instructions:gv('med_instructions')||'',
      drugId:d?d.id:null, fromInventory:!!d });
    if(rx.status!=='Active'&&rx.status!=='Dispensed') rx.status='Active';
    AUD('CLINICAL','Pharmacy','PRESCRIBE','Added '+qty+'× '+name+' @ '+FMT(price)+' to '+rx.code,'Low');
    TOAST('Added to '+rx.code+' — dispense to deduct stock & bill'); CLOSE(); SAVE(); RERENDER();
  };

  /* ═══ EDIT / REMOVE medication line ═══════════════════════════════════ */
  window.editMedItem=function(rxId,idx){
    var rx=(D_().prescriptions||[]).find(function(r){return r.id===rxId;}); if(!rx||!rx.items||!rx.items[idx])return;
    var it=rx.items[idx];
    var body='<div class="form-grid">'
      + '<div class="form-group"><label>Medication Name</label><input id="em_name" value="'+esc(it.name)+'"></div>'
      + '<div class="form-group"><label>Dosage</label><input id="em_dosage" value="'+esc(it.dosage||'')+'"></div>'
      + '<div class="form-group"><label>Frequency</label><select id="em_frequency">'+freqOpts(it.frequency)+'</select></div>'
      + '<div class="form-group"><label>Route</label><select id="em_route">'+routeOpts(it.route)+'</select></div>'
      + '<div class="form-group"><label>Duration</label><input id="em_duration" value="'+esc(it.duration||'')+'"></div>'
      + '<div class="form-group"><label>Quantity</label><input id="em_qty" type="number" min="1" value="'+(it.qty||1)+'" oninput="emLineTotal()"></div>'
      + '<div class="form-group"><label>Unit Price (₦)</label><input id="em_price" type="number" min="0" value="'+itemUnit(it)+'" oninput="emLineTotal()"></div>'
      + '<div class="form-group"><label>Line Total</label><input id="em_total" value="'+FMT(itemTotal(it))+'" readonly style="background:#f8fafc;font-weight:700;color:var(--pri2)"></div>'
      + '<div class="form-group full"><label>Special Instructions</label><textarea id="em_instructions" rows="2">'+esc(it.instructions||'')+'</textarea></div>'
      + '</div>';
    MODAL('<i class="fa-solid fa-edit" style="color:var(--pri);margin-right:8px"></i>Edit Medication', body,
      '<button class="btn btn-pri" onclick="saveMedEdit('+rxId+','+idx+')"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.emLineTotal=function(){ var q=parseInt(gv('em_qty'))||0, p=parseFloat(gv('em_price'))||0; var el=document.getElementById('em_total'); if(el)el.value=FMT(q*p); };
  window.saveMedEdit=function(rxId,idx){
    var rx=(D_().prescriptions||[]).find(function(r){return r.id===rxId;}); if(!rx||!rx.items||!rx.items[idx])return;
    var it=rx.items[idx];
    it.name=gv('em_name'); it.dosage=gv('em_dosage'); it.frequency=gv('em_frequency'); it.route=gv('em_route');
    it.duration=gv('em_duration'); it.qty=parseInt(gv('em_qty'))||1; it.unitPrice=parseFloat(gv('em_price'))||0;
    it.instructions=gv('em_instructions')||'';
    if(it.drugId==null){ var d=drugByName(it.name); if(d){it.drugId=d.id;it.fromInventory=true;} }
    TOAST('Medication updated'); CLOSE(); SAVE(); RERENDER();
  };
  window.removeMedItem=function(rxId,idx){
    var rx=(D_().prescriptions||[]).find(function(r){return r.id===rxId;}); if(!rx)return;
    rx.items.splice(idx,1); TOAST('Medication removed','err'); SAVE(); RERENDER();
  };

  /* ═══ EDIT prescription header ════════════════════════════════════════ */
  window.editPrescription=function(id){
    var rx=(D_().prescriptions||[]).find(function(r){return r.id===id;}); if(!rx)return;
    var st=['Active','Dispensed','Partially Dispensed','Expired','Cancelled'].map(function(s){return '<option'+(s===rx.status?' selected':'')+'>'+s+'</option>';}).join('');
    var body='<div class="form-grid">'
      + '<div class="form-group"><label>Rx Code</label><input value="'+esc(rx.code)+'" readonly style="background:#f8fafc;font-weight:700"></div>'
      + '<div class="form-group"><label>Date</label><input id="erx_date" type="date" value="'+esc(rx.date||TODAY())+'"></div>'
      + '<div class="form-group"><label>Patient <span class="req">*</span></label><select id="erx_patientId">'+patOpts(rx.patientId)+'</select></div>'
      + '<div class="form-group"><label>Prescriber (Doctor) <span class="req">*</span></label><select id="erx_doctorId">'+docOpts(rx.doctorId)+'</select></div>'
      + '<div class="form-group"><label>Status</label><select id="erx_status">'+st+'</select></div>'
      + '<div class="form-group full"><label>Notes</label><textarea id="erx_notes" rows="3">'+esc(rx.notes||'')+'</textarea></div>'
      + '</div>';
    MODAL('<i class="fa-solid fa-edit" style="color:var(--pri);margin-right:8px"></i>Edit Prescription '+esc(rx.code), body,
      '<button class="btn btn-pri" onclick="savePrescriptionEdit('+id+')"><i class="fa-solid fa-save"></i> Save Changes</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.savePrescriptionEdit=function(id){
    var rx=(D_().prescriptions||[]).find(function(r){return r.id===id;}); if(!rx)return;
    rx.patientId=parseInt(gv('erx_patientId'))||rx.patientId; rx.doctorId=parseInt(gv('erx_doctorId'))||rx.doctorId;
    rx.date=gv('erx_date')||rx.date; rx.status=gv('erx_status')||rx.status; rx.notes=gv('erx_notes');
    TOAST('Prescription updated'); CLOSE(); SAVE(); RERENDER();
  };

  /* ═══ DISPENSE (uses the editable per-item prices) ════════════════════ */
  window.dispensePrescription=function(rxId){
    var rx=(D_().prescriptions||[]).find(function(r){return r.id===rxId;}); if(!rx){TOAST('Rx not found','err');return;}
    if(!rx.items||!rx.items.length){TOAST('No medications to dispense','err');return;}
    if(rx.status==='Dispensed'){TOAST('Already dispensed','err');return;}
    var rows='',total=0,anyIssue=false;
    rx.items.forEach(function(it){
      var d=it.drugId?drugById(it.drugId):drugByName(it.name); var q=parseInt(it.qty)||1;
      var unit=itemUnit(it); var line=unit*q; total+=line;
      var ok=!d?false:(d.stock>=q);
      if(!ok) anyIssue=true;
      var stk=d?(ok?'<span class="st st-active">'+d.stock+' in stock</span>':'<span class="st st-critical">only '+d.stock+'</span>'):'<span class="st st-draft">no inventory match</span>';
      rows+='<tr><td class="bold">'+esc(it.name)+'</td><td>'+esc(it.dosage||'')+'</td><td style="text-align:right">'+q+'</td><td style="text-align:right">'+FMT(unit)+'</td><td style="text-align:right;font-weight:700">'+FMT(line)+'</td><td>'+stk+'</td></tr>';
    });
    var body='<div class="twh-sumbar" style="margin:0 0 12px"><span><b style="color:var(--txt)">'+esc(PAT(rx.patientId))+'</b> · '+esc(rx.code)+' · prescribed by '+esc(DOC(rx.doctorId))+'</span><span>Total: <b>'+FMT(total)+'</b></span></div>'
      + '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Medication</th><th>Dosage</th><th style="text-align:right">Qty</th><th style="text-align:right">Unit Price</th><th style="text-align:right">Line Total</th><th>Stock</th></tr></thead><tbody>'+rows
      + '</tbody><tfoot><tr style="font-weight:800"><td colspan="4" style="text-align:right">Total Charge</td><td style="text-align:right;color:var(--pri2)">'+FMT(total)+'</td><td></td></tr></tfoot></table></div>'
      + (anyIssue?'<div style="margin-top:10px;padding:10px;background:#fffbeb;border:1px solid #fde68a;border-radius:8px;color:#92400e;font-size:12px"><i class="fa-solid fa-exclamation-triangle"></i> Some items have no/low inventory match. Dispensing deducts what is available; unmatched items are still billed at the entered price.</div>':'')
      + '<div class="form-group full" style="margin-top:12px"><label>Dispensing Notes</label><textarea id="disp_notes" rows="2" placeholder="Counselling / batch / pharmacist notes…"></textarea></div>';
    MODAL('<i class="fa-solid fa-pills" style="color:#059669;margin-right:8px"></i>Dispense '+esc(rx.code), body,
      '<button class="btn btn-pri" style="background:#059669" onclick="confirmDispense('+rxId+')"><i class="fa-solid fa-check"></i> Confirm Dispense &amp; Bill</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
  };
  window.confirmDispense=function(rxId){
    var rx=(D_().prescriptions||[]).find(function(r){return r.id===rxId;}); if(!rx)return;
    if(rx.status==='Dispensed'){TOAST('Already dispensed','err');return;}
    var notes=gv('disp_notes')||'';
    var cogs=0, revenue=0, billItems=[];
    (rx.items||[]).forEach(function(it){
      var d=it.drugId?drugById(it.drugId):drugByName(it.name); var q=parseInt(it.qty)||1;
      var unit=itemUnit(it); var line=unit*q; revenue+=line;
      if(d){ d.stock=Math.max(0,(d.stock||0)-q); cogs+=costPrice(d)*q; }
      billItems.push({ s:esc(it.name)+' × '+q+' @ '+FMT(unit), a:line, category:'Pharmacy', drugId:d?d.id:null, qty:q, unitPrice:unit });
    });
    rx.status='Dispensed'; rx.dispensedDate=TODAY(); rx.dispensedBy=actor(); if(notes)rx.dispenseNotes=notes;
    /* COGS to GL (Dr Pharmacy COGS 5010 / Cr Inventory 1030) */
    if(cogs>0 && !rx.__cogsPosted && typeof postJE==='function'){
      try{ postJE(rx.dispensedDate,'Pharmacy dispense COGS — '+rx.code,
        [{account:'5010',dr:cogs,cr:0,memo:'Cost of drugs dispensed'},{account:'1030',dr:0,cr:cogs,memo:'Pharmacy inventory released'}],'rx.dispense:'+rx.id);
        rx.__cogsPosted=true; }catch(e){}
    }
    var billCode='';
    if(billItems.length){
      var bill={ id:NID(), code:'BILL-RX'+UID(), patientId:rx.patientId, date:rx.dispensedDate, type:'Pharmacy',
        items:billItems, total:revenue, discount:0, tax:0, paid:0, balance:revenue, status:'Pending',
        notes:'Auto-generated from prescription '+rx.code+' dispensed by '+rx.dispensedBy+(notes?(' • '+notes):''),
        source:'pharmacy', sourceId:rx.id, sourceCode:rx.code };
      D_().bills=D_().bills||[]; D_().bills.push(bill);
      rx.billId=bill.id; rx.billCode=bill.code; billCode=bill.code;
      emit('bill.created',bill);
    }
    emit('pharmacy.dispensed',{id:rx.id,code:rx.code,patientId:rx.patientId,revenue:revenue,cogs:cogs,billCode:billCode});
    AUD('CLINICAL','Pharmacy','DISPENSE','Rx '+rx.code+' dispensed — COGS '+FMT(cogs)+', Revenue '+FMT(revenue)+(billCode?(' posted as '+billCode):''),'Medium');
    CLOSE(); SAVE(); RERENDER();
    TOAST('Dispensed — '+(billCode?(billCode+' ('+FMT(revenue)+') posted to Receivables'):'no charge'));
  };

  /* ═══ RENDER — professional prescription module ═══════════════════════ */
  function rxCards(list){
    if(!list.length) return '<div class="card" style="text-align:center;color:var(--txt3);padding:34px"><i class="fa-solid fa-prescription" style="font-size:30px;opacity:.3;display:block;margin-bottom:10px"></i>No prescriptions match your search.</div>';
    return list.map(function(rx){
      var p=(D_().patients||[]).find(function(x){return x.id===rx.patientId;});
      var tot=rxTotal(rx);
      var rows=(rx.items||[]).length? rx.items.map(function(it,idx){
        return '<tr><td class="bold">'+esc(it.name)+'</td><td>'+esc(it.dosage||'')+'</td><td>'+esc(it.frequency||'')+'</td><td>'+esc(it.route||'')+'</td><td>'+esc(it.duration||'')+'</td><td style="text-align:right">'+(it.qty||'')+'</td><td style="text-align:right">'+FMT(itemUnit(it))+'</td><td style="text-align:right;font-weight:700">'+FMT(itemTotal(it))+'</td>'
          +'<td><div class="act-row"><button class="act-btn" title="Edit" onclick="editMedItem('+rx.id+','+idx+')"><i class="fa-solid fa-edit"></i></button><button class="act-btn del" title="Remove" onclick="removeMedItem('+rx.id+','+idx+')"><i class="fa-solid fa-times"></i></button></div></td></tr>';
      }).join('') : '<tr><td colspan="9" style="text-align:center;color:var(--txt3);padding:18px"><i class="fa-solid fa-pills" style="margin-right:6px"></i>No medications yet — click <b>Add medication</b>.</td></tr>';
      var dispBtn = rx.status==='Active' ? '<button class="btn btn-sm" style="background:#059669;color:#fff" onclick="dispensePrescription('+rx.id+')"><i class="fa-solid fa-pills"></i> Dispense</button>' : '';
      return '<div class="card">'
        + '<div class="card-hd"><div><h3><i class="fa-solid fa-prescription" style="color:var(--pri);margin-right:8px"></i>'+esc(rx.code)+' <span style="font-weight:400;color:var(--txt3);font-size:12px;margin-left:8px">'+esc(rx.date||'')+'</span></h3>'
          + '<div style="font-size:13px;color:var(--txt2);margin-top:4px">Patient: <b>'+esc(PAT(rx.patientId))+'</b>'+(p?' <span class="twh-pill-soft">'+esc(p.mrn||'')+'</span>':'')+' · Prescriber: <b>'+esc(DOC(rx.doctorId))+'</b></div></div>'
          + '<div style="display:flex;gap:6px;align-items:center;flex-wrap:wrap"><span class="st '+STC(rx.status)+'">'+esc(rx.status)+'</span>'
            + (rx.billCode?'<span class="twh-pill-soft" title="Billed">'+esc(rx.billCode)+'</span>':'')
            + '<button class="btn btn-ghost btn-sm" onclick="addMedication('+rx.id+')"><i class="fa-solid fa-plus"></i> Add medication</button>'
            + dispBtn
            + '<button class="act-btn" title="Edit Rx" onclick="editPrescription('+rx.id+')"><i class="fa-solid fa-edit"></i></button>'
            + '<button class="act-btn print" title="Print" onclick="printRecord(\'prescriptions\','+rx.id+')"><i class="fa-solid fa-print"></i></button>'
            + '<button class="act-btn del" title="Delete" onclick="deleteRecord(\'prescriptions\','+rx.id+')"><i class="fa-solid fa-trash"></i></button></div></div>'
        + '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Medication</th><th>Dosage</th><th>Frequency</th><th>Route</th><th>Duration</th><th style="text-align:right">Qty</th><th style="text-align:right">Unit Price</th><th style="text-align:right">Line Total</th><th style="width:74px">Actions</th></tr></thead>'
          + '<tbody>'+rows+'</tbody>'
          + ((rx.items||[]).length?'<tfoot><tr style="font-weight:800"><td colspan="7" style="text-align:right">Prescription Total</td><td style="text-align:right;color:var(--pri2)">'+FMT(tot)+'</td><td></td></tr></tfoot>':'')
          + '</table></div>'
        + (rx.notes?'<div style="margin-top:8px;font-size:12px;color:var(--txt3);font-style:italic;padding:8px 12px;background:#f8fafc;border-radius:8px"><i class="fa-solid fa-info-circle" style="margin-right:4px"></i>'+esc(rx.notes)+'</div>':'')
        + '</div>';
    }).join('');
  }
  window.RXrenderList=function(){
    var f=window._rxFilter||'all', s=(window._rxSearch||'').toLowerCase();
    var list=(D_().prescriptions||[]).slice().reverse();
    if(f==='active') list=list.filter(function(r){return r.status==='Active';});
    else if(f==='dispensed') list=list.filter(function(r){return r.status==='Dispensed'||r.status==='Partially Dispensed';});
    else if(f==='expired') list=list.filter(function(r){return r.status==='Expired'||r.status==='Cancelled';});
    if(s) list=list.filter(function(r){ var p=(D_().patients||[]).find(function(x){return x.id===r.patientId;});
      return String(r.code||'').toLowerCase().indexOf(s)>=0 || (p&&String(p.fullName||'').toLowerCase().indexOf(s)>=0) || (p&&String(p.mrn||'').toLowerCase().indexOf(s)>=0); });
    var el=document.getElementById('rxListContainer'); if(el) el.innerHTML=rxCards(list);
  };
  window.renderPrescriptions=function(){
    var rxs=D_().prescriptions||[];
    var active=rxs.filter(function(r){return r.status==='Active';}).length;
    var dispensed=rxs.filter(function(r){return r.status==='Dispensed';}).length;
    var meds=rxs.reduce(function(s,r){return s+((r.items||[]).length);},0);
    var ph=D_().pharmacy||[];
    var tool=function(fn,label,icon,bg){ return (typeof window[fn]==='function')?('<button class="btn btn-sm" style="background:'+bg+';color:#fff" onclick="'+fn+'()"><i class="fa-solid '+icon+'"></i> '+label+'</button>'):''; };
    return '<div class="v28-module-hdr" style="background:linear-gradient(135deg,#0d9488,#14b8a6)">'
        + '<i class="fa-solid fa-prescription mh-icon"></i>'
        + '<div style="flex:1"><b>Prescription Management</b><span>Create scripts, manage medications &amp; pricing, then dispense and bill.</span></div>'
        + '<button class="btn btn-sm" style="background:rgba(255,255,255,.2);color:#fff;border:1px solid rgba(255,255,255,.3)" onclick="newRx()"><i class="fa-solid fa-plus"></i> New Rx</button>'
      + '</div>'
      + '<div class="kpi-grid">'
        + '<div class="v28-stat-card"><div class="vsc-label">Total Rx</div><div class="vsc-value">'+rxs.length+'</div><div class="vsc-sub">'+meds+' medications</div></div>'
        + '<div class="v28-stat-card" style="border-left-color:#10b981"><div class="vsc-label">Active</div><div class="vsc-value" style="color:#065f46">'+active+'</div><div class="vsc-sub">awaiting dispense</div></div>'
        + '<div class="v28-stat-card" style="border-left-color:#7c3aed"><div class="vsc-label">Dispensed</div><div class="vsc-value" style="color:#5b21b6">'+dispensed+'</div><div class="vsc-sub">completed</div></div>'
        + '<div class="v28-stat-card" style="border-left-color:#f59e0b"><div class="vsc-label">Pharmacy Items</div><div class="vsc-value" style="color:#b45309">'+ph.length+'</div><div class="vsc-sub">'+ph.filter(function(p){return p.stock<=p.minStock;}).length+' low stock</div></div>'
      + '</div>'
      + '<div class="v28-toolbar">'
        + '<div class="v28-grp">'
          + '<input type="text" placeholder="Search by Rx code, patient, MRN…" oninput="window._rxSearch=this.value;RXrenderList()" value="'+esc(window._rxSearch||'')+'" style="padding:7px 12px;border-radius:8px;border:1.5px solid var(--bdr);font-size:12px;min-width:240px">'
          + '<select onchange="window._rxFilter=this.value;RXrenderList()" style="padding:7px 10px;border-radius:8px;border:1.5px solid var(--bdr);font-size:11px">'
            + '<option value="all"'+((window._rxFilter||'all')==='all'?' selected':'')+'>All Rx</option>'
            + '<option value="active"'+(window._rxFilter==='active'?' selected':'')+'>Active</option>'
            + '<option value="dispensed"'+(window._rxFilter==='dispensed'?' selected':'')+'>Dispensed</option>'
            + '<option value="expired"'+(window._rxFilter==='expired'?' selected':'')+'>Expired/Cancelled</option>'
          + '</select>'
        + '</div>'
        + '<div class="v28-grp">'+tool('showDosingCalculator','Dosing Calc','fa-calculator','#0d9488')+tool('showDrugFoodInteractions','Food Int.','fa-utensils','#f59e0b')+tool('showTherapeuticDuplication','Dup Check','fa-clone','#ef4444')+'</div>'
        + '<div class="v28-grp">'+tool('showPriorAuthWorkflow','Prior Auth','fa-shield-alt','#0ea5e9')+tool('showDispensingWorkflow','Dispense Queue','fa-pills','#22c55e')+'</div>'
        + '<div class="v28-grp" style="margin-left:auto">'
          + '<button class="btn btn-ghost btn-sm" onclick="exportExcel(\'Prescriptions\',[\'code\',\'patientId\',\'doctorId\',\'date\',\'status\'],D.prescriptions)"><i class="fa-solid fa-file-excel"></i> Excel</button>'
          + '<button class="btn btn-ghost btn-sm" onclick="printTable(\'Prescriptions\',D.prescriptions,[{k:\'code\',l:\'Code\'},{k:\'patientId\',l:\'Patient\'},{k:\'doctorId\',l:\'Doctor\'},{k:\'date\',l:\'Date\'},{k:\'status\',l:\'Status\'}])"><i class="fa-solid fa-print"></i> Print</button>'
        + '</div>'
      + '</div>'
      + '<div id="rxListContainer">'+rxCards((function(){ var f=window._rxFilter||'all',s=(window._rxSearch||'').toLowerCase();var l=rxs.slice().reverse();
          if(f==='active')l=l.filter(function(r){return r.status==='Active';});else if(f==='dispensed')l=l.filter(function(r){return r.status==='Dispensed'||r.status==='Partially Dispensed';});else if(f==='expired')l=l.filter(function(r){return r.status==='Expired'||r.status==='Cancelled';});
          if(s)l=l.filter(function(r){var p=(D_().patients||[]).find(function(x){return x.id===r.patientId;});return String(r.code||'').toLowerCase().indexOf(s)>=0||(p&&String(p.fullName||'').toLowerCase().indexOf(s)>=0)||(p&&String(p.mrn||'').toLowerCase().indexOf(s)>=0);});
          return l; })())+'</div>';
  };

  /* Re-assert renderPrescriptions on a few timers so any deferred legacy
     pack that re-defines it after us cannot win the module view. */
  function reassert(){ /* our definitions are already the latest on window */ }
  reassert();

  try{ console.log('%c✅ v110 — Prescription Management (New Rx · editable price · dispense) + UI/UX polish','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/089-the-full-v110-prescription-api-these-are-the-cur.js ==== */
(function(){
  "use strict";
  /* The full v110 prescription API — these are the current window bindings at
     this synchronous point in the load (v110 ran just above), i.e. the correct
     professional implementations. */
  var LOCK=[
    'newRx','saveNewRx','rxAddLine','rxRemoveLine','rxPickDrug','rxUpdateTotal',
    'addMedication','medPick','medLineTotal','saveMedication',
    'editMedItem','emLineTotal','saveMedEdit','removeMedItem',
    'editPrescription','savePrescriptionEdit',
    'dispensePrescription','confirmDispense',
    'renderPrescriptions','RXrenderList'
  ];

  function lock(name){
    var fn = window[name];
    if(typeof fn !== 'function') return;        // nothing to lock
    try{
      Object.defineProperty(window, name, {
        configurable:true,
        enumerable:true,
        get:function(){ return fn; },
        /* swallow later re-assignments (v90/v97/etc timer reasserts) so the
           v110 professional handler remains authoritative */
        set:function(v){ /* intentionally ignored */ }
      });
    }catch(e){
      try{ window[name]=fn; }catch(_){}
    }
  }

  LOCK.forEach(lock);

  try{ console.log('%c✅ v111 — Prescription API locked (v110 handlers authoritative; "Prescription not found" timer-war fixed)','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/090-safe-helpers-2.js ==== */
(function(){
  "use strict";

  /* ── safe helpers ─────────────────────────────────────────────────────── */
  function D_(){ try{ if(typeof D!=='undefined' && D) return D; }catch(e){} return window.D||{}; }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} }
  function RERENDER(){ try{ if(typeof render==='function') render(); else if(window.render) window.render(); }catch(e){} }
  function TOAST(m,t){ try{ if(typeof toast==='function') toast(m,t||'ok'); }catch(e){} }
  function MODAL(t,b,f,s){ try{ showModal(t,b,f,s); }catch(e){} }
  function CLOSE(){ try{ closeModal(); }catch(e){} }
  function NID(){ try{ return (typeof nid==='function')?nid():(Date.now()+Math.floor(Math.random()*1000)); }catch(e){ return Date.now(); } }
  function UID(){ try{ return (typeof uid==='function')?uid():Math.random().toString(36).substr(2,6).toUpperCase(); }catch(e){ return Math.random().toString(36).substr(2,6).toUpperCase(); } }
  function TODAY(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
  function FMT(n){ try{ return (typeof F==='function')?F(n):('₦'+Number(n||0).toLocaleString()); }catch(e){ return '₦'+(n||0); } }
  function PAT(id){ try{ if(typeof pat==='function') return pat(id);}catch(e){} var p=(D_().patients||[]).find(function(x){return x.id===id;}); return p?(p.fullName||p.name||('Patient '+id)):'—'; }
  function DOC(id){ try{ if(typeof doc==='function') return doc(id);}catch(e){} var e2=(D_().employees||[]).find(function(x){return x.id===id;}); return e2?(e2.fullName||('#'+id)):'—'; }
  function STC(s){ try{ if(typeof stc==='function') return stc(s);}catch(e){} return ''; }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function emit(evt,p){ try{ if(window.SyncBus) SyncBus.emit(evt,p); }catch(e){} try{ if(typeof HMSEvents!=='undefined'&&HMSEvents.emit) HMSEvents.emit(evt,p); }catch(e){} }
  function AUD(t,m,a,d,r){ try{ if(typeof auditAction==='function') auditAction(t,m,a,d,r); }catch(e){} }
  function gv(id){ var el=document.getElementById(id); return el?el.value:''; }
  function gc(id){ var el=document.getElementById(id); return el?!!el.checked:false; }
  function actor(){ return (D_().currentUser&&D_().currentUser.fullName)||'Pharmacist'; }

  /* robust prescription resolver (number / string / code) */
  function resolveRx(rxId){
    var list=D_().prescriptions||[];
    if(rxId===undefined||rxId===null||rxId==='undefined') return null;
    return list.find(function(x){return x.id===rxId;})
        || list.find(function(x){return String(x.id)===String(rxId);})
        || list.find(function(x){return (x.code||'')===String(rxId);})
        || null;
  }

  var FREQ=['Once daily (OD)','Twice daily (BD)','Three times daily (TDS)','Four times daily (QDS)','Every 6 hours (Q6H)','Every 8 hours (Q8H)','Every 12 hours','At bedtime (Nocte)','As needed (PRN)','Before meals','After meals','Stat (once)'];
  var ROUTE=['Oral','IV','IM','SC','Topical','Rectal','Inhaler','Nebulizer','Sublingual','Eye drops','Ear drops'];
  function freqOpts(sel){ return FREQ.map(function(f){return '<option'+(sel===f?' selected':'')+'>'+esc(f)+'</option>';}).join(''); }
  function routeOpts(sel){ return ROUTE.map(function(r){return '<option'+(sel===r?' selected':'')+'>'+esc(r)+'</option>';}).join(''); }

  /* ── pharmacy pricing ─────────────────────────────────────────────────── */
  function drugByName(name){ if(!name)return null; var ph=D_().pharmacy||[],n=String(name).toLowerCase();
    return ph.find(function(d){return String(d.name||'').toLowerCase()===n;})
        || ph.find(function(d){return String(d.name||'').toLowerCase().indexOf(n)>-1 || n.indexOf(String(d.name||'').toLowerCase())>-1;})||null; }
  function drugById(id){ return (D_().pharmacy||[]).find(function(d){return d.id===id;})||null; }
  function sellPrice(d){ return d?(+d.sellingPrice||+d.price||0):0; }
  function costPrice(d){ return d?(+d.unitCost||+d.costPrice||+d.unitPrice||Math.round(sellPrice(d)*0.6)):0; }
  function itemUnit(it){ if(it&&it.unitPrice!=null&&it.unitPrice!=='') return +it.unitPrice||0; var d=it&&it.drugId?drugById(it.drugId):drugByName(it&&it.name); return sellPrice(d); }
  function itemTotal(it){ return itemUnit(it)*(parseInt(it&&it.qty)||0); }
  function rxTotal(rx){ return (rx.items||[]).reduce(function(s,it){return s+itemTotal(it);},0); }
  function pharmDatalist(){ return (D_().pharmacy||[]).slice().sort(function(a,b){return String(a.name||'').localeCompare(String(b.name||''));})
      .map(function(d){ var stk=(d.stock<=0)?'OUT':(d.stock<=d.minStock?('LOW '+d.stock):(d.stock+' in stock'));
        return '<option value="'+esc(d.name)+'">'+esc(d.name)+(d.strength?(' '+esc(d.strength)):'')+' — '+FMT(sellPrice(d))+' ['+stk+']</option>'; }).join(''); }
  function patOpts(sel){ return (D_().patients||[]).map(function(p){return '<option value="'+p.id+'"'+(String(sel)===String(p.id)?' selected':'')+'>'+esc(p.fullName||p.name)+' ['+esc(p.mrn||'')+']</option>';}).join(''); }
  function docOpts(sel){ return (D_().employees||[]).filter(function(e){return e.type==='Doctor'&&(e.status==='Active'||!e.status);}).map(function(e){return '<option value="'+e.id+'"'+(String(sel)===String(e.id)?' selected':'')+'>'+esc(e.fullName)+'</option>';}).join(''); }

  /* ═══ NEW Rx — inline multi-medication ════════════════════════════════ */
  var RXL=[], RXSEQ=0;
  function rxRow(i){
    return '<tr id="rxmRow_'+i+'">'
      +'<td><input id="rxm_name_'+i+'" list="rxm_drugs" autocomplete="off" placeholder="Drug name…" oninput="rxmPickDrug('+i+')" style="min-width:190px"></td>'
      +'<td><input id="rxm_dose_'+i+'" placeholder="500mg" style="width:90px"></td>'
      +'<td><select id="rxm_freq_'+i+'">'+freqOpts('Twice daily (BD)')+'</select></td>'
      +'<td><select id="rxm_route_'+i+'">'+routeOpts('Oral')+'</select></td>'
      +'<td><input id="rxm_dur_'+i+'" placeholder="7 days" style="width:78px"></td>'
      +'<td><input id="rxm_qty_'+i+'" type="number" min="1" value="1" oninput="rxmUpdateTotal()" style="width:62px;text-align:right"></td>'
      +'<td><input id="rxm_price_'+i+'" type="number" min="0" value="0" oninput="rxmUpdateTotal()" style="width:94px;text-align:right"></td>'
      +'<td style="text-align:center"><button type="button" class="act-btn del" title="Remove" onclick="rxmRemoveLine('+i+')"><i class="fa-solid fa-trash"></i></button></td></tr>';
  }
  window.rxmAddLine=function(){ var tb=document.getElementById('rxmLinesBody'); if(!tb)return; var i=++RXSEQ; RXL.push(i); tb.insertAdjacentHTML('beforeend',rxRow(i)); rxmUpdateTotal(); };
  window.rxmRemoveLine=function(i){ if(RXL.length<=1){TOAST('Keep at least one line','err');return;} var r=document.getElementById('rxmRow_'+i); if(r)r.parentNode.removeChild(r); RXL=RXL.filter(function(x){return x!==i;}); rxmUpdateTotal(); };
  window.rxmPickDrug=function(i){ var d=drugByName(gv('rxm_name_'+i)); if(d){ var pe=document.getElementById('rxm_price_'+i); if(pe)pe.value=sellPrice(d); var de=document.getElementById('rxm_dose_'+i); if(de&&!de.value&&d.strength)de.value=d.strength; } rxmUpdateTotal(); };
  window.rxmUpdateTotal=function(){ var t=0,n=0; RXL.forEach(function(i){ var q=parseInt(gv('rxm_qty_'+i))||0,p=parseFloat(gv('rxm_price_'+i))||0; t+=q*p; if(gv('rxm_name_'+i).trim())n++; }); var el=document.getElementById('rxmTotal'); if(el)el.textContent=FMT(t); var c=document.getElementById('rxmCount'); if(c)c.textContent=n+(n===1?' medication':' medications'); };

  window.rxmNewRx=function(){
    RXL=[]; RXSEQ=0; var first=++RXSEQ; RXL.push(first);
    var body='<div class="form-grid">'
      +'<div class="form-group"><label>Rx Code</label><input id="rxm_code" value="RX-'+esc(UID())+'" readonly style="background:#f8fafc;font-weight:700"></div>'
      +'<div class="form-group"><label>Date</label><input id="rxm_date" type="date" value="'+TODAY()+'"></div>'
      +'<div class="form-group"><label>Status</label><select id="rxm_status"><option selected>Active</option><option>Draft</option></select></div>'
      +'<div class="form-group"><label>Patient <span class="req">*</span></label><select id="rxm_patientId"><option value="">Select patient…</option>'+patOpts()+'</select></div>'
      +'<div class="form-group"><label>Prescriber (Doctor) <span class="req">*</span></label><select id="rxm_doctorId"><option value="">Select doctor…</option>'+docOpts()+'</select></div>'
      +'<div class="form-group full"><label>Clinical Notes / Instructions</label><textarea id="rxm_notes" rows="2" placeholder="e.g. Take with food; review in 2 weeks"></textarea></div>'
      +'<div class="form-section" style="grid-column:1/-1"><span>Medications</span></div>'
      +'</div>'
      +'<div class="tbl-wrap" style="margin-bottom:8px"><table class="tbl"><thead><tr><th>Medication</th><th>Dosage</th><th>Frequency</th><th>Route</th><th>Duration</th><th>Qty</th><th>Unit Price (₦)</th><th></th></tr></thead><tbody id="rxmLinesBody">'+rxRow(first)+'</tbody></table></div>'
      +'<datalist id="rxm_drugs">'+pharmDatalist()+'</datalist>'
      +'<div style="display:flex;justify-content:space-between;align-items:center">'
        +'<button type="button" class="btn btn-ghost btn-sm" onclick="rxmAddLine()"><i class="fa-solid fa-plus"></i> Add medication</button>'
        +'<div class="twh-sumbar" style="margin-top:0"><span id="rxmCount">1 medication</span> · Estimated total: <b id="rxmTotal">'+FMT(0)+'</b></div>'
      +'</div>'
      +'<div style="font-size:11px;color:var(--txt3);margin-top:8px"><i class="fa-solid fa-circle-info"></i> Prices auto-fill from the pharmacy and stay editable. Stock is deducted and the patient billed only when the Rx is <b>Dispensed</b>.</div>';
    MODAL('<i class="fa-solid fa-prescription" style="color:var(--pri);margin-right:8px"></i>New Prescription', body,
      '<button class="btn btn-pri" onclick="rxmSaveNewRx()"><i class="fa-solid fa-save"></i> Create Prescription</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
    setTimeout(rxmUpdateTotal,20);
  };
  window.rxmSaveNewRx=function(){
    var pid=parseInt(gv('rxm_patientId'),10)||null, did=parseInt(gv('rxm_doctorId'),10)||null;
    if(!pid){TOAST('Select a patient','err');return;}
    if(!did){TOAST('Select the prescriber','err');return;}
    var items=[];
    RXL.forEach(function(i){ var name=gv('rxm_name_'+i).trim(); if(!name)return; var d=drugByName(name);
      items.push({ name:name, dosage:gv('rxm_dose_'+i)||'', frequency:gv('rxm_freq_'+i)||'', route:gv('rxm_route_'+i)||'',
        duration:gv('rxm_dur_'+i)||'', qty:parseInt(gv('rxm_qty_'+i))||1, unitPrice:parseFloat(gv('rxm_price_'+i))||0,
        instructions:'', drugId:d?d.id:null, fromInventory:!!d }); });
    var rx={ id:NID(), code:gv('rxm_code')||('RX-'+UID()), patientId:pid, doctorId:did,
      date:gv('rxm_date')||TODAY(), status:gv('rxm_status')||'Active', notes:gv('rxm_notes')||'', items:items };
    D_().prescriptions=D_().prescriptions||[]; D_().prescriptions.push(rx);
    AUD('CLINICAL','Pharmacy','PRESCRIBE','New Rx '+rx.code+' for '+PAT(pid)+' — '+items.length+' medication(s)','Low');
    emit('prescription.created',{id:rx.id,code:rx.code,patientId:pid});
    CLOSE(); SAVE(); RERENDER();
    TOAST('Prescription '+rx.code+' created'+(items.length?(' — '+items.length+' medication(s)'):''));
  };

  /* ═══ ADD single medication (editable price) ══════════════════════════ */
  window.rxmAddMed=function(rxId){
    var rx=resolveRx(rxId); if(!rx){TOAST('Prescription not found','err');return;}
    var body='<div class="form-grid">'
      +'<div class="form-group full"><label>Pharmacy Item <span style="font-size:11px;color:var(--txt3)">(type to search — auto-fills price)</span></label>'
        +'<input id="rxm_pick" list="rxm_meddrugs" autocomplete="off" placeholder="Start typing a drug name…" oninput="rxmMedPick()"><datalist id="rxm_meddrugs">'+pharmDatalist()+'</datalist></div>'
      +'<div id="rxm_stockInfo" style="grid-column:1/-1;display:none;padding:9px 12px;border-radius:10px;font-size:12px"></div>'
      +'<div class="form-group"><label>Medication Name <span class="req">*</span></label><input id="rxm_mname" placeholder="Drug name"></div>'
      +'<div class="form-group"><label>Dosage <span class="req">*</span></label><input id="rxm_mdose" placeholder="e.g. 500mg"></div>'
      +'<div class="form-group"><label>Frequency <span class="req">*</span></label><select id="rxm_mfreq">'+freqOpts('Twice daily (BD)')+'</select></div>'
      +'<div class="form-group"><label>Route</label><select id="rxm_mroute">'+routeOpts('Oral')+'</select></div>'
      +'<div class="form-group"><label>Duration</label><input id="rxm_mdur" placeholder="e.g. 7 days"></div>'
      +'<div class="form-group"><label>Quantity <span class="req">*</span></label><input id="rxm_mqty" type="number" min="1" value="1" oninput="rxmMedTotal()"></div>'
      +'<div class="form-group"><label>Unit Price (₦) <span class="req">*</span></label><input id="rxm_mprice" type="number" min="0" value="0" oninput="rxmMedTotal()"></div>'
      +'<div class="form-group"><label>Line Total</label><input id="rxm_mtotal" value="'+FMT(0)+'" readonly style="background:#f8fafc;font-weight:700;color:var(--pri2)"></div>'
      +'<div class="form-group full"><label>Special Instructions</label><textarea id="rxm_minstr" rows="2" placeholder="Take with food, avoid alcohol…"></textarea></div>'
      +'</div>';
    MODAL('<i class="fa-solid fa-pills" style="color:var(--pri);margin-right:8px"></i>Add Medication — '+esc(rx.code), body,
      '<button class="btn btn-pri" onclick="rxmSaveMed('+rx.id+')"><i class="fa-solid fa-save"></i> Add Medication</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.rxmMedPick=function(){
    var d=drugByName(gv('rxm_pick')); var info=document.getElementById('rxm_stockInfo');
    if(!d){ if(info)info.style.display='none'; return; }
    var nm=document.getElementById('rxm_mname'); if(nm)nm.value=d.name;
    var dz=document.getElementById('rxm_mdose'); if(dz&&!dz.value&&d.strength)dz.value=d.strength;
    var pr=document.getElementById('rxm_mprice'); if(pr)pr.value=sellPrice(d);
    if(info){ var low=d.stock<=0,warn=d.stock<=d.minStock; var bc=low?'#dc2626':warn?'#f59e0b':'#059669',bg=low?'#fef2f2':warn?'#fffbeb':'#f0fdfa';
      info.style.display='block'; info.style.background=bg; info.style.borderLeft='4px solid '+bc;
      info.innerHTML='<b>'+esc(d.name)+'</b> ('+esc(d.category||'')+') · <b style="color:'+bc+'">'+d.stock+'</b> in stock · Price '+FMT(sellPrice(d))+' · Min '+d.minStock+(d.controlled?' · <span style="color:#7c3aed;font-weight:700">⚠ CONTROLLED</span>':''); }
    rxmMedTotal();
  };
  window.rxmMedTotal=function(){ var q=parseInt(gv('rxm_mqty'))||0,p=parseFloat(gv('rxm_mprice'))||0; var el=document.getElementById('rxm_mtotal'); if(el)el.value=FMT(q*p); };
  window.rxmSaveMed=function(rxId){
    var rx=resolveRx(rxId); if(!rx){TOAST('Prescription not found','err');return;}
    var name=gv('rxm_mname').trim(), qty=parseInt(gv('rxm_mqty'))||0, price=parseFloat(gv('rxm_mprice'))||0;
    if(!name){TOAST('Medication name required','err');return;}
    if(!qty){TOAST('Quantity required','err');return;}
    var d=drugByName(gv('rxm_pick'))||drugByName(name);
    rx.items=rx.items||[];
    rx.items.push({ name:name, dosage:gv('rxm_mdose'), frequency:gv('rxm_mfreq'), route:gv('rxm_mroute'),
      duration:gv('rxm_mdur'), qty:qty, unitPrice:price, instructions:gv('rxm_minstr')||'',
      drugId:d?d.id:null, fromInventory:!!d });
    if(rx.status!=='Active'&&rx.status!=='Dispensed') rx.status='Active';
    AUD('CLINICAL','Pharmacy','PRESCRIBE','Added '+qty+'× '+name+' @ '+FMT(price)+' to '+rx.code,'Low');
    TOAST('Added to '+rx.code+' — dispense to deduct stock & bill'); CLOSE(); SAVE(); RERENDER();
  };

  /* ═══ EDIT / REMOVE medication line ═══════════════════════════════════ */
  window.rxmEditMed=function(rxId,idx){
    var rx=resolveRx(rxId); if(!rx||!rx.items||!rx.items[idx])return; var it=rx.items[idx];
    var body='<div class="form-grid">'
      +'<div class="form-group"><label>Medication Name</label><input id="rxm_ename" value="'+esc(it.name)+'"></div>'
      +'<div class="form-group"><label>Dosage</label><input id="rxm_edose" value="'+esc(it.dosage||'')+'"></div>'
      +'<div class="form-group"><label>Frequency</label><select id="rxm_efreq">'+freqOpts(it.frequency)+'</select></div>'
      +'<div class="form-group"><label>Route</label><select id="rxm_eroute">'+routeOpts(it.route)+'</select></div>'
      +'<div class="form-group"><label>Duration</label><input id="rxm_edur" value="'+esc(it.duration||'')+'"></div>'
      +'<div class="form-group"><label>Quantity</label><input id="rxm_eqty" type="number" min="1" value="'+(it.qty||1)+'" oninput="rxmEmTotal()"></div>'
      +'<div class="form-group"><label>Unit Price (₦)</label><input id="rxm_eprice" type="number" min="0" value="'+itemUnit(it)+'" oninput="rxmEmTotal()"></div>'
      +'<div class="form-group"><label>Line Total</label><input id="rxm_etotal" value="'+FMT(itemTotal(it))+'" readonly style="background:#f8fafc;font-weight:700;color:var(--pri2)"></div>'
      +'<div class="form-group full"><label>Special Instructions</label><textarea id="rxm_einstr" rows="2">'+esc(it.instructions||'')+'</textarea></div>'
      +'</div>';
    MODAL('<i class="fa-solid fa-edit" style="color:var(--pri);margin-right:8px"></i>Edit Medication', body,
      '<button class="btn btn-pri" onclick="rxmSaveMedEdit('+rx.id+','+idx+')"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.rxmEmTotal=function(){ var q=parseInt(gv('rxm_eqty'))||0,p=parseFloat(gv('rxm_eprice'))||0; var el=document.getElementById('rxm_etotal'); if(el)el.value=FMT(q*p); };
  window.rxmSaveMedEdit=function(rxId,idx){
    var rx=resolveRx(rxId); if(!rx||!rx.items||!rx.items[idx])return; var it=rx.items[idx];
    it.name=gv('rxm_ename'); it.dosage=gv('rxm_edose'); it.frequency=gv('rxm_efreq'); it.route=gv('rxm_eroute');
    it.duration=gv('rxm_edur'); it.qty=parseInt(gv('rxm_eqty'))||1; it.unitPrice=parseFloat(gv('rxm_eprice'))||0; it.instructions=gv('rxm_einstr')||'';
    if(it.drugId==null){ var d=drugByName(it.name); if(d){it.drugId=d.id;it.fromInventory=true;} }
    TOAST('Medication updated'); CLOSE(); SAVE(); RERENDER();
  };
  window.rxmRemoveMed=function(rxId,idx){ var rx=resolveRx(rxId); if(!rx)return; rx.items.splice(idx,1); TOAST('Medication removed','err'); SAVE(); RERENDER(); };

  /* ═══ EDIT prescription header ════════════════════════════════════════ */
  window.rxmEditRx=function(id){
    var rx=resolveRx(id); if(!rx)return;
    var st=['Active','Dispensed','Partially Dispensed','Expired','Cancelled'].map(function(s){return '<option'+(s===rx.status?' selected':'')+'>'+s+'</option>';}).join('');
    var body='<div class="form-grid">'
      +'<div class="form-group"><label>Rx Code</label><input value="'+esc(rx.code)+'" readonly style="background:#f8fafc;font-weight:700"></div>'
      +'<div class="form-group"><label>Date</label><input id="rxm_xdate" type="date" value="'+esc(rx.date||TODAY())+'"></div>'
      +'<div class="form-group"><label>Patient <span class="req">*</span></label><select id="rxm_xpat">'+patOpts(rx.patientId)+'</select></div>'
      +'<div class="form-group"><label>Prescriber (Doctor) <span class="req">*</span></label><select id="rxm_xdoc">'+docOpts(rx.doctorId)+'</select></div>'
      +'<div class="form-group"><label>Status</label><select id="rxm_xstatus">'+st+'</select></div>'
      +'<div class="form-group full"><label>Notes</label><textarea id="rxm_xnotes" rows="3">'+esc(rx.notes||'')+'</textarea></div>'
      +'</div>';
    MODAL('<i class="fa-solid fa-edit" style="color:var(--pri);margin-right:8px"></i>Edit Prescription '+esc(rx.code), body,
      '<button class="btn btn-pri" onclick="rxmSaveRx('+rx.id+')"><i class="fa-solid fa-save"></i> Save Changes</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  };
  window.rxmSaveRx=function(id){
    var rx=resolveRx(id); if(!rx)return;
    rx.patientId=parseInt(gv('rxm_xpat'))||rx.patientId; rx.doctorId=parseInt(gv('rxm_xdoc'))||rx.doctorId;
    rx.date=gv('rxm_xdate')||rx.date; rx.status=gv('rxm_xstatus')||rx.status; rx.notes=gv('rxm_xnotes');
    TOAST('Prescription updated'); CLOSE(); SAVE(); RERENDER();
  };

  /* ═══ DISPENSE (+ optional immediate payment / transaction) ═══════════ */
  window.rxmDispense=function(rxId){
    var rx=resolveRx(rxId); if(!rx){TOAST('Prescription not found','err');return;}
    if(!rx.items||!rx.items.length){TOAST('No medications to dispense','err');return;}
    if(rx.status==='Dispensed'){TOAST('Already dispensed','err');return;}
    var rows='',total=0,anyIssue=false;
    rx.items.forEach(function(it){ var d=it.drugId?drugById(it.drugId):drugByName(it.name); var q=parseInt(it.qty)||1;
      var unit=itemUnit(it), line=unit*q; total+=line; var ok=!d?false:(d.stock>=q); if(!ok)anyIssue=true;
      var stk=d?(ok?'<span class="st st-active">'+d.stock+' in stock</span>':'<span class="st st-critical">only '+d.stock+'</span>'):'<span class="st st-draft">no inventory match</span>';
      rows+='<tr><td class="bold">'+esc(it.name)+'</td><td>'+esc(it.dosage||'')+'</td><td style="text-align:right">'+q+'</td><td style="text-align:right">'+FMT(unit)+'</td><td style="text-align:right;font-weight:700">'+FMT(line)+'</td><td>'+stk+'</td></tr>'; });
    var body='<div class="twh-sumbar" style="margin:0 0 12px"><span><b style="color:var(--txt)">'+esc(PAT(rx.patientId))+'</b> · '+esc(rx.code)+' · prescribed by '+esc(DOC(rx.doctorId))+'</span><span>Total: <b>'+FMT(total)+'</b></span></div>'
      +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Medication</th><th>Dosage</th><th style="text-align:right">Qty</th><th style="text-align:right">Unit Price</th><th style="text-align:right">Line Total</th><th>Stock</th></tr></thead><tbody>'+rows
      +'</tbody><tfoot><tr style="font-weight:800"><td colspan="4" style="text-align:right">Total Charge</td><td style="text-align:right;color:var(--pri2)">'+FMT(total)+'</td><td></td></tr></tfoot></table></div>'
      +(anyIssue?'<div style="margin-top:10px;padding:10px;background:#fffbeb;border:1px solid #fde68a;border-radius:8px;color:#92400e;font-size:12px"><i class="fa-solid fa-exclamation-triangle"></i> Some items have no/low inventory match. Dispensing deducts what is available; unmatched items are still billed at the entered price.</div>':'')
      +'<div class="form-grid" style="margin-top:12px">'
        +'<div class="form-group full"><label>Dispensing Notes</label><textarea id="rxm_dispnotes" rows="2" placeholder="Counselling / batch / pharmacist notes…"></textarea></div>'
        +'<div class="form-section" style="grid-column:1/-1"><span>Payment</span></div>'
        +'<div class="form-group"><label>Collect payment now?</label><select id="rxm_collect" onchange="rxmToggleCollect()"><option value="no" selected>No — bill to Receivables (pay at cashier)</option><option value="yes">Yes — collect now</option></select></div>'
        +'<div class="form-group" id="rxm_payMethodWrap" style="display:none"><label>Payment Method</label><select id="rxm_payMethod"><option>Cash</option><option>POS / Card</option><option>Bank Transfer</option><option>Mobile Money</option><option>Insurance</option></select></div>'
      +'</div>';
    MODAL('<i class="fa-solid fa-pills" style="color:#059669;margin-right:8px"></i>Dispense '+esc(rx.code), body,
      '<button class="btn btn-pri" style="background:#059669" onclick="rxmConfirmDispense('+rx.id+')"><i class="fa-solid fa-check"></i> Confirm Dispense</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
  };
  window.rxmToggleCollect=function(){ var w=document.getElementById('rxm_payMethodWrap'); if(w)w.style.display=(gv('rxm_collect')==='yes')?'':'none'; };
  window.rxmConfirmDispense=function(rxId){
    var rx=resolveRx(rxId); if(!rx)return;
    if(rx.status==='Dispensed'){TOAST('Already dispensed','err');return;}
    var notes=gv('rxm_dispnotes')||'', collect=(gv('rxm_collect')==='yes'), method=gv('rxm_payMethod')||'Cash';
    var cogs=0,revenue=0,billItems=[];
    (rx.items||[]).forEach(function(it){ var d=it.drugId?drugById(it.drugId):drugByName(it.name); var q=parseInt(it.qty)||1;
      var unit=itemUnit(it), line=unit*q; revenue+=line;
      if(d){ d.stock=Math.max(0,(d.stock||0)-q); cogs+=costPrice(d)*q; }
      billItems.push({ s:esc(it.name)+' × '+q+' @ '+FMT(unit), a:line, category:'Pharmacy', drugId:d?d.id:null, qty:q, unitPrice:unit }); });
    rx.status='Dispensed'; rx.dispensedDate=TODAY(); rx.dispensedBy=actor(); if(notes)rx.dispenseNotes=notes;
    /* COGS GL */
    if(cogs>0 && !rx.__cogsPosted && typeof postJE==='function'){
      try{ postJE(rx.dispensedDate,'Pharmacy dispense COGS — '+rx.code,
        [{account:'5010',dr:cogs,cr:0,memo:'Cost of drugs dispensed'},{account:'1030',dr:0,cr:cogs,memo:'Pharmacy inventory released'}],'rx.dispense:'+rx.id);
        rx.__cogsPosted=true; }catch(e){} }
    /* Bill */
    var billCode='', bill=null;
    if(billItems.length){
      var paidNow=collect?revenue:0;
      bill={ id:NID(), code:'BILL-RX'+UID(), patientId:rx.patientId, date:rx.dispensedDate, type:'Pharmacy',
        items:billItems, total:revenue, discount:0, tax:0, paid:paidNow, balance:revenue-paidNow,
        status:(collect?'Paid':'Pending'),
        notes:'Auto-generated from prescription '+rx.code+' dispensed by '+rx.dispensedBy+(notes?(' • '+notes):''),
        source:'pharmacy', sourceId:rx.id, sourceCode:rx.code };
      D_().bills=D_().bills||[]; D_().bills.push(bill);
      rx.billId=bill.id; rx.billCode=bill.code; billCode=bill.code; emit('bill.created',bill);
    }
    /* Transaction (only when collecting payment now) */
    var txnCode='';
    if(collect && revenue>0){
      var txn={ id:NID(), code:'TXN-'+UID(), type:'Payment', method:method, patientId:rx.patientId,
        amount:revenue, status:'Completed', date:rx.dispensedDate, cashier:rx.dispensedBy,
        reference:'', category:'Laboratory'==='x'?'':'Pharmacy', billCode:billCode,
        notes:'Pharmacy dispense payment for '+rx.code };
      txn.category='Pharmacy';
      D_().transactions=D_().transactions||[]; D_().transactions.push(txn); txnCode=txn.code;
      emit('payment.recorded',{id:txn.id,code:txn.code,amount:revenue,billCode:billCode,patientId:rx.patientId});
      emit('transaction.created',txn);
      AUD('FINANCE','Payments','CREATE','Pharmacy payment '+txn.code+' '+FMT(revenue)+' ('+method+') for '+rx.code,'Medium');
    }
    emit('pharmacy.dispensed',{id:rx.id,code:rx.code,patientId:rx.patientId,revenue:revenue,cogs:cogs,billCode:billCode});
    AUD('CLINICAL','Pharmacy','DISPENSE','Rx '+rx.code+' dispensed — COGS '+FMT(cogs)+', Revenue '+FMT(revenue)+(billCode?(' billed '+billCode):'')+(txnCode?(' paid '+txnCode):''),'Medium');
    CLOSE(); SAVE(); RERENDER();
    TOAST(collect ? ('Dispensed & paid — '+FMT(revenue)+' ('+method+'), '+billCode+' settled')
                  : ('Dispensed — '+(billCode?(billCode+' ('+FMT(revenue)+') posted to Receivables'):'no charge')));
  };

  /* ═══ RENDER — professional view, wired to rxm* handlers ══════════════ */
  function rxCard(rx){
    var p=(D_().patients||[]).find(function(x){return x.id===rx.patientId;}); var tot=rxTotal(rx);
    var rows=(rx.items||[]).length? rx.items.map(function(it,idx){
      return '<tr><td class="bold">'+esc(it.name)+'</td><td>'+esc(it.dosage||'')+'</td><td>'+esc(it.frequency||'')+'</td><td>'+esc(it.route||'')+'</td><td>'+esc(it.duration||'')+'</td><td style="text-align:right">'+(it.qty||'')+'</td><td style="text-align:right">'+FMT(itemUnit(it))+'</td><td style="text-align:right;font-weight:700">'+FMT(itemTotal(it))+'</td>'
        +'<td><div class="act-row"><button class="act-btn" title="Edit" onclick="rxmEditMed('+rx.id+','+idx+')"><i class="fa-solid fa-edit"></i></button><button class="act-btn del" title="Remove" onclick="rxmRemoveMed('+rx.id+','+idx+')"><i class="fa-solid fa-times"></i></button></div></td></tr>';
    }).join('') : '<tr><td colspan="9" style="text-align:center;color:var(--txt3);padding:18px"><i class="fa-solid fa-pills" style="margin-right:6px"></i>No medications yet — click <b>Add medication</b>.</td></tr>';
    var dispBtn = rx.status==='Active' ? '<button class="btn btn-sm" style="background:#059669;color:#fff" onclick="rxmDispense('+rx.id+')"><i class="fa-solid fa-pills"></i> Dispense</button>' : '';
    return '<div class="card">'
      +'<div class="card-hd"><div><h3><i class="fa-solid fa-prescription" style="color:var(--pri);margin-right:8px"></i>'+esc(rx.code)+' <span style="font-weight:400;color:var(--txt3);font-size:12px;margin-left:8px">'+esc(rx.date||'')+'</span></h3>'
        +'<div style="font-size:13px;color:var(--txt2);margin-top:4px">Patient: <b>'+esc(PAT(rx.patientId))+'</b>'+(p?' <span class="twh-pill-soft">'+esc(p.mrn||'')+'</span>':'')+' · Prescriber: <b>'+esc(DOC(rx.doctorId))+'</b></div></div>'
        +'<div style="display:flex;gap:6px;align-items:center;flex-wrap:wrap"><span class="st '+STC(rx.status)+'">'+esc(rx.status)+'</span>'
          +(rx.billCode?'<span class="twh-pill-soft" title="Billed">'+esc(rx.billCode)+'</span>':'')
          +'<button class="btn btn-ghost btn-sm" onclick="rxmAddMed('+rx.id+')"><i class="fa-solid fa-plus"></i> Add medication</button>'
          +dispBtn
          +'<button class="act-btn" title="Edit Rx" onclick="rxmEditRx('+rx.id+')"><i class="fa-solid fa-edit"></i></button>'
          +'<button class="act-btn print" title="Print" onclick="printRecord(\'prescriptions\','+rx.id+')"><i class="fa-solid fa-print"></i></button>'
          +'<button class="act-btn del" title="Delete" onclick="deleteRecord(\'prescriptions\','+rx.id+')"><i class="fa-solid fa-trash"></i></button></div></div>'
      +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Medication</th><th>Dosage</th><th>Frequency</th><th>Route</th><th>Duration</th><th style="text-align:right">Qty</th><th style="text-align:right">Unit Price</th><th style="text-align:right">Line Total</th><th style="width:74px">Actions</th></tr></thead>'
        +'<tbody>'+rows+'</tbody>'
        +((rx.items||[]).length?'<tfoot><tr style="font-weight:800"><td colspan="7" style="text-align:right">Prescription Total</td><td style="text-align:right;color:var(--pri2)">'+FMT(tot)+'</td><td></td></tr></tfoot>':'')
        +'</table></div>'
      +(rx.notes?'<div style="margin-top:8px;font-size:12px;color:var(--txt3);font-style:italic;padding:8px 12px;background:#f8fafc;border-radius:8px"><i class="fa-solid fa-info-circle" style="margin-right:4px"></i>'+esc(rx.notes)+'</div>':'')
      +'</div>';
  }
  function filtered(){
    var f=window._rxFilter||'all', s=(window._rxSearch||'').toLowerCase();
    var l=(D_().prescriptions||[]).slice().reverse();
    if(f==='active')l=l.filter(function(r){return r.status==='Active';});
    else if(f==='dispensed')l=l.filter(function(r){return r.status==='Dispensed'||r.status==='Partially Dispensed';});
    else if(f==='expired')l=l.filter(function(r){return r.status==='Expired'||r.status==='Cancelled';});
    if(s)l=l.filter(function(r){ var p=(D_().patients||[]).find(function(x){return x.id===r.patientId;});
      return String(r.code||'').toLowerCase().indexOf(s)>=0||(p&&String(p.fullName||'').toLowerCase().indexOf(s)>=0)||(p&&String(p.mrn||'').toLowerCase().indexOf(s)>=0); });
    return l;
  }
  function cards(list){ if(!list.length) return '<div class="card" style="text-align:center;color:var(--txt3);padding:34px"><i class="fa-solid fa-prescription" style="font-size:30px;opacity:.3;display:block;margin-bottom:10px"></i>No prescriptions match your search.</div>'; return list.map(rxCard).join(''); }
  window.rxmRenderList=function(){ var el=document.getElementById('rxListContainer'); if(el) el.innerHTML=cards(filtered()); };
  window.rxmRender=function(){
    var rxs=D_().prescriptions||[];
    var active=rxs.filter(function(r){return r.status==='Active';}).length;
    var dispensed=rxs.filter(function(r){return r.status==='Dispensed';}).length;
    var meds=rxs.reduce(function(s,r){return s+((r.items||[]).length);},0);
    var ph=D_().pharmacy||[];
    var tool=function(fn,label,icon,bg){ return (typeof window[fn]==='function')?('<button class="btn btn-sm" style="background:'+bg+';color:#fff" onclick="'+fn+'()"><i class="fa-solid '+icon+'"></i> '+label+'</button>'):''; };
    return '<div class="v28-module-hdr" style="background:linear-gradient(135deg,#0d9488,#14b8a6)">'
        +'<i class="fa-solid fa-prescription mh-icon"></i>'
        +'<div style="flex:1"><b>Prescription Management</b><span>Create scripts, manage medications &amp; pricing, dispense and take payment.</span></div>'
        +'<button class="btn btn-sm" style="background:rgba(255,255,255,.2);color:#fff;border:1px solid rgba(255,255,255,.3)" onclick="rxmNewRx()"><i class="fa-solid fa-plus"></i> New Rx</button>'
      +'</div>'
      +'<div class="kpi-grid">'
        +'<div class="v28-stat-card"><div class="vsc-label">Total Rx</div><div class="vsc-value">'+rxs.length+'</div><div class="vsc-sub">'+meds+' medications</div></div>'
        +'<div class="v28-stat-card" style="border-left-color:#10b981"><div class="vsc-label">Active</div><div class="vsc-value" style="color:#065f46">'+active+'</div><div class="vsc-sub">awaiting dispense</div></div>'
        +'<div class="v28-stat-card" style="border-left-color:#7c3aed"><div class="vsc-label">Dispensed</div><div class="vsc-value" style="color:#5b21b6">'+dispensed+'</div><div class="vsc-sub">completed</div></div>'
        +'<div class="v28-stat-card" style="border-left-color:#f59e0b"><div class="vsc-label">Pharmacy Items</div><div class="vsc-value" style="color:#b45309">'+ph.length+'</div><div class="vsc-sub">'+ph.filter(function(p){return p.stock<=p.minStock;}).length+' low stock</div></div>'
      +'</div>'
      +'<div class="v28-toolbar">'
        +'<div class="v28-grp">'
          +'<input type="text" placeholder="Search by Rx code, patient, MRN…" oninput="window._rxSearch=this.value;rxmRenderList()" value="'+esc(window._rxSearch||'')+'" style="padding:7px 12px;border-radius:8px;border:1.5px solid var(--bdr);font-size:12px;min-width:240px">'
          +'<select onchange="window._rxFilter=this.value;rxmRenderList()" style="padding:7px 10px;border-radius:8px;border:1.5px solid var(--bdr);font-size:11px">'
            +'<option value="all"'+((window._rxFilter||'all')==='all'?' selected':'')+'>All Rx</option>'
            +'<option value="active"'+(window._rxFilter==='active'?' selected':'')+'>Active</option>'
            +'<option value="dispensed"'+(window._rxFilter==='dispensed'?' selected':'')+'>Dispensed</option>'
            +'<option value="expired"'+(window._rxFilter==='expired'?' selected':'')+'>Expired/Cancelled</option>'
          +'</select>'
        +'</div>'
        +'<div class="v28-grp">'+tool('showDosingCalculator','Dosing Calc','fa-calculator','#0d9488')+tool('showDrugFoodInteractions','Food Int.','fa-utensils','#f59e0b')+tool('showTherapeuticDuplication','Dup Check','fa-clone','#ef4444')+'</div>'
        +'<div class="v28-grp" style="margin-left:auto">'
          +'<button class="btn btn-ghost btn-sm" onclick="exportExcel(\'Prescriptions\',[\'code\',\'patientId\',\'doctorId\',\'date\',\'status\'],D.prescriptions)"><i class="fa-solid fa-file-excel"></i> Excel</button>'
          +'<button class="btn btn-ghost btn-sm" onclick="printTable(\'Prescriptions\',D.prescriptions,[{k:\'code\',l:\'Code\'},{k:\'patientId\',l:\'Patient\'},{k:\'doctorId\',l:\'Doctor\'},{k:\'date\',l:\'Date\'},{k:\'status\',l:\'Status\'}])"><i class="fa-solid fa-print"></i> Print</button>'
        +'</div>'
      +'</div>'
      +'<div id="rxListContainer">'+cards(filtered())+'</div>';
  };

  /* ── Make the rxm* handlers AUTHORITATIVE ─────────────────────────────
     Earlier packs (incl. the v111 lock) may have defined these names as
     accessors or keep re-assigning them on timers. We install our working
     handlers behind a getter with a no-op setter so:
       • the module view (bare renderPrescriptions()) returns rxmRender, and
       • any later plain re-assignment (v97 timers, etc.) is silently ignored.
     defineProperty is allowed because the prior locks are configurable. */
  function lockTo(name, fn){
    try{
      Object.defineProperty(window, name, {
        configurable:true, enumerable:true,
        get:function(){ return fn; },
        set:function(v){ /* ignore later overrides — rxm* stays authoritative */ }
      });
    }catch(e){ try{ window[name]=fn; }catch(_){ } }
  }
  /* the module view */
  lockTo('renderPrescriptions', rxmRender);
  lockTo('RXrenderList', rxmRenderList);
  /* point every legacy shared name at the working handler, so ANY caller
     (cards, patient profile, deep links) reaches the fixed flow */
  lockTo('newRx', rxmNewRx);
  lockTo('addMedication', rxmAddMed);
  lockTo('saveMedication', rxmSaveMed);
  lockTo('dispensePrescription', rxmDispense);
  lockTo('confirmDispense', rxmConfirmDispense);
  lockTo('editMedItem', rxmEditMed);
  lockTo('saveMedEdit', rxmSaveMedEdit);
  lockTo('removeMedItem', rxmRemoveMed);
  lockTo('editPrescription', rxmEditRx);
  lockTo('savePrescriptionEdit', rxmSaveRx);

  try{ console.log('%c✅ v112 — Prescription module rebuilt under conflict-proof rxm* names; Add Medication fixed; dispense can collect payment','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/091-d.js ==== */
(function(){
  "use strict";

  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||{}; }
  function TOAST(m,t){ try{ if(typeof toast==='function') toast(m,t||'ok'); }catch(e){} }
  function MODAL(t,b,f,s){ try{ showModal(t,b,f,s); }catch(e){} }
  function CLOSE(){ try{ closeModal(); }catch(e){} }
  function FMT(n){ try{ return (typeof F==='function')?F(n):('₦'+Number(n||0).toLocaleString()); }catch(e){ return '₦'+(n||0); } }
  function TODAY(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
  function PAT(id){ try{ if(typeof pat==='function') return pat(id);}catch(e){} var p=(D_().patients||[]).find(function(x){return x.id===id;}); return p?(p.fullName||p.name||('Patient '+id)):'—'; }
  function DOC(id){ try{ if(typeof doc==='function') return doc(id);}catch(e){} var e2=(D_().employees||[]).find(function(x){return x.id===id;}); return e2?(e2.fullName||('#'+id)):'—'; }
  function STC(s){ try{ if(typeof stc==='function') return stc(s);}catch(e){} return ''; }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function gv(id){ var el=document.getElementById(id); return el?el.value:''; }
  function gc(id){ var el=document.getElementById(id); return el?!!el.checked:false; }

  function resolveRx(rxId){ var list=D_().prescriptions||[]; if(rxId==null||rxId==='undefined')return null;
    return list.find(function(x){return x.id===rxId;})||list.find(function(x){return String(x.id)===String(rxId);})||list.find(function(x){return (x.code||'')===String(rxId);})||null; }

  /* pricing (mirror v112) */
  function drugById(id){ return (D_().pharmacy||[]).find(function(d){return d.id===id;})||null; }
  function drugByName(name){ if(!name)return null; var ph=D_().pharmacy||[],n=String(name).toLowerCase();
    return ph.find(function(d){return String(d.name||'').toLowerCase()===n;})||ph.find(function(d){return String(d.name||'').toLowerCase().indexOf(n)>-1||n.indexOf(String(d.name||'').toLowerCase())>-1;})||null; }
  function sellPrice(d){ return d?(+d.sellingPrice||+d.price||0):0; }
  function itemUnit(it){ if(it&&it.unitPrice!=null&&it.unitPrice!=='') return +it.unitPrice||0; var d=it&&it.drugId?drugById(it.drugId):drugByName(it&&it.name); return sellPrice(d); }
  function itemTotal(it){ return itemUnit(it)*(parseInt(it&&it.qty)||0); }
  function rxTotal(rx){ return (rx.items||[]).reduce(function(s,it){return s+itemTotal(it);},0); }
  function stockOK(rx){ return (rx.items||[]).every(function(it){ var d=it.drugId?drugById(it.drugId):drugByName(it.name); return d?d.stock>=(parseInt(it.qty)||1):false; }); }

  /* ═══ DISPENSING QUEUE ════════════════════════════════════════════════ */
  function queueRows(){
    var s=(window._rxmQF||'').toLowerCase();
    var pend=(D_().prescriptions||[]).filter(function(r){return r.status==='Active'&&(r.items||[]).length;});
    if(s) pend=pend.filter(function(r){ var p=(D_().patients||[]).find(function(x){return x.id===r.patientId;});
      return String(r.code||'').toLowerCase().indexOf(s)>=0||(p&&String(p.fullName||'').toLowerCase().indexOf(s)>=0)||(p&&String(p.mrn||'').toLowerCase().indexOf(s)>=0); });
    if(!pend.length) return '<tr><td colspan="7" style="text-align:center;color:var(--txt3);padding:22px"><i class="fa-solid fa-circle-check" style="margin-right:6px;color:#22c55e"></i>No prescriptions awaiting dispensing.</td></tr>';
    return pend.map(function(r){
      var ready=stockOK(r);
      var badge=ready?'<span class="st st-active">Ready</span>':'<span class="st st-partial">Check stock</span>';
      return '<tr><td><b>'+esc(r.code)+'</b></td><td>'+esc(PAT(r.patientId))+'</td><td>'+esc(DOC(r.doctorId))+'</td><td>'+esc(r.date||'')+'</td><td style="text-align:center">'+(r.items||[]).length+'</td><td style="text-align:right;font-weight:700">'+FMT(rxTotal(r))+'</td>'
        +'<td style="white-space:nowrap">'+badge+' <button class="btn btn-sm" style="background:#059669;color:#fff" onclick="rxmQueueDispense('+r.id+')"><i class="fa-solid fa-pills"></i> Dispense</button></td></tr>';
    }).join('');
  }
  function dispensedTodayRows(){
    var t=TODAY();
    var done=(D_().prescriptions||[]).filter(function(r){return r.status==='Dispensed'&&r.dispensedDate===t;});
    if(!done.length) return '<tr><td colspan="6" style="text-align:center;color:var(--txt3);padding:16px">None dispensed yet today.</td></tr>';
    return done.map(function(r){
      var bill=(D_().bills||[]).find(function(b){return b.code===r.billCode;});
      var paid=bill&&bill.status==='Paid';
      return '<tr><td><b>'+esc(r.code)+'</b></td><td>'+esc(PAT(r.patientId))+'</td><td style="text-align:right;font-weight:700">'+FMT(rxTotal(r))+'</td><td>'+(r.billCode?('<span class="twh-pill-soft">'+esc(r.billCode)+'</span>'):'—')+'</td><td>'+(bill?('<span class="st '+(paid?'st-active':'st-partial')+'">'+esc(bill.status)+'</span>'):'—')+'</td>'
        +'<td><button class="act-btn" title="View" onclick="viewRecord(\'prescriptions\','+r.id+')"><i class="fa-solid fa-eye"></i></button><button class="act-btn print" title="Print" onclick="printRecord(\'prescriptions\','+r.id+')"><i class="fa-solid fa-print"></i></button></td></tr>';
    }).join('');
  }
  window.rxmQueueRefresh=function(){
    var b=document.getElementById('rxmQueueBody'); if(b) b.innerHTML=queueRows();
    var d=document.getElementById('rxmDoneBody'); if(d) d.innerHTML=dispensedTodayRows();
  };
  window.rxmDispenseQueue=function(){
    window._rxmFromQueue=false;
    var rxs=D_().prescriptions||[];
    var pend=rxs.filter(function(r){return r.status==='Active'&&(r.items||[]).length;});
    var pendVal=pend.reduce(function(s,r){return s+rxTotal(r);},0);
    var doneToday=rxs.filter(function(r){return r.status==='Dispensed'&&r.dispensedDate===TODAY();}).length;
    var body=''
      +'<div class="kpi-grid" style="margin-bottom:12px">'
        +'<div class="v28-stat-card" style="border-left-color:#059669"><div class="vsc-label">Awaiting Dispense</div><div class="vsc-value" style="color:#065f46">'+pend.length+'</div><div class="vsc-sub">'+FMT(pendVal)+' value</div></div>'
        +'<div class="v28-stat-card" style="border-left-color:#7c3aed"><div class="vsc-label">Dispensed Today</div><div class="vsc-value" style="color:#5b21b6">'+doneToday+'</div><div class="vsc-sub">'+TODAY()+'</div></div>'
        +'<div class="v28-stat-card" style="border-left-color:#f59e0b"><div class="vsc-label">Pharmacy Items</div><div class="vsc-value" style="color:#b45309">'+(D_().pharmacy||[]).length+'</div><div class="vsc-sub">'+(D_().pharmacy||[]).filter(function(p){return p.stock<=p.minStock;}).length+' low stock</div></div>'
      +'</div>'
      +'<div style="margin-bottom:8px"><input type="text" placeholder="Search queue by Rx code, patient or MRN…" oninput="window._rxmQF=this.value;rxmQueueRefresh()" value="'+esc(window._rxmQF||'')+'" style="width:100%;padding:8px 12px;border:1.5px solid var(--bdr);border-radius:10px;font-size:13px"></div>'
      +'<div style="font-weight:700;color:var(--pri2);font-size:13px;margin:4px 0 6px"><i class="fa-solid fa-list-check" style="margin-right:6px"></i>Queue — awaiting dispensing</div>'
      +'<div class="tbl-wrap" style="margin-bottom:16px"><table class="tbl"><thead><tr><th>Rx Code</th><th>Patient</th><th>Prescriber</th><th>Date</th><th style="text-align:center">Meds</th><th style="text-align:right">Value</th><th>Action</th></tr></thead><tbody id="rxmQueueBody">'+queueRows()+'</tbody></table></div>'
      +'<div style="font-weight:700;color:var(--pri2);font-size:13px;margin:4px 0 6px"><i class="fa-solid fa-circle-check" style="margin-right:6px"></i>Dispensed today</div>'
      +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Rx Code</th><th>Patient</th><th style="text-align:right">Value</th><th>Bill</th><th>Payment</th><th>Actions</th></tr></thead><tbody id="rxmDoneBody">'+dispensedTodayRows()+'</tbody></table></div>';
    MODAL('<i class="fa-solid fa-pills" style="color:#059669;margin-right:8px"></i>Dispensing Workflow — Pharmacy Queue', body,
      '<button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide');
  };
  /* launch the guided dispense from the queue and return to the queue after */
  window.rxmQueueDispense=function(rxId){ window._rxmFromQueue=true; try{ window.rxmDispense(rxId); }catch(e){ TOAST('Unable to open dispense','err'); } };

  /* ═══ Guided DISPENSE dialog (verification → stock → bill → complete) ══ */
  var V112_dispense = window.rxmDispense;        /* keep v112 reference (unused fallback) */
  var V112_confirm  = window.rxmConfirmDispense; /* the financial engine */

  window.rxmDispense=function(rxId){
    var rx=resolveRx(rxId); if(!rx){TOAST('Prescription not found','err');return;}
    if(!rx.items||!rx.items.length){TOAST('No medications to dispense','err');return;}
    if(rx.status==='Dispensed'){TOAST('Already dispensed','err');return;}
    var p=(D_().patients||[]).find(function(x){return x.id===rx.patientId;});
    var allergies=(p&&p.allergies&&p.allergies!=='None')?p.allergies:'';
    var rows='',total=0,anyIssue=false;
    rx.items.forEach(function(it){ var d=it.drugId?drugById(it.drugId):drugByName(it.name); var q=parseInt(it.qty)||1;
      var unit=itemUnit(it),line=unit*q; total+=line; var ok=!d?false:(d.stock>=q); if(!ok)anyIssue=true;
      var stk=d?(ok?'<span class="st st-active">'+d.stock+' in stock</span>':'<span class="st st-critical">only '+d.stock+'</span>'):'<span class="st st-draft">no inventory match</span>';
      rows+='<tr><td class="bold">'+esc(it.name)+'</td><td>'+esc(it.dosage||'')+'</td><td style="text-align:right">'+q+'</td><td style="text-align:right">'+FMT(unit)+'</td><td style="text-align:right;font-weight:700">'+FMT(line)+'</td><td>'+stk+'</td></tr>'; });

    var steps=['Verify','Stock','Bill','Complete'];
    var stepBar='<div style="display:flex;gap:8px;margin-bottom:14px">'+steps.map(function(s,i){
      return '<div style="flex:1;text-align:center;padding:8px 6px;border-radius:10px;background:'+(i<3?'#d1fae5':'#eef2ff')+';color:'+(i<3?'#065f46':'#3730a3')+';font-size:11px;font-weight:700"><div style="font-size:15px;margin-bottom:2px">'+(i+1)+'</div>'+s+'</div>';
    }).join('<div style="display:flex;align-items:center;color:var(--txt3)">→</div>')+'</div>';

    var verify='<div class="form-section" style="grid-column:1/-1"><span>1 · Verification</span></div>'
      +(allergies?'<div class="form-group full"><div style="padding:9px 12px;background:#fef2f2;border:1px solid #fecaca;border-radius:8px;color:#991b1b;font-size:12px"><i class="fa-solid fa-triangle-exclamation"></i> <b>Allergies:</b> '+esc(allergies)+' — confirm none of the dispensed drugs conflict.</div></div>':'')
      +'<div class="form-group full" style="display:grid;grid-template-columns:1fr 1fr;gap:6px">'
        +'<label style="display:flex;gap:8px;align-items:center;font-size:12px;font-weight:600"><input type="checkbox" id="rxm_v_identity"> Patient identity confirmed</label>'
        +'<label style="display:flex;gap:8px;align-items:center;font-size:12px;font-weight:600"><input type="checkbox" id="rxm_v_allergy"> Allergies reviewed</label>'
        +'<label style="display:flex;gap:8px;align-items:center;font-size:12px;font-weight:600"><input type="checkbox" id="rxm_v_interaction"> Interactions checked</label>'
        +'<label style="display:flex;gap:8px;align-items:center;font-size:12px;font-weight:600"><input type="checkbox" id="rxm_v_dose"> Dose / quantity appropriate</label>'
      +'</div>';

    var body=stepBar
      +'<div class="twh-sumbar" style="margin:0 0 12px"><span><b style="color:var(--txt)">'+esc(PAT(rx.patientId))+'</b> · '+esc(rx.code)+' · prescribed by '+esc(DOC(rx.doctorId))+'</span><span>Total: <b>'+FMT(total)+'</b></span></div>'
      +'<div class="form-grid">'+verify+'</div>'
      +'<div class="form-section" style="margin-top:6px"><span>2 · Items &amp; stock</span></div>'
      +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Medication</th><th>Dosage</th><th style="text-align:right">Qty</th><th style="text-align:right">Unit Price</th><th style="text-align:right">Line Total</th><th>Stock</th></tr></thead><tbody>'+rows
      +'</tbody><tfoot><tr style="font-weight:800"><td colspan="4" style="text-align:right">Total Charge</td><td style="text-align:right;color:var(--pri2)">'+FMT(total)+'</td><td></td></tr></tfoot></table></div>'
      +(anyIssue?'<div style="margin-top:10px;padding:10px;background:#fffbeb;border:1px solid #fde68a;border-radius:8px;color:#92400e;font-size:12px"><i class="fa-solid fa-exclamation-triangle"></i> Some items have no/low inventory match. Dispensing deducts what is available; unmatched items are still billed at the entered price. (Tip: adjust quantity or price via the medication\'s Edit before dispensing.)</div>':'')
      +'<div class="form-grid" style="margin-top:12px">'
        +'<div class="form-section" style="grid-column:1/-1"><span>3 · Bill &amp; Payment</span></div>'
        +'<div class="form-group"><label>Collect payment now?</label><select id="rxm_collect" onchange="rxmToggleCollect()"><option value="no" selected>No — bill to Receivables (pay at cashier)</option><option value="yes">Yes — collect now</option></select></div>'
        +'<div class="form-group" id="rxm_payMethodWrap" style="display:none"><label>Payment Method</label><select id="rxm_payMethod"><option>Cash</option><option>POS / Card</option><option>Bank Transfer</option><option>Mobile Money</option><option>Insurance</option></select></div>'
        +'<div class="form-section" style="grid-column:1/-1"><span>4 · Counselling &amp; complete</span></div>'
        +'<div class="form-group full"><label>Counselling / Dispensing Notes</label><textarea id="rxm_dispnotes" rows="2" placeholder="Counselling given, administration advice, batch/lot, pharmacist…"></textarea></div>'
      +'</div>';
    MODAL('<i class="fa-solid fa-pills" style="color:#059669;margin-right:8px"></i>Dispense '+esc(rx.code), body,
      '<button class="btn btn-pri" style="background:#059669" onclick="rxmConfirmDispense('+rx.id+')"><i class="fa-solid fa-check"></i> Complete Dispensing</button><button class="btn btn-ghost" onclick="'+(window._rxmFromQueue?'rxmDispenseQueue()':'closeModal()')+'">'+(window._rxmFromQueue?'Back to Queue':'Cancel')+'</button>','wide');
    setTimeout(function(){ try{ rxmToggleCollect(); }catch(e){} },20);
  };

  /* wrap the financial engine: enforce verification, store counselling, return to queue */
  window.rxmConfirmDispense=function(rxId){
    var rx=resolveRx(rxId); if(!rx){TOAST('Prescription not found','err');return;}
    /* enforce verification only when the checklist is on screen */
    if(document.getElementById('rxm_v_identity')){
      if(!gc('rxm_v_identity')||!gc('rxm_v_allergy')||!gc('rxm_v_interaction')){
        TOAST('Complete the verification checklist (identity, allergies, interactions) before dispensing','err'); return;
      }
      rx.verification={ identity:gc('rxm_v_identity'), allergy:gc('rxm_v_allergy'), interaction:gc('rxm_v_interaction'), dose:gc('rxm_v_dose'), by:(D_().currentUser&&D_().currentUser.fullName)||'Pharmacist', at:TODAY() };
    }
    rx.counseling=gv('rxm_dispnotes')||rx.counseling||'';
    var fromQueue=window._rxmFromQueue;
    try{ V112_confirm(rxId); }catch(e){ TOAST('Dispense error','err'); return; }   /* real work: stock/COGS/bill/payment/status */
    if(fromQueue){ window._rxmFromQueue=false; setTimeout(function(){ try{ rxmDispenseQueue(); }catch(e){} },80); }
  };

  /* ═══ Authoritative wiring (override v111/v112 locks; survive timers) ══ */
  function lockTo(name, fn){ try{ Object.defineProperty(window,name,{configurable:true,enumerable:true,get:function(){return fn;},set:function(v){}}); }catch(e){ try{window[name]=fn;}catch(_){} } }

  /* the old cosmetic workflow → real queue (or guided dispense if an id is passed) */
  function showDispensingWorkflowReal(rxId){ if(rxId!=null){ window._rxmFromQueue=false; return window.rxmDispense(rxId); } return window.rxmDispenseQueue(); }
  lockTo('showDispensingWorkflow', showDispensingWorkflowReal);

  /* add a "Dispensing Queue" button to the prescription module header */
  var baseRender = window.renderPrescriptions;   /* v112 rxmRender (via accessor) */
  function enhancedRender(){
    var html=''; try{ html=baseRender(); }catch(e){ return '<div style="padding:12px;color:#ef4444">Prescription view error: '+esc(e.message)+'</div>'; }
    if(typeof html==='string' && html.indexOf('rxmDispenseQueue')<0){
      html=html.replace('> New Rx</button>',
        '> New Rx</button><button class="btn btn-sm" style="background:rgba(255,255,255,.22);color:#fff;border:1px solid rgba(255,255,255,.35);margin-left:6px" onclick="rxmDispenseQueue()"><i class="fa-solid fa-pills"></i> Dispensing Queue</button>');
    }
    return html;
  }
  lockTo('renderPrescriptions', enhancedRender);

  try{ console.log('%c✅ v113 — Full Dispensing Workflow (queue + guided verify→stock→bill→pay→complete) wired to the real engine','color:#059669;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/092-d-2.js ==== */
(function(){
  "use strict";
  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||{}; }
  function TOAST(m,t){ try{ if(typeof toast==='function') toast(m,t||'ok'); }catch(e){} }
  function MODAL(t,b,f,s){ try{ showModal(t,b,f,s); }catch(e){} }
  function CLOSE(){ try{ closeModal(); }catch(e){} }
  function FMT(n){ try{ return (typeof F==='function')?F(n):('₦'+Number(n||0).toLocaleString()); }catch(e){ return '₦'+(n||0); } }
  function DOC(id){ try{ if(typeof doc==='function') return doc(id);}catch(e){} var e2=(D_().employees||[]).find(function(x){return x.id===id;}); return e2?(e2.fullName||('#'+id)):'—'; }
  function DEPT(id){ try{ if(typeof dept==='function') return dept(id);}catch(e){} return '—'; }
  function STC(s){ try{ if(typeof stc==='function') return stc(s);}catch(e){} return ''; }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  function drugById(id){ return (D_().pharmacy||[]).find(function(d){return d.id===id;})||null; }
  function drugByName(name){ if(!name)return null; var ph=D_().pharmacy||[],n=String(name).toLowerCase();
    return ph.find(function(d){return String(d.name||'').toLowerCase()===n;})||ph.find(function(d){return String(d.name||'').toLowerCase().indexOf(n)>-1||n.indexOf(String(d.name||'').toLowerCase())>-1;})||null; }
  function sellPrice(d){ return d?(+d.sellingPrice||+d.price||0):0; }
  function itemUnit(it){ if(it&&it.unitPrice!=null&&it.unitPrice!=='') return +it.unitPrice||0; var d=it&&it.drugId?drugById(it.drugId):drugByName(it&&it.name); return sellPrice(d); }
  function itemTotal(it){ return itemUnit(it)*(parseInt(it&&it.qty)||0); }
  function rxTotal(rx){ return (rx.items||[]).reduce(function(s,it){return s+itemTotal(it);},0); }

  /* ── one-shot "return to chart" plumbing ─────────────────────────────── */
  window.vpGo=function(pid){ window._vpReturnPatient=pid; var a=[].slice.call(arguments,1); var fn=a.shift();
    try{ if(typeof window[fn]==='function') window[fn].apply(null,a); }catch(e){ TOAST('Action error','err'); } };
  function reopenChart(){ var pid=window._vpReturnPatient; if(pid!=null){ window._vpReturnPatient=null; setTimeout(function(){ try{ window.viewPatient(pid); }catch(e){} },90); } }

  /* wrap rxm completion handlers so the chart re-opens after an action */
  function wrapReopen(name, linkEncounter){
    var orig=window[name]; if(typeof orig!=='function') return;
    window[name]=function(){
      var ret=orig.apply(this, arguments);
      if(linkEncounter && window.__rxEncounter!=null){
        try{ var list=D_().prescriptions||[]; var rx=list[list.length-1];
          if(rx){ rx.encounterId=window.__rxEncounter; var emr=(D_().medicalRecords||[]).find(function(m){return m.id===window.__rxEncounter;}); if(emr)rx.emrCode=emr.code; } }catch(e){}
        window.__rxEncounter=null;
      }
      reopenChart();
      return ret;
    };
  }
  wrapReopen('rxmSaveNewRx', true);
  wrapReopen('rxmSaveMed', false);
  wrapReopen('rxmSaveMedEdit', false);
  wrapReopen('rxmConfirmDispense', false);
  wrapReopen('rxmSaveRx', false);
  wrapReopen('rxmRemoveMed', false);

  /* ── New Rx prefilled & locked to a patient (from the medical record) ── */
  window.rxmNewRxFor=function(patientId, doctorId, encounterId){
    if(typeof window.rxmNewRx!=='function'){ TOAST('Prescription module unavailable','err'); return; }
    window.__rxEncounter = (encounterId!=null?encounterId:null);
    window.rxmNewRx();   /* opens the standard New Rx modal & resets its line state */
    setTimeout(function(){
      var ps=document.getElementById('rxm_patientId');
      if(ps){ ps.value=String(patientId); ps.setAttribute('data-locked','1'); ps.style.background='#f1f5f9'; ps.title='Locked to the patient whose record is open'; ps.onchange=function(){ ps.value=String(patientId); }; }
      var ds=document.getElementById('rxm_doctorId'); if(ds&&doctorId) ds.value=String(doctorId);
      var note=document.getElementById('rxm_patientId');
      if(note&&note.parentNode){ var hint=document.createElement('div'); hint.style.cssText='font-size:10px;color:var(--pri2);margin-top:3px'; hint.innerHTML='<i class="fa-solid fa-lock"></i> Prescribing within this patient\'s medical record'; note.parentNode.appendChild(hint); }
    },40);
  };

  /* ── patient-scoped prescription cards (compact, full actions) ───────── */
  function rxCardForChart(rx, pid){
    var tot=rxTotal(rx);
    var rows=(rx.items||[]).length? rx.items.map(function(it,idx){
      return '<tr><td class="bold">'+esc(it.name)+'</td><td>'+esc(it.dosage||'')+'</td><td>'+esc(it.frequency||'')+'</td><td style="text-align:right">'+(it.qty||'')+'</td><td style="text-align:right">'+FMT(itemUnit(it))+'</td><td style="text-align:right;font-weight:700">'+FMT(itemTotal(it))+'</td>'
        +'<td><button class="act-btn" title="Edit" onclick="vpGo('+pid+',\'rxmEditMed\','+rx.id+','+idx+')"><i class="fa-solid fa-edit"></i></button><button class="act-btn del" title="Remove" onclick="vpGo('+pid+',\'rxmRemoveMed\','+rx.id+','+idx+')"><i class="fa-solid fa-times"></i></button></td></tr>';
    }).join('') : '<tr><td colspan="7" style="text-align:center;color:var(--txt3);padding:14px">No medications — click <b>Add medication</b>.</td></tr>';
    var disp = rx.status==='Active' ? '<button class="btn btn-sm" style="background:#059669;color:#fff" onclick="vpGo('+pid+',\'rxmDispense\','+rx.id+')"><i class="fa-solid fa-pills"></i> Dispense</button>' : '';
    return '<div class="card" style="margin-bottom:10px">'
      +'<div class="card-hd"><div><h3 style="font-size:15px"><i class="fa-solid fa-prescription" style="color:var(--pri);margin-right:6px"></i>'+esc(rx.code)+' <span style="font-weight:400;color:var(--txt3);font-size:11px">'+esc(rx.date||'')+'</span></h3>'
        +'<div style="font-size:12px;color:var(--txt2)">Prescriber: <b>'+esc(DOC(rx.doctorId))+'</b>'+(rx.emrCode?(' · Encounter <span class="twh-pill-soft">'+esc(rx.emrCode)+'</span>'):'')+'</div></div>'
        +'<div style="display:flex;gap:5px;align-items:center;flex-wrap:wrap"><span class="st '+STC(rx.status)+'">'+esc(rx.status)+'</span>'+(rx.billCode?'<span class="twh-pill-soft">'+esc(rx.billCode)+'</span>':'')
          +'<button class="btn btn-ghost btn-sm" onclick="vpGo('+pid+',\'rxmAddMed\','+rx.id+')"><i class="fa-solid fa-plus"></i> Add medication</button>'+disp
          +'<button class="act-btn" title="Edit Rx" onclick="vpGo('+pid+',\'rxmEditRx\','+rx.id+')"><i class="fa-solid fa-edit"></i></button>'
          +'<button class="act-btn print" title="Print" onclick="printRecord(\'prescriptions\','+rx.id+')"><i class="fa-solid fa-print"></i></button></div></div>'
      +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Medication</th><th>Dosage</th><th>Frequency</th><th style="text-align:right">Qty</th><th style="text-align:right">Unit Price</th><th style="text-align:right">Line Total</th><th style="width:62px"></th></tr></thead>'
        +'<tbody>'+rows+'</tbody>'+((rx.items||[]).length?'<tfoot><tr style="font-weight:800"><td colspan="5" style="text-align:right">Total</td><td style="text-align:right;color:var(--pri2)">'+FMT(tot)+'</td><td></td></tr></tfoot>':'')+'</table></div>'
      +(rx.notes?'<div style="margin-top:6px;font-size:11px;color:var(--txt3);font-style:italic">'+esc(rx.notes)+'</div>':'')
      +'</div>';
  }

  /* ── tab switcher ────────────────────────────────────────────────────── */
  window.vpShowTab=function(tab){
    ['overview','encounters','rx','labs','imaging','billing'].forEach(function(t){
      var el=document.getElementById('vpTab_'+t); if(el) el.style.display=(t===tab)?'':'none';
      var b=document.getElementById('vpBtn_'+t); if(b){ b.style.background=(t===tab)?'var(--pri)':'transparent'; b.style.color=(t===tab)?'#fff':'var(--txt2)'; }
    });
  };

  /* ── the Medical Record chart ────────────────────────────────────────── */
  function chart(id){
    var p=(D_().patients||[]).find(function(x){return x.id===id;}); if(!p) return;
    window._vpReturnPatient=null;
    var encs=(D_().medicalRecords||[]).filter(function(r){return r.patientId===id;}).sort(function(a,b){return String(b.visitDate||'').localeCompare(String(a.visitDate||''));});
    var rxs=(D_().prescriptions||[]).filter(function(r){return r.patientId===id;}).slice().reverse();
    var labs=(D_().labTests||[]).filter(function(l){return l.patientId===id;});
    var imgs=(D_().radiologyOrders||[]).filter(function(r){return r.patientId===id;});
    var bills=(D_().bills||[]).filter(function(b){return b.patientId===id;});
    var attendingDoc = p.doctorId;
    var lastEnc = encs[0];
    var openEnc = encs.find(function(e){return e.status==='Open';});
    var allergy = (p.allergies&&p.allergies!=='None')?p.allergies:'';

    /* header */
    var head='<div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:10px;margin-bottom:12px;padding:12px 14px;border-radius:12px;background:linear-gradient(135deg,#0d9488,#14b8a6);color:#fff">'
      +'<div><div style="font-size:18px;font-weight:800">'+esc(p.fullName)+'</div>'
        +'<div style="font-size:12px;opacity:.95;margin-top:2px">'+esc(p.mrn||'')+' · '+esc(p.gender||'')+' · '+((p.age!=null&&p.age!=='')?(esc(p.age)+'y'):'—')+' · Blood '+esc(p.bloodGroup||'—')+' · '+esc(p.status||'')+'</div>'
        +(allergy?'<div style="margin-top:6px;background:rgba(255,255,255,.18);border:1px solid rgba(255,255,255,.35);padding:3px 10px;border-radius:999px;font-size:11px;font-weight:700;display:inline-block"><i class="fa-solid fa-triangle-exclamation"></i> Allergies: '+esc(allergy)+'</div>':'')
      +'</div>'
      +'<div style="text-align:right;font-size:12px;opacity:.95">Attending: <b>'+esc(DOC(attendingDoc))+'</b><br>'+esc(DEPT(p.deptId))+(p.room?(' · Room '+esc(p.room)):'')+'</div>'
    +'</div>';

    /* tab bar */
    function tb(t,label,icon,n){ return '<button id="vpBtn_'+t+'" class="btn btn-sm" style="background:transparent;color:var(--txt2);border:none;border-radius:8px" onclick="vpShowTab(\''+t+'\')"><i class="fa-solid '+icon+'"></i> '+label+(n!=null?(' <span class="twh-pill-soft">'+n+'</span>'):'')+'</button>'; }
    var tabbar='<div style="display:flex;gap:4px;flex-wrap:wrap;border-bottom:1.5px solid var(--bdr);padding-bottom:8px;margin-bottom:12px">'
      +tb('overview','Overview','fa-id-card')+tb('encounters','Encounters','fa-stethoscope',encs.length)+tb('rx','Prescriptions','fa-prescription',rxs.length)
      +tb('labs','Labs','fa-flask',labs.length)+tb('imaging','Imaging','fa-x-ray',imgs.length)+tb('billing','Billing','fa-file-invoice-dollar',bills.length)+'</div>';

    /* Overview */
    function di(l,v,c){ return '<div class="detail-item"><div class="dl">'+l+'</div><div class="dv"'+(c?(' style="color:'+c+';font-weight:700"'):'')+'>'+(v||'—')+'</div></div>'; }
    var overview='<div id="vpTab_overview"><div class="detail-grid">'
      +di('MRN',esc(p.mrn))+di('Status','<span class="st '+STC(p.status)+'">'+esc(p.status)+'</span>')+di('Department',esc(DEPT(p.deptId)))+di('Attending Doctor',esc(DOC(p.doctorId)))
      +di('Blood Group',esc(p.bloodGroup),'var(--red)')+di('Genotype',esc(p.genotype))+di('DOB',esc(p.dob))+di('Age',(p.age!=null&&p.age!=='')?esc(p.age):'—')
      +di('Gender',esc(p.gender))+di('Phone',esc(p.phone))+di('Insurance',esc(p.insurance))+di('Admission',esc(p.admissionDate))
      +di('Allergies',esc(p.allergies),(allergy?'var(--red)':''))+di('Conditions',esc(p.conditions))
      +'<div class="detail-item full"><div class="dl">Address</div><div class="dv">'+esc(p.address||'—')+'</div></div>'
      +'<div class="detail-item full"><div class="dl">Emergency Contact</div><div class="dv">'+esc(p.ecName||'—')+(p.ecRelation?(' ('+esc(p.ecRelation)+')'):'')+(p.ecPhone?(' — '+esc(p.ecPhone)):'')+'</div></div>'
      +'</div></div>';

    /* Encounters */
    var encRows = encs.length? encs.map(function(r){
      return '<tr><td><b>'+esc(r.code)+'</b></td><td>'+esc(r.visitDate||'')+'</td><td><span class="st '+STC(r.visitType)+'">'+esc(r.visitType||'')+'</span></td><td style="max-width:220px">'+esc(r.diagnosis||'—')+'</td><td><span class="st '+STC(r.status)+'">'+esc(r.status||'')+'</span></td>'
        +'<td style="white-space:nowrap"><button class="act-btn" title="View" onclick="viewRecord(\'medicalRecords\','+r.id+')"><i class="fa-solid fa-eye"></i></button><button class="btn btn-xs" style="background:#0d9488;color:#fff" title="Prescribe from this encounter" onclick="vpGo('+id+',\'rxmNewRxFor\','+id+','+(r.doctorId||p.doctorId||'null')+','+r.id+')"><i class="fa-solid fa-prescription"></i> Prescribe</button></td></tr>';
    }).join('') : '<tr><td colspan="6" style="text-align:center;color:var(--txt3);padding:18px">No clinical encounters recorded.</td></tr>';
    var encounters='<div id="vpTab_encounters" style="display:none">'
      +'<div style="display:flex;justify-content:flex-end;margin-bottom:8px"><button class="btn btn-pri btn-sm" onclick="closeModal();addNewRecord(\'medicalRecords\')"><i class="fa-solid fa-plus"></i> New Encounter</button></div>'
      +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Date</th><th>Type</th><th>Diagnosis</th><th>Status</th><th>Actions</th></tr></thead><tbody>'+encRows+'</tbody></table></div></div>';

    /* Prescriptions (full process) */
    var presDoc = (openEnc&&openEnc.doctorId)||p.doctorId;
    var presEnc = openEnc?openEnc.id:(lastEnc?lastEnc.id:null);
    var rxBody = rxs.length? rxs.map(function(r){return rxCardForChart(r,id);}).join('') : '<div class="card" style="text-align:center;color:var(--txt3);padding:26px"><i class="fa-solid fa-prescription" style="font-size:26px;opacity:.3;display:block;margin-bottom:8px"></i>No prescriptions yet for this patient.</div>';
    var prescriptions='<div id="vpTab_rx" style="display:none">'
      +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:10px">'
        +'<div style="font-size:12px;color:var(--txt3)">'+rxs.length+' prescription(s) · standard flow: New Rx → add medications (editable price) → dispense</div>'
        +'<div style="display:flex;gap:6px"><button class="btn btn-pri btn-sm" onclick="vpGo('+id+',\'rxmNewRxFor\','+id+','+(presDoc||'null')+','+(presEnc!=null?presEnc:'null')+')"><i class="fa-solid fa-plus"></i> New Prescription</button>'
          +'<button class="btn btn-sm" style="background:#059669;color:#fff" onclick="closeModal();rxmDispenseQueue()"><i class="fa-solid fa-pills"></i> Dispensing Queue</button></div>'
      +'</div>'+rxBody+'</div>';

    /* Labs */
    var labRows=labs.length?labs.slice().reverse().map(function(l){ return '<tr><td><b>'+esc(l.code||'')+'</b></td><td>'+esc(l.testType||l.test||'')+'</td><td>'+esc(l.category||'')+'</td><td>'+esc(l.orderDate||l.date||'')+'</td><td><span class="st '+STC(l.status)+'">'+esc(l.status||'')+'</span></td></tr>'; }).join(''):'<tr><td colspan="5" style="text-align:center;color:var(--txt3);padding:18px">No lab orders.</td></tr>';
    var labsTab='<div id="vpTab_labs" style="display:none"><div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Test</th><th>Category</th><th>Date</th><th>Status</th></tr></thead><tbody>'+labRows+'</tbody></table></div></div>';

    /* Imaging */
    var imgRows=imgs.length?imgs.slice().reverse().map(function(r){ return '<tr><td><b>'+esc(r.code||'')+'</b></td><td>'+esc(r.modality||'')+'</td><td>'+esc(r.examType||r.bodyPart||'')+'</td><td>'+esc(r.scheduledDate||r.orderDate||'')+'</td><td><span class="st '+STC(r.status)+'">'+esc(r.status||'')+'</span></td></tr>'; }).join(''):'<tr><td colspan="5" style="text-align:center;color:var(--txt3);padding:18px">No imaging orders.</td></tr>';
    var imgTab='<div id="vpTab_imaging" style="display:none"><div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Modality</th><th>Exam</th><th>Date</th><th>Status</th></tr></thead><tbody>'+imgRows+'</tbody></table></div></div>';

    /* Billing */
    var billRows=bills.length?bills.slice().reverse().map(function(b){ return '<tr><td><b>'+esc(b.code||'')+'</b></td><td>'+esc(b.type||'')+'</td><td>'+esc(b.date||'')+'</td><td style="text-align:right">'+FMT(b.total||0)+'</td><td style="text-align:right">'+FMT(b.balance!=null?b.balance:(b.total||0))+'</td><td><span class="st '+STC(b.status)+'">'+esc(b.status||'')+'</span></td></tr>'; }).join(''):'<tr><td colspan="6" style="text-align:center;color:var(--txt3);padding:18px">No bills.</td></tr>';
    var billTot=bills.reduce(function(s,b){return s+(+b.total||0);},0), billBal=bills.reduce(function(s,b){return s+(b.balance!=null?(+b.balance||0):(+b.total||0));},0);
    var billTab='<div id="vpTab_billing" style="display:none"><div class="twh-sumbar" style="margin:0 0 10px"><span>Total billed: <b>'+FMT(billTot)+'</b></span><span>Outstanding: <b>'+FMT(billBal)+'</b></span></div><div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Type</th><th>Date</th><th style="text-align:right">Total</th><th style="text-align:right">Balance</th><th>Status</th></tr></thead><tbody>'+billRows+'</tbody></table></div></div>';

    var body=head+tabbar+overview+encounters+prescriptions+labsTab+imgTab+billTab;
    MODAL('<i class="fa-solid fa-folder-open" style="color:var(--pri);margin-right:8px"></i>Medical Record', body,
      '<button class="btn btn-ghost" onclick="window._vpReturnPatient=null;closeModal()">Close</button>','wide');
  }

  /* ── make chart authoritative ────────────────────────────────────────── */
  function lockTo(name, fn){ try{ Object.defineProperty(window,name,{configurable:true,enumerable:true,get:function(){return fn;},set:function(v){}}); }catch(e){ try{window[name]=fn;}catch(_){} } }
  lockTo('viewPatient', chart);

  try{ console.log('%c✅ v114 — Prescriptions integrated into the Medical Record (tabbed chart + prescribe-from-encounter)','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/093-d-3.js ==== */
(function(){
  "use strict";
  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||{}; }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} }
  function RERENDER(){ try{ if(typeof render==='function') render(); else if(window.render) window.render(); }catch(e){} }
  function TOAST(m,t){ try{ if(typeof toast==='function') toast(m,t||'ok'); }catch(e){} }
  function MODAL(t,b,f,s){ try{ showModal(t,b,f,s); }catch(e){} }
  function CLOSE(){ try{ closeModal(); }catch(e){} }
  function NID(){ try{ return (typeof nid==='function')?nid():(Date.now()+Math.floor(Math.random()*1000)); }catch(e){ return Date.now(); } }
  function UID(){ try{ return (typeof uid==='function')?uid():Math.random().toString(36).substr(2,6).toUpperCase(); }catch(e){ return Math.random().toString(36).substr(2,6).toUpperCase(); } }
  function TODAY(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
  function FMT(n){ try{ return (typeof F==='function')?F(n):('₦'+Number(n||0).toLocaleString()); }catch(e){ return '₦'+(n||0); } }
  function PAT(id){ try{ if(typeof pat==='function') return pat(id);}catch(e){} var p=(D_().patients||[]).find(function(x){return x.id===id;}); return p?(p.fullName||p.name||('Patient '+id)):'—'; }
  function DOC(id){ try{ if(typeof doc==='function') return doc(id);}catch(e){} var e2=(D_().employees||[]).find(function(x){return x.id===id;}); return e2?(e2.fullName||('#'+id)):'—'; }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function emit(evt,p){ try{ if(window.SyncBus) SyncBus.emit(evt,p); }catch(e){} }
  function AUD(t,m,a,d,r){ try{ if(typeof auditAction==='function') auditAction(t,m,a,d,r); }catch(e){} }
  function gv(id){ var el=document.getElementById(id); return el?el.value:''; }

  function resolveRx(rxId){ var l=D_().prescriptions||[]; if(rxId==null||rxId==='undefined')return null;
    return l.find(function(x){return x.id===rxId;})||l.find(function(x){return String(x.id)===String(rxId);})||l.find(function(x){return (x.code||'')===String(rxId);})||null; }

  /* fetch ALL medication items in the application (full pharmacy catalogue) */
  function allMeds(){ return (D_().pharmacy||[]).slice().sort(function(a,b){return String(a.name||'').localeCompare(String(b.name||''));}); }
  function drugById(id){ return (D_().pharmacy||[]).find(function(d){return d.id===id;})||null; }
  function drugByName(name){ if(!name)return null; var n=String(name).toLowerCase();
    return (D_().pharmacy||[]).find(function(d){return String(d.name||'').toLowerCase()===n;})||(D_().pharmacy||[]).find(function(d){return String(d.name||'').toLowerCase().indexOf(n)>-1||n.indexOf(String(d.name||'').toLowerCase())>-1;})||null; }
  function sellPrice(d){ return d?(+d.sellingPrice||+d.price||0):0; }
  function itemUnit(it){ if(it&&it.unitPrice!=null&&it.unitPrice!=='') return +it.unitPrice||0; var d=it&&it.drugId?drugById(it.drugId):drugByName(it&&it.name); return sellPrice(d); }
  function itemTotal(it){ return itemUnit(it)*(parseInt(it&&it.qty)||0); }
  function rxTotal(rx){ return (rx.items||[]).reduce(function(s,it){return s+itemTotal(it);},0); }
  function stockBadge(d){ if(!d) return '<span style="color:#94a3b8">—</span>'; if(d.stock<=0) return '<span style="color:#dc2626;font-weight:700">Out</span>'; if(d.stock<=d.minStock) return '<span style="color:#f59e0b;font-weight:700">Low '+d.stock+'</span>'; return '<span style="color:#059669;font-weight:600">'+d.stock+'</span>'; }

  var FREQ=['Once daily (OD)','Twice daily (BD)','Three times daily (TDS)','Four times daily (QDS)','Every 6 hours (Q6H)','Every 8 hours (Q8H)','Every 12 hours','At bedtime (Nocte)','As needed (PRN)','Before meals','After meals','Stat (once)'];
  var ROUTE=['Oral','IV','IM','SC','Topical','Rectal','Inhaler','Nebulizer','Sublingual','Eye drops','Ear drops'];
  function freqOpts(sel){ return FREQ.map(function(f){return '<option'+(sel===f?' selected':'')+'>'+esc(f)+'</option>';}).join(''); }
  function routeOpts(sel){ return ROUTE.map(function(r){return '<option'+(sel===r?' selected':'')+'>'+esc(r)+'</option>';}).join(''); }
  function patOpts(sel){ return (D_().patients||[]).map(function(p){return '<option value="'+p.id+'"'+(String(sel)===String(p.id)?' selected':'')+'>'+esc(p.fullName||p.name)+' ['+esc(p.mrn||'')+']</option>';}).join(''); }
  function docOpts(sel){ return (D_().employees||[]).filter(function(e){return e.type==='Doctor'&&(e.status==='Active'||!e.status);}).map(function(e){return '<option value="'+e.id+'"'+(String(sel)===String(e.id)?' selected':'')+'>'+esc(e.fullName)+'</option>';}).join(''); }

  /* ── line state ──────────────────────────────────────────────────────── */
  var RX2={ seq:0, lines:[] };

  function catalogHTML(){
    var s=(window._rxm2Search||'').toLowerCase();
    var meds=allMeds().filter(function(d){ if(!s)return true; return String(d.name||'').toLowerCase().indexOf(s)>=0||String(d.category||'').toLowerCase().indexOf(s)>=0; });
    if(!meds.length) return '<div style="padding:18px;text-align:center;color:var(--txt3);font-size:12px">No medication matches "'+esc(window._rxm2Search||'')+'".</div>';
    return meds.map(function(d){
      return '<div style="display:flex;align-items:center;gap:8px;padding:7px 10px;border-bottom:1px solid var(--bdr)">'
        +'<div style="flex:1;min-width:0"><div style="font-weight:600;font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">'+esc(d.name)+(d.strength?(' <span style="color:var(--txt3);font-weight:400">'+esc(d.strength)+'</span>'):'')+'</div>'
          +'<div style="font-size:11px;color:var(--txt3)">'+esc(d.category||'—')+' · '+FMT(sellPrice(d))+' · stock '+stockBadge(d)+(d.controlled?' · <span style="color:#7c3aed;font-weight:700">CTRL</span>':'')+'</div></div>'
        +'<button type="button" class="btn btn-xs btn-pri" onclick="rxm2Add('+d.id+')"><i class="fa-solid fa-plus"></i> Add</button>'
      +'</div>';
    }).join('');
  }
  function lineRowHTML(ln){
    return '<tr id="rxm2_row_'+ln.id+'">'
      +'<td style="font-weight:600">'+esc(ln.name)+(ln.strength?(' <span style="color:var(--txt3);font-weight:400;font-size:11px">'+esc(ln.strength)+'</span>'):'')+'</td>'
      +'<td><input value="'+esc(ln.dosage||'')+'" oninput="rxm2Set('+ln.id+',\'dosage\',this.value)" placeholder="500mg" style="width:80px"></td>'
      +'<td><select onchange="rxm2Set('+ln.id+',\'frequency\',this.value)">'+freqOpts(ln.frequency)+'</select></td>'
      +'<td><select onchange="rxm2Set('+ln.id+',\'route\',this.value)">'+routeOpts(ln.route)+'</select></td>'
      +'<td><input value="'+esc(ln.duration||'')+'" oninput="rxm2Set('+ln.id+',\'duration\',this.value)" placeholder="7 days" style="width:74px"></td>'
      +'<td><input type="number" min="1" value="'+(ln.qty||1)+'" oninput="rxm2Set('+ln.id+',\'qty\',this.value)" style="width:60px;text-align:right"></td>'
      +'<td><input type="number" min="0" value="'+(ln.unitPrice||0)+'" oninput="rxm2Set('+ln.id+',\'unitPrice\',this.value)" style="width:92px;text-align:right"></td>'
      +'<td id="rxm2_lt_'+ln.id+'" style="text-align:right;font-weight:700;white-space:nowrap">'+FMT((ln.qty||0)*(ln.unitPrice||0))+'</td>'
      +'<td style="text-align:center"><button type="button" class="act-btn del" title="Remove" onclick="rxm2Del('+ln.id+')"><i class="fa-solid fa-trash"></i></button></td></tr>';
  }
  function linesBody(){ return RX2.lines.length? RX2.lines.map(lineRowHTML).join('') : '<tr id="rxm2_empty"><td colspan="9" style="text-align:center;color:var(--txt3);padding:18px"><i class="fa-solid fa-arrow-up" style="margin-right:6px"></i>Pick medications from the catalogue above.</td></tr>'; }
  function grandTotal(){ return RX2.lines.reduce(function(s,l){return s+(parseInt(l.qty)||0)*(parseFloat(l.unitPrice)||0);},0); }

  window.rxm2CatalogFilter=function(v){ window._rxm2Search=v; var el=document.getElementById('rxm2Catalog'); if(el) el.innerHTML=catalogHTML(); };
  window.rxm2Add=function(drugId){ var d=drugById(drugId); if(!d)return;
    var ln={ id:++RX2.seq, drugId:d.id, name:d.name, strength:d.strength||'', category:d.category||'', dosage:d.strength||'', frequency:'Twice daily (BD)', route:'Oral', duration:'', qty:1, unitPrice:sellPrice(d) };
    RX2.lines.push(ln); refreshLines(); TOAST(d.name+' added'); };
  window.rxm2Del=function(id){ RX2.lines=RX2.lines.filter(function(l){return l.id!==id;}); refreshLines(); };
  window.rxm2Set=function(id,field,val){ var ln=RX2.lines.find(function(l){return l.id===id;}); if(!ln)return; ln[field]=val;
    if(field==='qty'||field==='unitPrice'){ var lt=document.getElementById('rxm2_lt_'+id); if(lt) lt.textContent=FMT((parseInt(ln.qty)||0)*(parseFloat(ln.unitPrice)||0)); updateTotals(); } };
  function refreshLines(){ var b=document.getElementById('rxm2LinesBody'); if(b) b.innerHTML=linesBody(); updateTotals(); }
  function updateTotals(){ var t=grandTotal(); var el=document.getElementById('rxm2Total'); if(el) el.textContent=FMT(t); var c=document.getElementById('rxm2Count'); if(c) c.textContent=RX2.lines.length+(RX2.lines.length===1?' medication':' medications'); }

  /* ── enhanced New Prescription form ──────────────────────────────────── */
  window.rxmNewRx=function(){
    RX2={ seq:0, lines:[] }; window._rxm2Search='';
    var body=''
      +'<div class="form-grid">'
        +'<div class="form-group"><label>Rx Code</label><input id="rxm_code" value="RX-'+esc(UID())+'" readonly style="background:#f8fafc;font-weight:700"></div>'
        +'<div class="form-group"><label>Date</label><input id="rxm_date" type="date" value="'+TODAY()+'"></div>'
        +'<div class="form-group"><label>Status</label><select id="rxm_status"><option selected>Active</option><option>Draft</option></select></div>'
        +'<div class="form-group"><label>Patient <span class="req">*</span></label><select id="rxm_patientId"><option value="">Select patient…</option>'+patOpts()+'</select></div>'
        +'<div class="form-group"><label>Prescriber (Doctor) <span class="req">*</span></label><select id="rxm_doctorId"><option value="">Select doctor…</option>'+docOpts()+'</select></div>'
        +'<div class="form-group full"><label>Clinical Notes / Instructions</label><textarea id="rxm_notes" rows="2" placeholder="e.g. Take with food; review in 2 weeks"></textarea></div>'
      +'</div>'
      +'<div class="form-section" style="grid-column:1/-1;margin-top:4px"><span>Add medications from the pharmacy catalogue</span></div>'
      +'<div style="display:grid;grid-template-columns:1fr;gap:8px;margin-bottom:10px">'
        +'<input type="text" placeholder="🔍 Search all medications by name or category… ('+allMeds().length+' items)" oninput="rxm2CatalogFilter(this.value)" style="width:100%;padding:9px 12px;border:1.5px solid var(--bdr);border-radius:10px;font-size:13px">'
        +'<div id="rxm2Catalog" style="max-height:190px;overflow-y:auto;border:1px solid var(--bdr);border-radius:10px;background:var(--card)">'+catalogHTML()+'</div>'
      +'</div>'
      +'<div class="form-section" style="grid-column:1/-1"><span>Prescribed medications</span></div>'
      +'<div class="tbl-wrap" style="margin-bottom:8px"><table class="tbl"><thead><tr><th>Medication</th><th>Dosage</th><th>Frequency</th><th>Route</th><th>Duration</th><th style="text-align:right">Qty</th><th style="text-align:right">Unit Price (₦)</th><th style="text-align:right">Line Total</th><th></th></tr></thead><tbody id="rxm2LinesBody">'+linesBody()+'</tbody></table></div>'
      +'<div class="twh-sumbar" style="margin-bottom:8px"><span id="rxm2Count">0 medications</span> · Estimated total: <b id="rxm2Total">'+FMT(0)+'</b></div>'
      +'<div style="padding:9px 12px;background:#eff6ff;border:1px solid #bfdbfe;border-radius:10px;color:#1e40af;font-size:12px"><i class="fa-solid fa-circle-info"></i> Prices auto-fill from the pharmacy and remain editable. <b>Stock is deducted and the patient is billed only when this prescription is dispensed</b> — a bill is then posted to Receivables and a receipt can be generated.</div>';
    MODAL('<i class="fa-solid fa-prescription" style="color:var(--pri);margin-right:8px"></i>New Prescription', body,
      '<button class="btn btn-pri" onclick="rxmSaveNewRx()"><i class="fa-solid fa-save"></i> Create Prescription</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
  };

  window.rxmSaveNewRx=function(){
    var pid=parseInt(gv('rxm_patientId'),10)||null, did=parseInt(gv('rxm_doctorId'),10)||null;
    if(!pid){ TOAST('Select a patient','err'); return; }
    if(!did){ TOAST('Select the prescriber','err'); return; }
    if(!RX2.lines.length){ TOAST('Add at least one medication from the catalogue','err'); return; }
    var items=RX2.lines.map(function(l){ return { name:l.name, dosage:l.dosage||'', frequency:l.frequency||'', route:l.route||'', duration:l.duration||'',
      qty:parseInt(l.qty)||1, unitPrice:parseFloat(l.unitPrice)||0, instructions:'', drugId:l.drugId||null, fromInventory:!!l.drugId }; });
    var rx={ id:NID(), code:gv('rxm_code')||('RX-'+UID()), patientId:pid, doctorId:did,
      date:gv('rxm_date')||TODAY(), status:gv('rxm_status')||'Active', notes:gv('rxm_notes')||'', items:items };
    /* link the open encounter when prescribing from the medical record */
    if(window.__rxEncounter!=null){ rx.encounterId=window.__rxEncounter; var emr=(D_().medicalRecords||[]).find(function(m){return m.id===window.__rxEncounter;}); if(emr)rx.emrCode=emr.code; window.__rxEncounter=null; }
    D_().prescriptions=D_().prescriptions||[]; D_().prescriptions.push(rx);
    AUD('CLINICAL','Pharmacy','PRESCRIBE','New Rx '+rx.code+' for '+PAT(pid)+' — '+items.length+' medication(s)','Low');
    emit('prescription.created',{id:rx.id,code:rx.code,patientId:pid});
    CLOSE(); SAVE(); RERENDER();
    TOAST('Prescription '+rx.code+' created — '+items.length+' medication(s). Dispense to deduct stock & bill.');
    /* return to the patient's medical record if launched from there */
    var ret=window._vpReturnPatient; if(ret!=null){ window._vpReturnPatient=null; setTimeout(function(){ try{ window.viewPatient(ret); }catch(e){} },90); }
  };

  /* ── printable pharmacy receipt (posted to Receivables) ──────────────── */
  window.rxmReceipt=function(rxId){
    var rx=resolveRx(rxId); if(!rx){ TOAST('Prescription not found','err'); return; }
    var p=(D_().patients||[]).find(function(x){return x.id===rx.patientId;});
    var bill=(D_().bills||[]).find(function(b){return b.code===rx.billCode;});
    var s=D_().settings||{};
    var dispensed=(rx.status==='Dispensed');
    var total=rxTotal(rx);
    var paid=bill?(+bill.paid||0):0, bal=bill?(bill.balance!=null?+bill.balance:total):total;
    var payStatus = bill ? (bill.status==='Paid'?'PAID':'OUTSTANDING — posted to Receivables') : (dispensed?'—':'NOT YET DISPENSED');
    var rows=(rx.items||[]).map(function(it){ var q=parseInt(it.qty)||1,u=itemUnit(it); return '<tr><td>'+esc(it.name)+(it.dosage?(' '+esc(it.dosage)):'')+'</td><td style="text-align:center">'+q+'</td><td style="text-align:right">'+FMT(u)+'</td><td style="text-align:right">'+FMT(u*q)+'</td></tr>'; }).join('');
    var html=''
      +'<div style="text-align:center;margin-bottom:16px"><div style="font-size:20px;font-weight:800">'+esc(s.hospitalName||'Hospital')+'</div>'
        +'<div style="font-size:12px;color:#64748b">'+esc(s.address||'')+'</div><div style="font-size:12px;color:#64748b">Tel: '+esc(s.phone||'')+'</div>'
        +'<div style="margin-top:6px;font-size:13px;font-weight:700;letter-spacing:1px;color:#0d9488">PHARMACY '+(dispensed?'RECEIPT':'PRO-FORMA')+'</div></div>'
      +'<div style="border:1px solid #d1fae5;border-radius:8px;padding:14px;margin-bottom:14px"><table style="width:100%;font-size:13px">'
        +'<tr><td style="width:50%"><b>Rx No:</b> '+esc(rx.code)+'</td><td><b>Date:</b> '+esc(rx.dispensedDate||rx.date||TODAY())+'</td></tr>'
        +'<tr><td><b>Patient:</b> '+(p?esc(p.fullName):esc(PAT(rx.patientId)))+'</td><td><b>MRN:</b> '+(p?esc(p.mrn||'—'):'—')+'</td></tr>'
        +'<tr><td><b>Prescriber:</b> '+esc(DOC(rx.doctorId))+'</td><td><b>Bill Ref:</b> '+esc(rx.billCode||'—')+'</td></tr>'
        +(rx.dispensedBy?('<tr><td><b>Dispensed by:</b> '+esc(rx.dispensedBy)+'</td><td><b>Payment:</b> '+esc(payStatus)+'</td></tr>'):('<tr><td colspan="2"><b>Status:</b> '+esc(payStatus)+'</td></tr>'))
      +'</table></div>'
      +'<table style="width:100%;margin-bottom:14px;font-size:13px;border-collapse:collapse"><thead><tr style="border-bottom:2px solid #0d9488"><th style="text-align:left;padding:6px 4px">Medication</th><th style="text-align:center">Qty</th><th style="text-align:right">Unit</th><th style="text-align:right">Amount</th></tr></thead><tbody>'+rows
      +'</tbody><tfoot><tr style="border-top:2px solid #0d9488;font-weight:800"><td colspan="3" style="text-align:right;padding:8px 4px">TOTAL</td><td style="text-align:right;font-size:16px">'+FMT(total)+'</td></tr>'
        +(bill?('<tr><td colspan="3" style="text-align:right;padding:2px 4px">Paid</td><td style="text-align:right">'+FMT(paid)+'</td></tr><tr><td colspan="3" style="text-align:right;padding:2px 4px">Balance</td><td style="text-align:right;font-weight:700;color:'+(bal>0?'#dc2626':'#059669')+'">'+FMT(bal)+'</td></tr>'):'')
      +'</tfoot></table>'
      +'<div style="border-top:1px dashed #cbd5e1;padding-top:10px;text-align:center;font-size:12px;color:#64748b">'
        +(dispensed?('This receipt confirms medications dispensed and '+(bill&&bill.status==='Paid'?'paid in full.':'billed to the patient account (Receivables).')):'Pro-forma estimate — not yet dispensed.')
        +'<br>Thank you for choosing '+esc(s.hospitalName||'us')+'.</div>';
    try{ if(typeof printContent==='function'){ printContent('Pharmacy Receipt — '+(rx.billCode||rx.code), html); } else { var w=window.open('','_blank'); w.document.write(html); w.print(); } }catch(e){ TOAST('Unable to open receipt','err'); }
  };

  /* ── add a Receipt button to prescription cards (after the print button) ─ */
  function lockTo(name, fn){ try{ Object.defineProperty(window,name,{configurable:true,enumerable:true,get:function(){return fn;},set:function(v){}}); }catch(e){ try{window[name]=fn;}catch(_){} } }
  var baseRender = window.renderPrescriptions;
  function renderWithReceipt(){
    var html=''; try{ html=baseRender(); }catch(e){ return '<div style="padding:12px;color:#ef4444">Prescription view error</div>'; }
    if(typeof html==='string'){
      html=html.replace(/onclick="printRecord\('prescriptions',(\d+)\)"><i class="fa-solid fa-print"><\/i><\/button>/g,
        function(m,id){ return m+'<button class="act-btn" title="Pharmacy Receipt" style="color:#0d9488" onclick="rxmReceipt('+id+')"><i class="fa-solid fa-receipt"></i></button>'; });
    }
    return html;
  }
  lockTo('renderPrescriptions', renderWithReceipt);
  lockTo('newRx', window.rxmNewRx);   /* keep legacy alias pointing at the new form */

  try{ console.log('%c✅ v115 — New Prescription catalogue picker + pharmacy receipt (stock/bill only at dispense)','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/095-ensurefdo.js ==== */
(function(){
  "use strict";
  function ensureFDO(){
    try{
      if(typeof D==='undefined' || !D) return;
      D.responsibilities = D.responsibilities || {};
      var role = 'Front Desk Officer';
      D.responsibilities[role] = D.responsibilities[role] || {};
      var added = false;
      ['laboratory','radiology'].forEach(function(m){
        if(!D.responsibilities[role][m]){ D.responsibilities[role][m] = true; added = true; }
      });
      if(added){
        try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){}
        /* if a Front Desk Officer is currently signed in, refresh the sidebar/nav */
        try{
          if(D.currentUser && D.currentUser.role===role && typeof render==='function'){ render(); }
        }catch(e){}
      }
    }catch(e){}
  }
  /* run now and across the init window to outlast any re-seeding of roles */
  ensureFDO();
  [400,1200,2500,4500,7000].forEach(function(t){ setTimeout(ensureFDO, t); });
  try{ console.log('%c✅ v117 — Front Desk Officer granted Laboratory & Radiology','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/096-d-4.js ==== */
(function(){
  "use strict";
  if(window.__roleTrimV118) return; window.__roleTrimV118 = true;

  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||null; }
  function TOAST(m){ try{ if(typeof toast==='function') toast(m,'err'); }catch(e){} }
  function curRole(){
    try{ var d=D_();
      if(d && d.currentUser && d.currentUser.role) return d.currentUser.role;
      if(typeof currentUser!=='undefined' && currentUser && currentUser.role) return currentUser.role;
    }catch(e){}
    return 'Staff';
  }
  function isFull(){ var r=curRole(); return r==='System Administrator' || r==='CEO' || r==='Admin'; }

  /* ── (A) module removal: Lab Tech loses "settings" ──────────────────── */
  function trimModules(){
    var d=D_(); if(!d) return;
    d.responsibilities = d.responsibilities || {};
    if(d.responsibilities['Lab Tech'] && d.responsibilities['Lab Tech']['settings']){
      delete d.responsibilities['Lab Tech']['settings'];
      try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){}
      try{ if(curRole()==='Lab Tech' && typeof render==='function') render(); }catch(e){}
    }
  }

  /* ── (B) link removal: hide buttons by onclick for the affected role ── */
  var HIDE = {
    'Nurse':         ["V25_addHousehold("],
    'Lab Scientist': ["addNewRecord('patients')", "V25_addHousehold("]
  };
  function sweep(){
    try{
      if(isFull()) return;
      var pats = HIDE[curRole()]; if(!pats || !pats.length) return;
      var root = document.getElementById('moduleContent') || document.body; if(!root) return;
      var nodes = root.querySelectorAll('[onclick]');
      Array.prototype.forEach.call(nodes, function(b){
        var oc = b.getAttribute('onclick') || '';
        for(var i=0;i<pats.length;i++){ if(oc.indexOf(pats[i])>=0){ b.style.display='none'; break; } }
      });
    }catch(e){}
  }

  /* ── (C) action guards (block even if a link is reached another way) ── */
  function householdBlocked(){ var r=curRole(); return !isFull() && (r==='Nurse' || r==='Lab Scientist'); }
  function patientCreateBlocked(){ return !isFull() && curRole()==='Lab Scientist'; }

  function wrapGuards(){
    if(window.V25_addHousehold && !window.V25_addHousehold.__v118){
      var _h = window.V25_addHousehold;
      window.V25_addHousehold = function(){ if(householdBlocked()){ TOAST('Your role is not permitted to register a household.'); return; } return _h.apply(this, arguments); };
      window.V25_addHousehold.__v118 = true;
    }
    if(window.addNewRecord && !window.addNewRecord.__v118){
      var _a = window.addNewRecord;
      window.addNewRecord = function(key){ if(key==='patients' && patientCreateBlocked()){ TOAST('Your role is not permitted to register patients.'); return; } return _a.apply(this, arguments); };
      window.addNewRecord.__v118 = true;
    }
  }

  /* ── wiring: run after every render, observe DOM changes, and on timers ── */
  function runAll(){ trimModules(); wrapGuards(); sweep(); }

  if(window.render && !window.render.__v118){
    var _r = window.render;
    window.render = function(){ var out = _r.apply(this, arguments); try{ setTimeout(sweep, 0); }catch(e){} return out; };
    window.render.__v118 = true;
  }
  try{
    var mo = DOMBus.__mo(function(){ sweep(); });
    var target = document.getElementById('moduleContent') || document.body;
    if(target) mo.observe(target, {childList:true, subtree:true});
  }catch(e){}

  runAll();
  [300,1000,2200,4000,6500].forEach(function(t){ setTimeout(runAll, t); });

  try{ console.log('%c✅ v118 — role trims: Nurse −Register Household · Lab Tech −Settings · Lab Scientist −Register Patient/Household','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/097-d-5.js ==== */
(function(){
  "use strict";
  if(window.__patPhotoV119) return; window.__patPhotoV119 = true;

  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||null; }
  function TOAST(m,t){ try{ if(typeof toast==='function') toast(m,t||'ok'); }catch(e){} }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); return true; }catch(e){ return false; } }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function findPat(id){ var ps=(D_()&&D_().patients)||[]; return ps.find(function(p){return p.id===id;}) || ps.find(function(p){return String(p.id)===String(id);}) || null; }
  function initials(name){ var parts=String(name||'').trim().split(/\s+/).filter(Boolean); if(!parts.length) return '?'; var a=parts[0][0]||''; var b=parts.length>1?(parts[parts.length-1][0]||''):''; return (a+b).toUpperCase(); }
  function hue(name){ var s=String(name||''),h=0; for(var i=0;i<s.length;i++) h=(h*31+s.charCodeAt(i))%360; return h; }

  /* avatar markup — img when a photo exists, otherwise an initials disc */
  window.patAvatarHTML = function(p, size, opts){
    opts = opts || {}; size = size || 48; var r = Math.round(size/2);
    var ring = opts.ring ? ('border:'+(opts.ringW||2)+'px solid '+(opts.ring)+';') : '';
    var cam = opts.camera ? ('<span style="position:absolute;right:-2px;bottom:-2px;width:'+Math.max(18,Math.round(size*0.34))+'px;height:'+Math.max(18,Math.round(size*0.34))+'px;border-radius:50%;background:#0d9488;color:#fff;display:flex;align-items:center;justify-content:center;border:2px solid #fff;font-size:'+Math.max(9,Math.round(size*0.16))+'px"><i class="fa-solid fa-camera"></i></span>') : '';
    var inner;
    if(p && p.photo){
      inner = '<img src="'+p.photo+'" alt="patient photo" style="width:'+size+'px;height:'+size+'px;border-radius:50%;object-fit:cover;display:block;'+ring+'">';
    } else {
      var h = hue(p&&(p.fullName||p.name));
      inner = '<div style="width:'+size+'px;height:'+size+'px;border-radius:50%;'+ring+'background:linear-gradient(135deg,hsl('+h+',55%,52%),hsl('+((h+40)%360)+',55%,42%));color:#fff;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:'+Math.round(size*0.38)+'px">'+esc(initials(p&&(p.fullName||p.name)))+'</div>';
    }
    var click = opts.uploadId!=null ? (' onclick="event.stopPropagation();patSetPhoto('+opts.uploadId+')" title="Click to add or change photo" style="cursor:pointer;position:relative;display:inline-block;line-height:0"') : ' style="position:relative;display:inline-block;line-height:0"';
    return '<span'+click+'>'+inner+cam+'</span>';
  };

  /* store a (already-encoded) photo on a patient + refresh views */
  window.patApplyPhoto = function(id, dataUrl){
    var p = findPat(id); if(!p) return false;
    var prev = p.photo; p.photo = dataUrl;
    if(!SAVE()){ p.photo = prev; TOAST('Could not save photo (storage full). Try a smaller image.','err'); return false; }
    TOAST(dataUrl?'Patient photo updated':'Patient photo removed');
    try{ if(typeof render==='function') render(); }catch(e){}
    try{ if(document.getElementById('modalBg') && window.__patChartOpenId===id && typeof window.viewPatient==='function'){ setTimeout(function(){ window.viewPatient(id); }, 30); } }catch(e){}
    return true;
  };

  /* file picker → downscale ≤480px → JPEG → store */
  window.patSetPhoto = function(id){
    var p = findPat(id); if(!p){ TOAST('Patient not found','err'); return; }
    var inp = document.createElement('input'); inp.type='file'; inp.accept='image/*';
    inp.style.display='none';
    inp.onchange = function(){
      var f = inp.files && inp.files[0]; if(!f){ return; }
      if(!/^image\//.test(f.type||'')){ TOAST('Please choose an image file','err'); return; }
      var rd = new FileReader();
      rd.onload = function(){
        var img = new Image();
        img.onload = function(){
          try{
            var max=480, w=img.naturalWidth||img.width, h=img.naturalHeight||img.height;
            var s = Math.min(1, max/Math.max(w,h)); w=Math.round(w*s); h=Math.round(h*s);
            var c=document.createElement('canvas'); c.width=w; c.height=h;
            c.getContext('2d').drawImage(img,0,0,w,h);
            var url=c.toDataURL('image/jpeg',0.85);
            window.patApplyPhoto(id, url);
          }catch(e){ TOAST('Could not process image','err'); }
          try{ document.body.removeChild(inp); }catch(e){}
        };
        img.onerror = function(){ TOAST('Could not read image','err'); };
        img.src = rd.result;
      };
      rd.onerror = function(){ TOAST('Could not read file','err'); };
      rd.readAsDataURL(f);
    };
    document.body.appendChild(inp); inp.click();
  };

  window.patRemovePhoto = function(id){
    try{ if(!confirm('Remove this patient\'s photo?')) return; }catch(e){}
    window.patApplyPhoto(id, '');
  };

  /* ── inject the avatar into the Medical Record profile header ───────── */
  var _vp = (typeof window.viewPatient==='function') ? window.viewPatient : null;
  function injectChartAvatar(id){
    try{
      var bg=document.getElementById('modalBg'); if(!bg) return;
      var header = bg.querySelector('.modal-body > div'); if(!header) return;
      if(header.getAttribute('data-pavatar')) return;
      var left = header.children && header.children[0]; if(!left) return;
      var p = findPat(id); if(!p) return;
      header.setAttribute('data-pavatar','1');
      var row=document.createElement('div'); row.style.cssText='display:flex;gap:14px;align-items:center';
      var av=document.createElement('div'); av.style.cssText='flex:0 0 auto';
      av.innerHTML = window.patAvatarHTML(p, 64, {camera:true, ring:'rgba(255,255,255,.7)', ringW:2, uploadId:id});
      header.insertBefore(row, left);
      row.appendChild(av); row.appendChild(left);
    }catch(e){}
  }
  if(_vp){
    function wrapped(id){ window.__patChartOpenId = id; var out=_vp(id); try{ setTimeout(function(){ injectChartAvatar(id); }, 0); }catch(e){} return out; }
    try{ Object.defineProperty(window,'viewPatient',{configurable:true,enumerable:true,get:function(){return wrapped;},set:function(){}}); }
    catch(e){ window.viewPatient = wrapped; }
  }

  /* ── registry thumbnails: add the face to the Patient column ────────── */
  function sweepRegistry(){
    try{
      var root=document.getElementById('moduleContent'); if(!root) return;
      var table=root.querySelector('#patTable'); if(!table) return;
      var rows=table.querySelectorAll('tbody tr');
      Array.prototype.forEach.call(rows, function(tr){
        if(tr.getAttribute('data-pavatar')) return;
        var ed=tr.querySelector('[onclick*="editRecord(\'patients\'"]') || tr.querySelector('[onclick*="V25_viewPatient("]');
        if(!ed) return;
        var oc=ed.getAttribute('onclick')||''; var m=oc.match(/(?:editRecord\('patients',|V25_viewPatient\()\s*(\d+)/); if(!m) return;
        var id=parseInt(m[1],10); var p=findPat(id); if(!p) return;
        var nameCell=tr.querySelector('td.bold'); if(!nameCell) return;
        tr.setAttribute('data-pavatar','1');
        var wrap=document.createElement('div'); wrap.style.cssText='display:flex;align-items:center;gap:8px';
        var av=document.createElement('span'); av.style.cssText='flex:0 0 auto'; av.innerHTML=window.patAvatarHTML(p,30,{uploadId:id});
        var content=document.createElement('div'); while(nameCell.firstChild){ content.appendChild(nameCell.firstChild); }
        wrap.appendChild(av); wrap.appendChild(content);
        nameCell.appendChild(wrap);
      });
    }catch(e){}
  }
  if(window.render && !window.render.__patPhoto){
    var _r=window.render;
    window.render=function(){ var o=_r.apply(this,arguments); try{ setTimeout(sweepRegistry,0); }catch(e){} return o; };
    window.render.__patPhoto=true;
  }
  try{ var mo=DOMBus.__mo(function(){ sweepRegistry(); }); var t=document.getElementById('moduleContent')||document.body; if(t) mo.observe(t,{childList:true,subtree:true}); }catch(e){}
  [400,1500,3500].forEach(function(t){ setTimeout(sweepRegistry,t); });

  try{ console.log('%c✅ v119 — patient photo: upload from profile, face shown in chart header & registry','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/098-explicit-targets.js ==== */
(function(){
  "use strict";
  if(window.__killBadgesV120) return; window.__killBadgesV120 = true;

  function removeBadges(){
    try{
      if(typeof document==='undefined' || !document.body) return;
      // explicit targets
      var byId = document.getElementById('v24Banner'); if(byId && byId.parentNode) byId.parentNode.removeChild(byId);
      ['.v28-pill','.v27-pill'].forEach(function(sel){
        var ns = document.querySelectorAll(sel);
        Array.prototype.forEach.call(ns, function(e){ if(e && e.parentNode) e.parentNode.removeChild(e); });
      });
      // legacy floating version badges (preserve V28's original cleanup) + the two requested ones
      var KILL = ['v28 ux refined','hms v24 active','v25 patient','v26 ap/ar','v27 finance'];
      var divs = document.body.querySelectorAll ? document.body.querySelectorAll('div') : [];
      Array.prototype.forEach.call(divs, function(d){
        if(!d || !d.style || d.style.position!=='fixed') return;
        var t = (d.textContent||'').toLowerCase();
        for(var i=0;i<KILL.length;i++){ if(t.indexOf(KILL[i])>=0){ if(d.parentNode) d.parentNode.removeChild(d); break; } }
      });
    }catch(e){}
  }

  /* Replace the badge routine so the v28 pill is never re-created on render,
     while keeping its legacy badge cleanup behaviour. */
  try{ window.V28_cleanupBadges = function(){ removeBadges(); }; }catch(e){}

  removeBadges();
  [150,400,800,1500,2600,3600,5000,9000,14000].forEach(function(t){ setTimeout(removeBadges, t); });

  try{
    var mo = DOMBus.__mo(function(){ removeBadges(); });
    var target = document.body || document.documentElement;
    if(target) mo.observe(target, {childList:true});
  }catch(e){}

  try{ console.log('%c✅ v120 — removed HMS v24 Active banner & v28 module-refinements pill','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/099-d-6.js ==== */
(function(){
  "use strict";
  if(window.__empPhotoV121) return; window.__empPhotoV121 = true;

  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||null; }
  function TOAST(m,t){ try{ if(typeof toast==='function') toast(m,t||'ok'); }catch(e){} }
  function SAVE(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); return true; }catch(e){ return false; } }
  function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function findEmp(id){ var es=(D_()&&D_().employees)||[]; return es.find(function(e){return e.id===id;}) || es.find(function(e){return String(e.id)===String(id);}) || null; }
  function curEmp(){ try{ return (typeof window.essEmp==='function') ? window.essEmp() : null; }catch(e){ return null; } }
  function onESS(){ try{ return typeof currentMod!=='undefined' && currentMod==='selfservice'; }catch(e){ return false; } }
  function initials(name){ var p=String(name||'').trim().split(/\s+/).filter(Boolean); if(!p.length) return '?'; var a=p[0][0]||''; var b=p.length>1?(p[p.length-1][0]||''):''; return (a+b).toUpperCase(); }
  function hue(name){ var s=String(name||''),h=0; for(var i=0;i<s.length;i++) h=(h*31+s.charCodeAt(i))%360; return h; }

  /* reuse patient avatar styling if present, else self-contained */
  window.empAvatarHTML = function(e, size, opts){
    opts = opts || {}; size = size || 64;
    var ring = opts.ring ? ('border:'+(opts.ringW||2)+'px solid '+opts.ring+';') : '';
    var cam = opts.camera ? ('<span style="position:absolute;right:-2px;bottom:-2px;width:'+Math.max(18,Math.round(size*0.32))+'px;height:'+Math.max(18,Math.round(size*0.32))+'px;border-radius:50%;background:#0d9488;color:#fff;display:flex;align-items:center;justify-content:center;border:2px solid #fff;font-size:'+Math.max(9,Math.round(size*0.15))+'px"><i class="fa-solid fa-camera"></i></span>') : '';
    var inner;
    if(e && e.photo){
      inner = '<img src="'+e.photo+'" alt="employee photo" style="width:'+size+'px;height:'+size+'px;border-radius:50%;object-fit:cover;display:block;'+ring+'">';
    } else {
      var h=hue(e&&(e.fullName||e.name));
      inner = '<div style="width:'+size+'px;height:'+size+'px;border-radius:50%;'+ring+'background:linear-gradient(135deg,hsl('+h+',55%,52%),hsl('+((h+40)%360)+',55%,42%));color:#fff;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:'+Math.round(size*0.38)+'px">'+esc(initials(e&&(e.fullName||e.name)))+'</div>';
    }
    var click = opts.uploadId!=null ? (' onclick="event.stopPropagation();empSetPhoto('+opts.uploadId+')" title="Click to add or change photo" style="cursor:pointer;position:relative;display:inline-block;line-height:0"') : ' style="position:relative;display:inline-block;line-height:0"';
    return '<span'+click+'>'+inner+cam+'</span>';
  };

  window.empApplyPhoto = function(id, dataUrl){
    var e = findEmp(id); if(!e) return false;
    var prev = e.photo; e.photo = dataUrl;
    if(!SAVE()){ e.photo = prev; TOAST('Could not save photo (storage full). Try a smaller image.','err'); return false; }
    try{ if(typeof auditAction==='function') auditAction('HR','ESS','PHOTO',(e.fullName||('#'+id))+(dataUrl?' updated photo':' removed photo'),'Low'); }catch(_e){}
    TOAST(dataUrl?'Profile photo updated':'Profile photo removed');
    try{ if(typeof render==='function') render(); }catch(_e){}
    return true;
  };

  window.empSetPhoto = function(id){
    var e = findEmp(id); if(!e){ TOAST('Employee not found','err'); return; }
    var inp = document.createElement('input'); inp.type='file'; inp.accept='image/*'; inp.style.display='none';
    inp.onchange = function(){
      var f = inp.files && inp.files[0]; if(!f) return;
      if(!/^image\//.test(f.type||'')){ TOAST('Please choose an image file','err'); return; }
      var rd = new FileReader();
      rd.onload = function(){
        var img = new Image();
        img.onload = function(){
          try{
            var max=480, w=img.naturalWidth||img.width, h=img.naturalHeight||img.height;
            var s=Math.min(1, max/Math.max(w,h)); w=Math.round(w*s); h=Math.round(h*s);
            var c=document.createElement('canvas'); c.width=w; c.height=h;
            c.getContext('2d').drawImage(img,0,0,w,h);
            window.empApplyPhoto(id, c.toDataURL('image/jpeg',0.85));
          }catch(e2){ TOAST('Could not process image','err'); }
          try{ document.body.removeChild(inp); }catch(e2){}
        };
        img.onerror = function(){ TOAST('Could not read image','err'); };
        img.src = rd.result;
      };
      rd.onerror = function(){ TOAST('Could not read file','err'); };
      rd.readAsDataURL(f);
    };
    document.body.appendChild(inp); inp.click();
  };

  window.empRemovePhoto = function(id){ try{ if(!confirm('Remove your profile photo?')) return; }catch(e){} window.empApplyPhoto(id,''); };

  /* ── inject the avatar into the ESS "My Profile" card ───────────────── */
  function closestCard(node){ var n=node; for(var i=0;i<6 && n;i++){ if(n.className && (' '+n.className+' ').indexOf(' card ')>=0) return n; n=n.parentNode; } return null; }
  function sweepESS(){
    try{
      if(!onESS()) return;
      var emp = curEmp(); if(!emp) return;
      var root = document.getElementById('moduleContent'); if(!root) return;
      var heads = root.querySelectorAll('.card-hd h3');
      var card = null;
      Array.prototype.forEach.call(heads, function(h){ if(!card && (h.textContent||'').indexOf('My Profile')>=0) card = closestCard(h); });
      if(!card || card.getAttribute('data-eavatar')) return;
      var grid = card.querySelector('div[style*="grid-template-columns"]'); if(!grid) return;
      card.setAttribute('data-eavatar','1');
      var row = document.createElement('div'); row.style.cssText='display:flex;gap:16px;align-items:center';
      var av = document.createElement('div'); av.style.cssText='flex:0 0 auto';
      av.innerHTML = window.empAvatarHTML(emp, 84, {camera:true, ring:'var(--bdr)', ringW:2, uploadId:emp.id});
      grid.parentNode.insertBefore(row, grid);
      row.appendChild(av); row.appendChild(grid);
    }catch(e){}
  }

  if(window.render && !window.render.__empPhoto){
    var _r=window.render;
    window.render=function(){ var o=_r.apply(this,arguments); try{ setTimeout(sweepESS,0); }catch(e){} return o; };
    window.render.__empPhoto=true;
  }
  try{ var mo=DOMBus.__mo(function(){ sweepESS(); }); var t=document.getElementById('moduleContent')||document.body; if(t) mo.observe(t,{childList:true,subtree:true}); }catch(e){}
  [400,1500,3500].forEach(function(t){ setTimeout(sweepESS,t); });

  try{ console.log('%c✅ v121 — employee photo on Self-Service profile (upload + face display)','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/100-d-7.js ==== */
(function(){
  "use strict";
  if(window.__patFormPhotoV122) return; window.__patFormPhotoV122 = true;

  function D_(){ try{ if(typeof D!=='undefined'&&D) return D; }catch(e){} return window.D||null; }
  function TOAST(m,t){ try{ if(typeof toast==='function') toast(m,t||'ok'); }catch(e){} }
  function val(id){ var e=document.getElementById(id); return e?e.value:''; }

  window.patFormRenderPreview = function(){
    var inp=document.getElementById('add_photo'); var av=document.getElementById('add_photo_av'); if(!av) return;
    var url=inp?inp.value:''; var rm=document.getElementById('add_photo_rm');
    if(url){
      av.innerHTML='<img src="'+url+'" alt="patient photo" style="width:74px;height:74px;border-radius:50%;object-fit:cover;border:2px solid #99f6e4;display:block">';
      if(rm) rm.style.display='';
    } else {
      var fn=(val('add_firstName')||'').trim(), ln=(val('add_lastName')||'').trim();
      var ini=((fn[0]||'')+(ln[0]||'')).toUpperCase();
      var inner = ini ? ini : '<i class="fa-solid fa-user"></i>';
      av.innerHTML='<div style="width:74px;height:74px;border-radius:50%;background:linear-gradient(135deg,#14b8a6,#0d9488);color:#fff;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:26px">'+inner+'</div>';
      if(rm) rm.style.display='none';
    }
  };

  window.patFormSetPhoto = function(){
    var inp=document.getElementById('add_photo'); if(!inp){ TOAST('Open the patient form first','err'); return; }
    var picker=document.createElement('input'); picker.type='file'; picker.accept='image/*'; picker.style.display='none';
    picker.onchange=function(){
      var f=picker.files&&picker.files[0]; if(!f){ return; }
      if(!/^image\//.test(f.type||'')){ TOAST('Please choose an image file','err'); return; }
      var rd=new FileReader();
      rd.onload=function(){
        var img=new Image();
        img.onload=function(){
          try{
            var max=480,w=img.naturalWidth||img.width,h=img.naturalHeight||img.height;
            var s=Math.min(1,max/Math.max(w,h)); w=Math.round(w*s); h=Math.round(h*s);
            var c=document.createElement('canvas'); c.width=w; c.height=h;
            c.getContext('2d').drawImage(img,0,0,w,h);
            inp.value=c.toDataURL('image/jpeg',0.85);
            window.patFormRenderPreview();
            TOAST('Photo added — it will be saved with the patient');
          }catch(e){ TOAST('Could not process image','err'); }
          try{ document.body.removeChild(picker); }catch(e){}
        };
        img.onerror=function(){ TOAST('Could not read image','err'); };
        img.src=rd.result;
      };
      rd.onerror=function(){ TOAST('Could not read file','err'); };
      rd.readAsDataURL(f);
    };
    document.body.appendChild(picker); picker.click();
  };

  window.patFormClearPhoto = function(){
    var inp=document.getElementById('add_photo'); if(inp) inp.value='';
    window.patFormRenderPreview();
  };

  function injectPatPhoto(){
    var grid=document.querySelector('#modalBg .form-grid')||document.querySelector('.form-grid');
    if(!grid || document.getElementById('add_photo_block')) return;
    var block=document.createElement('div');
    block.id='add_photo_block'; block.className='form-group full';
    block.style.cssText='grid-column:1/-1;display:flex;align-items:center;gap:16px;background:#f0fdfa;border:1.5px dashed #99f6e4;border-radius:14px;padding:14px;margin:4px 0';
    block.innerHTML=''
      +'<span id="add_photo_av" style="flex:0 0 auto"></span>'
      +'<div style="display:flex;flex-direction:column;gap:6px">'
      +'<b style="color:#0f766e;font-size:13px"><i class="fa-solid fa-camera" style="margin-right:6px"></i>Patient Photo</b>'
      +'<div style="display:flex;gap:8px">'
      +'<button type="button" class="btn btn-sm btn-ghost" onclick="patFormSetPhoto()"><i class="fa-solid fa-upload"></i> Upload Photo</button>'
      +'<button type="button" class="btn btn-sm btn-ghost" id="add_photo_rm" style="color:#dc2626;display:none" onclick="patFormClearPhoto()"><i class="fa-solid fa-trash"></i> Remove</button>'
      +'</div>'
      +'<span style="font-size:11px;color:var(--txt3)">Optional. JPG/PNG — auto-resized. Shows on the patient profile &amp; registry.</span>'
      +'</div>'
      +'<input type="hidden" id="add_photo" value="">';
    grid.insertBefore(block, grid.firstChild);
    window.patFormRenderPreview();
  }
  window.__injectPatPhoto = injectPatPhoto;

  /* chain on top of the current addNewRecord / editRecord (which build the modal) */
  if(window.addNewRecord && !window.addNewRecord.__photoForm){
    var _add=window.addNewRecord;
    window.addNewRecord=function(dataKey){
      var r=_add.apply(this,arguments);
      if(dataKey==='patients'){ try{ injectPatPhoto(); }catch(e){} }
      return r;
    };
    window.addNewRecord.__photoForm=true;
  }
  if(window.editRecord && !window.editRecord.__photoForm){
    var _edit=window.editRecord;
    window.editRecord=function(dataKey,id){
      var r=_edit.apply(this,arguments);
      if(dataKey==='patients'){
        try{ injectPatPhoto(); }catch(e){}
        setTimeout(function(){
          try{
            var rec=((D_()&&D_().patients)||[]).find(function(p){return p.id===id;});
            var inp=document.getElementById('add_photo');
            if(inp && rec && rec.photo && !inp.value) inp.value=rec.photo;
            window.patFormRenderPreview();
          }catch(e){}
        },70);
      }
      return r;
    };
    window.editRecord.__photoForm=true;
  }

  try{ console.log('%c✅ v122 — patient photo control in Register/Edit forms','color:#0d9488;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/101-twh-crm-v123.js ==== */
(function(){
'use strict';
if(typeof window==='undefined') return;
function D_(){ return window.D||(window.D={}); }
function $(id){ return document.getElementById(id); }
function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
function num(v){ var n=parseFloat(v); return isNaN(n)?0:n; }
function tdy(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
function genId(){ try{ return (typeof nid==='function')?nid():(Date.now()+Math.floor(Math.random()*1000)); }catch(e){ return Date.now()+Math.floor(Math.random()*1000); } }
function money(n){ try{ return (typeof F==='function')?F(n):('₦'+Number(n||0).toLocaleString()); }catch(e){ return '₦'+(n||0); } }
function toasty(m,t){ try{ if(typeof toast==='function') toast(m,t); }catch(e){} }
function save(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} }
function rerender(){ try{ if(typeof render==='function') render(); }catch(e){} }
function meName(){ try{ var D=D_(); return (D.currentUser&&D.currentUser.fullName)||'BD Manager'; }catch(e){ return 'BD Manager'; } }

var STAGES=['New','Contacted','Qualified','Booked','Won','Lost'];
var STAGE_COLOR={New:'#64748b',Contacted:'#3b82f6',Qualified:'#8b5cf6',Booked:'#f59e0b',Won:'#22c55e',Lost:'#ef4444'};
var SOURCES=['Walk-in','Phone','Referral','Website','WhatsApp','Campaign','Social Media','Insurance','Corporate'];
var CHANNELS=['Phone Call','WhatsApp','SMS','Email','In-person','Video'];
var TYPES=['Patient','Prospective','Referring GP','Insurance','Corporate','Vendor'];

/* ---- normalise legacy contacts so every record has the new fields ---- */
function normalize(){
  var D=D_(); D.crmContacts=D.crmContacts||[];
  D.crmContacts.forEach(function(c){
    if(c.stage==null){
      c.stage = c.type==='Patient' ? 'Won'
              : c.type==='Referring GP' ? 'Qualified'
              : (c.status==='Follow-up') ? 'Contacted' : 'New';
    }
    if(c.source==null) c.source = c.type==='Referring GP'?'Referral':(c.type==='Prospective'?'Phone':'Walk-in');
    if(c.value==null) c.value = c.type==='Prospective'?150000:(c.type==='Corporate'?500000:0);
    if(c.email==null) c.email='';
    if(!Array.isArray(c.interactions)){
      c.interactions = c.lastContact ? [{date:c.lastContact,channel:'Phone Call',note:c.reason||'Initial contact',by:c.assignedTo||'Staff'}] : [];
    }
    if(c.nextFollowUp===undefined) c.nextFollowUp = (c.status==='Follow-up')? tdy() : '';
    if(c.lostReason===undefined) c.lostReason='';
  });
  /* seed campaigns once */
  if(!Array.isArray(D.crmCampaigns)){
    D.crmCampaigns=[
      {id:genId(),name:'Health Check Promotion',channel:'SMS + Email',target:'Patients 40+',sent:450,responded:312,converted:45,status:'Active',start:'2024-01-05'},
      {id:genId(),name:'Flu Vaccination Drive',channel:'SMS',target:'All registered patients',sent:1200,responded:180,converted:120,status:'Active',start:'2024-01-10'},
      {id:genId(),name:'Maternity Package Launch',channel:'Email + WhatsApp',target:'Female 25–40',sent:300,responded:210,converted:22,status:'Active',start:'2024-01-12'},
      {id:genId(),name:'Patient Satisfaction Survey',channel:'SMS',target:'Discharged (30d)',sent:85,responded:52,converted:0,status:'Closed',start:'2024-01-15'}
    ];
  }
  /* seed complaints once */
  if(!Array.isArray(D.crmComplaints)){
    D.crmComplaints=[
      {id:genId(),code:'COMP-001',subject:'Long waiting time in OPD',contact:'Amara Okwu',date:'2024-01-20',severity:'High',status:'Under Review',owner:'OPD Supervisor',resolution:'Queue optimisation in progress'},
      {id:genId(),code:'COMP-002',subject:'Billing dispute — lab tests',contact:'Funke Adeyemi',date:'2024-01-18',severity:'Medium',status:'Investigating',owner:'Finance Manager',resolution:'Reviewing itemised charges'},
      {id:genId(),code:'COMP-003',subject:'Commendation — Nurse Jennifer',contact:'Adebayo Johnson',date:'2024-01-19',severity:'Low',status:'Acknowledged',owner:'HR',resolution:'Forwarded to Nursing Director'}
    ];
  }
}

/* ---- helpers ---- */
function isOpen(c){ return c.stage!=='Won' && c.stage!=='Lost'; }
function dueState(c){
  if(!c.nextFollowUp) return '';
  var t=tdy();
  if(c.nextFollowUp<t) return 'overdue';
  if(c.nextFollowUp===t) return 'today';
  return 'upcoming';
}
function crmStats(){
  var D=D_(); var cs=D.crmContacts||[];
  var leads=cs.length;
  var won=cs.filter(function(c){return c.stage==='Won';}).length;
  var lost=cs.filter(function(c){return c.stage==='Lost';}).length;
  var closed=won+lost;
  var conv=closed>0?Math.round(won/closed*100):0;
  var due=cs.filter(function(c){var d=dueState(c);return d==='today'||d==='overdue';}).length;
  var pipeline=cs.filter(isOpen).reduce(function(s,c){return s+num(c.value);},0);
  var rated=cs.filter(function(c){return c.satisfaction;});
  var sat=rated.length?(rated.reduce(function(s,c){return s+num(c.satisfaction);},0)/rated.length):0;
  return {leads:leads,won:won,conv:conv,due:due,pipeline:pipeline,sat:sat};
}
window.crmGo=function(t){ D_()._crmTab=t; rerender(); };
function tabBtn(k,l,i,badge){ var on=(D_()._crmTab||'pipeline')===k; return '<button class="tab-btn'+(on?' active':'')+'" onclick="crmGo(\''+k+'\')"><i class="fa-solid '+i+'" style="margin-right:5px"></i>'+l+(badge?' <span style="background:#ef4444;color:#fff;border-radius:99px;padding:0 6px;font-size:10px;margin-left:3px">'+badge+'</span>':'')+'</button>'; }
function stagePill(s){ return '<span style="display:inline-block;padding:2px 10px;border-radius:99px;font-size:10.5px;font-weight:700;color:#fff;background:'+(STAGE_COLOR[s]||'#64748b')+'">'+esc(s)+'</span>'; }
function stars(n){ n=num(n); return n?('<span style="color:#f59e0b">'+'★'.repeat(n)+'<span style="color:#cbd5e1">'+'☆'.repeat(5-n)+'</span></span>'):'<span style="color:var(--txt3)">—</span>'; }

/* ════════════════════════ KPI HEADER ════════════════════════ */
function kpiHeader(){
  var s=crmStats();
  function k(grad,icon,val,label){ return '<div class="kpi" style="background:linear-gradient(135deg,'+grad+');color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2);color:#fff"><i class="fa-solid '+icon+'"></i></div><div class="kpi-val">'+val+'</div><div class="kpi-label">'+label+'</div></div>'; }
  return '<div class="kpi-grid">'
    +k('#3b82f6,#60a5fa','fa-users',s.leads,'Total Leads')
    +k('#f59e0b,#fbbf24','fa-bell',s.due,'Follow-ups Due')
    +k('#22c55e,#4ade80','fa-percent',s.conv+'%','Conversion Rate')
    +k('#8b5cf6,#a78bfa','fa-sack-dollar',money(s.pipeline),'Open Pipeline')
    +k('#0d9488,#14b8a6','fa-star',s.sat?s.sat.toFixed(1):'—','Avg Satisfaction')
    +'</div>';
}

/* ════════════════════════ PIPELINE BOARD ════════════════════════ */
function tabPipeline(){
  var D=D_(); var cs=D.crmContacts||[];
  var cols=STAGES.map(function(st){
    var inCol=cs.filter(function(c){return c.stage===st;});
    var val=inCol.reduce(function(s,c){return s+num(c.value);},0);
    var cards=inCol.map(function(c){
      var d=dueState(c);
      var flag=d==='overdue'?'<span title="Overdue follow-up" style="color:#ef4444;font-weight:700;font-size:10px"><i class="fa-solid fa-triangle-exclamation"></i> overdue</span>':(d==='today'?'<span title="Follow-up due today" style="color:#b45309;font-weight:700;font-size:10px"><i class="fa-solid fa-clock"></i> today</span>':'');
      return '<div class="crm-card" onclick="crmView('+c.id+')" style="border:1px solid var(--bdr);border-radius:10px;padding:9px 11px;margin-bottom:8px;cursor:pointer;background:#fff">'
        +'<div style="display:flex;justify-content:space-between;gap:6px"><b style="font-size:12.5px">'+esc(c.name)+'</b>'+(c.value?'<span style="font-size:10.5px;color:var(--txt2);white-space:nowrap">'+money(c.value)+'</span>':'')+'</div>'
        +'<div style="font-size:10.5px;color:var(--txt3);margin-top:2px">'+esc(c.type)+' · '+esc(c.source)+'</div>'
        +(flag?'<div style="margin-top:4px">'+flag+'</div>':'')
        +'</div>';
    }).join('')||'<div style="font-size:11px;color:var(--txt3);text-align:center;padding:10px 0">—</div>';
    return '<div style="flex:1;min-width:155px;background:#f8fafc;border-radius:12px;padding:10px">'
      +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px"><span style="font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.5px;color:'+(STAGE_COLOR[st])+'">'+st+' ('+inCol.length+')</span></div>'
      +(val?'<div style="font-size:10px;color:var(--txt3);margin:-4px 0 8px">'+money(val)+'</div>':'')
      +cards+'</div>';
  }).join('');
  return '<div style="display:flex;gap:8px;margin-bottom:14px"><button class="btn btn-pri" onclick="crmAdd()"><i class="fa-solid fa-plus"></i> New Lead / Contact</button><span style="margin-left:auto;font-size:11.5px;color:var(--txt3);align-self:center">Tap any card to open, log a call, advance the stage or book a visit.</span></div>'
    +'<div style="display:flex;gap:10px;overflow-x:auto;padding-bottom:6px">'+cols+'</div>';
}

/* ════════════════════════ CONTACTS TABLE ════════════════════════ */
window.crmFilter=function(){ rerender(); };
function tabContacts(){
  var D=D_(); var cs=(D.crmContacts||[]).slice();
  var f=D._crmF||{};
  var rows=cs.filter(function(c){
    if(f.type&&f.type!=='all'&&c.type!==f.type) return false;
    if(f.stage&&f.stage!=='all'&&c.stage!==f.stage) return false;
    if(f.q){ var q=f.q.toLowerCase(); if((c.name||'').toLowerCase().indexOf(q)<0 && (c.phone||'').toLowerCase().indexOf(q)<0 && (c.email||'').toLowerCase().indexOf(q)<0) return false; }
    return true;
  });
  rows.sort(function(a,b){ return String(b.lastContact||'').localeCompare(String(a.lastContact||'')); });
  function opt(v,l,cur){ return '<option value="'+v+'"'+(cur===v?' selected':'')+'>'+l+'</option>'; }
  var controls='<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center;margin-bottom:12px">'
    +'<button class="btn btn-pri" onclick="crmAdd()"><i class="fa-solid fa-plus"></i> New Lead / Contact</button>'
    +'<input id="crmQ" value="'+esc(f.q||'')+'" placeholder="Search name / phone / email" oninput="crmSetF(\'q\',this.value)" style="padding:8px 12px;border:1.5px solid var(--bdr);border-radius:9px;font-size:12.5px;min-width:210px">'
    +'<select onchange="crmSetF(\'type\',this.value)" style="padding:8px 10px;border:1.5px solid var(--bdr);border-radius:9px;font-size:12.5px">'+opt('all','All Types',f.type||'all')+TYPES.map(function(t){return opt(t,t,f.type);}).join('')+'</select>'
    +'<select onchange="crmSetF(\'stage\',this.value)" style="padding:8px 10px;border:1.5px solid var(--bdr);border-radius:9px;font-size:12.5px">'+opt('all','All Stages',f.stage||'all')+STAGES.map(function(t){return opt(t,t,f.stage);}).join('')+'</select>'
    +'<span style="margin-left:auto;font-size:11.5px;color:var(--txt3)">'+rows.length+' of '+cs.length+'</span></div>';
  var body=rows.length?rows.map(function(c){
    var d=dueState(c);
    var fu=c.nextFollowUp?('<span style="color:'+(d==='overdue'?'#ef4444':d==='today'?'#b45309':'var(--txt2)')+';font-weight:'+(d==='overdue'||d==='today'?'700':'400')+'">'+c.nextFollowUp+'</span>'):'<span style="color:var(--txt3)">—</span>';
    return '<tr style="cursor:pointer" onclick="crmView('+c.id+')"><td class="bold">'+esc(c.name)+'</td><td><span class="st st-'+(c.type==='Patient'?'active':c.type==='Referring GP'?'scheduled':'pending')+'">'+esc(c.type)+'</span></td>'
      +'<td>'+stagePill(c.stage)+'</td><td style="font-size:11.5px">'+esc(c.phone||'—')+'</td><td style="font-size:11.5px">'+esc(c.source)+'</td>'
      +'<td style="font-size:11.5px">'+(c.value?money(c.value):'—')+'</td><td style="font-size:11.5px">'+fu+'</td><td>'+stars(c.satisfaction)+'</td>'
      +'<td onclick="event.stopPropagation()"><div class="act-row">'
      +'<button class="act-btn" title="Open" onclick="crmView('+c.id+')"><i class="fa-solid fa-eye"></i></button>'
      +'<button class="act-btn edit" title="Log interaction" onclick="crmLog('+c.id+')"><i class="fa-solid fa-comment-dots"></i></button>'
      +'<button class="act-btn print" title="Edit" onclick="crmEdit('+c.id+')"><i class="fa-solid fa-pen"></i></button>'
      +'</div></td></tr>';
  }).join(''):'<tr><td colspan="9" style="text-align:center;color:var(--txt3);padding:20px">No contacts match your filters.</td></tr>';
  return controls
    +'<div class="card"><div class="card-hd"><h3 style="font-size:14px"><i class="fa-solid fa-address-book" style="color:#3b82f6;margin-right:8px"></i>Contact &amp; Lead Register</h3></div>'
    +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Name</th><th>Type</th><th>Stage</th><th>Phone</th><th>Source</th><th>Value</th><th>Next Follow-up</th><th>Rating</th><th></th></tr></thead><tbody>'+body+'</tbody></table></div></div>';
}
window.crmSetF=function(k,v){ var D=D_(); D._crmF=D._crmF||{}; D._crmF[k]=v; rerender();
  /* keep focus / caret in the search box after re-render */
  if(k==='q'){ setTimeout(function(){ var el=$('crmQ'); if(el){ el.focus(); el.setSelectionRange(el.value.length,el.value.length); } },0); }
};

/* ════════════════════════ FOLLOW-UPS ════════════════════════ */
function tabFollowups(){
  var D=D_(); var cs=(D.crmContacts||[]).filter(function(c){return c.nextFollowUp;});
  var t=tdy();
  var overdue=cs.filter(function(c){return c.nextFollowUp<t;}).sort(function(a,b){return a.nextFollowUp.localeCompare(b.nextFollowUp);});
  var today_=cs.filter(function(c){return c.nextFollowUp===t;});
  var upcoming=cs.filter(function(c){return c.nextFollowUp>t;}).sort(function(a,b){return a.nextFollowUp.localeCompare(b.nextFollowUp);});
  function block(title,arr,color,icon){
    if(!arr.length) return '';
    return '<div class="card" style="border-left:4px solid '+color+';margin-bottom:12px"><div class="card-hd"><h3 style="font-size:13px"><i class="fa-solid '+icon+'" style="color:'+color+';margin-right:6px"></i>'+title+' ('+arr.length+')</h3></div>'
      +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Due</th><th>Name</th><th>Stage</th><th>Phone</th><th>Next Action</th><th>Assigned</th><th></th></tr></thead><tbody>'
      +arr.map(function(c){return '<tr><td style="font-weight:700;color:'+color+'">'+c.nextFollowUp+'</td><td class="bold">'+esc(c.name)+'</td><td>'+stagePill(c.stage)+'</td><td style="font-size:11.5px">'+esc(c.phone||'—')+'</td><td style="font-size:11.5px">'+esc(c.nextAction||'—')+'</td><td style="font-size:11.5px">'+esc(c.assignedTo||'—')+'</td>'
        +'<td><div class="act-row"><button class="btn btn-xs" style="background:#0d9488;color:#fff" onclick="crmLog('+c.id+')"><i class="fa-solid fa-check"></i> Log call</button><button class="act-btn" title="Open" onclick="crmView('+c.id+')"><i class="fa-solid fa-eye"></i></button></div></td></tr>';}).join('')
      +'</tbody></table></div></div>';
  }
  var out=block('Overdue',overdue,'#ef4444','fa-triangle-exclamation')+block('Due Today',today_,'#b45309','fa-clock')+block('Upcoming',upcoming,'#3b82f6','fa-calendar-day');
  if(!out) out='<div class="card" style="text-align:center;color:var(--txt3);padding:30px"><i class="fa-solid fa-mug-hot" style="font-size:30px;color:#cbd5e1;margin-bottom:10px"></i><div>No follow-ups scheduled. Open a contact and set a "Next follow-up" date to populate this board.</div></div>';
  return '<div style="font-size:11.5px;color:var(--txt2);margin-bottom:12px"><i class="fa-solid fa-circle-info" style="color:var(--pri);margin-right:5px"></i>Your daily call list — work top to bottom. Logging a call lets you set the next follow-up date.</div>'+out;
}

/* ════════════════════════ CAMPAIGNS ════════════════════════ */
function tabCampaigns(){
  var D=D_(); var camps=D.crmCampaigns||[];
  var rows=camps.map(function(m){
    var oRate=m.sent?Math.round(m.responded/m.sent*100):0;
    var cRate=m.sent?Math.round(m.converted/m.sent*100):0;
    return '<tr><td class="bold">'+esc(m.name)+'</td><td style="font-size:11.5px">'+esc(m.channel)+'</td><td style="font-size:11.5px">'+esc(m.target)+'</td><td>'+num(m.sent).toLocaleString()+'</td><td>'+num(m.responded).toLocaleString()+' <span style="color:var(--txt3);font-size:10.5px">('+oRate+'%)</span></td><td style="font-weight:700;color:#16a34a">'+num(m.converted).toLocaleString()+' <span style="color:var(--txt3);font-size:10.5px;font-weight:400">('+cRate+'%)</span></td><td><span class="st '+(m.status==='Active'?'st-active':'st-cancelled')+'">'+esc(m.status)+'</span></td>'
      +'<td><div class="act-row"><button class="act-btn print" title="Edit / update results" onclick="crmEditCampaign('+m.id+')"><i class="fa-solid fa-pen"></i></button></div></td></tr>';
  }).join('')||'<tr><td colspan="8" style="text-align:center;color:var(--txt3);padding:18px">No campaigns yet.</td></tr>';
  var totSent=camps.reduce(function(s,m){return s+num(m.sent);},0);
  var totConv=camps.reduce(function(s,m){return s+num(m.converted);},0);
  return '<div style="display:flex;gap:8px;margin-bottom:12px;align-items:center"><button class="btn btn-pri" onclick="crmAddCampaign()"><i class="fa-solid fa-bullhorn"></i> New Campaign</button>'
    +'<span style="margin-left:auto;font-size:11.5px;color:var(--txt3)">'+camps.length+' campaign(s) · '+totSent.toLocaleString()+' messages sent · <b style="color:#16a34a">'+totConv.toLocaleString()+'</b> conversions</span></div>'
    +'<div class="card"><div class="tbl-wrap"><table class="tbl"><thead><tr><th>Campaign</th><th>Channel</th><th>Target</th><th>Sent</th><th>Responded</th><th>Converted</th><th>Status</th><th></th></tr></thead><tbody>'+rows+'</tbody></table></div></div>';
}
window.crmAddCampaign=function(){
  showModal('<i class="fa-solid fa-bullhorn" style="color:var(--pri);margin-right:8px"></i>New Campaign',
    '<div class="form-grid"><div class="form-group full"><label>Campaign Name <span class="req">*</span></label><input id="cmp_name" placeholder="e.g. Diabetes Screening Week"></div>'
    +'<div class="form-group"><label>Channel</label><select id="cmp_channel"><option>SMS</option><option>Email</option><option>WhatsApp</option><option>SMS + Email</option><option>Email + WhatsApp</option><option>Social Media</option></select></div>'
    +'<div class="form-group"><label>Target Segment</label><input id="cmp_target" placeholder="e.g. Patients 40+"></div>'
    +'<div class="form-group"><label>Messages Sent</label><input id="cmp_sent" type="number" value="0"></div>'
    +'<div class="form-group"><label>Responded</label><input id="cmp_resp" type="number" value="0"></div>'
    +'<div class="form-group"><label>Converted</label><input id="cmp_conv" type="number" value="0"></div>'
    +'<div class="form-group"><label>Status</label><select id="cmp_status"><option>Active</option><option>Closed</option></select></div></div>',
    '<button class="btn btn-pri" onclick="crmSaveCampaign()"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
};
window.crmSaveCampaign=function(){
  var D=D_(); var name=($('cmp_name')||{}).value; if(!name||!name.trim()){ toasty('Campaign name is required','err'); return; }
  D.crmCampaigns=D.crmCampaigns||[];
  D.crmCampaigns.push({id:genId(),name:name.trim(),channel:($('cmp_channel')||{}).value,target:(($('cmp_target')||{}).value||'').trim()||'All',sent:num(($('cmp_sent')||{}).value),responded:num(($('cmp_resp')||{}).value),converted:num(($('cmp_conv')||{}).value),status:($('cmp_status')||{}).value,start:tdy()});
  save(); toasty('Campaign created'); closeModal(); rerender();
};
window.crmEditCampaign=function(id){
  var D=D_(); var m=(D.crmCampaigns||[]).find(function(x){return x.id===id;}); if(!m) return;
  showModal('<i class="fa-solid fa-bullhorn" style="color:var(--pri);margin-right:8px"></i>Update Campaign — '+esc(m.name),
    '<div class="form-grid"><div class="form-group full"><label>Campaign Name</label><input id="cmp_name" value="'+esc(m.name)+'"></div>'
    +'<div class="form-group"><label>Channel</label><input id="cmp_channel" value="'+esc(m.channel)+'"></div>'
    +'<div class="form-group"><label>Target</label><input id="cmp_target" value="'+esc(m.target)+'"></div>'
    +'<div class="form-group"><label>Sent</label><input id="cmp_sent" type="number" value="'+num(m.sent)+'"></div>'
    +'<div class="form-group"><label>Responded</label><input id="cmp_resp" type="number" value="'+num(m.responded)+'"></div>'
    +'<div class="form-group"><label>Converted</label><input id="cmp_conv" type="number" value="'+num(m.converted)+'"></div>'
    +'<div class="form-group"><label>Status</label><select id="cmp_status"><option'+(m.status==='Active'?' selected':'')+'>Active</option><option'+(m.status==='Closed'?' selected':'')+'>Closed</option></select></div></div>',
    '<button class="btn btn-pri" onclick="crmUpdateCampaign('+id+')"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
};
window.crmUpdateCampaign=function(id){
  var D=D_(); var m=(D.crmCampaigns||[]).find(function(x){return x.id===id;}); if(!m) return;
  m.name=(($('cmp_name')||{}).value||m.name).trim(); m.channel=($('cmp_channel')||{}).value; m.target=($('cmp_target')||{}).value;
  m.sent=num(($('cmp_sent')||{}).value); m.responded=num(($('cmp_resp')||{}).value); m.converted=num(($('cmp_conv')||{}).value); m.status=($('cmp_status')||{}).value;
  save(); toasty('Campaign updated'); closeModal(); rerender();
};

/* ════════════════════════ REFERRERS ════════════════════════ */
function tabReferrers(){
  var D=D_(); var cs=D.crmContacts||[];
  var refs=cs.filter(function(c){return c.type==='Referring GP'||c.type==='Corporate'||c.type==='Insurance';});
  /* group by name as a referral source; count contacts that came via 'Referral' source overall */
  var fromRef=cs.filter(function(c){return c.source==='Referral';});
  var wonFromRef=fromRef.filter(function(c){return c.stage==='Won';}).length;
  var rows=refs.map(function(c){
    return '<tr style="cursor:pointer" onclick="crmView('+c.id+')"><td class="bold">'+esc(c.name)+'</td><td><span class="st st-scheduled">'+esc(c.type)+'</span></td><td style="font-size:11.5px">'+esc(c.phone||'—')+'</td><td style="font-size:11.5px">'+(c.lastContact||'—')+'</td><td>'+stagePill(c.stage)+'</td><td style="font-size:11.5px">'+esc(c.nextAction||'—')+'</td>'
      +'<td onclick="event.stopPropagation()"><div class="act-row"><button class="btn btn-xs" style="background:#0d9488;color:#fff" onclick="crmLog('+c.id+')"><i class="fa-solid fa-comment-dots"></i> Log</button></div></td></tr>';
  }).join('')||'<tr><td colspan="7" style="text-align:center;color:var(--txt3);padding:18px">No referral partners logged yet. Add a contact of type "Referring GP", "Corporate" or "Insurance".</td></tr>';
  return '<div class="kpi-grid" style="margin-bottom:12px">'
    +'<div class="kpi" style="background:linear-gradient(135deg,#0ea5e9,#38bdf8);color:#fff"><div class="kpi-val">'+refs.length+'</div><div class="kpi-label">Referral Partners</div></div>'
    +'<div class="kpi" style="background:linear-gradient(135deg,#8b5cf6,#a78bfa);color:#fff"><div class="kpi-val">'+fromRef.length+'</div><div class="kpi-label">Leads via Referral</div></div>'
    +'<div class="kpi" style="background:linear-gradient(135deg,#22c55e,#4ade80);color:#fff"><div class="kpi-val">'+wonFromRef+'</div><div class="kpi-label">Converted from Referral</div></div></div>'
    +'<div style="margin-bottom:10px"><button class="btn btn-pri" onclick="crmAdd(\'Referring GP\')"><i class="fa-solid fa-plus"></i> Add Referral Partner</button></div>'
    +'<div class="card"><div class="card-hd"><h3 style="font-size:14px"><i class="fa-solid fa-handshake-angle" style="color:#0ea5e9;margin-right:8px"></i>Referral Partners &amp; Source Performance</h3></div>'
    +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Partner</th><th>Type</th><th>Phone</th><th>Last Contact</th><th>Stage</th><th>Next Action</th><th></th></tr></thead><tbody>'+rows+'</tbody></table></div></div>';
}

/* ════════════════════════ COMPLAINTS ════════════════════════ */
function tabComplaints(){
  var D=D_(); var cps=D.crmComplaints||[];
  var sevColor={High:'#ef4444',Medium:'#f59e0b',Low:'#22c55e'};
  var open=cps.filter(function(c){return c.status!=='Resolved'&&c.status!=='Acknowledged';}).length;
  var cards=cps.map(function(c){
    return '<div class="card" style="border-left:4px solid '+(sevColor[c.severity]||'#64748b')+';margin-bottom:8px"><div style="display:flex;justify-content:space-between;gap:8px"><b>'+esc(c.code)+' — '+esc(c.subject)+'</b><span class="st '+(c.status==='Resolved'||c.status==='Acknowledged'?'st-completed':'st-pending')+'">'+esc(c.status)+'</span></div>'
      +'<div style="font-size:12px;color:var(--txt2);margin-top:4px">Contact: '+esc(c.contact||'—')+' · '+esc(c.date)+' · Severity: <b style="color:'+(sevColor[c.severity]||'#64748b')+'">'+esc(c.severity)+'</b> · Owner: '+esc(c.owner||'—')+'</div>'
      +'<div style="font-size:11.5px;margin-top:4px">'+esc(c.resolution||'')+'</div>'
      +'<div style="margin-top:8px;display:flex;gap:6px"><button class="btn btn-xs print" onclick="crmEditComplaint('+c.id+')"><i class="fa-solid fa-pen"></i> Update</button>'+(c.status!=='Resolved'?'<button class="btn btn-xs" style="background:#22c55e;color:#fff" onclick="crmResolveComplaint('+c.id+')"><i class="fa-solid fa-check"></i> Mark Resolved</button>':'')+'</div></div>';
  }).join('')||'<div style="color:var(--txt3);text-align:center;padding:18px">No complaints logged.</div>';
  return '<div style="display:flex;gap:8px;margin-bottom:12px;align-items:center"><button class="btn btn-pri" onclick="crmAddComplaint()"><i class="fa-solid fa-plus"></i> Log Complaint / Feedback</button><span style="margin-left:auto;font-size:11.5px;color:var(--txt3)"><b style="color:#ef4444">'+open+'</b> open · '+cps.length+' total</span></div>'+cards;
}
window.crmAddComplaint=function(){
  showModal('<i class="fa-solid fa-exclamation-circle" style="color:#ef4444;margin-right:8px"></i>Log Complaint / Feedback',
    '<div class="form-grid"><div class="form-group full"><label>Subject <span class="req">*</span></label><input id="cp_subj" placeholder="Short description"></div>'
    +'<div class="form-group"><label>Contact / Patient</label><input id="cp_contact"></div>'
    +'<div class="form-group"><label>Severity</label><select id="cp_sev"><option>High</option><option selected>Medium</option><option>Low</option></select></div>'
    +'<div class="form-group"><label>Owner</label><input id="cp_owner" placeholder="Who is handling it"></div>'
    +'<div class="form-group"><label>Status</label><select id="cp_status"><option>Under Review</option><option>Investigating</option><option>Acknowledged</option><option>Resolved</option></select></div>'
    +'<div class="form-group full"><label>Resolution / Notes</label><textarea id="cp_res" rows="2"></textarea></div></div>',
    '<button class="btn btn-pri" onclick="crmSaveComplaint()"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
};
window.crmSaveComplaint=function(){
  var D=D_(); var subj=($('cp_subj')||{}).value; if(!subj||!subj.trim()){ toasty('Subject is required','err'); return; }
  D.crmComplaints=D.crmComplaints||[];
  var seq=D.crmComplaints.length+1;
  D.crmComplaints.push({id:genId(),code:'COMP-'+String(seq).padStart(3,'0'),subject:subj.trim(),contact:($('cp_contact')||{}).value,date:tdy(),severity:($('cp_sev')||{}).value,status:($('cp_status')||{}).value,owner:($('cp_owner')||{}).value,resolution:($('cp_res')||{}).value});
  save(); toasty('Complaint logged'); closeModal(); rerender();
};
window.crmEditComplaint=function(id){
  var D=D_(); var c=(D.crmComplaints||[]).find(function(x){return x.id===id;}); if(!c) return;
  function so(v){ return '<option'+(c.status===v?' selected':'')+'>'+v+'</option>'; }
  showModal('Update '+esc(c.code),
    '<div class="form-grid"><div class="form-group full"><label>Subject</label><input id="cp_subj" value="'+esc(c.subject)+'"></div>'
    +'<div class="form-group"><label>Owner</label><input id="cp_owner" value="'+esc(c.owner||'')+'"></div>'
    +'<div class="form-group"><label>Status</label><select id="cp_status">'+so('Under Review')+so('Investigating')+so('Acknowledged')+so('Resolved')+'</select></div>'
    +'<div class="form-group full"><label>Resolution / Notes</label><textarea id="cp_res" rows="2">'+esc(c.resolution||'')+'</textarea></div></div>',
    '<button class="btn btn-pri" onclick="crmUpdateComplaint('+id+')"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
};
window.crmUpdateComplaint=function(id){
  var D=D_(); var c=(D.crmComplaints||[]).find(function(x){return x.id===id;}); if(!c) return;
  c.subject=(($('cp_subj')||{}).value||c.subject); c.owner=($('cp_owner')||{}).value; c.status=($('cp_status')||{}).value; c.resolution=($('cp_res')||{}).value;
  save(); toasty('Complaint updated'); closeModal(); rerender();
};
window.crmResolveComplaint=function(id){
  var D=D_(); var c=(D.crmComplaints||[]).find(function(x){return x.id===id;}); if(!c) return;
  c.status='Resolved'; save(); toasty('Complaint '+c.code+' resolved'); rerender();
};

/* ════════════════════════ CONTACT: ADD / EDIT / VIEW / LOG ════════════════════════ */
window.crmAdd=function(presetType){
  function to(v){ return '<option'+(presetType===v?' selected':'')+'>'+v+'</option>'; }
  showModal('<i class="fa-solid fa-user-plus" style="color:var(--pri);margin-right:8px"></i>New Lead / Contact',
    '<div class="form-grid"><div class="form-group"><label>Name <span class="req">*</span></label><input id="c_name"></div>'
    +'<div class="form-group"><label>Type</label><select id="c_type">'+TYPES.map(to).join('')+'</select></div>'
    +'<div class="form-group"><label>Phone</label><input id="c_phone" placeholder="+234-..."></div>'
    +'<div class="form-group"><label>Email</label><input id="c_email"></div>'
    +'<div class="form-group"><label>Source</label><select id="c_source">'+SOURCES.map(function(s){return '<option>'+s+'</option>';}).join('')+'</select></div>'
    +'<div class="form-group"><label>Stage</label><select id="c_stage">'+STAGES.map(function(s){return '<option>'+s+'</option>';}).join('')+'</select></div>'
    +'<div class="form-group"><label>Estimated Value (₦)</label><input id="c_value" type="number" placeholder="0"></div>'
    +'<div class="form-group"><label>Next Follow-up</label><input id="c_followup" type="date"></div>'
    +'<div class="form-group full"><label>Reason / Interest</label><input id="c_reason" placeholder="What does this lead want?"></div>'
    +'<div class="form-group full"><label>Next Action</label><input id="c_next" placeholder="e.g. Send package brochure"></div></div>',
    '<button class="btn btn-pri" onclick="crmSaveNew()"><i class="fa-solid fa-save"></i> Save Lead</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
};
window.crmSaveNew=function(){
  var D=D_(); var name=($('c_name')||{}).value; if(!name||!name.trim()){ toasty('Name is required','err'); return; }
  D.crmContacts=D.crmContacts||[];
  var reason=($('c_reason')||{}).value||'New enquiry';
  D.crmContacts.push({id:genId(),name:name.trim(),type:($('c_type')||{}).value,phone:($('c_phone')||{}).value,email:($('c_email')||{}).value,
    source:($('c_source')||{}).value,stage:($('c_stage')||{}).value,value:num(($('c_value')||{}).value),
    lastContact:tdy(),reason:reason,status:'Follow-up',assignedTo:meName(),nextAction:($('c_next')||{}).value,
    nextFollowUp:($('c_followup')||{}).value||'',satisfaction:null,lostReason:'',
    interactions:[{date:tdy(),channel:'Phone Call',note:reason,by:meName()}]});
  try{ if(typeof auditAction==='function') auditAction('CRM','Contact','CREATE',name+' added to pipeline','Low'); }catch(e){}
  save(); toasty('Lead saved'); closeModal(); rerender();
};
window.crmEdit=function(id){
  var D=D_(); var c=(D.crmContacts||[]).find(function(x){return x.id===id;}); if(!c) return;
  function so(list,cur){ return list.map(function(v){return '<option'+(cur===v?' selected':'')+'>'+v+'</option>';}).join(''); }
  showModal('<i class="fa-solid fa-pen" style="color:var(--pri);margin-right:8px"></i>Edit — '+esc(c.name),
    '<div class="form-grid"><div class="form-group"><label>Name</label><input id="c_name" value="'+esc(c.name)+'"></div>'
    +'<div class="form-group"><label>Type</label><select id="c_type">'+so(TYPES,c.type)+'</select></div>'
    +'<div class="form-group"><label>Phone</label><input id="c_phone" value="'+esc(c.phone||'')+'"></div>'
    +'<div class="form-group"><label>Email</label><input id="c_email" value="'+esc(c.email||'')+'"></div>'
    +'<div class="form-group"><label>Source</label><select id="c_source">'+so(SOURCES,c.source)+'</select></div>'
    +'<div class="form-group"><label>Stage</label><select id="c_stage">'+so(STAGES,c.stage)+'</select></div>'
    +'<div class="form-group"><label>Estimated Value (₦)</label><input id="c_value" type="number" value="'+num(c.value)+'"></div>'
    +'<div class="form-group"><label>Next Follow-up</label><input id="c_followup" type="date" value="'+esc(c.nextFollowUp||'')+'"></div>'
    +'<div class="form-group"><label>Satisfaction (1–5)</label><input id="c_sat" type="number" min="0" max="5" value="'+num(c.satisfaction)+'"></div>'
    +'<div class="form-group"><label>Assigned To</label><input id="c_assigned" value="'+esc(c.assignedTo||'')+'"></div>'
    +'<div class="form-group full"><label>Next Action</label><input id="c_next" value="'+esc(c.nextAction||'')+'"></div></div>',
    '<button class="btn btn-pri" onclick="crmSaveEdit('+id+')"><i class="fa-solid fa-save"></i> Save</button><button class="btn btn-dan" onclick="crmDelete('+id+')"><i class="fa-solid fa-trash"></i> Delete</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
};
window.crmSaveEdit=function(id){
  var D=D_(); var c=(D.crmContacts||[]).find(function(x){return x.id===id;}); if(!c) return;
  c.name=(($('c_name')||{}).value||c.name).trim(); c.type=($('c_type')||{}).value; c.phone=($('c_phone')||{}).value; c.email=($('c_email')||{}).value;
  c.source=($('c_source')||{}).value; c.stage=($('c_stage')||{}).value; c.value=num(($('c_value')||{}).value);
  c.nextFollowUp=($('c_followup')||{}).value||''; var sv=num(($('c_sat')||{}).value); c.satisfaction=sv>0?sv:null;
  c.assignedTo=($('c_assigned')||{}).value; c.nextAction=($('c_next')||{}).value;
  save(); toasty('Contact updated'); closeModal(); rerender();
};
window.crmDelete=function(id){
  var D=D_(); var c=(D.crmContacts||[]).find(function(x){return x.id===id;}); if(!c) return;
  if(!confirm('Delete '+c.name+' from the CRM?')) return;
  D.crmContacts=D.crmContacts.filter(function(x){return x.id!==id;});
  save(); toasty('Contact removed','err'); closeModal(); rerender();
};
window.crmView=function(id){
  var D=D_(); var c=(D.crmContacts||[]).find(function(x){return x.id===id;}); if(!c) return;
  var d=dueState(c);
  var fuTxt=c.nextFollowUp?('<span style="color:'+(d==='overdue'?'#ef4444':d==='today'?'#b45309':'var(--txt2)')+';font-weight:700">'+c.nextFollowUp+(d==='overdue'?' (overdue)':d==='today'?' (today)':'')+'</span>'):'<span style="color:var(--txt3)">none set</span>';
  var timeline=(c.interactions||[]).slice().reverse().map(function(it){
    return '<div style="display:flex;gap:10px;padding:8px 0;border-bottom:1px solid #f1f5f9"><div style="width:30px;height:30px;border-radius:8px;background:#f0fdfa;color:var(--pri);display:flex;align-items:center;justify-content:center;flex-shrink:0"><i class="fa-solid fa-comment-dots"></i></div>'
      +'<div style="flex:1"><div style="font-size:12px"><b>'+esc(it.channel)+'</b> · <span style="color:var(--txt3)">'+esc(it.date)+'</span> · '+esc(it.by||'')+'</div><div style="font-size:12px;color:var(--txt2)">'+esc(it.note||'')+'</div></div></div>';
  }).join('')||'<div style="color:var(--txt3);font-size:12px;padding:8px 0">No interactions logged yet.</div>';
  var stageBtns=STAGES.filter(function(s){return s!==c.stage;}).map(function(s){return '<button class="btn btn-xs" style="background:'+(STAGE_COLOR[s])+';color:#fff" onclick="crmStage('+id+',\''+s+'\')">→ '+s+'</button>';}).join('');
  var head='<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:10px;font-size:12px;margin-bottom:14px">'
    +'<div><div style="color:var(--txt3);font-size:10.5px">TYPE</div>'+esc(c.type)+'</div>'
    +'<div><div style="color:var(--txt3);font-size:10.5px">STAGE</div>'+stagePill(c.stage)+'</div>'
    +'<div><div style="color:var(--txt3);font-size:10.5px">PHONE</div>'+esc(c.phone||'—')+'</div>'
    +'<div><div style="color:var(--txt3);font-size:10.5px">EMAIL</div>'+esc(c.email||'—')+'</div>'
    +'<div><div style="color:var(--txt3);font-size:10.5px">SOURCE</div>'+esc(c.source)+'</div>'
    +'<div><div style="color:var(--txt3);font-size:10.5px">EST. VALUE</div>'+(c.value?money(c.value):'—')+'</div>'
    +'<div><div style="color:var(--txt3);font-size:10.5px">NEXT FOLLOW-UP</div>'+fuTxt+'</div>'
    +'<div><div style="color:var(--txt3);font-size:10.5px">SATISFACTION</div>'+stars(c.satisfaction)+'</div>'
    +'<div style="grid-column:1/-1"><div style="color:var(--txt3);font-size:10.5px">NEXT ACTION</div>'+esc(c.nextAction||'—')+'</div></div>';
  var quick='<div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:12px">'
    +'<button class="btn btn-sm btn-pri" onclick="crmLog('+id+')"><i class="fa-solid fa-comment-dots"></i> Log Interaction</button>'
    +'<button class="btn btn-sm" style="background:#25D366;color:#fff" onclick="crmQuick('+id+',\'WhatsApp\')"><i class="fa-brands fa-whatsapp"></i> WhatsApp</button>'
    +'<button class="btn btn-sm" style="background:#3b82f6;color:#fff" onclick="crmQuick('+id+',\'SMS\')"><i class="fa-solid fa-sms"></i> SMS</button>'
    +'<button class="btn btn-sm" style="background:#0d9488;color:#fff" onclick="crmBook('+id+')"><i class="fa-solid fa-calendar-check"></i> Book Appointment</button>'
    +'<button class="btn btn-sm btn-ghost" onclick="crmEdit('+id+')"><i class="fa-solid fa-pen"></i> Edit</button></div>'
    +'<div style="font-size:10.5px;color:var(--txt3);margin-bottom:6px">MOVE STAGE</div><div style="display:flex;gap:6px;flex-wrap:wrap;margin-bottom:14px">'+stageBtns+'</div>';
  var body=head+quick+'<div style="font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.5px;color:var(--txt3);margin-bottom:4px">Interaction Timeline</div>'+timeline;
  showModal('<i class="fa-solid fa-user" style="color:var(--pri);margin-right:8px"></i>'+esc(c.name),body,'<button class="btn btn-ghost" onclick="closeModal()">Close</button>','wide');
};
window.crmLog=function(id){
  var D=D_(); var c=(D.crmContacts||[]).find(function(x){return x.id===id;}); if(!c) return;
  function so(list,cur){ return list.map(function(v){return '<option'+(cur===v?' selected':'')+'>'+v+'</option>';}).join(''); }
  showModal('<i class="fa-solid fa-comment-dots" style="color:var(--pri);margin-right:8px"></i>Log Interaction — '+esc(c.name),
    '<div class="form-grid"><div class="form-group"><label>Channel</label><select id="lg_channel">'+so(CHANNELS,'Phone Call')+'</select></div>'
    +'<div class="form-group"><label>Outcome / Status</label><select id="lg_status"><option>Completed</option><option>No Answer</option><option>Follow-up</option><option>Not Interested</option></select></div>'
    +'<div class="form-group full"><label>Notes <span class="req">*</span></label><textarea id="lg_note" rows="2" placeholder="What was discussed?"></textarea></div>'
    +'<div class="form-group"><label>Move Stage To</label><select id="lg_stage">'+so(STAGES,c.stage)+'</select></div>'
    +'<div class="form-group"><label>Next Follow-up</label><input id="lg_followup" type="date" value="'+esc(c.nextFollowUp||'')+'"></div>'
    +'<div class="form-group"><label>Satisfaction (1–5, optional)</label><input id="lg_sat" type="number" min="0" max="5" value="'+(c.satisfaction||'')+'"></div>'
    +'<div class="form-group full"><label>Next Action</label><input id="lg_next" value="'+esc(c.nextAction||'')+'"></div></div>',
    '<button class="btn btn-pri" onclick="crmSaveLog('+id+')"><i class="fa-solid fa-save"></i> Save Interaction</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
};
window.crmSaveLog=function(id){
  var D=D_(); var c=(D.crmContacts||[]).find(function(x){return x.id===id;}); if(!c) return;
  var note=($('lg_note')||{}).value; if(!note||!note.trim()){ toasty('Notes are required','err'); return; }
  c.interactions=c.interactions||[];
  c.interactions.push({date:tdy(),channel:($('lg_channel')||{}).value,note:note.trim(),by:meName()});
  c.lastContact=tdy(); c.status=($('lg_status')||{}).value;
  c.stage=($('lg_stage')||{}).value; c.nextFollowUp=($('lg_followup')||{}).value||'';
  var sv=num(($('lg_sat')||{}).value); if(sv>0) c.satisfaction=sv;
  c.nextAction=($('lg_next')||{}).value;
  try{ if(typeof auditAction==='function') auditAction('CRM','Interaction','LOG',c.name+' — '+($('lg_channel')||{}).value,'Low'); }catch(e){}
  save(); toasty('Interaction logged'); closeModal(); rerender();
};
window.crmStage=function(id,st){
  var D=D_(); var c=(D.crmContacts||[]).find(function(x){return x.id===id;}); if(!c) return;
  if(st==='Lost'){ var r=prompt('Reason this lead was lost? (optional)'); c.lostReason=r||''; }
  if(st==='Won' && c.type==='Prospective') c.type='Patient';
  c.stage=st; c.lastContact=tdy();
  c.interactions=c.interactions||[]; c.interactions.push({date:tdy(),channel:'Stage change',note:'Moved to '+st,by:meName()});
  save(); toasty('Moved to '+st); closeModal(); rerender();
};
window.crmQuick=function(id,channel){
  var D=D_(); var c=(D.crmContacts||[]).find(function(x){return x.id===id;}); if(!c) return;
  var msg=prompt(channel+' message to '+c.name+(c.phone?(' ('+c.phone+')'):'')+':','Hello '+c.name+', this is '+meName()+' from Tranquil Hospital. ');
  if(msg==null) return;
  c.interactions=c.interactions||[]; c.interactions.push({date:tdy(),channel:channel,note:msg,by:meName()});
  c.lastContact=tdy();
  save(); toasty(channel+' sent (logged)'); closeModal(); rerender();
};
window.crmBook=function(id){
  var D=D_(); var c=(D.crmContacts||[]).find(function(x){return x.id===id;}); if(!c) return;
  showModal('<i class="fa-solid fa-calendar-check" style="color:var(--pri);margin-right:8px"></i>Book Appointment — '+esc(c.name),
    '<div class="form-grid"><div class="form-group"><label>Date <span class="req">*</span></label><input id="bk_date" type="date" value="'+tdy()+'"></div>'
    +'<div class="form-group"><label>Time</label><input id="bk_time" placeholder="e.g. 10:00 AM" value="10:00 AM"></div>'
    +'<div class="form-group full"><label>Reason</label><input id="bk_reason" value="'+esc(c.reason||'Consultation')+'"></div></div>'
    +'<div class="alert alert-blue" style="font-size:11.5px;margin-top:8px"><i class="fa-solid fa-info-circle"></i> Booking advances this lead to the <b>Booked</b> stage, logs the interaction and adds an appointment to the schedule.</div>',
    '<button class="btn btn-pri" onclick="crmSaveBooking('+id+')"><i class="fa-solid fa-calendar-check"></i> Confirm Booking</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
};
window.crmSaveBooking=function(id){
  var D=D_(); var c=(D.crmContacts||[]).find(function(x){return x.id===id;}); if(!c) return;
  var date=($('bk_date')||{}).value||tdy(); var time=($('bk_time')||{}).value||'10:00 AM'; var reason=($('bk_reason')||{}).value||'Consultation';
  /* try to match an existing patient by name */
  var pat=(D.patients||[]).find(function(p){return (p.fullName||'').trim().toLowerCase()===(c.name||'').trim().toLowerCase();});
  D.appointments=D.appointments||[];
  var seq=D.appointments.length+1;
  D.appointments.push({id:genId(),code:'APT-'+String(seq).padStart(4,'0'),patientId:pat?pat.id:null,patientName:pat?undefined:c.name,doctorId:null,deptId:null,date:date,time:time,duration:30,type:'Consultation',status:'Scheduled',reason:reason,source:'CRM'});
  c.stage='Booked'; c.lastContact=tdy(); c.nextAction='Confirm visit on '+date;
  c.interactions=c.interactions||[]; c.interactions.push({date:tdy(),channel:'Booking',note:'Appointment booked for '+date+' '+time+' — '+reason,by:meName()});
  try{ if(typeof auditAction==='function') auditAction('CRM','Appointment','BOOK',c.name+' booked '+date,'Low'); }catch(e){}
  save(); toasty('Appointment booked for '+c.name); closeModal(); rerender();
};

/* ════════════════════════ MAIN RENDER (overrides renderCRM) ════════════════════════ */
window.renderCRM=function(){
  normalize();
  var s=crmStats();
  var tab=D_()._crmTab||'pipeline';
  var body;
  try{
    body = tab==='contacts'?tabContacts()
        : tab==='followups'?tabFollowups()
        : tab==='campaigns'?tabCampaigns()
        : tab==='referrers'?tabReferrers()
        : tab==='complaints'?tabComplaints()
        : tabPipeline();
  }catch(e){ body='<div class="card">Unable to render: '+esc(e.message)+'</div>'; }
  var tabs='<div class="tab-row" style="flex-wrap:wrap">'
    +tabBtn('pipeline','Pipeline','fa-diagram-project')
    +tabBtn('contacts','Contacts','fa-address-book')
    +tabBtn('followups','Follow-ups','fa-bell',s.due||'')
    +tabBtn('campaigns','Campaigns','fa-bullhorn')
    +tabBtn('referrers','Referrers','fa-handshake-angle')
    +tabBtn('complaints','Complaints','fa-exclamation-circle')
    +'</div>';
  return kpiHeader()+tabs+body;
};

/* keep the old helper names working if referenced elsewhere */
window.addCRMContact=function(){ window.crmAdd(); };
window.showCRMCampaigns=function(){ D_()._crmTab='campaigns'; rerender(); };
window.showComplaintTracker=function(){ D_()._crmTab='complaints'; rerender(); };

function boot(){ try{ normalize(); }catch(e){} }
boot(); setTimeout(boot,600); setTimeout(boot,2000);
if(document.readyState==='loading'){ window.addEventListener('DOMContentLoaded', function(){ setTimeout(boot,200); }); }
try{ console.log('%c✅ v123 — Call Center / CRM rebuilt for the Business Development Manager (pipeline · follow-ups · interactions · campaigns · referrers · complaints)','background:#1e40af;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/102-twh-ess-balance-v124.js ==== */
(function(){
'use strict';
if(typeof window==='undefined') return;
function D_(){ return window.D||(window.D={}); }
function $(id){ return document.getElementById(id); }
function esc(s){ return String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
function num(v){ var n=parseFloat(v); return isNaN(n)?0:n; }
function tdy(){ try{ return (typeof today==='function')?today():new Date().toISOString().slice(0,10); }catch(e){ return new Date().toISOString().slice(0,10); } }
function money(n){ try{ return (typeof F==='function')?F(n):('₦'+Number(n||0).toLocaleString()); }catch(e){ return '₦'+(n||0); } }
function toasty(m,t){ try{ if(typeof toast==='function') toast(m,t); }catch(e){} }
function save(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} }
function rerender(){ try{ if(typeof render==='function') render(); }catch(e){} }
function empName(id){ try{ if(typeof doc==='function') return doc(id); }catch(e){} var e=(D_().employees||[]).find(function(x){return x.id===id;}); return e?e.fullName:('#'+id); }
function stc2(s){ try{ return (typeof stc==='function')?stc(s):'st-scheduled'; }catch(e){ return 'st-scheduled'; } }

var LEAVE_TYPES=['Annual','Sick','Maternity','Paternity','Compassionate','Study','Unpaid'];
var ENT_KEY={ Annual:'annualLeaveDays', Sick:'sickLeaveDays', Maternity:'maternityLeaveDays', Paternity:'paternityLeaveDays', Compassionate:'compassionateLeaveDays', Study:'studyLeaveDays' };
var ENT_DEFAULT={ Annual:20, Sick:10, Maternity:90, Paternity:14, Compassionate:5, Study:10, Unpaid:null };

/* ---- entitlement lookup: employee override → claimSettings (HR config) → settings → default ---- */
function entFor(emp,type){
  var D=D_();
  if(type==='Unpaid') return null;
  if(emp && emp.leaveEntitlements && emp.leaveEntitlements[type]!=null) return num(emp.leaveEntitlements[type]);
  var key=ENT_KEY[type]; if(!key) return ENT_DEFAULT[type]||null;
  var cs=D.claimSettings||{}, st=D.settings||{};
  if(cs[key]!=null && cs[key]!=='') return num(cs[key]);   /* HR-configured value (single source of truth) */
  if(st[key]!=null && st[key]!=='') return num(st[key]);
  return ENT_DEFAULT[type]!=null?ENT_DEFAULT[type]:null;
}
function daysOf(emp,type,status){
  var D=D_(); var yr=tdy().slice(0,4);
  return (D.leaveRequests||[]).filter(function(l){
    return l.employeeId===emp.id && l.type===type && l.status===status && String(l.startDate||'').slice(0,4)===yr;
  }).reduce(function(s,l){ return s+num(l.days); },0);
}
/* unified, synced balances — used by ESS modal, ESS tabs and HR */
window.essLeaveBalances=function(emp){
  return LEAVE_TYPES.map(function(t){
    var ent=entFor(emp,t), used=daysOf(emp,t,'Approved'), pend=daysOf(emp,t,'Pending');
    return { type:t, ent:ent, used:used, pending:pend, left:(ent==null?null:Math.max(0, ent-used)) };
  });
};
/* keep legacy callers in sync */
window.leaveBalanceAll=function(emp){ return window.essLeaveBalances(emp); };
function balFor(emp,type){ return window.essLeaveBalances(emp).filter(function(b){return b.type===type;})[0]; }

/* ---- seed D.settings entitlement keys from claimSettings so both objects agree ---- */
function syncSettings(){
  var D=D_(); D.settings=D.settings||{}; var cs=D.claimSettings||{};
  Object.keys(ENT_KEY).forEach(function(t){ var k=ENT_KEY[t];
    if((D.settings[k]==null||D.settings[k]==='') && cs[k]!=null && cs[k]!=='') D.settings[k]=num(cs[k]);
  });
}

/* ════════════ ESS: New Leave modal (synced validation) ════════════ */
function essEmpSafe(){ try{ return (typeof essEmp==='function')?essEmp():null; }catch(e){ return null; } }
window.essLeaveDays=function(){
  var f=($('lv_from')||{}).value, t=($('lv_to')||{}).value, el=$('lv_days'); if(!el) return;
  if(f&&t){ var d=Math.round((new Date(t)-new Date(f))/86400000)+1; el.value=d>0?d:''; }
};
window.__lvBalNote=function(){
  var emp=essEmpSafe(); if(!emp) return; var note=$('lv_balNote'); if(!note) return;
  var type=($('lv_type')||{}).value||'Annual'; var b=balFor(emp,type); var req=num(($('lv_days')||{}).value);
  note.innerHTML='<i class="fa-solid fa-info-circle"></i> '+esc(type)+' balance: <b>'+(b.left==null?'N/A (uncapped)':b.left)+'</b>'+(b.ent==null?'':(' of '+b.ent+' day(s)'+(b.pending?(' · '+b.pending+' pending'):'')))
    +(req>0 && b.left!=null?(' • requesting <b>'+req+'</b> day(s)'+(req>b.left?' <span style="color:#ef4444;font-weight:700">— exceeds balance</span>':'')):'');
};
window.essNewLeave=function(){
  var emp=essEmpSafe(); if(!emp){ toasty('Link your employee profile first','err'); return; }
  var bals=window.essLeaveBalances(emp);
  var balTable='<div style="border:1px solid var(--bdr);border-radius:8px;overflow:auto;margin-bottom:12px"><table class="tbl" style="margin:0;font-size:12px"><thead><tr><th>Leave Type</th><th style="text-align:right">Entitled</th><th style="text-align:right">Used</th><th style="text-align:right">Pending</th><th style="text-align:right">Remaining</th></tr></thead><tbody>'
    +bals.map(function(b){ return '<tr><td class="bold">'+esc(b.type)+'</td><td style="text-align:right">'+(b.ent==null?'—':b.ent)+'</td><td style="text-align:right">'+b.used+'</td><td style="text-align:right;color:#b45309">'+(b.pending||0)+'</td><td style="text-align:right;font-weight:700;color:'+(b.left==null?'#64748b':(b.left>0?'#16a34a':'#ef4444'))+'">'+(b.left==null?'N/A':b.left)+'</td></tr>'; }).join('')
    +'</tbody></table></div>';
  var typeOpts=LEAVE_TYPES.map(function(t){return '<option>'+esc(t)+'</option>';}).join('');
  showModal('<i class="fa-solid fa-umbrella-beach" style="color:var(--pri);margin-right:8px"></i>New Leave Request',
    balTable
    +'<div id="lv_balNote" class="alert alert-blue" style="font-size:11.5px;margin-bottom:12px"></div>'
    +'<div class="form-grid">'
    +'<div class="form-group"><label>Leave Type <span class="req">*</span></label><select id="lv_type" onchange="__lvBalNote()">'+typeOpts+'</select></div>'
    +'<div class="form-group"><label>Days</label><input id="lv_days" type="number" readonly placeholder="auto"></div>'
    +'<div class="form-group"><label>From <span class="req">*</span></label><input id="lv_from" type="date" onchange="essLeaveDays();__lvBalNote()"></div>'
    +'<div class="form-group"><label>To <span class="req">*</span></label><input id="lv_to" type="date" onchange="essLeaveDays();__lvBalNote()"></div>'
    +'<div class="form-group full"><label>Reason <span class="req">*</span></label><input id="lv_reason" placeholder="Reason for leave"></div></div>',
    '<button class="btn btn-pri" onclick="essSaveLeave()"><i class="fa-solid fa-paper-plane"></i> Submit Request</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>');
  window.__lvBalNote();
};
window.essSaveLeave=function(){
  var emp=essEmpSafe(); if(!emp) return;
  var type=($('lv_type')||{}).value, f=($('lv_from')||{}).value, t=($('lv_to')||{}).value, r=(($('lv_reason')||{}).value||'').trim();
  var days=num(($('lv_days')||{}).value);
  if(!f||!t||!r){ toasty('Dates and reason are required','err'); return; }
  if(days<=0){ toasty('End date must be on/after start date','err'); return; }
  var b=balFor(emp,type);
  if(b.left!=null && days>b.left){ toasty('Request exceeds your remaining '+type+' balance ('+b.left+' days)','err'); return; }
  var D=D_(); D.leaveRequests=D.leaveRequests||[];
  D.leaveRequests.push({ id:(typeof nid==='function'?nid():Date.now()), employeeId:emp.id, type:type, startDate:f, endDate:t, days:days, reason:r, status:'Pending', approvedBy:null, approvedDate:null });
  try{ if(typeof auditAction==='function') auditAction('HR','Leave','REQUEST',emp.fullName+' requested '+days+'d '+type+' leave','Low'); }catch(e){}
  save(); toasty('Leave request submitted for approval'); try{ closeModal(); }catch(e){} rerender();
};

/* ════════════ ESS: "Balances" tab body ════════════ */
function claimsYTD(emp,status){
  var D=D_(); var yr=tdy().slice(0,4);
  return (D.claims||[]).filter(function(c){return c.employeeId===emp.id && String(c.code||'').indexOf('CLM-S')===0 && c.status===status && String(c.date||'').slice(0,4)===yr;}).reduce(function(s,c){return s+num(c.total);},0);
}
window.essBalancesBody=function(emp){
  var bals=window.essLeaveBalances(emp);
  var leaveRows=bals.map(function(b){
    var pct=(b.ent==null||b.ent===0)?0:Math.min(100,Math.round(b.used/b.ent*100));
    return '<tr><td class="bold">'+esc(b.type)+'</td><td style="text-align:right">'+(b.ent==null?'—':b.ent)+'</td><td style="text-align:right">'+b.used+'</td><td style="text-align:right;color:#b45309">'+(b.pending||0)+'</td>'
      +'<td style="text-align:right;font-weight:700;color:'+(b.left==null?'#64748b':(b.left>0?'#16a34a':'#ef4444'))+'">'+(b.left==null?'N/A':b.left)+'</td>'
      +'<td style="min-width:120px"><div style="background:#e2e8f0;border-radius:99px;height:8px;overflow:hidden"><div style="height:100%;width:'+pct+'%;background:'+(pct>=90?'#ef4444':pct>=70?'#f59e0b':'#0d9488')+'"></div></div></td></tr>';
  }).join('');
  var clApproved=claimsYTD(emp,'Approved'), clPending=claimsYTD(emp,'Pending'), clPaid=claimsYTD(emp,'Paid');
  return '<div class="alert alert-blue" style="font-size:11.5px;margin-bottom:12px"><i class="fa-solid fa-rotate"></i> These balances are live — they reflect the entitlements set by HR (Configuration → Leave Management) and update the moment a request is approved or rejected.</div>'
    +'<div class="card" style="margin-bottom:12px"><div class="card-hd"><h3 style="font-size:14px"><i class="fa-solid fa-umbrella-beach" style="color:#1e40af;margin-right:8px"></i>Leave Balances — '+tdy().slice(0,4)+'</h3></div>'
    +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Leave Type</th><th style="text-align:right">Entitled</th><th style="text-align:right">Used</th><th style="text-align:right">Pending</th><th style="text-align:right">Remaining</th><th>Usage</th></tr></thead><tbody>'+leaveRows+'</tbody></table></div></div>'
    +'<div class="card"><div class="card-hd"><h3 style="font-size:14px"><i class="fa-solid fa-hand-holding-usd" style="color:#b45309;margin-right:8px"></i>Claims Reimbursement — '+tdy().slice(0,4)+'</h3></div>'
    +'<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:10px;padding:4px">'
    +'<div style="background:#fef3c7;border-radius:10px;padding:12px;text-align:center"><div style="font-size:18px;font-weight:800;color:#92400e">'+money(clPending)+'</div><div style="font-size:11px;color:#92400e">Pending Approval</div></div>'
    +'<div style="background:#d1fae5;border-radius:10px;padding:12px;text-align:center"><div style="font-size:18px;font-weight:800;color:#065f46">'+money(clApproved)+'</div><div style="font-size:11px;color:#065f46">Approved (awaiting pay)</div></div>'
    +'<div style="background:#dbeafe;border-radius:10px;padding:12px;text-align:center"><div style="font-size:18px;font-weight:800;color:#1e40af">'+money(clPaid)+'</div><div style="font-size:11px;color:#1e40af">Reimbursed</div></div>'
    +'</div></div>';
}
/* compact synced strip for the dashboard */
window.essBalanceStrip=function(emp){
  var bals=window.essLeaveBalances(emp).filter(function(b){return b.ent!=null;});
  var cells=bals.map(function(b){ return '<div style="flex:1;min-width:92px;background:#f8fafc;border-radius:10px;padding:9px 10px;text-align:center"><div style="font-size:17px;font-weight:800;color:'+(b.left>0?'#0d9488':'#ef4444')+'">'+b.left+'<span style="font-size:11px;color:var(--txt3)">/'+b.ent+'</span></div><div style="font-size:10px;color:var(--txt2)">'+esc(b.type)+(b.pending?(' · '+b.pending+'p'):'')+'</div></div>'; }).join('');
  return '<div class="card"><div class="card-hd"><h3 style="font-size:13px"><i class="fa-solid fa-scale-balanced" style="color:var(--pri);margin-right:6px"></i>My Leave Balances <span style="font-size:10.5px;color:var(--txt3);font-weight:400">(live · synced with HR)</span></h3><button class="btn btn-xs btn-ghost" onclick="essGo(\'balances\')">View all <i class="fa-solid fa-arrow-right"></i></button></div><div style="display:flex;gap:8px;flex-wrap:wrap">'+cells+'</div></div>';
};

/* ════════════ re-wrap renderSelfService: add Balances tab + dashboard strip ════════════ */
function wrapESS124(){
  if(typeof window.renderSelfService!=='function' || window.renderSelfService.__v124) return;
  var prev=window.renderSelfService;
  window.renderSelfService=function(){
    var D=D_();
    var emp=null; try{ emp=(typeof essEmp==='function')?essEmp():null; }catch(e){}
    if(!emp) return prev.apply(this,arguments);            /* not linked — show linker */
    if(D._essTab==='balances'){
      var tb=''
        +tb_('home','My Dashboard','fa-house-user')
        +tb_('balances','Balances','fa-scale-balanced')
        +tb_('attendance','Attendance','fa-fingerprint')
        +tb_('leave','Leave','fa-umbrella-beach')
        +tb_('claims','Staff Claims','fa-hand-holding-usd');
      var body; try{ body=window.essBalancesBody(emp); }catch(e){ body='<div class="card">Unable to render balances: '+esc(e.message)+'</div>'; }
      return '<div class="tab-row" style="flex-wrap:wrap">'+tb+'</div>'+body;
    }
    var html=prev.apply(this,arguments);
    /* add a Balances tab button right after the Leave tab */
    try{
      var btn=tb_('balances','Balances','fa-scale-balanced');
      var re=/(<button class="tab-btn[^>]*onclick="essGo\('leave'\)[\s\S]*?<\/button>)/;
      if(re.test(html)) html=html.replace(re,'$1'+btn);
    }catch(e){}
    /* on the dashboard, append the synced balance strip */
    try{ if((D._essTab||'home')==='home'){ html += window.essBalanceStrip(emp); } }catch(e){}
    return html;
  };
  window.renderSelfService.__v124=true;
}
function tb_(k,l,i){ var on=(D_()._essTab||'home')===k; return '<button class="tab-btn'+(on?' active':'')+'" onclick="essGo(\''+k+'\')"><i class="fa-solid '+i+'" style="margin-right:5px"></i>'+l+'</button>'; }

/* ════════════ HR Leave Management: surface the SAME balances + persist approvals ════════════ */
function wrapHRLeave(){
  if(typeof window.renderLeave!=='function' || window.renderLeave.__v124) return;
  var prev=window.renderLeave;
  window.renderLeave=function(){
    var html=prev.apply(this,arguments);
    try{
      var D=D_();
      var emps=(D.employees||[]).filter(function(e){return e.status==='Active';});
      var rows=emps.map(function(e){
        var bals=window.essLeaveBalances(e);
        var cell=function(t){ var b=bals.filter(function(x){return x.type===t;})[0]; if(!b) return '—'; if(b.ent==null) return '<span style="color:var(--txt3)">—</span>'; var col=b.left>0?'#16a34a':'#ef4444'; return '<span style="font-weight:700;color:'+col+'">'+b.left+'</span><span style="color:var(--txt3);font-size:10.5px">/'+b.ent+'</span>'+(b.pending?'<span style="color:#b45309;font-size:10px"> ('+b.pending+'p)</span>':''); };
        return '<tr><td class="bold">'+esc(e.fullName)+'</td><td style="font-size:11.5px">'+esc(e.position||'—')+'</td><td style="text-align:center">'+cell('Annual')+'</td><td style="text-align:center">'+cell('Sick')+'</td><td style="text-align:center">'+cell('Maternity')+'</td><td style="text-align:center">'+cell('Paternity')+'</td><td style="text-align:center">'+cell('Compassionate')+'</td><td style="text-align:center">'+cell('Study')+'</td></tr>';
      }).join('');
      var section='<div class="card" style="margin-top:16px;border-left:4px solid var(--pri)"><div class="card-hd"><h3 style="font-size:14px"><i class="fa-solid fa-scale-balanced" style="color:var(--pri);margin-right:8px"></i>Leave Balances by Employee <span style="font-size:10.5px;color:var(--txt3);font-weight:400">(same figures staff see in Self-Service · entitlements from Configuration → Leave Management)</span></h3></div>'
        +'<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Employee</th><th>Position</th><th style="text-align:center">Annual</th><th style="text-align:center">Sick</th><th style="text-align:center">Maternity</th><th style="text-align:center">Paternity</th><th style="text-align:center">Compass.</th><th style="text-align:center">Study</th></tr></thead><tbody>'+rows+'</tbody></table></div>'
        +'<div style="font-size:10.5px;color:var(--txt3);padding:6px 2px 0">Remaining / Entitled shown · "p" = days pending approval.</div></div>';
      html += section;
    }catch(e){}
    return html;
  };
  window.renderLeave.__v124=true;
}
/* persist leave approvals so balances sync everywhere */
function wrapApprovals(){
  if(typeof window.approveLeave==='function' && !window.approveLeave.__v124){
    var pa=window.approveLeave;
    window.approveLeave=function(id){ var r=pa.apply(this,arguments); save(); return r; };
    window.approveLeave.__v124=true;
  }
  if(typeof window.rejectLeave==='function' && !window.rejectLeave.__v124){
    var pr=window.rejectLeave;
    window.rejectLeave=function(id){ var r=pr.apply(this,arguments); save(); return r; };
    window.rejectLeave.__v124=true;
  }
}

function boot(){ syncSettings(); wrapESS124(); wrapHRLeave(); wrapApprovals(); }
boot(); setTimeout(boot,500); setTimeout(boot,1600); setTimeout(boot,4000); setTimeout(boot,8000);
if(document.readyState==='loading'){ window.addEventListener('DOMContentLoaded', function(){ setTimeout(boot,250); }); }
try{ console.log('%c✅ v124 — ESS balance sync (entitlements from claimSettings · Balances tab · HR balance table · persisted approvals)','background:#0e7490;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
})();

;

/* ==== /js/103-twh-dept-fix-v125.js ==== */
(function(){
'use strict';
if(typeof window==='undefined') return;
function D_(){ return window.D||(window.D={}); }
function save(){ try{ if(typeof window._hmsSave==='function') window._hmsSave(); }catch(e){} }
function audit(m,a,o,d,s){ try{ if(typeof auditAction==='function') auditAction(m,a,o,d,s||'Low'); }catch(e){} }

/* canonical specialist departments (codes + ids match the seed so both converge) */
var SPECIALIST=[
  {id:13,code:'RADI',name:'Radiology & Imaging',type:'Clinical',location:'Building B, Floor 1',phone:'3101'},
  {id:14,code:'PSYC',name:'Psychiatry & Mental Health',type:'Clinical',location:'Building C, Floor 2',phone:'3102'},
  {id:15,code:'ITSU',name:'Information Technology',type:'Administrative',location:'Building D, Floor 3',phone:'D004'},
  {id:16,code:'FACL',name:'Facilities & Maintenance',type:'Support',location:'Building D, Ground',phone:'D005'},
  {id:17,code:'SECU',name:'Security',type:'Support',location:'Main Gate',phone:'D006'},
  {id:18,code:'ADMN',name:'Administration',type:'Administrative',location:'Building D, Floor 1',phone:'D007'}
];
function deptIdByCode(code){ var D=D_(); var d=(D.departments||[]).find(function(x){return (x.code||'').toUpperCase()===String(code).toUpperCase();}); return d?d.id:null; }
function ensureDepts(){
  var D=D_(); D.departments=D.departments||[];
  SPECIALIST.forEach(function(sp){
    if(D.departments.some(function(x){return (x.code||'').toUpperCase()===sp.code;})) return; /* already there */
    var maxId=D.departments.reduce(function(m,x){return (+x.id>m)?+x.id:m;},0);
    var id=D.departments.some(function(x){return x.id===sp.id;})?(maxId+1):sp.id;
    D.departments.push({id:id,code:sp.code,name:sp.name,type:sp.type,location:sp.location,head:'',phone:sp.phone,active:true});
  });
}

/* definitive correct department for an employee */
function correctDept(emp){
  var D=D_();
  /* explicit overrides by employee code (the known TWH roster) */
  var byCode={ E014:'RADI', E015:'PSYC', E027:'RADI', E028:'RADI', E030:'ITSU', E032:'ADMN', E034:'FACL', E035:'SECU' };
  if(emp.code && byCode[emp.code]) { var idc=deptIdByCode(byCode[emp.code]); if(idc) return idc; }

  var s=((emp.specialization||'')+' '+(emp.position||'')+' '+(emp.type||'')).toLowerCase();
  function has(){ for(var i=0;i<arguments.length;i++){ if(s.indexOf(arguments[i])>=0) return true; } return false; }
  if(has('radiolog','radiograph','imaging','x-ray','xray','ultrasound','ct/mri','ct ','mri','sonograph')) return deptIdByCode('RADI');
  if(has('psychiat','mental health','psycholog')) return deptIdByCode('PSYC');
  if(has('cardio')) return deptIdByCode('CARD');
  if(has('obstetric','gynae','gynec','maternal','antenatal')) return deptIdByCode('OBST');
  if(has('neonat','nicu','paediatr','pediatr')) return deptIdByCode('PEDI');
  if(has('ortho','joint','bone')) return deptIdByCode('ORTH');
  if(has('emergenc','triage','opd','ambulance')) return deptIdByCode('EMRG');
  if(has('anesth','anaesth','surger','surgeon','operating','theatre','or nurse','perioperative')) return deptIdByCode('SURG');
  if(has('hematol','haematol','patholog','microbiol','laborator','phlebotom','lab scientist','lab director','lab tech')) return deptIdByCode('PATH');
  if(has('pharmac')) return deptIdByCode('PHAR');
  if(has('neurolog','neuro')) return deptIdByCode('NEUR');
  if(has('critical care','intensive','icu')) return deptIdByCode('ICCM');
  if(has('it support','system admin','sysadmin','information tech','software','network','helpdesk')) return deptIdByCode('ITSU');
  if(has('housekeep','sanitation','cleaning','janitor','maintenance','facilit')) return deptIdByCode('FACL');
  if(has('security','guard')) return deptIdByCode('SECU');
  if(has('finance','account','procure','supply chain','cashier','treasur','audit','billing')) return deptIdByCode('FINC');
  if(has('human resource','recruit','people ','hr manager','hr staff')) return deptIdByCode('HRES');
  if(has('reception','front desk','administ','clerk','secretar')) return deptIdByCode('ADMN');
  /* fall back by employee.type */
  var t=(emp.type||'').toLowerCase();
  if(t.indexOf('pharm')>=0) return deptIdByCode('PHAR');
  if(t.indexOf('lab')>=0) return deptIdByCode('PATH');
  if(t.indexOf('radiograph')>=0) return deptIdByCode('RADI');
  if(t.indexOf('account')>=0) return deptIdByCode('FINC');
  if(t.indexOf('hr')>=0) return deptIdByCode('HRES');
  if(t.indexOf('it')>=0) return deptIdByCode('ITSU');
  if(t.indexOf('security')>=0) return deptIdByCode('SECU');
  if(t.indexOf('driver')>=0) return deptIdByCode('EMRG');
  if(t.indexOf('support')>=0) return deptIdByCode('FACL');
  if(t.indexOf('admin')>=0) return deptIdByCode('ADMN');
  return emp.deptId||deptIdByCode('ADMN');
}

function refreshHeads(){
  var D=D_();
  (D.departments||[]).forEach(function(d){
    var staff=(D.employees||[]).filter(function(e){ return e.deptId===d.id; });
    if(!staff.length) return;
    var senior=staff.find(function(e){ return /director|head|chief|consultant|senior|manager|specialist|registrar|officer/i.test(e.position||''); });
    var head=senior||staff[0];
    if(head) d.head=head.fullName;
  });
}

function runFix(){
  var D=D_();
  if(!D||!D.employees||!D.employees.length||!D.departments){ return false; }
  if(D._deptFixV125) return true;               /* one-time authoritative correction */
  ensureDepts();
  var moved=0, log=[];
  D.employees.forEach(function(e){
    var nd=correctDept(e);
    if(nd && e.deptId!==nd){ log.push((e.fullName||e.code)+' → '+((D.departments.find(function(x){return x.id===nd;})||{}).name||nd)); e.deptId=nd; moved++; }
  });
  refreshHeads();
  D._deptFixV125=1;
  save();
  audit('HR','Departments','UPDATE','v125 corrected '+moved+' employee department(s)','Low');
  try{ console.log('%c✅ v125 — departments corrected for '+moved+' employee(s)'+(moved?(': '+log.join(' · ')):' (already correct)'),'background:#7c3aed;color:#fff;padding:4px 10px;border-radius:6px;font-weight:bold'); }catch(e){}
  try{ if(typeof render==='function' && moved) render(); }catch(e){}
  return true;
}

/* run as soon as data is present; retry until it sticks */
function boot(){ try{ if(runFix()) { /* done */ } }catch(e){ try{console.error('[v125]',e);}catch(_){} } }
boot();
[300,900,2000,4000,8000].forEach(function(ms){ setTimeout(boot,ms); });
if(document.readyState==='loading'){ window.addEventListener('DOMContentLoaded', function(){ setTimeout(boot,200); }); }
})();

;

/* ==== /js/104-end-v125.js ==== */
/* ===== WELLNESS SCREENING & ASSESSMENT MODULE (appended) ===== */
/* ============================================================================
   TRANQUIL HMS — WELLNESS SCREENING & ASSESSMENT MODULE
   Implements the 3-level Wellness Workflow from the Wellness Department guide:
     L1  Rapid Wellness Screening      (Doctor / Nutritionist / Nurse) — ALL adults
     L2  Wellness & Malnutrition Risk  (Nutritionist) — at-risk only
     L3  Comprehensive Wellness Assess (Nutritionist / Dietitian) — moderate+
   Features: auto BMI/WHR, section scoring engines, red-flag override,
   risk classification, automatic escalation + alerts, role-based access.
   Linked to all required roles via moduleRegistry + responsibilities.
   ============================================================================ */
(function(){
  'use strict';
  if(typeof D==='undefined'){console.error('[Wellness] D not found');return;}

  /* ── tiny helpers (reuse host app globals, with safe fallbacks) ─────────── */
  var WID  = function(){ return (typeof nid==='function')?nid():(Date.now()+Math.floor(Math.random()*1000)); };
  var WTOAST=function(m,t){ if(typeof toast==='function') toast(m,t); };
  var WMODAL=function(title,body,footer,size){ if(typeof showModal==='function') showModal(title,body,footer,size); };
  var WCLOSE=function(){ if(typeof closeModal==='function') closeModal(); };
  var WRENDER=function(){ if(typeof render==='function') render(); };
  var WTODAY=function(){ return new Date().toISOString().split('T')[0]; };
  var WUSER =function(){ return (D.currentUser&&D.currentUser.fullName)||'Staff'; };
  var WROLE =function(){ return (D.currentUser&&D.currentUser.role)||'Staff'; };
  var WPAT  =function(id){ var p=(D.patients||[]).find(function(x){return x.id===id;}); return p?p.fullName:'—'; };
  var WPATOBJ=function(id){ return (D.patients||[]).find(function(x){return x.id===id;})||null; };
  var gv=function(id){ var e=document.getElementById(id); return e?e.value:''; };
  var gn=function(id){ var v=parseFloat(gv(id)); return isNaN(v)?0:v; };
  var gck=function(id){ var e=document.getElementById(id); return e&&e.checked; };
  function notify(title,msg,type){ if(typeof pushNotification==='function'){ try{ pushNotification(title,msg,type||'system','wellness'); return; }catch(e){} } WTOAST(title+': '+msg); }

  /* ── role access map (who may COMPLETE each level) ──────────────────────── */
  var ALLOW_VIEW = ['System Administrator','CEO','CMO','Doctor','Nurse','Nutritionist','Dietitian','Super System Admin'];
  var ALLOW_L1   = ['System Administrator','CMO','Doctor','Nurse','Nutritionist','Super System Admin'];
  var ALLOW_L2   = ['System Administrator','CMO','Nutritionist','Super System Admin'];
  var ALLOW_L3   = ['System Administrator','CMO','Nutritionist','Dietitian','Super System Admin'];
  function canDo(list){ return list.indexOf(WROLE())!==-1; }

  /* ── idempotent setup: data stores, module registry, role links ─────────── */
  function ensureWellnessData(){
    /* CRITICAL: bind to the host's LIVE lexical `D` (the authoritative state object the
       app renders from). A separate, partial `window.D` may also exist in this app; the
       module body uses bare `D`, so data/records MUST live here too — never on window.D. */
    var DD = (typeof D!=='undefined' && D) ? D : (typeof window!=='undefined' ? window.D : null);
    if(!DD) return;
    DD.wellnessScreenings      = DD.wellnessScreenings      || [];   /* L1 */
    DD.wellnessRiskAssessments = DD.wellnessRiskAssessments || [];   /* L2 */
    DD.comprehensiveAssessments= DD.comprehensiveAssessments|| [];   /* L3 */
    DD._wellTab = DD._wellTab || 'overview';
    var wReg = { id:'wellness', group:'Clinical', label:'Wellness Screening',
      icon:'fa-heart-pulse', enabled:true, locked:false,
      features:{'well.l1':true,'well.l2':true,'well.l3':true,'well.escalate':true} };
    var roles = ['System Administrator','CEO','CMO','Doctor','Nurse','Nutritionist','Dietitian','Super System Admin'];
    var baseline = ['dashboard','patients','emr','wellness','dietary','reports'];
    function applyRBAC(obj){
      if(!obj) return;
      try{
        obj.moduleRegistry = obj.moduleRegistry || {};
        if(!obj.moduleRegistry.wellness) obj.moduleRegistry.wellness = wReg;
      }catch(e){}
      try{
        obj.responsibilities = obj.responsibilities || {};
        roles.forEach(function(role){
          obj.responsibilities[role] = obj.responsibilities[role] || {};
          obj.responsibilities[role].wellness = true;
        });
        /* baseline clinical modules for the nutrition roles so they can actually work */
        ['Nutritionist','Dietitian'].forEach(function(r){
          obj.responsibilities[r] = obj.responsibilities[r] || {};
          baseline.forEach(function(m){ if(!(m in obj.responsibilities[r])) obj.responsibilities[r][m]=true; });
        });
      }catch(e){}
    }
    /* register + link roles on the live object … */
    applyRBAC(DD);
    /* … and mirror the RBAC bits onto window.D too, in case any host code consults it. */
    try{ if(typeof window!=='undefined' && window.D && window.D!==DD) applyRBAC(window.D); }catch(e){}
  }

  /* ════════════════════════════════════════════════════════════════════════
     SCORING ENGINE
     ════════════════════════════════════════════════════════════════════════ */
  function calcBMI(h,w){ if(!h||!w) return 0; return +(w/(h*h)).toFixed(1); }
  function calcWHR(waist,hip){ if(!waist||!hip) return 0; return +(waist/hip).toFixed(2); }
  function bmiCat(b){ if(!b) return '—'; if(b<18.5) return 'Underweight'; if(b<25) return 'Normal'; if(b<30) return 'Overweight'; if(b<35) return 'Obese I'; return 'Severe Obesity'; }
  function bmiScore(b){ if(!b) return 0; if(b<18.5) return 2; if(b<25) return 0; if(b<30) return 1; if(b<35) return 2; return 3; }
  function whrScore(whr,sex){ if(!whr) return 0; if(sex==='Female'){ if(whr<0.80) return 0; if(whr<=0.85) return 1; return 2; } if(whr<0.90) return 0; if(whr<=0.95) return 1; return 2; }
  function riskColor(r){ r=(r||'').toLowerCase(); if(r.indexOf('severe')>-1) return '#ef4444'; if(r.indexOf('high')>-1) return '#f97316'; if(r.indexOf('moderate')>-1) return '#f59e0b'; if(r.indexOf('mild')>-1) return '#3b82f6'; return '#22c55e'; }
  function riskBadge(r){ return '<span style="background:'+riskColor(r)+';color:#fff;padding:3px 10px;border-radius:99px;font-size:11px;font-weight:700;white-space:nowrap">'+(r||'—')+'</span>'; }

  /* Level 1 classification */
  function l1Class(total,redFlag){ if(redFlag||total>=21) return 'Severe Risk'; if(total>=16) return 'High Risk'; if(total>=11) return 'Moderate Risk'; if(total>=6) return 'Mild Risk'; return 'Low Risk'; }
  function l1Action(r){ return {'Low Risk':'Routine advice / discharge','Mild Risk':'Lifestyle counselling','Moderate Risk':'Refer for risk assessment','High Risk':'Immediate wellness + medical review','Severe Risk':'Urgent clinical intervention'}[r]||''; }
  /* Level 2 classification (wellness total) */
  function l2Class(total,redFlag){ if(redFlag||total>=16) return 'Severe Risk'; if(total>=11) return 'High Risk'; if(total>=6) return 'Moderate Risk'; return 'Low Risk'; }
  function l2Action(r){ return {'Low Risk':'Routine monitoring','Moderate Risk':'Lifestyle intervention','High Risk':'Clinical evaluation + refer comprehensive','Severe Risk':'Urgent multidisciplinary care'}[r]||''; }
  /* Malnutrition sub-score */
  function malnClass(s){ if(s>=13) return 'Severe Risk'; if(s>=9) return 'High Risk'; if(s>=5) return 'Moderate Risk'; return 'Low Risk'; }

  /* ════════════════════════════════════════════════════════════════════════
     ESCALATION ENGINE — auto-creates the next-level task + alerts
     ════════════════════════════════════════════════════════════════════════ */
  function escalateToL2(patientId,risk,sourceCode){
    var exists=D.wellnessRiskAssessments.some(function(a){ return a.patientId===patientId && a.status==='Pending'; });
    if(!exists){
      D.wellnessRiskAssessments.push({ id:WID(), code:'WMR-'+String(D.wellnessRiskAssessments.length+1).padStart(4,'0'),
        patientId:patientId, status:'Pending', date:WTODAY(), source:'L1 '+sourceCode, triggerRisk:risk, by:null });
    }
    notify('Wellness Risk Assessment required','Patient '+WPAT(patientId)+' triggered '+risk+' on rapid screening — Nutritionist review needed', risk.indexOf('Severe')>-1?'er':'system');
  }
  function escalateToL3(patientId,risk,sourceCode){
    var exists=D.comprehensiveAssessments.some(function(a){ return a.patientId===patientId && a.status==='Pending'; });
    if(!exists){
      D.comprehensiveAssessments.push({ id:WID(), code:'CWA-'+String(D.comprehensiveAssessments.length+1).padStart(4,'0'),
        patientId:patientId, status:'Pending', date:WTODAY(), source:'L2 '+sourceCode, triggerRisk:risk, by:null });
    }
    notify('Comprehensive Wellness Assessment required','Patient '+WPAT(patientId)+' ('+risk+') referred for full clinical assessment — Nutritionist/Dietitian', risk.indexOf('Severe')>-1?'er':'system');
  }
  function redFlagAlert(patientId,level){ notify('🚨 Wellness RED FLAG','HIGH PRIORITY — '+WPAT(patientId)+' flagged at '+level+'. Immediate intervention required.','er'); }

  /* ════════════════════════════════════════════════════════════════════════
     MAIN RENDERER
     ════════════════════════════════════════════════════════════════════════ */
  function patientPicker(id,preselect){
    var opts=(D.patients||[]).filter(function(p){return p.status!=='Discharged';})
      .map(function(p){ return '<option value="'+p.id+'"'+(preselect==p.id?' selected':'')+'>'+p.fullName+' — '+(p.mrn||'')+'</option>'; }).join('');
    return '<select id="'+id+'">'+opts+'</select>';
  }
  function noAccess(msg){ return '<div class="card"><i class="fa-solid fa-lock" style="color:var(--red);margin-right:6px"></i>'+(msg||'You do not have access to this action.')+'</div>'; }

  window.wellTab=function(t){ D._wellTab=t; WRENDER(); };

  window.renderWellness=function(){
    if(!canDo(ALLOW_VIEW) && WROLE()!=='Staff') { /* allow framework default if unknown */ }
    var l1=D.wellnessScreenings, l2=D.wellnessRiskAssessments, l3=D.comprehensiveAssessments;
    var l1Done=l1.filter(function(x){return x.status==='Completed';});
    var l2Pend=l2.filter(function(x){return x.status==='Pending';}), l2Done=l2.filter(function(x){return x.status==='Completed';});
    var l3Pend=l3.filter(function(x){return x.status==='Pending';}), l3Done=l3.filter(function(x){return x.status==='Completed';});
    var sev=l1Done.filter(function(x){return x.risk==='Severe Risk';}).length+l2Done.filter(function(x){return x.risk==='Severe Risk';}).length;

    var tabs=[['overview','Overview','fa-diagram-project'],['l1','L1 · Rapid Screening','fa-stethoscope'],
              ['l2','L2 · Risk Assessment','fa-clipboard-check'],['l3','L3 · Comprehensive','fa-notes-medical']];
    var tabBar='<div class="card" style="padding:8px;display:flex;gap:6px;flex-wrap:wrap;margin-bottom:14px">'+
      tabs.map(function(t){ var a=D._wellTab===t[0]; return '<button class="btn btn-sm '+(a?'btn-pri':'btn-ghost')+'" onclick="wellTab(\''+t[0]+'\')"><i class="fa-solid '+t[2]+'"></i> '+t[1]+'</button>'; }).join('')+'</div>';

    var body='';
    if(D._wellTab==='overview') body=wOverview(l1Done,l2Pend,l2Done,l3Pend,l3Done,sev);
    else if(D._wellTab==='l1') body=wLevelList(1,l1Done);
    else if(D._wellTab==='l2') body=wLevelList(2,l2Done,l2Pend);
    else if(D._wellTab==='l3') body=wLevelList(3,l3Done,l3Pend);
    return tabBar+body;
  };

  function kpi(color,icon,val,label){
    return '<div class="kpi" style="background:linear-gradient(135deg,'+color+');color:#fff"><div class="kpi-icon" style="background:rgba(255,255,255,.2);color:#fff"><i class="fa-solid '+icon+'"></i></div><div class="kpi-val">'+val+'</div><div class="kpi-label">'+label+'</div></div>';
  }

  function wOverview(l1Done,l2Pend,l2Done,l3Pend,l3Done,sev){
    var funnelStep=function(n,title,who,count,color){
      return '<div style="flex:1;min-width:150px;text-align:center;padding:16px;background:'+color+';border-radius:14px;color:#fff">'+
        '<div style="font-size:11px;opacity:.85;font-weight:700;letter-spacing:.5px">LEVEL '+n+'</div>'+
        '<div style="font-size:28px;font-weight:800;margin:4px 0">'+count+'</div>'+
        '<div style="font-size:13px;font-weight:700">'+title+'</div>'+
        '<div style="font-size:10px;opacity:.85;margin-top:4px">'+who+'</div></div>';
    };
    var arrow='<div style="display:flex;align-items:center;color:var(--txt3);font-size:20px;padding:0 4px"><i class="fa-solid fa-arrow-right"></i></div>';

    var queue=l2Pend.concat(l3Pend).sort(function(a,b){ return (b.triggerRisk||'').localeCompare(a.triggerRisk||''); });
    var qRows=queue.map(function(it){
      var lvl=D.wellnessRiskAssessments.indexOf(it)>-1?2:3;
      return '<tr><td class="bold">'+it.code+'</td><td>'+WPAT(it.patientId)+'</td><td>Level '+lvl+'</td><td>'+(it.source||'')+'</td><td>'+riskBadge(it.triggerRisk)+'</td><td><button class="btn btn-xs btn-pri" onclick="'+(lvl===2?'wOpenL2':'wOpenL3')+'('+it.patientId+','+it.id+')"><i class="fa-solid fa-play"></i> Complete</button></td></tr>';
    }).join('')||'<tr><td colspan="6" style="color:var(--txt2);text-align:center;padding:18px">No pending escalations — workflow clear.</td></tr>';

    return '<div class="kpi-grid">'+
        kpi('#0d9488,#14b8a6','fa-stethoscope',l1Done.length,'Rapid Screenings')+
        kpi('#3b82f6,#60a5fa','fa-clipboard-check',l2Done.length,'Risk Assessments')+
        kpi('#8b5cf6,#a78bfa','fa-notes-medical',l3Done.length,'Comprehensive')+
        kpi('#ef4444,#f87171','fa-triangle-exclamation',sev+(l2Pend.length+l3Pend.length),'Pending / Severe')+
      '</div>'+
      '<div class="card"><div class="card-hd"><h3><i class="fa-solid fa-diagram-project" style="color:#0d9488;margin-right:8px"></i>Wellness Workflow Funnel</h3></div>'+
        '<div style="display:flex;align-items:stretch;gap:4px;flex-wrap:wrap">'+
          funnelStep(1,'Rapid Screening','All adult patients · Doctor / Nutritionist',l1Done.length,'linear-gradient(135deg,#0d9488,#14b8a6)')+arrow+
          funnelStep(2,'Risk Assessment','At-risk only · Nutritionist',l2Done.length,'linear-gradient(135deg,#3b82f6,#60a5fa)')+arrow+
          funnelStep(3,'Comprehensive','Moderate+ · Nutritionist / Dietitian',l3Done.length,'linear-gradient(135deg,#8b5cf6,#a78bfa)')+
        '</div>'+
        '<div style="margin-top:14px;display:flex;gap:8px;flex-wrap:wrap">'+
          (canDo(ALLOW_L1)?'<button class="btn btn-pri" onclick="wOpenL1()"><i class="fa-solid fa-plus"></i> New Rapid Screening</button>':'')+
          (canDo(ALLOW_L2)?'<button class="btn btn-ghost" onclick="wOpenL2()"><i class="fa-solid fa-clipboard-check"></i> New Risk Assessment</button>':'')+
          (canDo(ALLOW_L3)?'<button class="btn btn-ghost" onclick="wOpenL3()"><i class="fa-solid fa-notes-medical"></i> New Comprehensive</button>':'')+
        '</div></div>'+
      '<div class="card"><div class="card-hd"><h3><i class="fa-solid fa-bell" style="color:#f59e0b;margin-right:8px"></i>Escalation Queue</h3><span class="badge" style="background:#f59e0b;color:#fff">'+queue.length+' pending</span></div>'+
        '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Patient</th><th>Level</th><th>Source</th><th>Trigger Risk</th><th>Action</th></tr></thead><tbody>'+qRows+'</tbody></table></div></div>';
  }

  function wLevelList(level,done,pending){
    var cfg={1:{t:'Rapid Wellness Screening',c:'#0d9488',open:'wOpenL1',allow:ALLOW_L1,who:'Doctor / Nutritionist / Nurse'},
             2:{t:'Wellness & Malnutrition Risk Assessment',c:'#3b82f6',open:'wOpenL2',allow:ALLOW_L2,who:'Nutritionist'},
             3:{t:'Comprehensive Wellness Assessment',c:'#8b5cf6',open:'wOpenL3',allow:ALLOW_L3,who:'Nutritionist / Dietitian'}}[level];
    var canAdd=canDo(cfg.allow);
    var head='<div class="card"><div class="card-hd"><h3><i class="fa-solid fa-notes-medical" style="color:'+cfg.c+';margin-right:8px"></i>'+cfg.t+'</h3>'+
      (canAdd?'<button class="btn btn-pri btn-sm" onclick="'+cfg.open+'()"><i class="fa-solid fa-plus"></i> New</button>':'<span style="font-size:11px;color:var(--txt3)">Completed by: '+cfg.who+'</span>')+'</div>';

    var pendHtml='';
    if(pending&&pending.length){
      pendHtml='<div style="margin-bottom:10px"><div style="font-size:12px;font-weight:700;color:#f59e0b;margin-bottom:6px"><i class="fa-solid fa-hourglass-half"></i> Pending (auto-escalated)</div>'+
        '<div class="tbl-wrap"><table class="tbl"><thead><tr><th>Code</th><th>Patient</th><th>Source</th><th>Trigger</th><th></th></tr></thead><tbody>'+
        pending.map(function(it){ return '<tr><td class="bold">'+it.code+'</td><td>'+WPAT(it.patientId)+'</td><td>'+(it.source||'')+'</td><td>'+riskBadge(it.triggerRisk)+'</td><td>'+(canAdd?'<button class="btn btn-xs btn-pri" onclick="'+cfg.open+'('+it.patientId+','+it.id+')"><i class="fa-solid fa-play"></i> Complete</button>':'')+'</td></tr>'; }).join('')+
        '</tbody></table></div></div>';
    }

    var cols=level===1?'<th>Code</th><th>Patient</th><th>Date</th><th>BMI</th><th>WHR</th><th>Total</th><th>Risk</th><th>By</th>'
            :level===2?'<th>Code</th><th>Patient</th><th>Date</th><th>Wellness</th><th>Malnutrition</th><th>Risk</th><th>By</th>'
            :'<th>Code</th><th>Patient</th><th>Date</th><th>Overall</th><th>Diet Plan</th><th>Risk</th><th>By</th>';
    var rows=(done||[]).slice().reverse().map(function(r){
      if(level===1) return '<tr><td class="bold">'+r.code+'</td><td>'+WPAT(r.patientId)+'</td><td>'+r.date+'</td><td>'+(r.bmi||'—')+' <span style="font-size:10px;color:var(--txt3)">'+bmiCat(r.bmi)+'</span></td><td>'+(r.whr||'—')+'</td><td class="bold">'+r.total+'</td><td>'+riskBadge(r.risk)+(r.redFlag?' <i class="fa-solid fa-flag" style="color:#ef4444" title="Red flag"></i>':'')+'</td><td style="font-size:11px">'+(r.by||'—')+'</td></tr>';
      if(level===2) return '<tr><td class="bold">'+r.code+'</td><td>'+WPAT(r.patientId)+'</td><td>'+r.date+'</td><td class="bold">'+r.total+'</td><td>'+(r.malnScore!=null?r.malnScore+' · '+r.malnRisk:'—')+'</td><td>'+riskBadge(r.risk)+(r.redFlag?' <i class="fa-solid fa-flag" style="color:#ef4444"></i>':'')+'</td><td style="font-size:11px">'+(r.by||'—')+'</td></tr>';
      return '<tr><td class="bold">'+r.code+'</td><td>'+WPAT(r.patientId)+'</td><td>'+r.date+'</td><td class="bold">'+(r.overallScore!=null?r.overallScore:'—')+'</td><td style="font-size:11px">'+(r.dietPlan||'—')+'</td><td>'+riskBadge(r.risk)+'</td><td style="font-size:11px">'+(r.by||'—')+'</td></tr>';
    }).join('')||'<tr><td colspan="8" style="color:var(--txt2);text-align:center;padding:18px">No completed records yet.</td></tr>';

    return head+pendHtml+'<div class="tbl-wrap"><table class="tbl"><thead><tr>'+cols+'</tr></thead><tbody>'+rows+'</tbody></table></div></div>';
  }

  /* ════════════════════════════════════════════════════════════════════════
     LEVEL 1 — RAPID WELLNESS SCREENING
     ════════════════════════════════════════════════════════════════════════ */
  var SEL=function(id,opts){ return '<select id="'+id+'" oninput="wL1Calc()">'+opts.map(function(o,i){return '<option value="'+(o.v!=null?o.v:i)+'">'+o.t+'</option>';}).join('')+'</select>'; };

  window.wOpenL1=function(patientId,pendingId){
    if(!canDo(ALLOW_L1)){ WMODAL('Access Denied',noAccess('Rapid Screening is completed by Doctor, Nutritionist or Nurse.'),'<button class="btn btn-ghost" onclick="closeModal()">Close</button>'); return; }
    var p=WPATOBJ(patientId); var sex=p?p.gender:'Male';
    var body=
    '<input type="hidden" id="wl1_pending" value="'+(pendingId||'')+'">'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Patient</label>'+patientPicker('wl1_pat',patientId)+'</div>'+
      '<div class="form-group"><label>Sex</label><select id="wl1_sex" oninput="wL1Calc()"><option'+(sex==='Male'?' selected':'')+'>Male</option><option'+(sex==='Female'?' selected':'')+'>Female</option></select></div>'+
      '<div class="form-group"><label>Date</label><input type="date" id="wl1_date" value="'+WTODAY()+'"></div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#0d9488"><i class="fa-solid fa-ruler"></i> 1. Anthropometrics (auto-calculated)</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Height (m)</label><input id="wl1_h" type="number" step="0.01" value="1.70" oninput="wL1Calc()"></div>'+
      '<div class="form-group"><label>Weight (kg)</label><input id="wl1_w" type="number" step="0.1" value="70" oninput="wL1Calc()"></div>'+
      '<div class="form-group"><label>Waist (cm)</label><input id="wl1_waist" type="number" value="85" oninput="wL1Calc()"></div>'+
      '<div class="form-group"><label>Hip (cm)</label><input id="wl1_hip" type="number" value="95" oninput="wL1Calc()"></div>'+
      '<div class="form-group"><label>Recent weight loss (3–6 mo)</label>'+SEL('wl1_wl',[{v:0,t:'No weight loss'},{v:1,t:'1–5 kg'},{v:2,t:'6–10 kg'},{v:3,t:'>10 kg'}])+'</div>'+
      '<div class="form-group"><label>Appetite / intake</label>'+SEL('wl1_food',[{v:0,t:'Normal intake'},{v:1,t:'Slightly reduced'},{v:2,t:'Moderately reduced'},{v:3,t:'Very poor intake'}])+'</div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#0d9488"><i class="fa-solid fa-notes-medical"></i> 2. Disease stress</h4>'+
    '<div class="form-grid"><div class="form-group full"><label>Condition</label>'+SEL('wl1_dis',[{v:0,t:'Stable condition'},{v:1,t:'Chronic disease (DM/HTN)'},{v:2,t:'Acute illness / surgery'},{v:3,t:'Critical illness / ICU'}])+'</div></div>'+
    '<h4 style="margin:12px 0 6px;color:#0d9488"><i class="fa-solid fa-brain"></i> 3. Mental wellness (last 2 weeks)</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Stress</label>'+SEL('wl1_stress',[{v:0,t:'None'},{v:1,t:'Mild'},{v:2,t:'Moderate'},{v:3,t:'Severe'}])+'</div>'+
      '<div class="form-group"><label>Low mood</label>'+SEL('wl1_mood',[{v:0,t:'No'},{v:1,t:'Sometimes'},{v:2,t:'Often'},{v:3,t:'Severe'}])+'</div>'+
      '<div class="form-group"><label>Anxiety</label>'+SEL('wl1_anx',[{v:0,t:'No'},{v:1,t:'Mild'},{v:2,t:'Moderate'},{v:3,t:'Severe'}])+'</div>'+
      '<div class="form-group"><label>Sleep disturbance</label>'+SEL('wl1_sleep',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#0d9488"><i class="fa-solid fa-person-walking"></i> 4 & 5. Lifestyle & general wellness</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Smoking</label>'+SEL('wl1_smoke',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Alcohol</label>'+SEL('wl1_alc',[{v:0,t:'No'},{v:1,t:'Occasional'},{v:2,t:'Regular'}])+'</div>'+
      '<div class="form-group"><label>Physical inactivity</label>'+SEL('wl1_inact',[{v:0,t:'No'},{v:1,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>High-stress lifestyle</label>'+SEL('wl1_hstress',[{v:0,t:'No'},{v:1,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Frequent fatigue</label>'+SEL('wl1_fatigue',[{v:0,t:'No'},{v:1,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Poor diet quality</label>'+SEL('wl1_diet',[{v:0,t:'No'},{v:1,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Social isolation</label>'+SEL('wl1_iso',[{v:0,t:'No'},{v:1,t:'Yes'}])+'</div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#ef4444"><i class="fa-solid fa-triangle-exclamation"></i> 6. Red-flag indicators</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Unexplained weight loss</label>'+SEL('wl1_rf_wl',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Severe weakness</label>'+SEL('wl1_rf_weak',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Observable depression</label>'+SEL('wl1_rf_dep',[{v:0,t:'No'},{v:3,t:'Yes'}])+'</div>'+
    '</div>'+
    '<div class="form-group full" style="margin-top:8px"><label>Notes</label><textarea id="wl1_notes" rows="2"></textarea></div>'+
    '<div id="wl1_preview" style="margin-top:12px;padding:14px;border-radius:12px;background:#f0fdfa;border:1px solid #99f6e4"></div>';
    WMODAL('<i class="fa-solid fa-stethoscope" style="color:#0d9488;margin-right:8px"></i>Level 1 — Rapid Wellness Screening', body,
      '<button class="btn btn-pri" onclick="wSaveL1()"><i class="fa-solid fa-save"></i> Save & Classify</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
    setTimeout(wL1Calc,30);
  };

  function l1Compute(){
    var h=gn('wl1_h'),w=gn('wl1_w'),waist=gn('wl1_waist'),hip=gn('wl1_hip'),sex=gv('wl1_sex');
    var bmi=calcBMI(h,w),whr=calcWHR(waist,hip);
    var s={bmi:bmiScore(bmi),whr:whrScore(whr,sex),wl:gn('wl1_wl'),food:gn('wl1_food'),dis:gn('wl1_dis'),
      mental:gn('wl1_stress')+gn('wl1_mood')+gn('wl1_anx')+gn('wl1_sleep'),
      lifestyle:gn('wl1_smoke')+gn('wl1_alc')+gn('wl1_inact')+gn('wl1_hstress'),
      general:gn('wl1_fatigue')+gn('wl1_diet')+gn('wl1_inact')+gn('wl1_hstress')+gn('wl1_iso')};
    var rf=gn('wl1_rf_wl')+gn('wl1_rf_weak')+gn('wl1_rf_dep');
    var redFlag=(gn('wl1_rf_wl')>0||gn('wl1_rf_weak')>0||gn('wl1_rf_dep')>0);
    var total=s.bmi+s.whr+s.wl+s.food+s.dis+s.mental+s.lifestyle+s.general+rf;
    var risk=l1Class(total,redFlag);
    return {bmi:bmi,whr:whr,s:s,rf:rf,redFlag:redFlag,total:total,risk:risk,sex:sex};
  }
  window.wL1Calc=function(){
    var r=l1Compute(); var box=document.getElementById('wl1_preview'); if(!box) return;
    box.innerHTML='<div style="display:flex;gap:18px;flex-wrap:wrap;align-items:center">'+
      '<div><span style="font-size:11px;color:var(--txt3)">BMI</span><div style="font-size:20px;font-weight:800">'+(r.bmi||'—')+' <span style="font-size:11px;font-weight:500;color:var(--txt2)">'+bmiCat(r.bmi)+'</span></div></div>'+
      '<div><span style="font-size:11px;color:var(--txt3)">WHR</span><div style="font-size:20px;font-weight:800">'+(r.whr||'—')+'</div></div>'+
      '<div><span style="font-size:11px;color:var(--txt3)">Total Score</span><div style="font-size:20px;font-weight:800">'+r.total+'</div></div>'+
      '<div><span style="font-size:11px;color:var(--txt3)">Classification</span><div style="margin-top:2px">'+riskBadge(r.risk)+'</div></div>'+
      (r.redFlag?'<div style="color:#ef4444;font-weight:700"><i class="fa-solid fa-flag"></i> RED FLAG — escalate immediately</div>':'')+
      '</div><div style="margin-top:8px;font-size:12px;color:var(--txt2)"><b>Recommended action:</b> '+l1Action(r.risk)+'</div>';
  };
  window.wSaveL1=function(){
    var patId=parseInt(gv('wl1_pat')); if(!patId){ WTOAST('Select a patient','err'); return; }
    var r=l1Compute(); var pendId=gv('wl1_pending');
    var rec={ id:WID(), code:'RWS-'+String(D.wellnessScreenings.length+1).padStart(4,'0'), patientId:patId, status:'Completed',
      date:gv('wl1_date')||WTODAY(), by:WUSER(), byRole:WROLE(), sex:r.sex,
      bmi:r.bmi, whr:r.whr, scores:r.s, redFlagScore:r.rf, redFlag:r.redFlag, total:r.total, risk:r.risk,
      action:l1Action(r.risk), notes:gv('wl1_notes') };
    D.wellnessScreenings.push(rec);
    if(pendId){ var pi=D.wellnessRiskAssessments.find(function(a){return a.id==pendId;}); /* no-op: L1 has no pending */ }
    if(r.redFlag) redFlagAlert(patId,'Rapid Screening');
    if(r.redFlag || r.total>=11) escalateToL2(patId,r.risk,rec.code);   /* Moderate/High/Severe */
    WTOAST('Rapid screening saved — '+r.risk); WCLOSE();
    if(typeof window._hmsSave==='function') window._hmsSave(); WRENDER();
  };

  /* ════════════════════════════════════════════════════════════════════════
     LEVEL 2 — WELLNESS & MALNUTRITION RISK ASSESSMENT
     ════════════════════════════════════════════════════════════════════════ */
  var SEL2=function(id,opts){ return '<select id="'+id+'" oninput="wL2Calc()">'+opts.map(function(o){return '<option value="'+o.v+'">'+o.t+'</option>';}).join('')+'</select>'; };

  window.wOpenL2=function(patientId,pendingId){
    if(!canDo(ALLOW_L2)){ WMODAL('Access Denied',noAccess('Risk Assessment is completed by a Nutritionist.'),'<button class="btn btn-ghost" onclick="closeModal()">Close</button>'); return; }
    var p=WPATOBJ(patientId); var sex=p?p.gender:'Male';
    var body=
    '<input type="hidden" id="wl2_pending" value="'+(pendingId||'')+'">'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Patient</label>'+patientPicker('wl2_pat',patientId)+'</div>'+
      '<div class="form-group"><label>Sex</label><select id="wl2_sex" oninput="wL2Calc()"><option'+(sex==='Male'?' selected':'')+'>Male</option><option'+(sex==='Female'?' selected':'')+'>Female</option></select></div>'+
      '<div class="form-group"><label>Date</label><input type="date" id="wl2_date" value="'+WTODAY()+'"></div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#3b82f6"><i class="fa-solid fa-ruler"></i> 1. Body composition (auto)</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Height (m)</label><input id="wl2_h" type="number" step="0.01" value="1.70" oninput="wL2Calc()"></div>'+
      '<div class="form-group"><label>Weight (kg)</label><input id="wl2_w" type="number" step="0.1" value="70" oninput="wL2Calc()"></div>'+
      '<div class="form-group"><label>Waist (cm)</label><input id="wl2_waist" type="number" value="85" oninput="wL2Calc()"></div>'+
      '<div class="form-group"><label>Hip (cm)</label><input id="wl2_hip" type="number" value="95" oninput="wL2Calc()"></div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#3b82f6"><i class="fa-solid fa-utensils"></i> 2. Nutritional risk</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Weight change (3–6 mo)</label>'+SEL2('wl2_wc',[{v:0,t:'Stable'},{v:1,t:'1–5 kg loss'},{v:2,t:'6–10 kg loss'},{v:3,t:'>10 kg loss'}])+'</div>'+
      '<div class="form-group"><label>Dietary intake</label>'+SEL2('wl2_diet',[{v:0,t:'Normal'},{v:1,t:'Slightly reduced'},{v:2,t:'Moderately reduced'},{v:3,t:'Very poor'}])+'</div>'+
      '<div class="form-group"><label>Clinical signs</label>'+SEL2('wl2_clin',[{v:0,t:'No physical signs'},{v:1,t:'Mild muscle loss'},{v:2,t:'Moderate loss'},{v:3,t:'Severe wasting / edema'}])+'</div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#3b82f6"><i class="fa-solid fa-brain"></i> 3. Mental wellness</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Mood / depression</label>'+SEL2('wl2_mood',[{v:0,t:'None'},{v:1,t:'Mild'},{v:2,t:'Moderate'},{v:3,t:'Severe'}])+'</div>'+
      '<div class="form-group"><label>Anxiety</label>'+SEL2('wl2_anx',[{v:0,t:'None'},{v:1,t:'Mild'},{v:2,t:'Moderate'},{v:3,t:'Severe'}])+'</div>'+
      '<div class="form-group"><label>Sleep disturbance</label>'+SEL2('wl2_sleep',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#3b82f6"><i class="fa-solid fa-heart-pulse"></i> 4. Cardio-metabolic <span style="font-size:11px;font-weight:400;color:var(--txt3)">(obesity auto from BMI)</span></h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Hypertension</label>'+SEL2('wl2_htn',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Diabetes</label>'+SEL2('wl2_dm',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Physical inactivity</label>'+SEL2('wl2_inact',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Unhealthy diet pattern</label>'+SEL2('wl2_updiet',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#3b82f6"><i class="fa-solid fa-person-cane"></i> 5. Functional / frailty</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Weakness</label>'+SEL2('wl2_weak',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Difficulty walking</label>'+SEL2('wl2_walk',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>History of falls</label>'+SEL2('wl2_falls',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Reduced mobility</label>'+SEL2('wl2_mob',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#3b82f6"><i class="fa-solid fa-people-group"></i> 6. Social wellness</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Lives alone</label>'+SEL2('wl2_alone',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Poor family support</label>'+SEL2('wl2_support',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Food insecurity</label>'+SEL2('wl2_foodsec',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Financial difficulty</label>'+SEL2('wl2_fin',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Poor healthcare access</label>'+SEL2('wl2_access',[{v:0,t:'No'},{v:1,t:'Yes'}])+'</div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#ef4444"><i class="fa-solid fa-triangle-exclamation"></i> 7. Red flags</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Severe weakness</label>'+SEL2('wl2_rf_weak',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Severe depression</label>'+SEL2('wl2_rf_dep',[{v:0,t:'No'},{v:3,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Critical illness</label>'+SEL2('wl2_rf_crit',[{v:0,t:'No'},{v:3,t:'Yes'}])+'</div>'+
    '</div>'+
    '<div class="form-group full" style="margin-top:8px"><label>Notes</label><textarea id="wl2_notes" rows="2"></textarea></div>'+
    '<div id="wl2_preview" style="margin-top:12px;padding:14px;border-radius:12px;background:#eff6ff;border:1px solid #bfdbfe"></div>';
    WMODAL('<i class="fa-solid fa-clipboard-check" style="color:#3b82f6;margin-right:8px"></i>Level 2 — Wellness & Malnutrition Risk Assessment', body,
      '<button class="btn btn-pri" onclick="wSaveL2()"><i class="fa-solid fa-save"></i> Save & Classify</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
    setTimeout(wL2Calc,30);
  };

  function l2Compute(){
    var h=gn('wl2_h'),w=gn('wl2_w'),waist=gn('wl2_waist'),hip=gn('wl2_hip'),sex=gv('wl2_sex');
    var bmi=calcBMI(h,w),whr=calcWHR(waist,hip);
    var obesityScore=(bmi>=30)?2:0;  /* auto from BMI per guide */
    var bmiS=bmiScore(bmi),whrS=whrScore(whr,sex);
    var wc=gn('wl2_wc'),diet=gn('wl2_diet'),clin=gn('wl2_clin');
    var mental=gn('wl2_mood')+gn('wl2_anx')+gn('wl2_sleep');
    var cardio=gn('wl2_htn')+gn('wl2_dm')+obesityScore+gn('wl2_inact')+gn('wl2_updiet');
    var func=gn('wl2_weak')+gn('wl2_walk')+gn('wl2_falls')+gn('wl2_mob');
    var social=gn('wl2_alone')+gn('wl2_support')+gn('wl2_foodsec')+gn('wl2_fin')+gn('wl2_access');
    var rf=gn('wl2_rf_weak')+gn('wl2_rf_dep')+gn('wl2_rf_crit');
    var redFlag=(gn('wl2_rf_weak')>0||gn('wl2_rf_dep')>0||gn('wl2_rf_crit')>0);
    var total=bmiS+whrS+wc+diet+clin+mental+cardio+func+social+rf;
    var risk=l2Class(total,redFlag);
    var malnScore=bmiS+whrS+wc+diet+clin; var malnRisk=malnClass(malnScore);
    return {bmi:bmi,whr:whr,bmiS:bmiS,whrS:whrS,wc:wc,diet:diet,clin:clin,mental:mental,cardio:cardio,func:func,social:social,rf:rf,redFlag:redFlag,total:total,risk:risk,malnScore:malnScore,malnRisk:malnRisk,obesityScore:obesityScore,sex:sex};
  }
  window.wL2Calc=function(){
    var r=l2Compute(); var box=document.getElementById('wl2_preview'); if(!box) return;
    box.innerHTML='<div style="display:flex;gap:18px;flex-wrap:wrap;align-items:center">'+
      '<div><span style="font-size:11px;color:var(--txt3)">BMI</span><div style="font-size:18px;font-weight:800">'+(r.bmi||'—')+' <span style="font-size:11px;font-weight:500;color:var(--txt2)">'+bmiCat(r.bmi)+'</span></div></div>'+
      '<div><span style="font-size:11px;color:var(--txt3)">WHR</span><div style="font-size:18px;font-weight:800">'+(r.whr||'—')+'</div></div>'+
      '<div><span style="font-size:11px;color:var(--txt3)">Wellness Total</span><div style="font-size:18px;font-weight:800">'+r.total+'</div></div>'+
      '<div><span style="font-size:11px;color:var(--txt3)">Wellness Risk</span><div style="margin-top:2px">'+riskBadge(r.risk)+'</div></div>'+
      '<div style="border-left:2px solid #bfdbfe;padding-left:14px"><span style="font-size:11px;color:var(--txt3)">Malnutrition</span><div style="font-size:18px;font-weight:800">'+r.malnScore+' '+riskBadge(r.malnRisk)+'</div></div>'+
      (r.redFlag?'<div style="color:#ef4444;font-weight:700"><i class="fa-solid fa-flag"></i> RED FLAG</div>':'')+
      '</div><div style="margin-top:8px;font-size:12px;color:var(--txt2)"><b>Action:</b> '+l2Action(r.risk)+'</div>';
  };
  window.wSaveL2=function(){
    var patId=parseInt(gv('wl2_pat')); if(!patId){ WTOAST('Select a patient','err'); return; }
    var r=l2Compute(); var pendId=gv('wl2_pending'); var stub=pendId?D.wellnessRiskAssessments.find(function(a){return a.id==pendId;}):null;
    var data={ status:'Completed', date:gv('wl2_date')||WTODAY(), by:WUSER(), byRole:WROLE(),
      sex:r.sex, bmi:r.bmi, whr:r.whr, total:r.total, risk:r.risk, malnScore:r.malnScore, malnRisk:r.malnRisk,
      redFlagScore:r.rf, redFlag:r.redFlag, action:l2Action(r.risk),
      sections:{bmi:r.bmiS,whr:r.whrS,weightChange:r.wc,diet:r.diet,clinical:r.clin,mental:r.mental,cardio:r.cardio,functional:r.func,social:r.social}, notes:gv('wl2_notes') };
    if(stub){ Object.assign(stub,data); }
    else { D.wellnessRiskAssessments.push(Object.assign({ id:WID(), code:'WMR-'+String(D.wellnessRiskAssessments.length+1).padStart(4,'0'), patientId:patId, source:'Direct' }, data)); }
    if(r.redFlag) redFlagAlert(patId,'Risk Assessment');
    if(r.redFlag || r.total>=11) escalateToL3(patId,r.risk,(stub?stub.code:'WMR'));  /* High/Severe auto-refer */
    WTOAST('Risk assessment saved — '+r.risk+' · Malnutrition '+r.malnRisk); WCLOSE();
    if(typeof window._hmsSave==='function') window._hmsSave(); WRENDER();
  };

  /* ════════════════════════════════════════════════════════════════════════
     LEVEL 3 — COMPREHENSIVE WELLNESS ASSESSMENT (with CDSS auto care-plan)
     ════════════════════════════════════════════════════════════════════════ */
  window.wOpenL3=function(patientId,pendingId){
    if(!canDo(ALLOW_L3)){ WMODAL('Access Denied',noAccess('Comprehensive Assessment is completed by a Nutritionist or Dietitian.'),'<button class="btn btn-ghost" onclick="closeModal()">Close</button>'); return; }
    var p=WPATOBJ(patientId); var sex=p?p.gender:'Male'; var dx=p?(p.conditions||''):'';
    var body=
    '<input type="hidden" id="wl3_pending" value="'+(pendingId||'')+'">'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Patient</label>'+patientPicker('wl3_pat',patientId)+'</div>'+
      '<div class="form-group"><label>Sex</label><select id="wl3_sex" oninput="wL3Calc()"><option'+(sex==='Male'?' selected':'')+'>Male</option><option'+(sex==='Female'?' selected':'')+'>Female</option></select></div>'+
      '<div class="form-group"><label>Date</label><input type="date" id="wl3_date" value="'+WTODAY()+'"></div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#8b5cf6"><i class="fa-solid fa-notes-medical"></i> Medical</h4>'+
    '<div class="form-grid"><div class="form-group full"><label>Primary diagnosis</label><input id="wl3_dx" value="'+dx.replace(/"/g,'&quot;')+'" oninput="wL3Calc()"></div></div>'+
    '<h4 style="margin:12px 0 6px;color:#8b5cf6"><i class="fa-solid fa-ruler"></i> Anthropometrics (auto)</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Height (m)</label><input id="wl3_h" type="number" step="0.01" value="1.70" oninput="wL3Calc()"></div>'+
      '<div class="form-group"><label>Weight (kg)</label><input id="wl3_w" type="number" step="0.1" value="70" oninput="wL3Calc()"></div>'+
      '<div class="form-group"><label>Waist (cm)</label><input id="wl3_waist" type="number" value="85" oninput="wL3Calc()"></div>'+
      '<div class="form-group"><label>Hip (cm)</label><input id="wl3_hip" type="number" value="95" oninput="wL3Calc()"></div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#8b5cf6"><i class="fa-solid fa-utensils"></i> Nutrition</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Appetite</label>'+SEL3('wl3_appetite',[{v:0,t:'Good'},{v:1,t:'Fair'},{v:2,t:'Poor'}])+'</div>'+
      '<div class="form-group"><label>Weight loss (3–6 mo)</label>'+SEL3('wl3_wl',[{v:0,t:'None'},{v:1,t:'1–5 kg'},{v:2,t:'6–10 kg'},{v:3,t:'>10 kg'}])+'</div>'+
      '<div class="form-group"><label>Malnutrition signs</label>'+SEL3('wl3_signs',[{v:0,t:'None observed'},{v:1,t:'Mild'},{v:2,t:'Moderate'},{v:3,t:'Severe wasting/edema'}])+'</div>'+
      '<div class="form-group"><label>GI symptoms</label>'+SEL3('wl3_gi',[{v:0,t:'None'},{v:1,t:'Mild (nausea/bloating)'},{v:2,t:'Significant'}])+'</div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#8b5cf6"><i class="fa-solid fa-person-running"></i> Lifestyle</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Physical activity</label>'+SEL3('wl3_act',[{v:2,t:'Sedentary'},{v:1,t:'Light'},{v:0,t:'Moderate'},{v:0,t:'Very active'}])+'</div>'+
      '<div class="form-group"><label>Smoking</label>'+SEL3('wl3_smoke',[{v:0,t:'No'},{v:2,t:'Yes'}])+'</div>'+
      '<div class="form-group"><label>Alcohol</label>'+SEL3('wl3_alc',[{v:0,t:'None'},{v:1,t:'Occasional'},{v:2,t:'Regular'}])+'</div>'+
      '<div class="form-group"><label>Sleep quality</label>'+SEL3('wl3_sleep',[{v:0,t:'Good'},{v:1,t:'Fair'},{v:2,t:'Poor'}])+'</div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#8b5cf6"><i class="fa-solid fa-brain"></i> Mental & functional</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Stress level</label>'+SEL3('wl3_stress',[{v:0,t:'Low'},{v:1,t:'Moderate'},{v:2,t:'High'}])+'</div>'+
      '<div class="form-group"><label>Mood</label>'+SEL3('wl3_mood',[{v:0,t:'Stable'},{v:1,t:'Anxious/Irritable'},{v:2,t:'Depressed'},{v:3,t:'Severe'}])+'</div>'+
      '<div class="form-group"><label>Mobility</label>'+SEL3('wl3_mob',[{v:0,t:'Independent'},{v:1,t:'Needs assistance'},{v:2,t:'Dependent'}])+'</div>'+
      '<div class="form-group"><label>Muscle strength</label>'+SEL3('wl3_strength',[{v:0,t:'Normal'},{v:1,t:'Reduced'},{v:2,t:'Severe weakness'}])+'</div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#8b5cf6"><i class="fa-solid fa-people-roof"></i> Social</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Support system</label>'+SEL3('wl3_support',[{v:0,t:'Strong'},{v:1,t:'Moderate'},{v:2,t:'Poor'}])+'</div>'+
      '<div class="form-group"><label>Food access</label>'+SEL3('wl3_foodacc',[{v:0,t:'Adequate'},{v:1,t:'Limited'},{v:2,t:'Inadequate'}])+'</div>'+
    '</div>'+
    '<h4 style="margin:12px 0 6px;color:#8b5cf6"><i class="fa-solid fa-bullseye"></i> Care plan</h4>'+
    '<div class="form-grid">'+
      '<div class="form-group"><label>Diet type</label><select id="wl3_diet"><option>Balanced wellness</option><option>Weight loss</option><option>Diabetic</option><option>Hypertension (DASH)</option><option>Renal</option><option>High protein</option><option>High fibre</option></select></div>'+
      '<div class="form-group"><label>Target calories (kcal/day)</label><input id="wl3_cal" type="number" value="2000"></div>'+
      '<div class="form-group"><label>Follow-up</label><select id="wl3_fu"><option>2 weeks (high risk)</option><option>1 month (stable)</option><option>3 months (routine)</option></select></div>'+
      '<div class="form-group full"><label>Intervention notes / education</label><textarea id="wl3_notes" rows="2"></textarea></div>'+
    '</div>'+
    '<div id="wl3_preview" style="margin-top:12px;padding:14px;border-radius:12px;background:#f5f3ff;border:1px solid #ddd6fe"></div>';
    WMODAL('<i class="fa-solid fa-notes-medical" style="color:#8b5cf6;margin-right:8px"></i>Level 3 — Comprehensive Wellness Assessment', body,
      '<button class="btn btn-pri" onclick="wSaveL3()"><i class="fa-solid fa-save"></i> Save & Generate Care Plan</button><button class="btn btn-ghost" onclick="closeModal()">Cancel</button>','wide');
    setTimeout(wL3Calc,30);
  };
  function SEL3(id,opts){ return '<select id="'+id+'" oninput="wL3Calc()">'+opts.map(function(o){return '<option value="'+o.v+'">'+o.t+'</option>';}).join('')+'</select>'; }

  function l3Compute(){
    var h=gn('wl3_h'),w=gn('wl3_w'),waist=gn('wl3_waist'),hip=gn('wl3_hip'),sex=gv('wl3_sex');
    var bmi=calcBMI(h,w),whr=calcWHR(waist,hip);
    var nutrition=bmiScore(bmi)+gn('wl3_appetite')+gn('wl3_wl')+gn('wl3_signs')+gn('wl3_gi');
    var lifestyle=gn('wl3_act')+gn('wl3_smoke')+gn('wl3_alc')+gn('wl3_sleep')+whrScore(whr,sex);
    var mental=gn('wl3_stress')+gn('wl3_mood');
    var functional=gn('wl3_mob')+gn('wl3_strength');
    var social=gn('wl3_support')+gn('wl3_foodacc');
    var overall=nutrition+lifestyle+mental+functional+social;
    var risk=overall>=18?'Severe Risk':overall>=12?'High Risk':overall>=6?'Moderate Risk':'Low Risk';
    /* CDSS auto care-plan suggestions */
    var dx=(gv('wl3_dx')||'').toLowerCase(); var sugg=[];
    if(dx.indexOf('hypertension')>-1||dx.indexOf('htn')>-1) sugg.push('Low-sodium DASH diet');
    if(dx.indexOf('diab')>-1) sugg.push('Diabetic / low-GI meal plan');
    if(dx.indexOf('renal')>-1||dx.indexOf('kidney')>-1) sugg.push('Renal diet (protein/K/Na control)');
    if(bmi>=30) sugg.push('Structured weight-loss plan + activity Rx');
    if(bmi&&bmi<18.5) sugg.push('High-calorie/high-protein repletion');
    if(gn('wl3_gi')>=1) sugg.push('High-fibre + hydration plan');
    if(gn('wl3_mood')>=2||gn('wl3_stress')>=2) sugg.push('Mental wellness / counselling referral');
    if(!sugg.length) sugg.push('Balanced wellness maintenance plan');
    return {bmi:bmi,whr:whr,nutrition:nutrition,lifestyle:lifestyle,mental:mental,functional:functional,social:social,overall:overall,risk:risk,sugg:sugg,sex:sex};
  }
  window.wL3Calc=function(){
    var r=l3Compute(); var box=document.getElementById('wl3_preview'); if(!box) return;
    box.innerHTML='<div style="display:flex;gap:16px;flex-wrap:wrap;align-items:center">'+
      '<div><span style="font-size:11px;color:var(--txt3)">BMI</span><div style="font-size:18px;font-weight:800">'+(r.bmi||'—')+' <span style="font-size:11px;font-weight:500;color:var(--txt2)">'+bmiCat(r.bmi)+'</span></div></div>'+
      '<div><span style="font-size:11px;color:var(--txt3)">Nutrition</span><div style="font-size:16px;font-weight:800">'+r.nutrition+'</div></div>'+
      '<div><span style="font-size:11px;color:var(--txt3)">Lifestyle</span><div style="font-size:16px;font-weight:800">'+r.lifestyle+'</div></div>'+
      '<div><span style="font-size:11px;color:var(--txt3)">Mental</span><div style="font-size:16px;font-weight:800">'+r.mental+'</div></div>'+
      '<div><span style="font-size:11px;color:var(--txt3)">Functional</span><div style="font-size:16px;font-weight:800">'+r.functional+'</div></div>'+
      '<div style="border-left:2px solid #ddd6fe;padding-left:14px"><span style="font-size:11px;color:var(--txt3)">Overall Wellness</span><div style="font-size:18px;font-weight:800">'+r.overall+' '+riskBadge(r.risk)+'</div></div>'+
      '</div><div style="margin-top:10px;font-size:12px;color:var(--txt2)"><b><i class="fa-solid fa-robot" style="color:#8b5cf6"></i> Clinical Decision Support — suggested plan:</b> '+r.sugg.join(' · ')+'</div>';
  };
  window.wSaveL3=function(){
    var patId=parseInt(gv('wl3_pat')); if(!patId){ WTOAST('Select a patient','err'); return; }
    var r=l3Compute(); var pendId=gv('wl3_pending'); var stub=pendId?D.comprehensiveAssessments.find(function(a){return a.id==pendId;}):null;
    var data={ status:'Completed', date:gv('wl3_date')||WTODAY(), by:WUSER(), byRole:WROLE(),
      diagnosis:gv('wl3_dx'), bmi:r.bmi, whr:r.whr,
      scores:{nutrition:r.nutrition,lifestyle:r.lifestyle,mental:r.mental,functional:r.functional,social:r.social},
      overallScore:r.overall, risk:r.risk, dietPlan:gv('wl3_diet'), calories:gn('wl3_cal'),
      followUp:gv('wl3_fu'), cdss:r.sugg, notes:gv('wl3_notes') };
    if(stub){ Object.assign(stub,data); }
    else { D.comprehensiveAssessments.push(Object.assign({ id:WID(), code:'CWA-'+String(D.comprehensiveAssessments.length+1).padStart(4,'0'), patientId:patId, source:'Direct' }, data)); }
    /* auto-create a dietary order to close the loop with the existing Dietary module */
    try{
      if(Array.isArray(D.dietaryOrders)){
        var p=WPATOBJ(patId);
        D.dietaryOrders.push({ id:WID(), code:'DIET-'+String(D.dietaryOrders.length+1).padStart(4,'0'), patientId:patId,
          patientName:p?p.fullName:'', ward:p&&p.room?p.room.split('-')[0]:'', bed:p&&p.room?p.room:'', diet:gv('wl3_diet'),
          allergies:p?p.allergies:'', restrictions:'From wellness care plan ('+r.risk+')', mealType:'Lunch', status:'Preparing',
          deliveryTime:'—', notes:gv('wl3_notes'), calories:gn('wl3_cal')||2000 });
      }
    }catch(e){}
    notify('Wellness care plan generated','Individualised plan for '+WPAT(patId)+' — '+gv('wl3_diet')+', follow-up '+gv('wl3_fu'),'system');
    WTOAST('Comprehensive assessment saved — care plan generated'); WCLOSE();
    if(typeof window._hmsSave==='function') window._hmsSave(); WRENDER();
  };

  /* ════════════════════════════════════════════════════════════════════════
     WIRE INTO HOST APP — idempotent; survives later re-patches & D re-seeds.
     Later enhancement scripts (v23–v30) run on timers AFTER this module and
     replace renderModule/buildNav and re-seed the registry/responsibilities.
     We therefore (a) re-ensure data+RBAC and (b) re-wrap the *current* host
     functions whenever they are not already our wrappers.
     ════════════════════════════════════════════════════════════════════════ */
  function applyWellnessWiring(){
    ensureWellnessData();

    if(!window.renderModule || !window.renderModule._wellWrapped){
      var _rm=window.renderModule;
      var f=function(){ if(typeof currentMod!=='undefined' && currentMod==='wellness') return window.renderWellness(); return _rm?_rm():''; };
      f._wellWrapped=true; window.renderModule=f;
    }
    if(!window.getModTitle || !window.getModTitle._wellWrapped){
      var _gt=window.getModTitle;
      var g=function(){ if(typeof currentMod!=='undefined' && currentMod==='wellness') return 'Wellness Screening & Assessment'; return _gt?_gt():'Dashboard'; };
      g._wellWrapped=true; window.getModTitle=g;
    }
    if(!window.buildNav || !window.buildNav._wellWrapped){
      var _bn=window.buildNav;
      var b=function(){
        var html=_bn?_bn():'';
        if(/goTo\('wellness'\)/.test(html)) return html; /* already present */
        if(typeof window.hasModuleAccess==='function' && !window.hasModuleAccess('wellness')) return html;
        var DD=(typeof D!=='undefined'&&D)?D:window.D;
        var pend=(DD.wellnessRiskAssessments||[]).filter(function(a){return a.status==='Pending';}).length
                +(DD.comprehensiveAssessments||[]).filter(function(a){return a.status==='Pending';}).length;
        var btn='<button class="sb-item '+((typeof currentMod!=='undefined'&&currentMod==='wellness')?'active':'')+'" onclick="goTo(\'wellness\')"><i class="fa-solid fa-heart-pulse"></i><span>Wellness Screening</span>'+(pend?'<span class="badge" style="background:#f59e0b">'+pend+'</span>':'')+'</button>';
        if(/goTo\('patients'\)/.test(html)){
          html=html.replace(/(<button class="sb-item[^"]*" onclick="goTo\('patients'\)">[\s\S]*?<\/button>)/, '$1'+btn);
        } else { html+=btn; }
        return html;
      };
      b._wellWrapped=true; window.buildNav=b;
    }
  }

  /* apply now, then again after the late enhancement scripts have run */
  applyWellnessWiring();
  [0,300,800,1500,3000,5000].forEach(function(ms){ setTimeout(applyWellnessWiring,ms); });
  if(typeof window.addEventListener==='function'){ window.addEventListener('load',function(){ applyWellnessWiring(); setTimeout(applyWellnessWiring,500); }); }
  /* keep nav/registry healthy on every re-render without stacking wrappers */
  DOMBus.register(applyWellnessWiring);

  console.log('[Wellness] Module loaded — 3-level workflow, scoring engine, escalation, RBAC linked to all roles.');
})();

/* ════════════════════════════════════════════════════════════════════════
   TWH · PATIENTS MODULE — ROBUST FILTERS + SEARCH + "SORT BY RECENT" (v308)
   ────────────────────────────────────────────────────────────────────────
   Appended to 104 (an independent IIFE) rather than shipped as a new manifest
   module, so the APP-chunk count stays 226 and the size-budget balancer keeps
   its passing cut points (a standalone module tipped APP chunk 2 over budget).

   User report (verbatim):
     "some field are … not functioning well on the patient module for the
      following : all status, all card types, all departments, search name,
      MRN. Make the search to work perfectly. also add button to sort by
      recent."

   ── WHY THE FILTERS / SEARCH DID NOT WORK RELIABLY ───────────────────────
   The core (010) filter window.V25_filterPatients() decides row visibility by
   reading FIXED CELL INDICES of each rendered <tr> (status←cells[8],
   card←cells[2], dept/search←whole-row text). But later packs RESHAPE rows:
   v119 (097) wraps the Patient name cell in a nested <div> + avatar; v164
   (114) scrubs "duplicate payer" <td>s on a timer/interval — which can REMOVE
   cells and shift every index to the right of the payer column. Once indices
   drift, the status/card filters match the wrong (or emptied) column, so the
   dropdowns "do nothing"; the dept filter also fails when the visible dept
   text differs from the stored name. Net: non-functioning filters / search.

   ── FIX ──────────────────────────────────────────────────────────────────
   (A) DATA-DRIVEN FILTER. Read the patient RECORD per row (each row carries
       the patient id in its action buttons: V25_viewPatient(<id>) /
       editRecord('patients',<id>)). Resolve id → D.patients and filter on the
       ACTUAL fields (status, cardTypeId, deptId, fullName, mrn) — immune to
       cell reshaping. Unresolvable rows fall back to robust whole-row text.
       We REPLACE window.V25_filterPatients (the existing onchange/onkeyup
       handlers keep calling it, now reliably).
   (B) FILTER PERSISTENCE. Re-apply the active filter after any re-render /
       sort / sweep so a filtered/searched view is never silently reset.
   (C) "SORT BY RECENT" BUTTON. Next to v166's "Sort A→Z" we inject a "Recent
       First / Oldest First" toggle ordering by createdAt/registeredAt/id, then
       re-apply the active filter so visibility stays correct.

   Governor-safe: DOMBus.register + HMS.every(≥10000) + bounded setTimeout; NO
   raw setInterval / MutationObserver / DOMContentLoaded; never wraps render /
   renderModule / goTo / doLogin; no for-in flag copy. Guard window.__twhV308.
   Diagnostics: window.__twhV308Diag()   Toggle: window.TWH_PATIENT_FILTERS
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV308) return;
  window.__twhV308 = true;

  if (typeof window.TWH_PATIENT_FILTERS === 'undefined') window.TWH_PATIENT_FILTERS = true;

  function isFn(f) { return typeof f === 'function'; }
  function log() {
    try { console.log.apply(console, ['%c[v308]', 'color:#fff;background:#0d9488;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (_e) {}
  }
  function D_() { try { if (typeof D !== 'undefined' && D) return D; } catch (_e) {} return window.D || null; }

  var diag = {
    filterInstalled: false, filtered: 0, lastCriteria: null,
    recentBtnInjected: false, sortButtonsDocked: false, sortedRecent: 0, recentDir: 'desc',
    resolvedById: 0, resolvedByText: 0, restored: 0, cleared: 0,
    stateChangedWired: false, toolbarCssInjected: false, lastError: null
  };

  function rowPatientId(tr) {
    if (!tr) return null;
    if (tr.__twhPid != null) return tr.__twhPid;
    var id = null;
    try {
      // NOTE: attribute-substring selectors must NOT include a trailing "(" —
      // an unescaped paren in [attr*="…("] fails to match in jsdom and some
      // engines. Match on the function NAME only, then pull the id from the
      // full onclick string with a strict regex (which keeps the paren).
      var nodes = tr.querySelectorAll('[onclick]');
      for (var k = 0; k < nodes.length && id == null; k++) {
        var oc = nodes[k].getAttribute('onclick') || '';
        var m = oc.match(/(?:V25_viewPatient\(|editRecord\('patients',|V25_printPatientCard\()\s*(\d+)/);
        if (m) id = parseInt(m[1], 10);
      }
    } catch (_e) {}
    if (id != null && !isNaN(id)) { tr.__twhPid = id; return id; }
    return null;
  }
  function patientById(id) {
    var d = D_(); if (!d || !d.patients) return null;
    for (var i = 0; i < d.patients.length; i++) { if (d.patients[i] && d.patients[i].id === id) return d.patients[i]; }
    return null;
  }

  /* ── (A) hardened, data-driven filter ───────────────────────────────────── */
  // Persisted "last user intent". The DB-sync poll (~10s) emits 'state:changed';
  // pack 178 (v230) routes that through quietRepaint() which does
  //   #moduleContent.innerHTML = renderModule()
  // rebuilding #patTable with fresh display:'' rows AND a NEW EMPTY search input.
  // Without persistence the live controls are wiped, so the next filter pass sees
  // no criteria and the view "disappears" back to the full list. We therefore
  // remember the criteria in _active and, after any rebuild, write them back into
  // the freshly-minted controls and re-filter — so the search STICKS until the
  // user explicitly clears it. This also removes the visible list-shake, because
  // the filtered subset is restored on the same tick as the rebuild.
  var _active = { st: '', ct: '', dp: '', q: '' };
  function _hasCriteria(c) { return !!(c && (c.st || c.ct || c.dp || c.q)); }
  function _cloneCriteria(c) { return { st: c.st || '', ct: c.ct || '', dp: c.dp || '', q: c.q || '' }; }
  function _sameCriteria(a, b) { return a.st === b.st && a.ct === b.ct && a.dp === b.dp && a.q === b.q; }

  function readCriteria() {
    return {
      st: (document.getElementById('patFilterStatus') || {}).value || '',
      ct: (document.getElementById('patFilterCard') || {}).value || '',
      dp: (document.getElementById('patFilterDept') || {}).value || '',
      q: (((document.getElementById('patFilterSearch') || {}).value || '') + '').trim().toLowerCase()
    };
  }
  // Write persisted criteria back into freshly-rebuilt controls. Only touches a
  // control that EXISTS and whose value differs, so it never fights live typing.
  function writeControls(c) {
    try {
      var st = document.getElementById('patFilterStatus'); if (st && st.value !== c.st) st.value = c.st;
      var ct = document.getElementById('patFilterCard'); if (ct && ct.value !== c.ct) ct.value = c.ct;
      var dp = document.getElementById('patFilterDept'); if (dp && dp.value !== c.dp) dp.value = c.dp;
      var q = document.getElementById('patFilterSearch');
      // The search box holds the RAW (un-lowercased) text; _active.q is trimmed
      // + lowercased. Only rewrite when the box is empty but we have a query —
      // i.e. it was just wiped by a rebuild — so we don't clobber the user's
      // exact casing/spacing while they are actively typing.
      if (q && c.q && !((q.value || '') + '').trim()) q.value = c.q;
    } catch (_e) {}
  }
  // Called after a rebuild (state:changed / DOM mutation). If the persisted
  // intent still wants a filtered view but the live controls came back empty,
  // restore them and re-apply the filter — synchronously, so there is no flash
  // of the full list.
  function restoreControls() {
    if (!window.TWH_PATIENT_FILTERS) return;
    if (!_hasCriteria(_active)) return;
    var tbl = document.getElementById('patTable'); if (!tbl) return;
    var live = readCriteria();
    if (!_hasCriteria(live) || !_sameCriteria(live, _active)) {
      writeControls(_active);
      diag.restored++;
    }
    try { hardenedFilter(); } catch (_e) {}
  }
  function matchesRecord(p, c) {
    if (c.st && String(p.status || '').toLowerCase() !== c.st.toLowerCase()) return false;
    if (c.ct) { var cid = parseInt(c.ct, 10); if (!isNaN(cid) && p.cardTypeId !== cid) return false; }
    if (c.dp) { var did = parseInt(c.dp, 10); if (!isNaN(did) && p.deptId !== did) return false; }
    if (c.q) {
      var hay = [p.fullName, p.mrn, p.phone, p.status].map(function (x) { return (x == null ? '' : String(x)).toLowerCase(); }).join(' ');
      if (hay.indexOf(c.q) === -1) return false;
    }
    return true;
  }
  function matchesText(tr, c) {
    var text = (tr.textContent || '').toLowerCase();
    if (c.q && text.indexOf(c.q) === -1) return false;
    if (c.st && text.indexOf(c.st.toLowerCase()) === -1) return false;
    if (c.dp) {
      var d = D_(); var dn = ((d && d.departments || []).find(function (x) { return x && x.id === parseInt(c.dp, 10); }) || {}).name || '';
      if (dn && text.indexOf(dn.toLowerCase()) === -1) return false;
    }
    return true;
  }
  function hardenedFilter() {
    if (!window.TWH_PATIENT_FILTERS) return;
    var tbl = document.getElementById('patTable'); if (!tbl) return;
    var live = readCriteria();
    var c;
    // Decide whether this pass reflects a genuine user intent (live controls have
    // criteria) or a post-rebuild pass where the controls were wiped. If the live
    // controls carry criteria, that IS the current intent → persist it. Otherwise,
    // fall back to the persisted _active (search sticks across rebuilds) UNLESS the
    // user has explicitly cleared everything.
    if (_hasCriteria(live)) {
      _active = _cloneCriteria(live);
      c = live;
    } else if (_hasCriteria(_active) && document.getElementById('patFilterSearch')) {
      // Controls exist but came back empty while we still hold intent: a rebuild
      // just wiped them. Restore the values, then filter by the persisted intent.
      writeControls(_active);
      c = _cloneCriteria(_active);
    } else {
      // No live criteria and no persisted intent → show everything.
      c = live;
    }
    diag.lastCriteria = c;
    var rows;
    try { rows = tbl.querySelectorAll('tbody tr'); } catch (_e) { return; }
    var shown = 0, byId = 0, byText = 0;
    Array.prototype.forEach.call(rows, function (tr) {
      if (tr.id === 'twhPatNoMatch') return;
      var cells = tr.cells;
      // Only WRITE tr.style.display when it actually needs to change. Writing the
      // same value on every DOMBus sweep is still an attribute mutation that
      // re-triggers the shared MutationObserver → another sweep → the search
      // result list "blinks". Diff-guarding the write makes a steady-state
      // re-filter a pure no-op (zero DOM writes) so the list stays perfectly
      // still while the ~10s DB-sync poll runs.
      if (!cells || !cells.length) { if (tr.style.display !== '') tr.style.display = ''; return; }
      var show = true;
      var id = rowPatientId(tr);
      var p = id != null ? patientById(id) : null;
      if (p) { show = matchesRecord(p, c); byId++; }
      else { show = matchesText(tr, c); byText++; }
      var want = show ? '' : 'none';
      if (tr.style.display !== want) tr.style.display = want;
      if (show) shown++;
    });
    diag.filtered++; diag.resolvedById = byId; diag.resolvedByText = byText;
    updateEmptyHint(tbl, shown, c);
  }
  function updateEmptyHint(tbl, shown, c) {
    try {
      var tb = tbl.tBodies && tbl.tBodies[0]; if (!tb) return;
      var hint = document.getElementById('twhPatNoMatch');
      var active = !!(c.st || c.ct || c.dp || c.q);
      if (shown === 0 && active) {
        if (!hint) {
          var colspan = (tbl.tHead && tbl.tHead.rows[0] && tbl.tHead.rows[0].cells.length) || 12;
          var tr = document.createElement('tr');
          tr.id = 'twhPatNoMatch';
          tr.innerHTML = '<td colspan="' + colspan + '" style="text-align:center;padding:18px;color:var(--txt3,#94a3b8);font-size:12px">' +
            '<i class="fa-solid fa-magnifying-glass" style="margin-right:6px"></i>No patients match the current filters / search.</td>';
          tb.appendChild(tr);
        } else if (hint.style.display !== '') { hint.style.display = ''; }
      } else if (hint && hint.style.display !== 'none') { hint.style.display = 'none'; }
    } catch (_e) {}
  }
  function installFilter() {
    if (diag.filterInstalled) return;
    try {
      window.V25_filterPatients = hardenedFilter;
      window.V25_filterPatients.__v308 = true;
      diag.filterInstalled = true;
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  // Bind user-input listeners on the four controls so we can tell a genuine
  // "user cleared the search" apart from "a rebuild wiped the controls". A real
  // user event that yields empty criteria clears the persisted intent; anything
  // else keeps it (so the search sticks across DB-sync rebuilds).
  function onUserInput() {
    try {
      var live = readCriteria();
      if (_hasCriteria(live)) {
        _active = _cloneCriteria(live);
      } else {
        // User genuinely emptied everything → forget the intent so the full list
        // is shown and stays shown.
        if (_hasCriteria(_active)) diag.cleared++;
        _active = { st: '', ct: '', dp: '', q: '' };
      }
    } catch (_e) {}
  }
  function bindControls() {
    ['patFilterStatus', 'patFilterCard', 'patFilterDept', 'patFilterSearch'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || el.__v308bound) return;
      el.__v308bound = true;
      try {
        el.addEventListener('input', onUserInput, true);
        el.addEventListener('change', onUserInput, true);
      } catch (_e) {}
    });
  }

  // Run the restore on the SAME async cycle as v230's quietRepaint (which is
  // scheduled via setTimeout(...,0) off 'state:changed'). We chain a 0ms timeout
  // too, but register a microtask-fallback so we execute right after the repaint
  // regardless of listener order — no visible flash of the full list.
  function wireStateChanged() {
    if (diag.stateChangedWired) return;
    try {
      if (window.HMS && isFn(window.HMS.on)) {
        window.HMS.on('state:changed', function () {
          // quietRepaint runs on setTimeout(0); schedule ours just after so the
          // freshly rebuilt controls are restored + re-filtered immediately.
          try { setTimeout(restoreControls, 0); } catch (_e) { restoreControls(); }
          try { Promise.resolve().then(function () { setTimeout(restoreControls, 0); }); } catch (_e) {}
        });
        diag.stateChangedWired = true;
      }
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  /* ── (C) SORT BUTTONS REMOVED (v341) ─────────────────────────────────────
     The "Recent First" and "Sort A→Z" toolbar buttons were removed per user
     request. The patients dashboard now shows only the 10 most-recent patients
     by default (handled in pack 257 / v341), with the hardened SEARCH below
     reaching the full roster. The button-injection code (twhSortPatientsRecent,
     makeRecentBtn, makeSortAZBtn, placeSortButtons, injectToolbarCSS, etc.) was
     deleted; only the filter/search/persistence machinery (A + B) remains.      */

  /* ── wiring ──────────────────────────────────────────────────────────────── */
  function tick() {
    try { installFilter(); } catch (_e) {}
    try { wireStateChanged(); } catch (_e) {}
    var tbl = document.getElementById('patTable');
    if (!tbl) return;
    try { bindControls(); } catch (_e) {}
    // Re-apply whenever there is EITHER a live selection OR a persisted intent —
    // this is what makes the search stick across DB-sync rebuilds (the rebuild
    // wipes the live controls, but _active still holds the query).
    try {
      var live = readCriteria();
      if (_hasCriteria(live) || _hasCriteria(_active)) restoreControls();
    } catch (_e) {}
  }

  installFilter();
  [200, 600, 1200, 2400, 4200].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', function () { setTimeout(tick, 350); }); } catch (_e) {}
  // DOMBus fires right after render mutates #moduleContent. tick() runs
  // bindControls + a filter re-apply, all idempotent no-ops once the controls/
  // rows are in their final state — so this sweep does ZERO DOM writes on the
  // steady state and cannot drive a churn loop.
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(function () { try { tick(); } catch (_e) {} }); } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, tick); } catch (_e) {}
  try { wireStateChanged(); } catch (_e) {}

  // Expose the persisted intent for diagnostics + tests, and a programmatic
  // clear (so a "Clear filters" affordance elsewhere can reset the sticky state).
  window.__twhV308Diag = function () {
    var d = JSON.parse(JSON.stringify(diag));
    d.active = _cloneCriteria(_active);
    return d;
  };
  window.__twhV308ClearFilters = function () {
    _active = { st: '', ct: '', dp: '', q: '' };
    try {
      var st = document.getElementById('patFilterStatus'); if (st) st.value = '';
      var ct = document.getElementById('patFilterCard'); if (ct) ct.value = '';
      var dp = document.getElementById('patFilterDept'); if (dp) dp.value = '';
      var q = document.getElementById('patFilterSearch'); if (q) q.value = '';
    } catch (_e) {}
    diag.cleared++;
    try { hardenedFilter(); } catch (_e) {}
  };
  // Test/helper hooks (do not affect production behaviour).
  window.__twhV308Restore = restoreControls;
  window.__twhV308ReadActive = function () { return _cloneCriteria(_active); };
  log('patient filters hardened + search fixed + "Sort by Recent" + sticky-search armed');
})();

/* ════════════════════════════════════════════════════════════════════════
   TWH · DOCK DATABASE-SYNC INTO SIDEBAR + PERMANENT NO-SHAKE (v309)
   ────────────────────────────────────────────────────────────────────────
   User request (verbatim):
     "Database sync : Let move it to the background or sidebar from all the
      modules. Provide the best solution that will make all pages from shaking.
      Then the solution for all the … no flash of the full list — which
      eliminates the visible shake."

   Two coordinated fixes, appended as ONE self-contained IIFE inside pack 104
   (so the manifest module COUNT stays 226 and the size-balanced app2/app3
   chunks — both at their ceiling — are not disturbed; this pack rides in app1,
   which has headroom). Nothing about the D1 schema, /api/state, merge.js,
   _redirects, worker, the CORE shell (008/010), the SPA CSS bundle, or the
   feature-pack ORDER changes.

   ── PART A · MOVE DB-SYNC OFF THE FLOATING OVERLAY, INTO THE SIDEBAR ───────
   v279 renders a floating status PILL (bottom-right, id #twhV279Pill) plus a
   popover. On every module it overlaps the content/action buttons (exactly the
   screenshot the user shared). We DON'T touch v279's logic — instead we:
     • hide the floating pill/popover with an injected stylesheet, and
     • dock a compact, IN-FLOW "Database sync" control inside the sidebar
       (<aside class="sb">), just above the footer. It shows the same live
       status and offers the same Push / Pull actions, driven entirely by the
       PUBLIC APIs v279 already relies on:
         window.HMS_DB (syncState/lastError/lastSaved/onState)
         window._hmsSave()      → push local → D1
         window._hmsRefresh()   → pull + conflict-safe merge from D1
     The dock is re-asserted after shell re-renders via the shared DOMBus and a
     couple of bounded catch-up ticks (no new timers / observers).

   ── PART B · PERMANENT NO-SHAKE FOR EVERY PAGE (data-signature gate) ───────
   The residual shake is the ~10s DB-sync poll: it emits 'state:changed', and
   pack 178 (v230) routes that through quietRepaint(), which rewrites
   #moduleContent.innerHTML = renderModule(). v230 only skips when the produced
   HTML is byte-identical — but many renderers emit non-deterministic bytes
   (timestamps, jitter) so the guard is defeated and the whole module rebuilds
   on every poll → flash of the full list + scroll fight = the visible shake.

   The writer-agnostic cure: gate the BACKGROUND repaint on a STABLE DATA
   SIGNATURE instead of volatile HTML. We wrap the helper v230 EXPOSES
   (window.__twhQuietRepaint — NOT render/renderModule/goTo) so that a
   background quiet repaint is allowed to touch the DOM only when the underlying
   DATA actually changed since the last accepted repaint. If the poll fired but
   nothing material changed, the repaint becomes a true no-op → zero DOM writes
   → zero flash → no shake, on ALL modules. Genuine data changes still repaint
   normally, and any user-initiated render() path is untouched.

   Governor-safe: guard window.__twhV309; HMS.every(>=10000)/DOMBus/bounded
   setTimeout only; NO raw setInterval / MutationObserver / DOMContentLoaded;
   never wraps render / renderModule / renderDashboard / goTo / doLogin; no
   for-in flag copy.

   Guard: window.__twhV309     Diagnostics: window.__twhV309Diag()
   Toggles: window.TWH_DBSYNC_IN_SIDEBAR (default true)
            window.TWH_NO_SHAKE_GATE    (default true)
   ════════════════════════════════════════════════════════════════════════ */
(function twhDbSyncDockNoShakeV309() {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV309) return;
  window.__twhV309 = true;

  if (typeof window.TWH_DBSYNC_IN_SIDEBAR === 'undefined') window.TWH_DBSYNC_IN_SIDEBAR = true;
  if (typeof window.TWH_NO_SHAKE_GATE === 'undefined') window.TWH_NO_SHAKE_GATE = true;

  var DOCK_ID = 'twhV309Dock';
  var CSS_ID = 'twhV309Style';
  var isFn = function (f) { return typeof f === 'function'; };
  function log309() {
    try { console.log.apply(console, ['%c[v309]', 'color:#fff;background:#4338ca;padding:1px 6px;border-radius:4px'].concat([].slice.call(arguments))); } catch (_e) {}
  }

  var diag = {
    dockInstalled: false, dockRepaints: 0, gateWrapped: false,
    gateSkips: 0, gateAllows: 0, lastSig: null, pushing: false, pulling: false,
    floatingHidden: false, lastError: null
  };

  /* ── shared helpers ──────────────────────────────────────────────────────── */
  function online() {
    try { return (typeof navigator !== 'undefined' && 'onLine' in navigator) ? navigator.onLine : true; }
    catch (_e) { return true; }
  }
  function toast309(msg, kind) {
    try { if (isFn(window.toast)) { window.toast(msg); return; } } catch (_e) {}
    try { console.log('[v309]', msg); } catch (_e) {}
  }
  function relTime(ts) {
    if (!ts) return '';
    var s = Math.max(0, Math.round((Date.now() - ts) / 1000));
    if (s < 5) return 'just now';
    if (s < 60) return s + 's ago';
    var m = Math.round(s / 60); if (m < 60) return m + 'm ago';
    var h = Math.round(m / 60); if (h < 24) return h + 'h ago';
    return Math.round(h / 24) + 'd ago';
  }
  function dbState() {
    var st = 'idle', err = null, saved = null;
    try { if (window.HMS_DB) { st = window.HMS_DB.syncState || 'idle'; err = window.HMS_DB.lastError || null; saved = window.HMS_DB.lastSaved || null; } } catch (_e) {}
    if (!online()) return { s: 'offline', err: err, saved: saved };
    if (diag.pulling) return { s: 'pulling', err: err, saved: saved };
    if (diag.pushing || st === 'syncing') return { s: 'syncing', err: err, saved: saved };
    if (st === 'error') return { s: 'error', err: err, saved: saved };
    return { s: 'idle', err: err, saved: saved };
  }
  var VIEW309 = {
    idle: { ico: 'fa-solid fa-cloud-check', label: 'Synced', color: '#34d399' },
    syncing: { ico: 'fa-solid fa-cloud-arrow-up', label: 'Saving\u2026', color: '#38bdf8' },
    pulling: { ico: 'fa-solid fa-cloud-arrow-down', label: 'Loading\u2026', color: '#38bdf8' },
    offline: { ico: 'fa-solid fa-plug-circle-xmark', label: 'Offline', color: '#94a3b8' },
    error: { ico: 'fa-solid fa-triangle-exclamation', label: 'Sync error', color: '#f87171' }
  };

  /* ── (A) stylesheet: hide the floating v279 pill/popover; style the dock ──── */
  function injectCSS() {
    if (document.getElementById(CSS_ID)) return;
    var st = document.createElement('style');
    st.id = CSS_ID;
    st.textContent = [
      // Hide the floating overlay pill + its popover (docked into sidebar now).
      window.TWH_DBSYNC_IN_SIDEBAR ? '#twhV279Pill,#twhV279Pop{display:none !important;}' : '',
      // Docked sidebar control.
      '#' + DOCK_ID + '{margin:0;padding:10px 16px;border-top:1px solid rgba(255,255,255,.04);}',
      '#' + DOCK_ID + ' .v309-row{display:flex;align-items:center;gap:8px;cursor:pointer;',
      '  padding:8px 10px;border-radius:10px;background:rgba(255,255,255,.05);',
      '  border:1px solid rgba(255,255,255,.06);transition:background .15s;}',
      '#' + DOCK_ID + ' .v309-row:hover{background:rgba(255,255,255,.09);}',
      '#' + DOCK_ID + ' .v309-dot{width:8px;height:8px;border-radius:50%;flex:0 0 auto;background:#34d399;}',
      '#' + DOCK_ID + ' .v309-ico{font-size:12px;color:#cbd5e1;width:14px;text-align:center;}',
      '#' + DOCK_ID + ' .v309-lbl{font:600 11.5px system-ui,Segoe UI,Roboto,sans-serif;color:#e2e8f0;}',
      '#' + DOCK_ID + ' .v309-rel{margin-left:auto;font:500 10px system-ui;color:#94a3b8;}',
      '#' + DOCK_ID + '.busy .v309-ico{animation:v309spin 1.4s linear infinite;}',
      '@keyframes v309spin{to{transform:rotate(360deg);}}',
      '#' + DOCK_ID + ' .v309-acts{display:flex;gap:6px;margin-top:6px;}',
      '#' + DOCK_ID + ' .v309-btn{flex:1;display:flex;align-items:center;justify-content:center;gap:5px;',
      '  padding:6px 8px;border:0;border-radius:8px;cursor:pointer;',
      '  font:600 10.5px system-ui,Segoe UI,Roboto,sans-serif;color:#fff;}',
      '#' + DOCK_ID + ' .v309-btn.push{background:#0f766e;} #' + DOCK_ID + ' .v309-btn.push:hover{background:#0d9488;}',
      '#' + DOCK_ID + ' .v309-btn.pull{background:#0369a1;} #' + DOCK_ID + ' .v309-btn.pull:hover{background:#0284c7;}',
      '#' + DOCK_ID + ' .v309-btn[disabled]{opacity:.5;cursor:not-allowed;}',
      '#' + DOCK_ID + ' .v309-acts.hidden{display:none;}'
    ].join('');
    (document.head || document.documentElement).appendChild(st);
    diag.floatingHidden = !!window.TWH_DBSYNC_IN_SIDEBAR;
  }

  /* ── (A) build/refresh the docked sidebar control ────────────────────────── */
  function sidebar() {
    return document.querySelector('aside.sb') || document.getElementById('sidebar') || document.querySelector('.sb');
  }
  function loggedIn() {
    try { if (typeof window.isLoggedIn !== 'undefined') return !!window.isLoggedIn; } catch (_e) {}
    return true;
  }
  function buildDock() {
    if (!window.TWH_DBSYNC_IN_SIDEBAR) return;
    if (!loggedIn()) { removeDock(); return; }
    var sb = sidebar(); if (!sb) return;
    var dock = document.getElementById(DOCK_ID);
    if (!dock) {
      dock = document.createElement('div');
      dock.id = DOCK_ID;
      dock.innerHTML =
        '<div class="v309-row" role="button" tabindex="0" title="Database sync — auto every 5 min · expand for manual Push / Pull">' +
        '<span class="v309-dot"></span><i class="v309-ico fa-solid fa-cloud-check"></i>' +
        '<span class="v309-lbl">Synced</span><span class="v309-rel"></span></div>' +
        '<div class="v309-acts hidden">' +
        '<button type="button" class="v309-btn push"><i class="fa-solid fa-cloud-arrow-up"></i> Push</button>' +
        '<button type="button" class="v309-btn pull"><i class="fa-solid fa-cloud-arrow-down"></i> Pull</button>' +
        '</div>';
      // Dock ABOVE the footer (.sb-ft) so it reads as part of the shell chrome.
      var ft = sb.querySelector('.sb-ft');
      if (ft && ft.parentNode) ft.parentNode.insertBefore(dock, ft);
      else sb.appendChild(dock);
      var row = dock.querySelector('.v309-row');
      var acts = dock.querySelector('.v309-acts');
      var toggle = function () { if (acts) acts.classList.toggle('hidden'); };
      if (row) { row.addEventListener('click', toggle); row.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } }); }
      var pushBtn = dock.querySelector('.v309-btn.push');
      var pullBtn = dock.querySelector('.v309-btn.pull');
      if (pushBtn) pushBtn.addEventListener('click', function (e) { e.stopPropagation(); doPush(); });
      if (pullBtn) pullBtn.addEventListener('click', function (e) { e.stopPropagation(); doPull(); });
      diag.dockInstalled = true;
    }
    paintDock();
  }
  function removeDock() { var d = document.getElementById(DOCK_ID); if (d) { try { d.remove(); } catch (_e) {} } }
  function paintDock() {
    var dock = document.getElementById(DOCK_ID); if (!dock) return;
    var stt = dbState();
    var v = VIEW309[stt.s] || VIEW309.idle;
    dock.className = (stt.s === 'syncing' || stt.s === 'pulling') ? 'busy' : '';
    var dot = dock.querySelector('.v309-dot');
    var ico = dock.querySelector('.v309-ico');
    var lbl = dock.querySelector('.v309-lbl');
    var rel = dock.querySelector('.v309-rel');
    if (dot) dot.style.background = v.color;
    if (ico) ico.className = 'v309-ico ' + v.ico;
    if (lbl) lbl.textContent = v.label;
    if (rel) rel.textContent = (stt.s === 'idle' && stt.saved) ? relTime(stt.saved) : (stt.saved ? relTime(stt.saved) : 'Not synced yet');
    var busy = (stt.s === 'syncing' || stt.s === 'pulling');
    var pb = dock.querySelector('.v309-btn.push'); if (pb) pb.disabled = busy;
    var lb = dock.querySelector('.v309-btn.pull'); if (lb) lb.disabled = busy;
    diag.dockRepaints++;
  }

  function doPush() {
    if (diag.pushing) return;
    if (!online()) { toast309('You are offline — changes queued for when back online', 'error'); paintDock(); return; }
    if (!isFn(window._hmsSave)) { toast309('Save unavailable', 'error'); return; }
    diag.pushing = true; paintDock();
    var p; try { p = window._hmsSave(); } catch (e) { p = Promise.reject(e); }
    Promise.resolve(p).then(function () {
      if (window.HMS_DB && window.HMS_DB.syncState === 'error') toast309('Push failed — will retry automatically', 'error');
      else toast309('Pushed to database');
    }).catch(function () { toast309('Push failed — will retry automatically', 'error'); })
      .then(function () { diag.pushing = false; paintDock(); });
  }
  function doPull() {
    if (diag.pulling) return;
    if (!online()) { toast309('You are offline — cannot pull right now', 'error'); paintDock(); return; }
    if (!isFn(window._hmsRefresh)) { toast309('Refresh unavailable', 'error'); return; }
    if (document.getElementById('modalBg')) { toast309('Close the open form before pulling from the database', 'error'); return; }
    diag.pulling = true; paintDock();
    var p; try { p = window._hmsRefresh(); } catch (e) { p = Promise.reject(e); }
    Promise.resolve(p).then(function () { toast309('Pulled latest from database'); })
      .catch(function () { toast309('Pull failed — try again', 'error'); })
      .then(function () { diag.pulling = false; paintDock(); });
  }

  /* ── (B) data-signature gate for background quiet repaints (no shake) ─────── */
  // A cheap, stable fingerprint of the data that the CURRENT module actually
  // renders from. If it hasn't changed since the last accepted background
  // repaint, the poll-driven rebuild is skipped entirely (no DOM write → no
  // flash → no shake). We deliberately key on COUNTS + a couple of monotonic
  // markers, never on volatile fields, so genuine edits still flip the sig.
  // Small stable string-hash (djb2) so the checksum survives STRING ids/codes
  // (e.g. "LAB-TSWY0I") and status text — arithmetic `r.id||0` would NaN on
  // those and miss changes. Keeps the fingerprint sensitive to the exact fields
  // the Lab/Radiology order panels render (status / approval / bill / _rev).
  function hstr(s) {
    s = s == null ? '' : String(s);
    var h = 5381, i = s.length;
    while (i) { h = (h * 33) ^ s.charCodeAt(--i); }
    return h >>> 0;
  }
  function rowFingerprint(r) {
    if (!r || typeof r !== 'object') return 0;
    // The exact fields that flip a chip / row on the order-management panels.
    return hstr([r.id, r._rev, r.status, r.approval, r.approvalStatus,
      r.billed, r.billStatus, r.result, r.priority].join('~'));
  }
  function dataSig() {
    var d = null;
    try { if (typeof D !== 'undefined' && D) d = D; } catch (_e) {}
    if (!d) d = window.D || null;
    if (!d) return '∅';
    // Comprehensive key list incl. every Lab/Radiology + billing alias so the
    // gate reliably recognises "nothing changed on this screen" and skips the
    // rebuild → no flicker/disappear on Laboratory & Radiology.
    var keys = ['patients', 'appointments', 'prescriptions',
      'labTests', 'labOrders', 'laboratoryOrders', 'labRequests',
      'radiologyOrders', 'radOrders', 'imagingOrders', 'radiologyRequests',
      'medicalRecords', 'encounters', 'transactions', 'invoices', 'bills',
      'admissions', 'beds', 'inventory', 'staff', 'users', 'referrals', 'bloodBank'];
    var parts = [];
    for (var i = 0; i < keys.length; i++) {
      var arr = d[keys[i]];
      if (Array.isArray(arr)) {
        // length + a status-aware checksum (first + last 60 rows, bounded) so
        // both count changes AND in-place status/approval/bill edits flip the
        // signature without walking huge collections every poll.
        var n = arr.length, sum = 0, take = Math.min(n, 60);
        for (var j = 0; j < take; j++) { sum = (sum + rowFingerprint(arr[j])) | 0; }
        for (var k = Math.max(take, n - 60); k < n; k++) { sum = (sum + rowFingerprint(arr[k])) | 0; }
        parts.push(keys[i].charAt(0) + n + ':' + (sum >>> 0));
      }
    }
    // Include the active module so switching pages always repaints once.
    var mod = '';
    try { mod = window.currentMod || (typeof D !== 'undefined' && D && D.currentMod) || ''; } catch (_e) {}
    return mod + '|' + parts.join(',');
  }

  function installGate() {
    if (diag.gateWrapped) return;
    var orig = window.__twhQuietRepaint;
    if (!isFn(orig) || orig.__v309) return;
    var wrapped = function () {
      if (!window.TWH_NO_SHAKE_GATE) return orig.apply(this, arguments);
      try {
        // Never gate while an editor/modal is open — defer to v230's own guard.
        if (document.getElementById('modalBg')) return orig.apply(this, arguments);
        var sig = dataSig();
        if (diag.lastSig !== null && sig === diag.lastSig) {
          // Data unchanged since last accepted repaint → the poll produced no
          // material delta. Skip the rebuild: this is the shake-killer.
          diag.gateSkips++;
          return false;
        }
        var out = orig.apply(this, arguments);
        // Only advance the accepted signature when the repaint actually ran (or
        // was itself a legit no-op) — either way the DOM now reflects `sig`.
        diag.lastSig = sig; diag.gateAllows++;
        return out;
      } catch (e) { diag.lastError = String(e && e.message || e); return orig.apply(this, arguments); }
    };
    try {
      wrapped.__v309 = true;
      window.__twhQuietRepaint = wrapped;
      diag.gateWrapped = true;
      log309('no-shake data-signature gate installed over __twhQuietRepaint');
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  /* ── wiring (governor-safe) ──────────────────────────────────────────────── */
  function tick() {
    try { injectCSS(); } catch (_e) {}
    try { installGate(); } catch (_e) {}
    try { buildDock(); } catch (_e) {}
  }

  // React to authoritative sync-state changes for a live dock label.
  function bindState() {
    try {
      if (window.HMS_DB && isFn(window.HMS_DB.onState) && !window.__twhV309StateBound) {
        window.__twhV309StateBound = true;
        window.HMS_DB.onState(function () { paintDock(); });
      }
    } catch (_e) {}
  }
  function bindBus() {
    try {
      if (window.HMS && isFn(window.HMS.on) && !window.__twhV309BusBound) {
        window.__twhV309BusBound = true;
        window.HMS.on('state:changed', function () { paintDock(); });
      }
    } catch (_e) {}
  }
  function bindConnectivity() {
    if (window.__twhV309ConnBound) return;
    window.__twhV309ConnBound = true;
    try {
      window.addEventListener('offline', function () { paintDock(); });
      window.addEventListener('online', function () { paintDock(); });
    } catch (_e) {}
  }

  tick(); bindState(); bindBus(); bindConnectivity();
  [150, 500, 1200, 2500, 4200].forEach(function (ms) { setTimeout(tick, ms); });
  try { window.addEventListener('load', function () { setTimeout(tick, 300); }); } catch (_e) {}
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(function () { try { tick(); } catch (_e) {} }); } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, tick); } catch (_e) {}

  // Diagnostics + programmatic toggles / helpers (tests + support).
  window.__twhV309Diag = function () { var o = JSON.parse(JSON.stringify(diag)); o.online = online(); o.state = dbState().s; return o; };
  window.__twhV309Sig = dataSig;
  window.__twhV309Push = doPush;
  window.__twhV309Pull = doPull;
  log309('DB-sync docked into sidebar + permanent no-shake gate armed');
})();

/* ═══════════════════════════════════════════════════════════════════════════
   v311 — Keep navigation INSIDE the SPA (no full-page reload, no blank screen)

   The screen recording (flink.mp4) proved the real "flicker/shake" is the whole
   app hard-RELOADING on navigation: the tab shows a blank white loading screen
   for 12–30 s and the "HMS v23 Loaded" boot toast reappears (a cold re-boot),
   with the shell briefly inconsistent (header=Laboratory while breadcrumb=
   Radiology). Root cause: v303 tab-routing (TWH_TAB_ROUTING, default true) makes
   EVERY module link open a standalone page (patients→/register.html,
   laboratory→/laboratory.html, radiology→/radiology.html …), and the
   "Fast … (stable page)" launchers (v265/v266) navigate via window.__twhNavigate
   → window.location.assign/href. When a popup is blocked that becomes a same-tab
   full navigation = blank + cold re-boot.

   Fix (governor-safe, no core edits): (1) default the two routing toggles to the
   in-app behaviour, and (2) install a same-tab nav seam (__twhSameTabNav) plus an
   in-app __twhNavigate that maps a known page URL back to its module and calls
   the SPA's own goTo(mod) — swapping #moduleContent in place with NO document
   reload. Genuine external/standalone URLs still fall back to a real navigation.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__twhV311) return;
  window.__twhV311 = true;

  function log311() {
    try { console.log.apply(console, ['[v311]'].concat([].slice.call(arguments))); } catch (_e) {}
  }
  function isFn(f) { return typeof f === 'function'; }

  var diag = {
    inApp: 0,           // navigations resolved by an in-app goTo()
    fullReloads: 0,     // navigations that fell back to a real document navigation
    reloadSuppressed: 0,// times we prevented a would-be reload
    lastMod: null,
    lastUrl: null,
    seamSet: false,
    lastError: null
  };

  // Prefer in-app navigation everywhere. These toggles are read at call time by
  // v303/v305, so setting them here (idempotently, without clobbering an explicit
  // user override) flips the whole app back to client-side module swaps.
  try { if (window.TWH_TAB_ROUTING !== false) window.TWH_TAB_ROUTING = false; } catch (_e) {}
  try { if (window.TWH_FASTLINK_NEW_TAB !== false) window.TWH_FASTLINK_NEW_TAB = false; } catch (_e) {}

  // Map a standalone page URL (or its query mod) back to an in-app module key.
  // Mirrors the v303 PAGES map without importing it (packs are isolated IIFEs).
  var URL_TO_MOD = {
    '/register.html': 'patients',
    '/patients.html': 'patients',
    '/appointments.html': 'appointments',
    '/emr.html': 'emr',
    '/laboratory.html': 'laboratory',
    '/lab.html': 'laboratory',
    '/radiology.html': 'radiology'
  };

  function modFromUrl(url) {
    if (!url || typeof url !== 'string') return null;
    // strip origin + hash, keep path + query
    var u = url;
    try { u = url.replace(/^https?:\/\/[^/]+/i, ''); } catch (_e) {}
    var path = u.split('#')[0];
    var qpos = path.indexOf('?');
    var query = qpos >= 0 ? path.slice(qpos + 1) : '';
    var bare = (qpos >= 0 ? path.slice(0, qpos) : path).toLowerCase();
    // /module.html?mod=<key>  → the explicit mod wins.
    if (query) {
      var m = /(?:^|&)mod=([a-z0-9_-]+)/i.exec(query);
      if (m && m[1]) return m[1].toLowerCase();
    }
    if (URL_TO_MOD[bare]) return URL_TO_MOD[bare];
    // /<key>.html → derive the key when it is a plain module page.
    var mm = /^\/([a-z0-9_-]+)\.html$/i.exec(bare);
    if (mm && mm[1]) return mm[1].toLowerCase();
    return null;
  }

  // Perform an in-app module swap through the SPA's own router. Returns true when
  // it handled the navigation (so we NEVER touch window.location → no reload).
  function navigateInApp(page) {
    var mod = modFromUrl(page);
    if (!mod) return false;
    if (!isFn(window.goTo)) return false;
    try {
      window.goTo(mod);
      diag.inApp++; diag.lastMod = mod; diag.lastUrl = page;
      diag.reloadSuppressed++;
      return true;
    } catch (e) {
      diag.lastError = String(e && e.message || e);
      return false;
    }
  }

  // Real same-tab navigation fallback (only for genuinely external/standalone
  // targets the SPA cannot render internally). A seam (window.__twhHardNav) lets
  // tests/hosts observe or override the real navigation without a live reload.
  function hardNavigate(page) {
    diag.fullReloads++; diag.lastUrl = page;
    try { if (isFn(window.__twhHardNav)) { window.__twhHardNav(page); return; } } catch (_e0) {}
    try { window.location.assign(page); return; } catch (_e) {}
    try { window.location.href = page; return; } catch (_e2) {}
  }

  // __twhSameTabNav is the seam v305 calls when new-tab routing is OFF. Make it
  // try the in-app swap first, then fall back to a real navigation.
  function installSameTabSeam() {
    var seam = function (page) {
      if (navigateInApp(page)) return;
      hardNavigate(page);
    };
    seam.__twhV311 = true;
    try { window.__twhSameTabNav = seam; } catch (_e) {}
  }

  // v265/v266 launchers call window.__twhNavigate(page) FIRST when it is a
  // function. Own it so "Fast … (stable page)" buttons swap in-app instead of
  // reloading. v305 only overrides __twhNavigate when TWH_FASTLINK_NEW_TAB is on
  // (we defaulted it off), so our in-app seam wins for the common case.
  function installNavSeam() {
    // Do not clobber v305's new-tab seam if the user explicitly opted into tabs.
    if (window.TWH_FASTLINK_NEW_TAB === true) return;
    var seam = function (page) {
      if (navigateInApp(page)) return;
      hardNavigate(page);
    };
    seam.__twhV311 = true;
    try { window.__twhNavigate = seam; diag.seamSet = true; } catch (_e) {}
  }

  function install() {
    installSameTabSeam();
    installNavSeam();
  }

  // Governor-safe scheduling: shared bus + bounded one-shots. No raw loops, no
  // MutationObserver, no DOMContentLoaded. Re-assert periodically because later
  // packs (v305) may (re)install their own seam after us.
  install();
  [200, 800, 2000, 4500].forEach(function (ms) { setTimeout(install, ms); });
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(function () { try { install(); } catch (_e) {} }); } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, install); } catch (_e) {}

  window.__twhV311Diag = function () { return JSON.parse(JSON.stringify(diag)); };
  window.__twhV311ModFromUrl = modFromUrl;
  window.__twhV311NavigateInApp = navigateInApp;
  log311('SPA navigation kept in-app — no full-page reload / blank screen on module switch');
})();

/* ═══════════════════════════════════════════════════════════════════════════
   v312 — Kill the blank-screen REBOOTS on every navigation + activate all links

   Two long recordings (clockA.mp4 21:48, ClockB.mp4 16:47) proved the "flicking
   and shaking" is the whole app hard-RELOADING: clicking a sidebar item / a
   Quick-Access tile / the logo blanks the screen white for 6–42 s and re-boots
   (the "HMS v23 Loaded" toast reappears; a "main thread blocked 5.1 s" overlay
   shows). v311 only owned the __twhNavigate / __twhSameTabNav seams used by the
   "Fast … (stable page)" launchers — but the SIDEBAR and QUICK-ACCESS clicks do
   NOT use those seams. They are intercepted by v303's CAPTURING document click
   listener, which does window.open(url) and — when the popup is blocked —
   window.location.assign(url) → a full document load → cold re-boot. Separately,
   v304 auto-reloads the whole app once after login (the "Sync to Database →
   30 s blank → login screen" reboot).

   Fix (governor-safe, no core edits, appended IIFE — keeps module count 226):
     1. Own navigation at the EARLIEST capture point. Pack 104 loads before v303
        (index 103 < 247), so a capturing click listener registered here fires
        FIRST. It resolves the clicked sidebar item / Quick-Access tile / logo /
        any element carrying goTo('<mod>') to a module key and calls the SPA's
        own window.goTo(mod) IN-APP, then stopImmediatePropagation() so v303 can
        never turn the click into window.open / location.assign. Every link
        therefore stays a live client-side module swap — no dead clicks, no
        blank reload.
     2. Disable the login auto-reload (TWH_AUTO_RELOAD_ON_LOGIN=false) so a
        sign-in no longer hard-reloads the shell (the app already hydrates from
        live state). Idempotent — respects an explicit user override.
     3. Keep TWH_TAB_ROUTING / TWH_FASTLINK_NEW_TAB pinned to the in-app values.
     4. Stabilise the header greeting time / "Saved" element (tabular-nums +
        reserved width) so its per-second update stops jittering 1–2 px.

   Governor: HMS.every(>=10000) / DOMBus.register / bounded setTimeout only; no
   raw setInterval / MutationObserver / DOMContentLoaded; never wraps render /
   renderModule / renderDashboard / goTo / doLogin; no for..in flag copy.

   Guard: window.__twhV312   Diagnostics: window.__twhV312Diag()
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  if (window.__twhV312) return;
  window.__twhV312 = true;

  function isFn(f) { return typeof f === 'function'; }

  var diag = {
    inAppClicks: 0,        // sidebar/tile/logo clicks resolved via goTo() in-app
    reloadsBlocked: 0,     // clicks we intercepted before v303 could reload
    loginReloadDisabled: false,
    headerStabilised: false,
    installed: false,
    lastMod: null,
    lastError: null
  };

  // ── 1) Pin the routing toggles to the in-app behaviour, and switch OFF the
  //       whole-app reload-after-login. All three are read live by v303/v304/
  //       v305, so setting them (without clobbering an explicit user true) makes
  //       navigation client-side and stops the login reboot.
  try { if (window.TWH_TAB_ROUTING !== false) window.TWH_TAB_ROUTING = false; } catch (_e) {}
  try { if (window.TWH_FASTLINK_NEW_TAB !== false) window.TWH_FASTLINK_NEW_TAB = false; } catch (_e) {}
  try {
    if (window.TWH_AUTO_RELOAD_ON_LOGIN !== false) {
      window.TWH_AUTO_RELOAD_ON_LOGIN = false;
      diag.loginReloadDisabled = true;
    } else {
      diag.loginReloadDisabled = true;
    }
  } catch (_e) {}

  // ── Resolve the module key a clicked element (or an ancestor) targets. Mirrors
  //    v303's recognition without importing it: an explicit data-mod/data-goto,
  //    or the module inside an onclick="goTo('x')" attribute. Bounded to 6 hops.
  function modFromEl(el) {
    if (!el || el.nodeType !== 1) return '';
    try {
      var dm = el.getAttribute && (el.getAttribute('data-mod') || el.getAttribute('data-goto'));
      if (dm) return String(dm).trim();
      var oc = el.getAttribute && el.getAttribute('onclick');
      if (oc) {
        var m = /goTo\(\s*['"]([a-zA-Z0-9_-]+)['"]\s*\)/.exec(oc);
        if (m) return m[1];
      }
    } catch (_e) {}
    return '';
  }

  function findNav(start) {
    var el = start, hops = 0;
    while (el && el.nodeType === 1 && hops < 6) {
      var isNav = false;
      try {
        isNav = (el.classList && el.classList.contains('sb-item')) ||
                (el.getAttribute && el.getAttribute('onclick') && /goTo\(/.test(el.getAttribute('onclick'))) ||
                (el.getAttribute && (el.getAttribute('data-mod') || el.getAttribute('data-goto')));
      } catch (_e) { isNav = false; }
      if (isNav) {
        var mod = modFromEl(el);
        if (mod) return { el: el, mod: mod };
        // A sidebar item with no resolvable module — stop; let the app handle it.
        if (el.classList && el.classList.contains('sb-item')) return null;
      }
      el = el.parentNode;
      hops++;
    }
    return null;
  }

  // ── 2) The earliest capturing click handler. It runs before v303's (pack 104
  //       loads first). For a recognised nav element it calls goTo(mod) in-app
  //       and cancels the event so NOTHING downstream can navigate the document.
  function onClickCapture(e) {
    try {
      // Respect normal browser affordances — let modified / non-left clicks be.
      if (e.defaultPrevented) return;
      if (typeof e.button === 'number' && e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      var hit = findNav(e.target);
      if (!hit || !hit.mod) return;
      if (!isFn(window.goTo)) return; // no in-app router yet — let the app decide

      // ── SIDEBAR carve-out (v307): the user wants every SIDEBAR link to open
      //    its module as a standalone full page in a NEW tab (no sidebar, no
      //    reload). v307 owns that behaviour. So when the click originates from
      //    a sidebar item (.sb-item) AND sidebar-new-tab is enabled, we DO NOT
      //    intercept here — we let the event continue so v307's capture handler
      //    opens the new tab. Non-sidebar nav (dashboard tiles, in-body links,
      //    card buttons) keep the in-app behaviour below so they never reload.
      try {
        var sbEl = hit.el;
        var isSidebar = false, hops = 0;
        while (sbEl && sbEl.nodeType === 1 && hops < 6) {
          if (sbEl.classList && sbEl.classList.contains('sb-item')) { isSidebar = true; break; }
          sbEl = sbEl.parentNode; hops++;
        }
        if (isSidebar && window.TWH_SIDEBAR_NEW_TAB !== false) {
          diag.sidebarDeferred = (diag.sidebarDeferred || 0) + 1;
          return; // hand off to v307 (new-tab opener)
        }
      } catch (_sb) {}

      // Intercept before v303's capture handler and before the inline goTo.
      e.preventDefault();
      e.stopPropagation();
      if (isFn(e.stopImmediatePropagation)) e.stopImmediatePropagation();

      window.goTo(hit.mod);
      diag.inAppClicks++;
      diag.reloadsBlocked++;
      diag.lastMod = hit.mod;
    } catch (err) {
      diag.lastError = String(err && err.message || err);
    }
  }

  function installClick() {
    if (diag.installed) return;
    try {
      document.addEventListener('click', onClickCapture, true);
      diag.installed = true;
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  // ── 4) Stop the header greeting time / "Saved" timestamp jittering, AND fix the
  //       Medical-Records "All Registered Patients" header (search box overlapping
  //       the title on a narrow view). One shared scoped stylesheet for every
  //       pack-104 layout/typography fix (no core/CSS-bundle edit): tabular header
  //       time + reserved widths for the time / "Saving…" pill, plus a flex header
  //       for #twhAllPatientsCard so the title shrinks and the search input is
  //       width-capped instead of overlapping.
  function stabiliseHeader() {
    if (diag.headerStabilised) return;
    try {
      if (!document.getElementById('twh-v312-style')) {
        var st = document.createElement('style');
        st.id = 'twh-v312-style';
        st.textContent =
          '.twh-hdr-time,.hdr-time{font-variant-numeric:tabular-nums;min-width:5.5ch;display:inline-block;text-align:right}' +
          '.sync-pill,.saving-pill{min-width:92px;text-align:center;display:inline-flex;align-items:center;justify-content:center}' +
          '#twhAllPatientsCard .card-hd{align-items:flex-start;gap:10px 12px}' +
          '#twhAllPatientsCard .card-hd>h3{flex:1 1 220px;min-width:0}' +
          '#twhAllPatientsCard #twhPatSearch{max-width:200px}';
        (document.head || document.documentElement).appendChild(st);
        diag.headerStabilised = true;
      }
    } catch (e) { diag.lastError = String(e && e.message || e); }
  }

  function install() {
    installClick();
    stabiliseHeader();
    // Re-assert the toggles in case a later pack flipped one back on.
    try { if (window.TWH_TAB_ROUTING !== false) window.TWH_TAB_ROUTING = false; } catch (_e) {}
    try { if (window.TWH_FASTLINK_NEW_TAB !== false) window.TWH_FASTLINK_NEW_TAB = false; } catch (_e) {}
    try { if (window.TWH_AUTO_RELOAD_ON_LOGIN !== false) window.TWH_AUTO_RELOAD_ON_LOGIN = false; } catch (_e) {}
  }

  // Governor-safe scheduling: register the capture listener now (before v303),
  // then re-assert toggles/header via the shared bus + bounded one-shots.
  install();
  [200, 800, 2000, 4500].forEach(function (ms) { setTimeout(install, ms); });
  try { if (window.DOMBus && isFn(window.DOMBus.register)) window.DOMBus.register(function () { try { install(); } catch (_e) {} }); } catch (_e) {}
  try { if (window.HMS && isFn(window.HMS.every)) window.HMS.every(10000, install); } catch (_e) {}

  window.__twhV312Diag = function () { return JSON.parse(JSON.stringify(diag)); };
  window.__twhV312ModFromEl = modFromEl;
  window.__twhV312FindNav = findNav;
})();

;